(function(){
  "use strict";
  window.PVM_BUILD = "xg-life-18";
  try{ console.info("[casino] build xg-life-18"); }catch(e){}
  var WIKI = "https://runescape.wiki/images/";
  var PVMA = window.PVM_LOOT_ASSETS || {};
  var MUSIC_URL = PVMA.music || "Tables_are_Turned.ogg";
  var EVENT_MUSIC_URL = PVMA.event || "Gorgon-Zola.ogg";   /* the chinchompa chase */

  /* RS Dashboard Supabase project: cloud saves + leaderboards.
     The game page URL must be on the Auth Redirect URLs allowlist. */
  var SUPA_URL = "https://kosljtreypsowsxkmybt.supabase.co";
  var SUPA_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imtvc2xqdHJleXBzb3dzeGtteWJ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODg4ODgxMjAsImV4cCI6MjEwNDQ2NDEyMH0.uxJ5jvdwmoAdeZqb5fUoLO89GHbW9X5jA7WPFOVbc7M";

  var ITEMS = [
    {tier:1, name:"Bones",         files:["Bones_detail.png","Bones.png"],                 glyph:"\u2620"},
    {tier:2, name:"Shark",         files:["Shark_detail.png","Shark.png"],                 glyph:"\u2707"},
    {tier:3, name:"Abyssal whip",  files:["Abyssal_whip_detail.png","Abyssal_whip.png"],   glyph:"\u269A"},
    {tier:4, name:"Seismic wand",  files:["Seismic_wand_detail.png","Seismic_wand.png"],   glyph:"\u26A1"},
    {tier:5, name:"Bow of the Last Guardian", files:["Bow_of_the_Last_Guardian_detail.png","Bow_of_the_Last_Guardian.png"], glyph:"\u27B3"},
    {tier:6, name:"Blue partyhat", files:["Blue_partyhat_detail.png","Blue_partyhat.png"], glyph:"\u2655"}
  ];
  var COPIES = 5;
  var HANDS = [
    {name:"High item",       mult:1},
    {name:"Pair",            mult:2},
    {name:"Two pair",        mult:3},
    {name:"Three of a kind", mult:4},
    {name:"Full house",      mult:6},
    {name:"Four of a kind",  mult:8},
    {name:"Five of a kind",  mult:16}
  ];

  var LINES = {
    prestige: [
      "Retired rich and starting broke. That is the most RuneScape thing I have ever seen.",
      "Your fortune warms my vault nicely. Wear the star, lad, you earned it.",
      "All that gold, gone in a handshake. Welcome back to the bottom."
    ],
    dyeBuy: [
      "A fine choice. That one never washes out.",
      "Dyed at the counter. No refunds, no exceptions.",
      "Careful, that stuff stains everything it touches."
    ],
    dyeTrim: [
      "Seven dyes... fine, FINE. Have the gold trim, collector.",
      "A full set. Take the trim, and know that parting with gold wounds me."
    ],
    chinSpawn: [
      "A chinchompa loose in my bank?! Catch it, lad!",
      "That thing is stuffed with coins. Grab it before the song ends!",
      "Chinchompa! Quick hands now, quick hands!"
    ],
    mpWin: [
      "{n} rakes it in. The felt remembers.",
      "Pot goes to {n}. Drinks still are not free.",
      "{n} takes it. I deal, I judge, I never miss.",
      "All that gold to {n}. Somewhere a gnome weeps."
    ],
    atm: [
      "Swiping plastic at MY tavern? Bold. The goblin bank honours it, somehow.",
      "Credit approved. The interest rate is your dignity.",
      "Fresh coins on credit, lad. Try not to hand them straight back to me.",
      "The Bank of Gielinor thanks you for your continued poverty."
    ],
    chinCatch: [
      "Boom! {n} coins rained out of that thing.",
      "Caught! {n} coins, and you keep the smell.",
      "Ha! Fine catch. {n} coins richer."
    ],
    chinMiss: [
      "Gone. Slippery little grenade, that one.",
      "It escaped, and my coins went with it. Tragic.",
      "Too slow, lad. It is halfway to the Feldip Hills by now."
    ],
    deal: [
      "Five each. No peeking at mine.",
      "I have been dealing these since before your grandfather.",
      "Careful now. The bank likes a brave man.",
      "Throw away what you hate. Quickly.",
      "I once won Draynor Manor with a pair of bones.",
      "The deck is honest. I make no such claims about myself.",
      "Bet like you mean it, lad.",
      "Ah, fresh coins. I can smell them."
    ],
    win: [
      "Bah. Take your coins.",
      "Lucky. Nothing more than lucky.",
      "Well played, I suppose.",
      "Don't let it go to your head.",
      "Even a broken clock, as they say.",
      "I let you have that one.",
      "Hmph. These goggles need cleaning.",
      "Enjoy it. The bank always eats last."
    ],
    bigwin: [
      "WHAT. Deal me new eyes.",
      "Robbery. Daylight robbery.",
      "I felt that one in my beard.",
      "The Party Room will hear of this."
    ],
    loss: [
      "The bank thanks you.",
      "You threw the wrong ones away.",
      "That is how it goes, lad.",
      "My hat says otherwise.",
      "Another donation to the church of me.",
      "I retired from adventuring for this exact reason.",
      "Your coins are in good hands. Mine.",
      "Perhaps try Draynor bank. Oh wait."
    ],
    push: [
      "A draw. Keep your coins.",
      "Even. How dull.",
      "Nobody wins. Especially not you."
    ],
    flaw: [
      "Five of a kind. Someone check his sleeves.",
      "In all my years. Take it.",
      "Impossible. I stacked that deck myself."
    ],
    greedy: [
      "The whole hand? Bold.",
      "Burn it all down, why not.",
      "Ah, the scorched earth strategy."
    ],
    debt: [
      "Playing on the bank's coin now, are we.",
      "Loans. My favourite kind of friend.",
      "I charge no interest. Only dignity.",
      "Your tab grows, lad.",
      "The bank of me extends credit. The bank of me remembers."
    ],
    idle: [
      "In my day we settled this with a strike spell.",
      "The monkey cheats, you know. Never play the monkey.",
      "I robbed a bank once. Allegedly.",
      "Blue suits me. Always has.",
      "That gnome has been on card three for an hour.",
      "Drink? The barman waters the ale.",
      "My beard has seen kings fold.",
      "Zenevivia would tell me to stop gambling. She is not here.",
      "Deal in or admire the decor. Both are free.",
      "I count cards. I also count coins. Yours."
    ]
  };

  var SAVE = "pvm_loot_poker_v3";
  var START_COINS = 200;

  var state = {
    coins: START_COINS, bonds: 0, bet: 1, phase: "idle",
    game: "poker", diceMode: "duel",
    cosmetics: {owned: [], eq: null, cycle: []},
    lastBet: 0,
    deck: [], player: [], dealer: [], toss: [false,false,false,false,false],
    sound: true, music: true, musicVol: 25, streak: 0,
    stats: {hands:0, wins:0, best:0, streak:0, flawless:0, chins:0, bjHands:0, bjWins:0, diceHands:0, diceWins:0, peak:0, prestige:0, burned:0, slotSpins:0, slotWins:0, pachDrops:0, pachWins:0, atmSwipes:0, rouSpins:0, rouWins:0, stakeDuels:0, stakeWins:0, stakeScams:0, ceeHands:0, ceeWins:0, lost:0, bacHands:0, bacWins:0, d55Rolls:0, d55Wins:0, flowerPlays:0, flowerWins:0, sqSpins:0, sqWins:0, barrowsRuns:0, barrowsWins:0, wildyRuns:0, wildyWins:0, wildyBest:0, derbyRaces:0, derbyWins:0, beers:0}
  };

  var el = {};
  ["gpValue","rpValue","minNote","bestNote","dealerRow","playerRow","dealerHand","playerHand","womChat",
   "vHand","vDelta","verdict","betValue","goBtn","soundBtn","musicBtn","musicVol",
   "presets","presets2","ladder","sHands","sWins","sBest","sPeak","sPrest","sBurned","sStreak","sFlaw","sChins","sBjH","sBjW","sDiceH","sDiceW","sSlotS","sSlotW","sPachD","sPachW","sAtm","sLost","sCeeH","sCeeW","sStakeD","sStakeW","sScam","sRouS","sRouW","payTable","scene","nogl",
   "settingsBtn","settingsPop","gtabs","atmBtn","atmBack","mpBtn","mp","mpClose","mpEntry","mpName","mpHostBtn","mpCode","mpJoinBtn","mpMsg","mpLobby","mpCodeShow","mpPlayersList","mpModePoker","mpModeBj","mpChips","mpTimer","mpEscBtn","mpAddBot","mpLobbyMsg","mpStart","mpLeave","mpBar","mpBarInfo","mpBarPlayers","mpExit","mpOpps","mpFeed","mpPot","mpRaise","mpEmoteBtn","mpEmotes","shopBtn","shop","shopClose","shopBody","shopPreview","diceReadout","diceZone","rouZone","rmode","rouReadout","rouPanel","stakeAsk","stakeAskName","stakeAskInfo","stakeAccept","stakeDecline","stakeZone","stakeReadout","stakePanel","standBtn","dblBtn","brandSub","boardsBtn","boards","boardsBody","boardsClose","authBtn"].forEach(function(id){
    el[id] = document.getElementById(id);
  });

  /* ============================================================
     1. 3D card room
     ============================================================ */
  var G = {ok:false, mood:"idle", moodT:0, t:0, npcs:[], torches:[], stars:[], clouds:[], chatNext:6};

  function noise(w,h,draw){
    var c = document.createElement("canvas"); c.width = w; c.height = h;
    draw(c.getContext("2d"), w, h);
    var tex = new THREE.CanvasTexture(c);
    tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
    return tex;
  }
  function stoneTex(){
    return noise(128,128,function(x,w,h){
      x.fillStyle = "#3a3547"; x.fillRect(0,0,w,h);
      var bh = 16, bw = 32;
      for(var r = 0; r < h/bh; r++){
        for(var c = -1; c < w/bw + 1; c++){
          var ox = (r % 2) * bw/2;
          var v = 40 + Math.floor(Math.random()*22);
          x.fillStyle = "rgb(" + (v+16) + "," + (v+10) + "," + (v+24) + ")";
          x.fillRect(c*bw + ox + 1, r*bh + 1, bw - 2, bh - 2);
        }
      }
    });
  }
  function woodTex(){
    return noise(128,128,function(x,w,h){
      x.fillStyle = "#4a3320"; x.fillRect(0,0,w,h);
      for(var i = 0; i < 70; i++){
        x.strokeStyle = "rgba(0,0,0," + (0.05 + Math.random()*0.12) + ")";
        x.lineWidth = 1 + Math.random()*2;
        var y = Math.random()*h;
        x.beginPath(); x.moveTo(0,y); x.bezierCurveTo(w*0.3, y+6, w*0.6, y-6, w, y); x.stroke();
      }
    });
  }
  function skyTex(){
    var c = document.createElement("canvas"); c.width = 4; c.height = 128;
    var x = c.getContext("2d");
    var g = x.createLinearGradient(0, 0, 0, 128);
    g.addColorStop(0, "#0c1434"); g.addColorStop(0.6, "#0a102a"); g.addColorStop(1, "#151f45");
    x.fillStyle = g; x.fillRect(0, 0, 4, 128);
    return new THREE.CanvasTexture(c);
  }
  function mat(color, opts){
    var o = opts || {};
    return new THREE.MeshStandardMaterial({
      color:color, flatShading:o.flat !== false, roughness:o.rough === undefined ? 0.85 : o.rough,
      metalness:o.metal || 0, map:o.map || null, emissive:o.emissive || 0x000000,
      emissiveIntensity:o.ei === undefined ? 1 : o.ei
    });
  }
  function bmat(color, opts){
    var o = opts || {};
    var m = new THREE.MeshBasicMaterial({color:color, map:o.map || null,
      transparent:!!o.transparent, opacity:o.opacity === undefined ? 1 : o.opacity});
    m.fog = false;
    return m;
  }
  function box(w,h,d,m,x,y,z,parent){
    var me = new THREE.Mesh(new THREE.BoxGeometry(w,h,d), m);
    me.position.set(x,y,z); (parent || G.scene).add(me); return me;
  }
  function cyl(rt,rb,h,seg,m,x,y,z,parent){
    var me = new THREE.Mesh(new THREE.CylinderGeometry(rt,rb,h,seg), m);
    me.position.set(x,y,z); (parent || G.scene).add(me); return me;
  }
  function sph(r,m,x,y,z,parent,sx,sy,sz){
    var me = new THREE.Mesh(new THREE.SphereGeometry(r,8,7), m);
    me.position.set(x,y,z);
    if(sx) me.scale.set(sx, sy || sx, sz || sx);
    (parent || G.scene).add(me); return me;
  }
  function cone(r,h,seg,m,x,y,z,parent){
    var me = new THREE.Mesh(new THREE.ConeGeometry(r,h,seg), m);
    me.position.set(x,y,z); (parent || G.scene).add(me); return me;
  }

  /* the blue partyhat: tall band, short flat points rising straight
     from the rim as one silhouette, flat faces in line with the band */
  function partyhat(parent, r, colA, colB){
    /* fully proportional to r, so every hat is the same model as the dealer's */
    cyl(r, r * 1.08, r * 0.87, 10, colA, 0, r * 1.03, 0, parent);
    cyl(r * 1.09, r * 1.10, r * 0.154, 10, colB, 0, r * 0.64, 0, parent);
    var n = 5;
    for(var i = 0; i < n; i++){
      var a = (i / n) * Math.PI * 2 + 0.3;
      var spike = cone(r * 0.51, r * 1.13, 4, colA,
                       Math.cos(a) * (r * 0.88), r * 1.87, Math.sin(a) * (r * 0.88), parent);
      spike.scale.z = 0.4;
      spike.rotation.y = -(a + Math.PI/2);   /* exact tangent for every point, front and back alike */
    }
  }

  /* prestige shows in the room: partyhats spread through the tavern, gold piles up on the counter */
  function applyPrestigeScene(){
    if(!G.ok) return;
    var P = G.prestigePreview != null ? G.prestigePreview : (state.stats.prestige || 0);
    P = Math.min(P, 10);
    var HC = [[0xd43b3b,0x8f2424],[0x3bb54a,0x247030],[0x8a4fc9,0x5a3287],[0xe8d34a,0xa3922e],[0xf2f2f2,0xb8b8b8]];
    G.hats = G.hats || [];
    var heads = G.npcHeads || [];
    for(var i = G.hats.length; i < Math.min(P, heads.length); i++){
      var w = new THREE.Group();
      partyhat(w, 0.15, mat(HC[i % HC.length][0]), mat(HC[i % HC.length][1]));
      w.scale.setScalar(heads[i].s || 0.85);
      w.position.y = (heads[i].y || 0) + 0.026;
      heads[i].h.add(w);
      G.hats.push(w);
    }
    if(!G.goldPile){
      G.goldPile = new THREE.Group();
      G.goldPile.position.set(2.0, 0.99, 1.22);
      G.scene.add(G.goldPile);
      G.goldPileL = new THREE.Group();
      G.goldPileL.position.set(-2.05, 0.99, 1.22);
      G.scene.add(G.goldPileL);
      G.goldStacks = 0; G.goldStacksL = 0;
    }
    var GOLDC = mat(0xd8a93f, {metal:.7, rough:.35});   /* the same coins this counter has always used */
    var SLOTS = [[0.24,0.06],[-0.22,0.1],[0.04,0.26],[-0.12,-0.22],[0.44,-0.08],[-0.42,-0.04],[0.24,-0.24],[-0.3,0.28],
                 [0.52,0.16],[-0.54,0.1],[0.06,-0.3],[0.4,0.28],[-0.46,-0.24],[0.62,-0.06],[-0.64,0.2],[0.14,0.3]];
    function coinStack(group, x, z, n, seed){
      for(var c2 = 0; c2 < n; c2++){
        var cc = cyl(0.08, 0.09, 0.024, 8, GOLDC, x, 0.013 + c2*0.026, z, group);
        cc.rotation.y = seed + c2 * 1.3;
      }
    }
    function stacksTo(group, have, want){
      for(var k = have; k < want; k++) coinStack(group, SLOTS[k][0], SLOTS[k][1], 2 + ((k*7) % 4), k);
      return want;
    }
    function coinHeap(group){
      var hp = new THREE.Group(); group.add(hp);
      var tiers = [[7, 0.14], [4, 0.085], [2, 0.03]];
      for(var L = 0; L < 3; L++){
        for(var i2 = 0; i2 < tiers[L][0]; i2++){
          var a2 = (i2 / tiers[L][0]) * Math.PI * 2 + L * 0.9;
          var hc = cyl(0.08, 0.09, 0.024, 8, GOLDC,
                       Math.cos(a2) * tiers[L][1], 0.013 + L*0.026, Math.sin(a2) * tiers[L][1], hp);
          hc.rotation.y = a2 * 2;
        }
      }
      return hp;
    }
    G.goldStacks = stacksTo(G.goldPile, G.goldStacks, Math.min(P * 2, SLOTS.length));
    G.goldStacksL = stacksTo(G.goldPileL, G.goldStacksL, Math.min(Math.max(P - 5, 0) * 4, SLOTS.length));
    if(P >= 4 && !G.goldMound) G.goldMound = coinHeap(G.goldPile);
    if(P >= 8 && !G.goldMoundL) G.goldMoundL = coinHeap(G.goldPileL);
    if(P >= 9 && !G.goldBars){
      G.goldBars = new THREE.Group();
      G.goldBars.position.set(0, 0.09, 0);
      G.goldPileL.add(G.goldBars);
      box(0.16, 0.05, 0.08, GOLDC, -0.05, 0.025, 0.01, G.goldBars);
      box(0.16, 0.05, 0.08, GOLDC, 0.09, 0.025, -0.03, G.goldBars).rotation.y = 0.5;
      box(0.16, 0.05, 0.08, GOLDC, 0.02, 0.077, -0.01, G.goldBars).rotation.y = 0.25;
    }
    if(P >= 10 && !G.goldPhat){
      G.goldPhat = new THREE.Group();
      partyhat(G.goldPhat, 0.07, mat(0xf2cf6e), mat(0xb8912e));
      G.goldPhat.position.set(0, 0.10, 0);
      G.goldPile.add(G.goldPhat);
    }
  }

  /* the south corner: turn around and the machines are waiting */
  function drawSlotSym(c2, cx, sym){
    c2.save(); c2.translate(cx, 0);
    var GLOWC = {bones:"#c9973f", shark:"#4da3e0", whip:"#a55ffb", wand:"#35e0ea", dye:"#ff4a3a", coin:"#ffd24a", phat:"#2f7bff"};
    c2.fillStyle = GLOWC[sym] || "#ffffff";
    c2.globalAlpha = 0.22;
    c2.beginPath(); c2.arc(0, 0, 46, 0, 7); c2.fill();
    c2.globalAlpha = 1;
    if(sym === "bones"){
      c2.lineCap = "round";
      c2.strokeStyle = "#4a3a26"; c2.lineWidth = 15;
      c2.beginPath(); c2.moveTo(-26, -24); c2.lineTo(26, 24); c2.stroke();
      c2.fillStyle = "#4a3a26";
      [[-32,-30],[-20,-34],[20,30],[32,26]].forEach(function(p){ c2.beginPath(); c2.arc(p[0], p[1], 11.5, 0, 7); c2.fill(); });
      c2.strokeStyle = "#f7f3ea"; c2.lineWidth = 10;
      c2.beginPath(); c2.moveTo(-26, -24); c2.lineTo(26, 24); c2.stroke();
      c2.fillStyle = "#f7f3ea";
      [[-32,-30],[-20,-34],[20,30],[32,26]].forEach(function(p){ c2.beginPath(); c2.arc(p[0], p[1], 9, 0, 7); c2.fill(); });
    } else if(sym === "shark"){
      c2.fillStyle = "#3d9be6";
      c2.beginPath(); c2.moveTo(-34, 0); c2.quadraticCurveTo(0, -30, 26, 0); c2.quadraticCurveTo(0, 30, -34, 0); c2.fill();
      c2.beginPath(); c2.moveTo(24, 0); c2.lineTo(40, -14); c2.lineTo(40, 14); c2.fill();
      c2.fillStyle = "#14101f"; c2.beginPath(); c2.arc(-18, -6, 3.5, 0, 7); c2.fill();
    } else if(sym === "whip"){
      c2.strokeStyle = "#a04ffb"; c2.lineWidth = 11; c2.lineCap = "round";
      c2.beginPath(); c2.moveTo(-30, 26); c2.quadraticCurveTo(-34, -20, 0, -22);
      c2.quadraticCurveTo(32, -24, 28, 2); c2.quadraticCurveTo(24, 22, 2, 14); c2.stroke();
    } else if(sym === "wand"){
      c2.lineCap = "round";
      c2.strokeStyle = "#0b4d58"; c2.lineWidth = 14;
      c2.beginPath(); c2.moveTo(-24, 26); c2.lineTo(16, -14); c2.stroke();
      c2.strokeStyle = "#17b6c9"; c2.lineWidth = 10;
      c2.beginPath(); c2.moveTo(-24, 26); c2.lineTo(16, -14); c2.stroke();
      c2.fillStyle = "#ffdb4d"; c2.strokeStyle = "#8a6a10"; c2.lineWidth = 3;
      c2.beginPath();
      for(var st = 0; st < 5; st++){
        var aa = st * (Math.PI * 4 / 5) - Math.PI / 2;
        c2[st ? "lineTo" : "moveTo"](22 + Math.cos(aa) * 13, -22 + Math.sin(aa) * 13);
      }
      c2.closePath(); c2.fill(); c2.stroke();
    } else if(sym === "dye"){
      c2.fillStyle = "#e8322b";
      c2.beginPath(); c2.moveTo(-14, -10); c2.lineTo(14, -10); c2.lineTo(20, 26); c2.lineTo(-20, 26); c2.fill();
      c2.fillStyle = "#6b4a2a"; c2.fillRect(-7, -28, 14, 14);
      c2.fillStyle = "#8a5a3a"; c2.fillRect(-9, -32, 18, 6);
    } else if(sym === "coin"){
      c2.fillStyle = "#ffd24a"; c2.beginPath(); c2.arc(0, 0, 26, 0, 7); c2.fill();
      c2.strokeStyle = "#9c6f1e"; c2.lineWidth = 5;
      c2.beginPath(); c2.arc(0, 0, 16, 0, 7); c2.stroke();
    } else if(sym === "phat"){
      c2.fillStyle = "#2f7bff";
      c2.beginPath(); c2.moveTo(-30, 22);
      [[-30,-6],[-18,10],[-9,-16],[0,10],[9,-16],[18,10],[30,-6],[30,22]].forEach(function(p){ c2.lineTo(p[0], p[1]); });
      c2.fill();
    }
    c2.restore();
  }
  var SLOT_CELLS = ["bones","shark","whip","bones","wand","dye","coin","phat"];
  function slotStripTex(){
    var cv = document.createElement("canvas"); cv.width = 1024; cv.height = 128;
    var c2 = cv.getContext("2d");
    for(var i = 0; i < 8; i++){
      c2.fillStyle = i % 2 ? "#efe4c8" : "#f0e6cf";
      c2.fillRect(i * 128, 0, 128, 128);
      c2.strokeStyle = "#c9b98f"; c2.lineWidth = 3;
      c2.strokeRect(i * 128 + 2, 2, 124, 124);
      c2.save();
      c2.translate(i * 128 + 64, 64);
      c2.rotate(Math.PI / 2);
      drawSlotSym(c2, 0, SLOT_CELLS[i]);
      c2.restore();
    }
    return new THREE.CanvasTexture(cv);
  }
  function textPlate(txt, w, h, px){
    var cv = document.createElement("canvas"); cv.width = 256; cv.height = 64;
    var c2 = cv.getContext("2d");
    c2.fillStyle = "#14101f"; c2.fillRect(0, 0, 256, 64);
    c2.fillStyle = "#e0b458"; c2.font = "bold " + (px || 34) + "px Georgia"; c2.textAlign = "center";
    c2.fillText(txt, 128, 44);
    return new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(cv)}));
  }
  function buildMachines(){
    var WOODD = mat(0x2e2030), TRIM = mat(0xc2913c, {metal:.6, rough:.4}), IRONM = mat(0x9aa0a8, {metal:.5, rough:.4});
    var stex = stoneTex(); stex.repeat.set(5, 2.4);
    box(9, 4.6, 0.4, new THREE.MeshStandardMaterial({map:stex, roughness:1}), 0, 2.3, 7.8);
    box(9.4, 0.3, 0.5, mat(0x1a1424), 0, 4.55, 7.8);
    makeTorch(-3.4, 2.4, 7.55, Math.PI);
    makeTorch(3.4, 2.4, 7.55, Math.PI);
    var rug2 = new THREE.Mesh(new THREE.PlaneGeometry(5.6, 2.6), mat(0x243a70, {rough:1}));
    rug2.rotation.x = -Math.PI/2; rug2.position.set(0, 0.012, 6.4); G.scene.add(rug2);

    /* Loot Slots */
    var sm = new THREE.Group(); sm.position.set(-1.35, 0, 6.8); sm.rotation.y = Math.PI; G.scene.add(sm);
    box(1.1, 0.5, 0.8, WOODD, 0, 0.25, 0, sm);
    box(1.0, 1.2, 0.62, mat(0x3a2050), 0, 1.1, 0, sm);
    box(1.06, 0.08, 0.68, TRIM, 0, 1.74, 0, sm);
    box(0.94, 0.36, 0.1, mat(0x14101f), 0, 1.95, 0.02, sm);
    var mq = textPlate("LOOT SLOTS", 0.86, 0.3);
    mq.position.set(0, 1.95, 0.083); sm.add(mq);
    box(0.94, 0.5, 0.12, mat(0x1a1226), 0, 1.18, 0.24, sm);
    var strip = slotStripTex();
    G.slotReels = [];
    for(var r3 = 0; r3 < 3; r3++){
      var rg = new THREE.Group();
      rg.position.set(-0.28 + r3 * 0.28, 1.18, 0.22);
      sm.add(rg);
      var drum = new THREE.Mesh(new THREE.CylinderGeometry(0.155, 0.155, 0.17, 16, 1, true),
        new THREE.MeshBasicMaterial({map:strip, side:THREE.DoubleSide}));
      drum.rotation.z = Math.PI/2;
      rg.add(drum);
      G.slotReels.push(rg);
    }
    box(0.98, 0.06, 0.12, TRIM, 0, 1.44, 0.30, sm);
    box(0.98, 0.06, 0.12, TRIM, 0, 0.92, 0.30, sm);
    box(0.05, 0.46, 0.12, TRIM, -0.42, 1.18, 0.30, sm);
    box(0.05, 0.46, 0.12, TRIM, 0.42, 1.18, 0.30, sm);
    box(0.05, 0.46, 0.12, TRIM, -0.14, 1.18, 0.30, sm);
    box(0.05, 0.46, 0.12, TRIM, 0.14, 1.18, 0.30, sm);
    var lev = new THREE.Group(); lev.position.set(0.56, 1.05, 0.1); sm.add(lev);
    cyl(0.025, 0.025, 0.42, 6, IRONM, 0, 0.21, 0, lev);
    sph(0.058, mat(0xc22a1e), 0, 0.44, 0, lev);
    G.slotLever = lev;
    for(var lb2 = 0; lb2 < 6; lb2++){
      sph(0.024, new THREE.MeshBasicMaterial({color: lb2 % 2 ? 0xffd24a : 0xff5f4a}), -0.35 + lb2 * 0.14, 2.16, 0.05, sm);
    }
    box(0.7, 0.06, 0.2, WOODD, 0, 0.56, 0.36, sm);
    box(0.7, 0.05, 0.03, TRIM, 0, 0.585, 0.46, sm);
    cone(0.045, 0.09, 4, TRIM, -0.5, 1.18, 0.31, sm).rotation.z = -Math.PI/2;
    cone(0.045, 0.09, 4, TRIM, 0.5, 1.18, 0.31, sm).rotation.z = Math.PI/2;

    /* Pachinko */
    var pm = new THREE.Group(); pm.position.set(1.35, 0, 6.8); pm.rotation.y = Math.PI; G.scene.add(pm);
    G.pach = pm;
    box(1.0, 0.5, 0.7, WOODD, 0, 0.25, 0, pm);
    var btc = document.createElement("canvas"); btc.width = 256; btc.height = 384;
    var b2 = btc.getContext("2d");
    var bgg = b2.createLinearGradient(0, 0, 0, 384);
    bgg.addColorStop(0, "#26456f"); bgg.addColorStop(1, "#101f3a");
    b2.fillStyle = bgg; b2.fillRect(0, 0, 256, 384);
    b2.strokeStyle = "rgba(255,255,255,0.05)"; b2.lineWidth = 2;
    for(var dg = -384; dg < 512; dg += 32){
      b2.beginPath(); b2.moveTo(dg, 0); b2.lineTo(dg + 384, 384); b2.stroke();
      b2.beginPath(); b2.moveTo(dg + 384, 0); b2.lineTo(dg, 384); b2.stroke();
    }
    b2.fillStyle = "#cfe4ff";
    for(var st2 = 0; st2 < 26; st2++){
      b2.globalAlpha = 0.3 + Math.random() * 0.5;
      b2.beginPath(); b2.arc(Math.random() * 256, Math.random() * 384, 1.2, 0, 7); b2.fill();
    }
    b2.globalAlpha = 1;
    var boardMesh = new THREE.Mesh(new THREE.BoxGeometry(0.95, 1.62, 0.16),
      new THREE.MeshStandardMaterial({map:new THREE.CanvasTexture(btc), roughness:0.85}));
    boardMesh.position.set(0, 1.52, 0.02); pm.add(boardMesh);
    box(1.03, 1.7, 0.06, TRIM, 0, 1.52, -0.06, pm);
    box(0.05, 1.7, 0.2, TRIM, -0.5, 1.52, 0.05, pm);
    box(0.05, 1.7, 0.2, TRIM, 0.5, 1.52, 0.05, pm);
    box(1.03, 0.06, 0.2, TRIM, 0, 2.36, 0.05, pm);
    var mq2 = textPlate("PACHINKO", 0.8, 0.26);
    mq2.position.set(0, 2.5, 0.045); pm.add(mq2);
    box(0.9, 0.2, 0.08, mat(0x14101f), 0, 2.5, -0.01, pm);
    for(var row = 0; row < 7; row++){
      var cnt = row % 2 === 0 ? 7 : 6;
      for(var pc = 0; pc < cnt; pc++){
        var px = -0.36 + pc * 0.12 + (row % 2 ? 0.06 : 0);
        cyl(0.012, 0.012, 0.1, 5, TRIM, px, 2.06 - row * 0.155, 0.13, pm).rotation.x = Math.PI/2;
        sph(0.02, IRONM, px, 2.06 - row * 0.155, 0.18, pm);
      }
    }
    for(var bi = 0; bi < 9; bi++){
      box(0.014, 0.2, 0.12, TRIM, -0.46 + bi * 0.115, 0.86, 0.13, pm);
    }
    var lbl = document.createElement("canvas"); lbl.width = 512; lbl.height = 48;
    var l2 = lbl.getContext("2d");
    l2.fillStyle = "#14101f"; l2.fillRect(0, 0, 512, 48);
    l2.fillStyle = "#e0b458"; l2.font = "bold 21px monospace"; l2.textAlign = "center";
    ["20","3","1",".2",".2","1","3","20"].forEach(function(t2, i2){ l2.fillText(t2 + "x", 32 + i2 * 64, 33); });
    var lp = new THREE.Mesh(new THREE.PlaneGeometry(0.92, 0.09), new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(lbl)}));
    lp.position.set(0, 0.72, 0.145); pm.add(lp);
    var glass = new THREE.Mesh(new THREE.PlaneGeometry(0.9, 1.55),
      new THREE.MeshBasicMaterial({color:0xbfe6ff, transparent:true, opacity:0.07, depthWrite:false}));
    glass.position.set(0, 1.52, 0.21); pm.add(glass);
    box(0.34, 0.05, 0.14, TRIM, -0.28, 2.24, 0.1, pm).rotation.z = -0.5;
    box(0.34, 0.05, 0.14, TRIM, 0.28, 2.24, 0.1, pm).rotation.z = 0.5;
    var BINC = [0xe0b458, 0x3bb54a, 0x4a7fd0, 0xc0392b, 0xc0392b, 0x4a7fd0, 0x3bb54a, 0xe0b458];
    for(var bf = 0; bf < 8; bf++){
      box(0.1, 0.03, 0.12, mat(BINC[bf]), -0.4025 + bf * 0.115, 0.78, 0.13, pm);
    }
    for(var lt = 0; lt < 8; lt++){
      sph(0.022, new THREE.MeshBasicMaterial({color: lt % 2 ? 0xffd24a : 0xff5f4a}), -0.42 + lt * 0.12, 2.4, 0.06, pm);
    }
  }

  function makeTorch(x, y, z, ry){
    var tg = new THREE.Group(); tg.position.set(x, y, z); tg.rotation.y = ry;
    G.scene.add(tg);
    var IRON = mat(0x4a4652,{metal:.5,rough:.5});
    var br = box(0.045, 0.045, 0.24, IRON, 0, 0.02, 0.12, tg); br.rotation.x = -0.55;
    var ring = new THREE.Mesh(new THREE.TorusGeometry(0.062, 0.016, 5, 10), IRON);
    ring.rotation.x = Math.PI/2; ring.position.set(0, 0.115, 0.235); tg.add(ring);
    var hd = cyl(0.032, 0.042, 0.36, 6, mat(0x5c4326), 0, 0.20, 0.24, tg); hd.rotation.x = 0.12;
    cyl(0.052, 0.052, 0.09, 6, mat(0x2e2118), 0, 0.375, 0.262, tg);
    var outer = cone(0.10, 0.30, 7, mat(0xff8a2a,{emissive:0xff6a10, ei:1.6, rough:1}), 0, 0.50, 0.268, tg);
    var inner = cone(0.055, 0.19, 6, mat(0xffd66a,{emissive:0xffc23a, ei:2.0, rough:1}), 0, 0.47, 0.268, tg);
    sph(0.028, mat(0xfff2c8,{emissive:0xffefb0, ei:2.4}), 0, 0.41, 0.268, tg);
    var l = new THREE.PointLight(0xff9a45, 0.7, 8, 2); l.position.set(0, 0.55, 0.45); tg.add(l);
    G.torches.push({outer:outer, inner:inner, light:l, seed:Math.random()*9});
  }

  function buildSky(){
    var back = new THREE.Mesh(new THREE.PlaneGeometry(34, 14), bmat(0xffffff, {map:skyTex()}));
    back.position.set(0, 5, -9.5); G.scene.add(back);
    var halo = new THREE.Mesh(new THREE.CircleGeometry(0.95, 16), bmat(0xf5edcf, {transparent:true, opacity:0.14}));
    halo.position.set(4.4, 5.4, -9.3); G.scene.add(halo);
    var moon = new THREE.Mesh(new THREE.CircleGeometry(0.5, 16), bmat(0xf5edcf));
    moon.position.set(4.4, 5.4, -9.25); G.scene.add(moon);
    G.moon = moon; G.moonHalo = halo;
    var sg = new THREE.PlaneGeometry(0.07, 0.07);
    for(var i = 0; i < 90; i++){
      var sm = bmat(0xffffff, {transparent:true, opacity:0.8});
      var st = new THREE.Mesh(sg, sm);
      st.position.set(-11 + Math.random()*22, 2.0 + Math.random()*7, -9.0);
      G.scene.add(st);
      G.stars.push({m:sm, seed:Math.random()*9, base:0.35 + Math.random()*0.5});
    }
    for(var c = 0; c < 5; c++){
      var cg = new THREE.Group();
      var cm = bmat(0x1c2850, {transparent:true, opacity:0.88});
      var wdt = 1.2 + Math.random()*1.2;
      sph(0.5, cm, 0, 0, 0, cg, wdt, 0.42, 1);
      sph(0.34, cm, -wdt*0.42, 0.06, 0, cg, 1, 0.75, 1);
      sph(0.34, cm, wdt*0.42, 0.02, 0, cg, 1, 0.7, 1);
      cg.position.set(-12 + Math.random()*24, 3.4 + Math.random()*3.6, -8.6);
      G.scene.add(cg);
      G.clouds.push({g:cg, spd:0.10 + Math.random()*0.14});
    }
  }

  /* ---------- the dealer ---------- */
  function buildWiseOldMan(){
    var g = new THREE.Group();
    var ROBE = mat(0x7d7a2e), ROBE_D = mat(0x6b6826), SKIN = mat(0xc9a780),
        WHITE = mat(0xf2efe6), BLUE = mat(0x2b3fe0), BLUE_D = mat(0x2333b8),
        BELT = mat(0x7a2020), GOLD = mat(0xc2913c,{metal:.6,rough:.4}),
        GREY = mat(0x9aa0a8,{metal:.5,rough:.4}), WOODM = mat(0x6b4a2a);

    cyl(0.34, 0.50, 0.55, 9, ROBE_D, 0, 0.28, 0, g);
    cyl(0.52, 0.53, 0.05, 9, ROBE_D, 0, 0.03, 0, g);
    cyl(0.26, 0.35, 0.36, 9, ROBE, 0, 0.72, 0, g);
    cyl(0.27, 0.245, 0.46, 9, ROBE, 0, 1.11, 0, g);
    box(0.03, 0.50, 0.02, ROBE_D, -0.10, 0.30, 0.36, g).rotation.x = -0.12;
    box(0.03, 0.50, 0.02, ROBE_D, 0.11, 0.30, 0.35, g).rotation.x = -0.12;
    cyl(0.285, 0.295, 0.09, 9, BELT, 0, 0.92, 0, g);
    box(0.09, 0.065, 0.03, GOLD, 0, 0.92, 0.28, g);
    sph(0.10, ROBE, -0.235, 1.31, 0, g, 0.9, 0.75, 0.9);
    sph(0.10, ROBE, 0.235, 1.31, 0, g, 0.9, 0.75, 0.9);
    var collar = new THREE.Mesh(new THREE.TorusGeometry(0.165, 0.042, 5, 10), ROBE_D);
    collar.rotation.x = Math.PI/2; collar.position.set(0, 1.35, 0); g.add(collar);

    var capeL = box(0.28, 1.12, 0.05, BLUE, -0.14, 0.86, -0.17, g);
    capeL.rotation.x = -0.07; capeL.rotation.y = 0.10;
    var capeR = box(0.28, 1.12, 0.05, BLUE_D, 0.14, 0.86, -0.17, g);
    capeR.rotation.x = -0.07; capeR.rotation.y = -0.10;
    sph(0.04, GOLD, -0.19, 1.39, 0.09, g);
    sph(0.04, GOLD, 0.19, 1.39, 0.09, g);

    function arm(side){
      var a = new THREE.Group();
      a.position.set(side * 0.26, 1.30, 0);
      var upper = cyl(0.075, 0.095, 0.30, 7, ROBE, 0, -0.15, 0, a);
      upper.rotation.z = side * 0.10;
      sph(0.078, ROBE, side * 0.03, -0.30, 0.01, a);
      var fore = cyl(0.062, 0.08, 0.26, 7, ROBE_D, side * 0.05, -0.43, 0.03, a);
      fore.rotation.z = side * 0.06;
      cyl(0.086, 0.086, 0.06, 7, WHITE, side * 0.06, -0.55, 0.04, a);
      sph(0.065, SKIN, side * 0.07, -0.62, 0.05, a);
      sph(0.03, SKIN, side * 0.02, -0.60, 0.10, a);
      g.add(a); return a;
    }
    var lArm = arm(-1), rArm = arm(1);

    var staffG = new THREE.Group(); staffG.position.set(-0.40, 0, 0.08); g.add(staffG);
    cyl(0.028, 0.034, 1.40, 6, WOODM, 0, 0.72, 0, staffG);
    cyl(0.036, 0.036, 0.05, 6, GOLD, 0, 1.05, 0, staffG);
    sph(0.06, WOODM, 0, 1.44, 0, staffG, 1, 0.85, 1);
    staffG.rotation.z = 0.06;

    var head = new THREE.Group(); head.position.set(0, 1.55, 0); g.add(head);
    sph(0.20, SKIN, 0, 0, 0, head, 1, 1.08, 0.95);
    var nose = cone(0.036, 0.10, 5, SKIN, 0, -0.01, 0.215, head);
    nose.rotation.x = Math.PI/2;
    sph(0.042, SKIN, -0.19, 0, 0, head, 0.5, 1, 0.8);
    sph(0.042, SKIN, 0.19, 0, 0, head, 0.5, 1, 0.8);
    box(0.085, 0.026, 0.04, WHITE, -0.08, 0.11, 0.175, head).rotation.z = 0.15;
    box(0.085, 0.026, 0.04, WHITE, 0.08, 0.11, 0.175, head).rotation.z = -0.15;
    [-0.08, 0.08].forEach(function(x){
      var ring = new THREE.Mesh(new THREE.TorusGeometry(0.058, 0.017, 5, 10), GREY);
      ring.position.set(x, 0.05, 0.175); head.add(ring);
      var lens = new THREE.Mesh(new THREE.CircleGeometry(0.049, 10), mat(0xb9c4cc,{rough:.2,metal:.3}));
      lens.position.set(x, 0.05, 0.18); head.add(lens);
    });
    box(0.065, 0.02, 0.03, GREY, 0, 0.05, 0.18, head);
    box(0.28, 0.028, 0.03, GREY, 0, 0.06, 0.095, head);
    sph(0.18, WHITE, 0, -0.105, 0.045, head, 1, 0.72, 0.95);
    box(0.065, 0.19, 0.095, WHITE, -0.155, -0.02, 0.085, head).rotation.z = 0.08;
    box(0.065, 0.19, 0.095, WHITE, 0.155, -0.02, 0.085, head).rotation.z = -0.08;
    /* beard hangs forward of the robe now, with a slight outward tilt */
    var beard = new THREE.Mesh(new THREE.ConeGeometry(0.14, 0.44, 7), WHITE);
    beard.rotation.x = Math.PI - 0.15;
    beard.position.set(0, -0.37, 0.23); head.add(beard);
    var beard2 = new THREE.Mesh(new THREE.ConeGeometry(0.09, 0.26, 6), mat(0xe2ddcf));
    beard2.rotation.x = Math.PI - 0.18;
    beard2.position.set(0, -0.55, 0.28); head.add(beard2);
    box(0.095, 0.033, 0.055, WHITE, -0.07, -0.072, 0.19, head).rotation.z = -0.35;
    box(0.095, 0.033, 0.055, WHITE, 0.07, -0.072, 0.19, head).rotation.z = 0.35;
    sph(0.19, WHITE, 0, 0.02, -0.055, head, 1.05, 0.95, 0.9);
    box(0.055, 0.21, 0.095, WHITE, -0.18, -0.075, -0.04, head);
    box(0.055, 0.21, 0.095, WHITE, 0.18, -0.075, -0.04, head);
    partyhat(head, 0.195, BLUE, BLUE_D);

    G.wom = {group:g, head:head, lArm:lArm, rArm:rArm, capeL:capeL, capeR:capeR, staff:staffG};
    g.position.set(0, 0.02, -0.55);
    G.scene.add(g);
  }

  /* ---------- background people (scaled to stand as tall as the dealer) ---------- */
  function makeMan(o){
    var g = new THREE.Group();
    var SKIN = mat(o.skin || 0xc9a780), SHIRT = mat(o.shirt), PANTS = mat(o.pants),
        HAIR = mat(o.hair), DARK = mat(0x2a2733);
    function leg(side){
      var L = new THREE.Group(); L.position.set(side * 0.09, 0.42, 0);
      cyl(0.062, 0.075, 0.42, 6, PANTS, 0, -0.21, 0, L);
      box(0.10, 0.06, 0.16, DARK, 0, -0.40, 0.03, L);
      g.add(L); return L;
    }
    var lL = leg(-1), rL = leg(1);
    cyl(0.17, 0.135, 0.40, 7, SHIRT, 0, 0.62, 0, g);
    cyl(0.145, 0.150, 0.05, 7, mat(0x5c1f22), 0, 0.44, 0, g);
    function arm(side){
      var a = new THREE.Group(); a.position.set(side * 0.19, 0.78, 0);
      var s = cyl(0.048, 0.058, 0.34, 6, SHIRT, 0, -0.17, 0, a);
      s.rotation.z = side * 0.10;
      sph(0.05, SKIN, side * 0.04, -0.36, 0.02, a);
      g.add(a); return a;
    }
    var lA = arm(-1), rA = arm(1);
    cyl(0.052, 0.06, 0.14, 6, SKIN, 0, 0.86, 0, g);   /* neck, so the head isn't floating */
    var head = new THREE.Group(); head.position.set(0, 0.97, 0); g.add(head);
    sph(0.115, SKIN, 0, 0, 0, head, 1, 1.1, 0.95);
    cone(0.02, 0.05, 4, SKIN, 0, -0.01, 0.115, head).rotation.x = Math.PI/2;
    sph(0.124, HAIR, 0, 0.052, -0.015, head, 1.04, 0.85, 1.0);
    g.scale.setScalar(o.scale || 1.7);
    return {group:g, head:head, lArm:lA, rArm:rA, lLeg:lL, rLeg:rL};
  }
  function makeGnome(){
    var m = makeMan({shirt:0x1f8a2e, pants:0x1f8a2e, hair:0xb08a3e, skin:0xd8b48a});
    var hat = cone(0.115, 0.42, 6, mat(0xb08a3e), 0, 0.20, 0, m.head);
    hat.rotation.x = -0.18;
    cone(0.045, 0.14, 5, mat(0xa07a34), 0, 0.42, -0.08, m.head).rotation.x = -0.7;
    box(0.05, 0.34, 0.06, mat(0xb08a3e), -0.11, -0.12, 0.06, m.head);
    box(0.05, 0.34, 0.06, mat(0xb08a3e), 0.11, -0.12, 0.06, m.head);
    m.group.scale.setScalar(1.05);
    return m;
  }
  function makeMonkey(){
    var g = new THREE.Group();
    var FUR = mat(0x8a6b32), LITE = mat(0xc9b276), RED = mat(0xc22a1e);
    sph(0.16, FUR, 0, 0.22, 0, g, 1, 0.9, 1.15);
    var head = new THREE.Group(); head.position.set(0, 0.40, 0.10); g.add(head);
    sph(0.11, FUR, 0, 0, 0, head);
    sph(0.075, LITE, 0, -0.02, 0.08, head, 1, 0.8, 0.9);
    sph(0.04, FUR, -0.10, 0.05, -0.01, head, 1, 1, 0.5);
    sph(0.04, FUR, 0.10, 0.05, -0.01, head, 1, 1, 0.5);
    cone(0.025, 0.09, 4, RED, -0.02, 0.13, 0.01, head).rotation.z = 0.2;
    cone(0.025, 0.11, 4, RED, 0.02, 0.14, 0, head).rotation.z = -0.15;
    /* jointed limbs so the hop reads through the whole body */
    function mArm(side){
      var A = new THREE.Group(); A.position.set(side * 0.13, 0.32, 0.08);
      cyl(0.032, 0.045, 0.32, 5, FUR, 0, -0.14, 0.04, A).rotation.x = 0.2;
      box(0.07, 0.035, 0.11, LITE, 0, -0.30, 0.10, A);
      g.add(A); return A;
    }
    function mLeg(side){
      var L = new THREE.Group(); L.position.set(side * 0.09, 0.16, -0.06);
      cyl(0.04, 0.05, 0.16, 5, FUR, 0, -0.07, 0, L);
      g.add(L); return L;
    }
    var t1 = cyl(0.022, 0.028, 0.22, 5, FUR, 0, 0.28, -0.20, g); t1.rotation.x = 0.9;
    var t2 = cyl(0.018, 0.022, 0.20, 5, FUR, 0, 0.44, -0.28, g); t2.rotation.x = 0.25;
    var t3 = cyl(0.014, 0.018, 0.16, 5, FUR, 0, 0.58, -0.26, g); t3.rotation.x = -0.5;
    return {group:g, head:head, tail:[t1,t2,t3],
            lArm:mArm(-1), rArm:mArm(1), lLeg:mLeg(-1), rLeg:mLeg(1), hop:true};
  }

  /* ---------- gorgonzola run: a chinchompa loose in the tavern ---------- */
  function makeChin(){
    var g = new THREE.Group();
    var FUR = mat(0x9aa3ad), LITE = mat(0xcdd3da), PINK = mat(0xd98a90), DARK = mat(0x3a3f47);
    sph(0.17, FUR, 0, 0.20, 0, g, 1.05, 0.95, 1.2);                 /* round body */
    sph(0.10, LITE, 0, 0.14, 0.16, g, 1, 0.85, 0.7);                /* belly */
    var head = new THREE.Group(); head.position.set(0, 0.34, 0.14); g.add(head);
    sph(0.11, FUR, 0, 0, 0, head, 1.05, 1, 1);
    sph(0.05, FUR, -0.09, 0.11, -0.01, head, 1, 1.15, 0.45);        /* big round ears */
    sph(0.05, FUR, 0.09, 0.11, -0.01, head, 1, 1.15, 0.45);
    sph(0.028, PINK, -0.09, 0.11, 0.012, head, 1, 1.1, 0.3);
    sph(0.028, PINK, 0.09, 0.11, 0.012, head, 1, 1.1, 0.3);
    sph(0.022, DARK, -0.045, 0.02, 0.095, head);                    /* eyes */
    sph(0.022, DARK, 0.045, 0.02, 0.095, head);
    sph(0.03, PINK, 0, -0.02, 0.11, head, 1, 0.7, 0.7);             /* nose */
    box(0.035, 0.045, 0.012, mat(0xf4efe2), 0, -0.075, 0.10, head); /* buck teeth */
    [-1, 1].forEach(function(sd){
      cyl(0.03, 0.038, 0.10, 5, FUR, sd*0.10, 0.06, 0.05, g);
      cyl(0.03, 0.038, 0.10, 5, FUR, sd*0.075, 0.06, -0.08, g);
    });
    var tail = sph(0.085, LITE, 0, 0.26, -0.22, g);                 /* puff tail */
    /* generous invisible click target for mobile taps */
    var hit = new THREE.Mesh(new THREE.SphereGeometry(0.8, 8, 6),
      new THREE.MeshBasicMaterial({transparent:true, opacity:0, depthWrite:false}));
    hit.position.y = 0.25; g.add(hit);
    return {group:g, head:head, tail:tail};
  }

  var CHIN = {active:false, escaping:false, m:null, group:null, target:null,
              endT:0, escT:0, nextAt:75 + Math.random()*90, parts:[]};
  var chinBgm = null;
  function chinPoints(){ return [[-6.4,1.1],[-3.2,0.7],[0.2,-1.3],[3.1,0.9],[6.2,-0.6],[4.8,-4.0],[0.3,-4.4],[-4.8,-3.6]]; }
  function chinPick(){
    var pts = chinPoints(), p = pts[Math.floor(Math.random()*pts.length)];
    if(CHIN.target && p[0] === CHIN.target[0] && p[1] === CHIN.target[1]) return chinPick();
    return p;
  }
  function startChin(){
    if(!CHIN.m) CHIN.m = makeChin();
    CHIN.group = CHIN.m.group;
    CHIN.group.position.set(-8.4, 0, 0.8);
    G.scene.add(CHIN.group);
    CHIN.active = true; CHIN.escaping = false;
    CHIN.target = [-5.5, 0.4];
    CHIN.endT = G.t + 34;
    say(pick(LINES.chinSpawn));
    if(state.music){
      if(bgm) bgm.pause();
      if(!chinBgm) chinBgm = new Audio(EVENT_MUSIC_URL);
      chinBgm.volume = state.musicVol / 100;
      chinBgm.currentTime = 0;
      chinBgm.play().catch(function(){});
    }
  }
  function endChin(caught){
    if(!CHIN.active) return;
    CHIN.active = false; CHIN.escaping = false;
    if(CHIN.group) G.scene.remove(CHIN.group);
    CHIN.nextAt = G.t + 150 + Math.random()*150;
    if(chinBgm) chinBgm.pause();
    if(state.music && bgm) bgm.play().catch(function(){});
    if(!caught) say(pick(LINES.chinMiss));
  }
  function catchChin(){
    if(!CHIN.active || CHIN.escaping) return;
    var reward = 15 + Math.floor(Math.random()*26);
    if(state.coins > 1000) reward = Math.max(reward, Math.round(state.coins * (0.01 + Math.random() * 0.02)));
    state.coins += reward;
    state.stats.chins = (state.stats.chins || 0) + 1;
    /* the chinchompa does what chinchompas do */
    var origin = CHIN.group.position.clone(); origin.y += 0.3;
    for(var k = 0; k < 12; k++){
      var pm = new THREE.MeshBasicMaterial({color: k % 3 ? 0xe0b458 : 0x9aa3ad, transparent:true});
      var pt = new THREE.Mesh(new THREE.BoxGeometry(0.07, 0.07, 0.07), pm);
      pt.position.copy(origin);
      pt.userData.v = new THREE.Vector3((Math.random()-0.5)*3.4, 1.6 + Math.random()*2.2, (Math.random()-0.5)*3.4);
      pt.userData.life = 1;
      G.scene.add(pt); CHIN.parts.push(pt);
    }
    tone(90, 0.22, "square", 0.14); tone(660, 0.10, "square", 0.09);
    say(pick(LINES.chinCatch).replace("{n}", fmtCoins(reward)));
    endChin(true);
    paint(); saveLocal(); cloudPush();
  }

  /* an upright fan gripped with both hands at the chest */
  function handCards(p){
    var fan = new THREE.Group();
    fan.position.set(0, 0.71, 0.33);   /* bottoms sit in the hands instead of poking through */
    fan.rotation.x = -0.15;            /* near vertical, slight lean toward the holder */
    var CARD = mat(0xf0e6cf,{rough:.9});
    [-1.5, -0.5, 0.5, 1.5].forEach(function(i){
      /* pivot at the grip: bottoms converge, tops spread outward */
      var a = -i * 0.22;
      var c = box(0.09, 0.13, 0.006, CARD, i*0.024 - Math.sin(a)*0.065, Math.cos(a)*0.065 - 0.065, i*0.003, fan);
      c.rotation.z = a;
      c.rotation.y = i * 0.05;
    });
    p.group.add(fan); p.fan = fan;
    p.lArm.rotation.set(-1.05, 0, 0.55);    /* hands rotate IN toward the fan */
    p.rArm.rotation.set(-1.05, 0, -0.55);
  }

  /* seated card game at a background table (tabletop is at y 0.92) */
  function seatPlayers(tx, tz){
    var gnome = makeGnome(), man = makeMan({shirt:0x4a4f6e, pants:0x8a7d5e, hair:0x8a5a2a});
    G.headGnome = gnome.head; G.headMan = man.head;   /* captured for prestige hats */
    box(0.5, 0.42, 0.5, mat(0x6b4a2a), tx, 0.21, tz + 1.18);
    gnome.group.position.set(tx, 0.42, tz + 1.18); gnome.group.rotation.y = Math.PI;
    man.group.position.set(tx, 0, tz - 1.15);
    G.scene.add(gnome.group); G.scene.add(man.group);
    [gnome, man].forEach(function(p){ handCards(p); });
    var played = [];
    for(var i = 0; i < 3; i++){
      var pc = box(0.10, 0.006, 0.14, mat(0xf0e6cf,{rough:.9}),
                   tx - 0.18 + i*0.18, 0.945, tz + (i%2 ? 0.10 : -0.08));
      pc.rotation.y = (i - 1) * 0.4;
      pc.visible = i < 1;
      played.push(pc);
    }
    var seed = Math.random()*9, next = 3 + Math.random()*3, shown = 1, turn = 0;
    G.npcs.push({update:function(t,dt){
      var a = turn ? man : gnome, b = turn ? gnome : man;
      [gnome, man].forEach(function(p, k){
        p.fan.rotation.z = Math.sin(t*1.2 + k*2)*0.06;
        p.fan.position.y = 0.71 + Math.sin(t*1.6 + k)*0.012;
        p.group.rotation.y = (p === gnome ? Math.PI : 0) + Math.sin(t*0.45 + k*3)*0.06;
      });
      a.head.rotation.x = 0.30 + Math.sin(t*1.4 + seed)*0.05;
      b.head.rotation.x = 0.22;
      b.head.rotation.y = Math.sin(t*0.8 + seed)*0.14;
      b.rArm.rotation.x = -1.05 + Math.sin(t*1.1 + seed)*0.06;
      next -= dt;
      if(next < 0.45 && next > 0){
        var s = Math.sin((0.45 - next)/0.45 * Math.PI);
        a.rArm.rotation.x = -1.05 + s * 0.75;
        a.rArm.rotation.z = -0.55 + s * 0.4;
      } else if(next <= 0){
        played[shown % played.length].visible = true;
        shown++; turn = 1 - turn;
        if(shown % played.length === 0) played.forEach(function(p,i){ p.visible = i === 0; });
        next = 3 + Math.random()*4;
        a.rArm.rotation.set(-1.05, 0, -0.55);
      }
    }});
  }

  function walker(model, pts, speed, bobAmt){
    var m = model, i = 0;
    m.group.position.set(pts[0][0], 0, pts[0][1]);
    G.scene.add(m.group);
    G.npcs.push({update:function(t,dt){
      var wp = pts[i];
      if(m.chase && CHIN.active && !CHIN.escaping) wp = [CHIN.group.position.x, CHIN.group.position.z];
      var target = new THREE.Vector3(wp[0], 0, wp[1]);
      var d = target.clone().sub(m.group.position); d.y = 0;
      if(d.length() < 0.12){ if(wp === pts[i]) i = (i + 1) % pts.length; return; }
      d.normalize();
      m.group.position.addScaledVector(d, speed * dt);
      m.group.rotation.y = Math.atan2(d.x, d.z);
      m.group.position.y = Math.abs(Math.sin(t * speed * 6)) * bobAmt;
      var sw = Math.sin(t * 6 * speed);
      if(m.hop){
        var hs = Math.abs(Math.sin(t * speed * 6));
        m.group.scale.y = 1 - 0.10 * hs;                 /* squash on landing */
        m.lArm.rotation.x = 0.2 + sw * 0.7;              /* limbs drive the hop */
        m.rArm.rotation.x = 0.2 + sw * 0.7;
        m.lLeg.rotation.x = -sw * 0.8;
        m.rLeg.rotation.x = -sw * 0.8;
      } else {
        if(m.lArm){ m.lArm.rotation.x = sw * 0.5; m.rArm.rotation.x = -sw * 0.5; }
        if(m.lLeg){ m.lLeg.rotation.x = -sw * 0.55; m.rLeg.rotation.x = sw * 0.55; }
      }
      if(m.tail){ m.tail.forEach(function(s,k){ s.rotation.z = Math.sin(t*3 + k)*0.18; }); }
    }});
  }

  /* ---------- the hall ---------- */
  function buildRoom(){
    var stone = stoneTex(); stone.repeat.set(5, 2);
    var wood = woodTex(); wood.repeat.set(3, 1);
    var STONE = mat(0x4a4458, {map:stone}), WOOD = mat(0x6b4a2a, {map:wood});
    var floorTex = stoneTex(); floorTex.repeat.set(10, 7);

    buildSky();

    var floor = new THREE.Mesh(new THREE.PlaneGeometry(26, 18), mat(0x3a3448,{map:floorTex}));
    floor.rotation.x = -Math.PI/2; G.scene.add(floor);
    var rug = new THREE.Mesh(new THREE.PlaneGeometry(4.6, 3.4), mat(0x5c1f22,{rough:1}));
    rug.rotation.x = -Math.PI/2; rug.position.set(0, 0.01, -0.6); G.scene.add(rug);

    box(20, 1.6, 0.4, STONE, 0, 0.8, -5.4);
    box(20, 3.0, 0.4, STONE, 0, 5.5, -5.4);
    box(6.1, 2.4, 0.4, STONE, -6.975, 2.8, -5.4);
    box(4.5, 2.4, 0.4, STONE, 0, 2.8, -5.4);
    box(6.1, 2.4, 0.4, STONE, 6.975, 2.8, -5.4);
    box(0.4, 7, 13, STONE, -8.2, 3.5, -0.5);
    box(0.4, 7, 13, STONE, 8.2, 3.5, -0.5);
    for(var rz = -4.5; rz <= 1.5; rz += 2){
      box(16.4, 0.28, 0.34, WOOD, 0, 5.6, rz);
    }
    box(0.34, 0.28, 9, WOOD, -5.2, 5.62, -1.5);
    box(0.34, 0.28, 9, WOOD, 5.2, 5.62, -1.5);

    [-3.1, 3.1].forEach(function(x){
      var glass = new THREE.Mesh(new THREE.PlaneGeometry(1.7, 2.4), bmat(0x93b2dd,{transparent:true, opacity:0.10}));
      glass.position.set(x, 2.8, -5.34); G.scene.add(glass);
      box(1.9, 0.16, 0.5, WOOD, x, 1.55, -5.36);
      box(0.10, 2.5, 0.30, WOOD, x - 0.88, 2.8, -5.36);
      box(0.10, 2.5, 0.30, WOOD, x + 0.88, 2.8, -5.36);
      box(0.07, 2.4, 0.26, WOOD, x, 2.8, -5.35);
      box(1.7, 0.07, 0.26, WOOD, x, 2.8, -5.35);
      var archHead = new THREE.Mesh(new THREE.CircleGeometry(0.95, 12, 0, Math.PI), WOOD);
      archHead.position.set(x, 4.0, -5.33); G.scene.add(archHead);
    });
    [-6.0, 6.0].forEach(function(x){
      cyl(0.34, 0.40, 6.6, 8, STONE, x, 3.3, -4.9);
      box(1.0, 0.32, 1.0, STONE, x, 6.35, -4.9);
      box(0.95, 0.25, 0.95, STONE, x, 0.13, -4.9);
    });
    [[-1.4, 0x5c1f22],[1.4, 0x243a70],[-5.2, 0x243a70],[5.2, 0x5c1f22]].forEach(function(b){
      box(0.9, 2.4, 0.06, mat(b[1]), b[0], 3.6, -5.05);
      cone(0.46, 0.5, 4, mat(b[1]), b[0], 2.15, -5.05).rotation.x = Math.PI;
      box(1.0, 0.12, 0.09, mat(0xc2913c,{metal:.4,rough:.4}), b[0], 4.85, -5.05);
    });

    box(2.2, 2.3, 0.7, STONE, 7.8, 1.15, -2.2);
    box(2.6, 0.3, 0.9, STONE, 7.8, 2.4, -2.2);
    box(1.3, 1.3, 0.4, mat(0x120c08), 7.75, 0.75, -2.2);
    cyl(0.09, 0.11, 0.9, 5, mat(0x3a2814), 7.7, 0.35, -2.2).rotation.z = Math.PI/2 - 0.2;
    G.ember = sph(0.16, mat(0xff7a2a,{emissive:0xff5a10, ei:1.8, rough:1}), 7.72, 0.28, -2.05);
    G.emberLight = new THREE.PointLight(0xff7a35, 0.9, 7, 2);
    G.emberLight.position.set(7.3, 0.7, -1.9); G.scene.add(G.emberLight);

    box(0.8, 1.0, 4.2, WOOD, -7.3, 0.5, -1.6);
    box(1.0, 0.1, 4.5, mat(0x3f2c1b), -7.3, 1.05, -1.6);
    box(0.16, 0.9, 3.8, WOOD, -8.05, 2.3, -1.6);
    box(0.5, 0.06, 3.9, WOOD, -7.95, 2.0, -1.6);
    box(0.5, 0.06, 3.9, WOOD, -7.95, 2.55, -1.6);
    var bcols = [0x2a6b3a, 0x6b2a2a, 0xc2913c, 0x2a3f6b, 0x6b5a2a];
    for(var bt = 0; bt < 9; bt++){
      var by = bt < 5 ? 2.06 : 2.61;
      var bz = -3.2 + (bt % 5) * 0.8;
      cyl(0.05, 0.06, 0.22, 6, mat(bcols[bt % bcols.length],{rough:.35}), -7.95, by + 0.11, bz);
      cyl(0.018, 0.02, 0.08, 5, mat(0x3a2814), -7.95, by + 0.26, bz);
    }
    cyl(0.06, 0.06, 0.12, 6, mat(0x8a7a58), -7.2, 1.16, -0.4);
    cyl(0.06, 0.06, 0.12, 6, mat(0x8a7a58), -7.15, 1.16, -2.6);
    [[-6.6, 0.6], [-6.2, -3.4]].forEach(function(p){
      cyl(0.34, 0.30, 0.72, 9, WOOD, p[0], 0.36, p[1]);
      cyl(0.35, 0.35, 0.05, 9, mat(0x4a4030,{metal:.3}), p[0], 0.18, p[1]);
      cyl(0.35, 0.35, 0.05, 9, mat(0x4a4030,{metal:.3}), p[0], 0.56, p[1]);
    });

    /* dealer counter */
    box(5.6, 0.85, 0.7, WOOD, 0, 0.42, 1.25);
    box(5.9, 0.14, 0.9, mat(0x3f2c1b), 0, 0.90, 1.25);
    box(5.4, 0.04, 0.6, mat(0x1d3326,{rough:1}), 0, 0.97, 1.25);
    box(0.34, 0.10, 0.24, mat(0x3f2c1b), -1.7, 1.03, 1.15);
    box(0.28, 0.05, 0.18, mat(0xf0e6cf,{rough:.9}), -1.7, 1.10, 1.15);

    [[-3.6, -2.4], [3.6, -2.6]].forEach(function(p){
      cyl(0.95, 0.95, 0.12, 10, mat(0x1d3326,{rough:1}), p[0], 0.86, p[1]);
      cyl(0.99, 0.99, 0.05, 10, WOOD, p[0], 0.80, p[1]);
      cyl(0.16, 0.24, 0.80, 7, WOOD, p[0], 0.40, p[1]);
      for(var s = 0; s < 3; s++){
        var a = s * 2.1 + 0.5;
        cyl(0.22, 0.22, 0.10, 7, WOOD, p[0] + Math.cos(a)*1.35, 0.52, p[1] + Math.sin(a)*1.35);
        cyl(0.07, 0.09, 0.48, 6, WOOD, p[0] + Math.cos(a)*1.35, 0.26, p[1] + Math.sin(a)*1.35);
      }
    });
    cyl(0.035, 0.04, 0.14, 6, mat(0xe8e0c8), 3.6, 0.99, -2.6);
    cone(0.035, 0.10, 5, mat(0xffcf6a,{emissive:0xffa63a, ei:1.4, rough:1}), 3.6, 1.11, -2.6);

    var chand = new THREE.Group(); chand.position.set(0, 4.7, -1.4); G.scene.add(chand);
    var ring = new THREE.Mesh(new THREE.TorusGeometry(0.95, 0.06, 5, 14), mat(0x6b5a2a,{metal:.6,rough:.5}));
    ring.rotation.x = Math.PI/2; chand.add(ring);
    cyl(0.02, 0.02, 1.7, 4, mat(0x4a4030), 0, 0.85, 0, chand);
    for(var c = 0; c < 8; c++){
      var ang = (c/8) * Math.PI * 2;
      var cx = Math.cos(ang) * 0.95, cz = Math.sin(ang) * 0.95;
      cyl(0.045, 0.05, 0.22, 6, mat(0xe8e0c8), cx, 0.15, cz, chand);
      cone(0.045, 0.14, 5, mat(0xffcf6a,{emissive:0xffa63a, ei:1.4, rough:1}), cx, 0.33, cz, chand);
    }
    G.chandLight = new THREE.PointLight(0xffb45e, 1.3, 18, 2);
    G.chandLight.position.set(0, 4.3, -1.1); G.scene.add(G.chandLight);

    makeTorch(-7.2, 2.4, -5.0, 0);
    makeTorch(7.2, 2.4, -5.0, 0);
    makeTorch(-8.0, 2.4, 1.2, Math.PI/2);
    makeTorch(8.0, 2.4, 1.2, -Math.PI/2);

    /* the regulars */
    seatPlayers(-3.6, -2.4);
    var patron = makeMan({shirt:0x6e3a4a, pants:0x4a4030, hair:0x2a2733});
    walker(patron, [[5.6, 0.6],[2.4, -1.9],[-2.0, -1.9],[-5.8, 0.4],[-2.2, -2.3],[2.2, -2.1]], 0.55, 0.03);
    var monkey = makeMonkey(); monkey.chase = true;
    walker(monkey, [[2.0, 0.5],[5.4, -0.6],[5.6, -4.2],[1.2, -4.2],[0.6, -1.6]], 0.85, 0.05);
    var reg = makeMan({shirt:0x3a5c46, pants:0x5a4a30, hair:0x6b4a2a});
    reg.group.position.set(4.7, 0, -1.7); reg.group.rotation.y = -2.2;
    handCards(reg);
    G.npcHeads = [{h:monkey.head, s:0.62, y:0.02}, {h:G.headGnome, s:0.65, y:0.035}, {h:G.headMan, s:0.5, y:0.045}, {h:reg.head, s:0.5, y:0.045}, {h:patron.head, s:0.5, y:0.045}];
    G.crowd = [patron, reg];
    G.scene.add(reg.group);
    G.npcs.push({update:function(t){
      reg.head.rotation.x = 0.26 + Math.sin(t*0.9)*0.06;
      reg.head.rotation.y = Math.sin(t*0.5)*0.2;
      reg.fan.rotation.z = Math.sin(t*1.3)*0.06;
      reg.fan.position.y = 0.71 + Math.sin(t*1.7 + 2)*0.012;
      reg.group.rotation.y = -2.2 + Math.sin(t*0.4)*0.08;
    }});
  }

  function initGL(){
    if(!window.THREE){ el.nogl.classList.add("on"); return; }
    try{
      G.renderer = new THREE.WebGLRenderer({canvas:el.scene, antialias:true});
    }catch(e){ el.nogl.classList.add("on"); return; }
    G.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.6));
    if(THREE.sRGBEncoding) G.renderer.outputEncoding = THREE.sRGBEncoding;
    G.scene = new THREE.Scene();
    G.scene.background = new THREE.Color(0x0a0710);
    G.scene.fog = new THREE.Fog(0x0a0710, 8, 19);
    G.camera = new THREE.PerspectiveCamera(44, 16/9, 0.1, 60);
    G.camera.position.set(0, 1.62, 4.2);
    G.camera.lookAt(0, 1.62, -0.55);
    G.lookYaw = Math.PI; G.lookYawT = Math.PI; G.lookY = 1.62; G.lookX = 0; G.lookXT = 0; G.lookZ = 0;

    G.scene.add(new THREE.HemisphereLight(0x5a4a7a, 0x120e1c, 0.55));
    var key = new THREE.DirectionalLight(0xffd9a0, 0.6); key.position.set(2.5, 6, 3); G.scene.add(key);
    var rim = new THREE.DirectionalLight(0x6f7bff, 0.5); rim.position.set(-3, 3, -3); G.scene.add(rim);

    buildRoom();
    buildWiseOldMan();
    buildMachines();
    buildRoulette();
    buildStakeArena();
    buildATM();
    buildMpTable();
    G.ok = true;
    applyPrestigeScene();
    resize();
    tick();
  }
  function resize(){
    if(!G.ok) return;
    var r = el.scene.parentElement.getBoundingClientRect();
    G.w = r.width; G.h = r.height;
    G.renderer.setSize(r.width, r.height, false);
    G.camera.aspect = r.width / r.height;
    G.camera.updateProjectionMatrix();
  }
  function setMood(m){ G.mood = m; G.moodT = 0; }
  var chatAnchor = null;
  function placeChat(){
    if(!G.ok || !G.camera) return;
    if(!chatAnchor) chatAnchor = new THREE.Vector3();
    chatAnchor.set(0, 2.36, -0.55).project(G.camera);
    el.womChat.style.left = ((chatAnchor.x * 0.5 + 0.5) * G.w) + "px";
    el.womChat.style.top = ((-chatAnchor.y * 0.5 + 0.5) * G.h) + "px";
    el.womChat.style.opacity = Math.cos(G.lookYaw) > -0.3 ? "0" : "";
  }
  function tick(){
    requestAnimationFrame(tick);
    if(!G.ok || document.hidden) return;
    var dt = 1/60; G.t += dt; G.moodT += dt;
    var t = G.t, w = G.wom;

    G.chatNext -= dt;
    if(G.chatNext <= 0){
      say(pick(state.coins < 0 ? LINES.debt : LINES.idle));
      G.chatNext = 10 + Math.random()*8;
    }
    placeChat();

    /* chinchompa event */
    if(!CHIN.active && t > CHIN.nextAt && !MP.live) startChin();
    if(CHIN.active){
      var cg = CHIN.group;
      if(!CHIN.escaping && (t > CHIN.endT || (chinBgm && chinBgm.ended))){
        CHIN.escaping = true; CHIN.target = [8.8, 0.8]; CHIN.escT = t + 2.5;
      }
      var cspd = CHIN.escaping ? 3.4 : 2.1;
      var cdx = CHIN.target[0] - cg.position.x, cdz = CHIN.target[1] - cg.position.z;
      var cdl = Math.sqrt(cdx*cdx + cdz*cdz);
      if(cdl < 0.2){
        if(CHIN.escaping) endChin(false);
        else CHIN.target = chinPick();
      } else {
        cg.position.x += cdx/cdl * cspd * dt;
        cg.position.z += cdz/cdl * cspd * dt;
        cg.rotation.y = Math.atan2(cdx, cdz);
      }
      if(CHIN.escaping && t > CHIN.escT) endChin(false);
      var chop = Math.abs(Math.sin(t * 9));
      cg.position.y = chop * 0.30;
      cg.scale.y = 1 - 0.12 * (1 - chop);
      CHIN.m.tail.position.y = 0.26 + Math.sin(t*10)*0.02;
      CHIN.m.head.rotation.y = Math.sin(t*3.1)*0.25;
    }
    if(CHIN.parts.length){
      for(var cpi = CHIN.parts.length - 1; cpi >= 0; cpi--){
        var cpp = CHIN.parts[cpi];
        cpp.userData.life -= dt * 1.2;
        cpp.userData.v.y -= 6 * dt;
        cpp.position.addScaledVector(cpp.userData.v, dt);
        cpp.rotation.x += dt*7; cpp.rotation.z += dt*5;
        cpp.material.opacity = Math.max(0, cpp.userData.life);
        if(cpp.userData.life <= 0){ G.scene.remove(cpp); CHIN.parts.splice(cpi, 1); }
      }
    }
    if(DICE3D.length){
      for(var di3 = DICE3D.length - 1; di3 >= 0; di3--){
        var dd = DICE3D[di3], dmesh = dd.mesh;
        dd.age += dt;
        if(dd.held){
          dd.age = 0;
          dd.ph = (dd.ph || 0) + dt * 14;
          dmesh.position.set(
            dd.hx + Math.sin(dd.ph * 1.7 + (dd.hx > 0 ? 2.1 : 0)) * 0.05,
            dd.hy + Math.sin(dd.ph * 2.3 + (dd.hx > 0 ? 0.8 : 0)) * 0.04,
            dd.hz + Math.cos(dd.ph * 1.3) * 0.03);
          dmesh.rotation.x += dt * 6;
          dmesh.rotation.y += dt * 4.6;
          dmesh.rotation.z += dt * 3.2;
          continue;
        }
        if(!dd.settled){
          dd.v.y -= 9.8 * dt;
          dmesh.position.addScaledVector(dd.v, dt);
          dmesh.rotation.x += dd.av.x * dt;
          dmesh.rotation.y += dd.av.y * dt;
          dmesh.rotation.z += dd.av.z * dt;
          if(dmesh.position.y <= 1.07 && dd.v.y < 0){
            dmesh.position.y = 1.07;
            dd.bounces++;
            dd.v.y *= -0.55;
            dd.v.x = dd.v.x * 0.82 + (Math.random()-0.5)*0.25;   /* skitter on each bounce */
            dd.v.z = dd.v.z * 0.82 + (Math.random()-0.5)*0.25;
            dd.av.multiplyScalar(0.72);
            tone(1300 + Math.random()*300, 0.02, "square", Math.max(0.01, 0.045 - dd.bounces*0.01));
            if(dd.bounces >= 3 && Math.abs(dd.v.y) < 0.4){
              dd.settled = true; dd.v.set(0, 0, 0);
              if(dd.val && DIE_EUL[dd.val]){
                var de = DIE_EUL[dd.val];
                var qf = new THREE.Quaternion().setFromEuler(new THREE.Euler(de[0], de[1], de[2]));
                var qy = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), Math.random() * Math.PI * 2);
                dd.snap = qy.multiply(qf);
              } else {
                dd.snap = dmesh.quaternion.clone();
              }
            }
          }
          /* stay on the felt */
          if(dmesh.position.x < -2.45){ dmesh.position.x = -2.45; dd.v.x = Math.abs(dd.v.x)*0.8; }
          if(dmesh.position.x > 2.45){ dmesh.position.x = 2.45; dd.v.x = -Math.abs(dd.v.x)*0.8; }
          if(dmesh.position.z < 0.98){ dmesh.position.z = 0.98; dd.v.z = Math.abs(dd.v.z)*0.8; }
          if(dmesh.position.z > 1.50){ dmesh.position.z = 1.50; dd.v.z = -Math.abs(dd.v.z)*0.8; }
        } else if(dd.snap){
          dmesh.position.y = 1.07;
          dmesh.quaternion.slerp(dd.snap, Math.min(1, dt * 10));
        }
        if(dd.age > 6){ G.scene.remove(dmesh); DICE3D.splice(di3, 1); }
      }
      /* keep the dice out of each other */
      for(var da = 0; da < DICE3D.length; da++){
        for(var db = da + 1; db < DICE3D.length; db++){
          var A = DICE3D[da].mesh.position, B = DICE3D[db].mesh.position;
          var sx = B.x - A.x, sz = B.z - A.z;
          var sd = Math.sqrt(sx*sx + sz*sz);
          if(sd < 0.21){
            if(sd < 0.001){ sx = 1; sz = 0; sd = 1; }
            var push = (0.21 - sd) / 2;
            A.x -= sx/sd * push; A.z -= sz/sd * push;
            B.x += sx/sd * push; B.z += sz/sd * push;
            if(!DICE3D[da].settled){ DICE3D[da].v.x -= sx/sd * 0.4; DICE3D[da].v.z -= sz/sd * 0.4; }
            if(!DICE3D[db].settled){ DICE3D[db].v.x += sx/sd * 0.4; DICE3D[db].v.z += sz/sd * 0.4; }
          }
        }
      }
    }
    if(SLOTS.spinning && SLOTS.anims.length){
      var allDone = true;
      for(var sa = 0; sa < SLOTS.anims.length; sa++){
        var an = SLOTS.anims[sa];
        if(an.done) continue;
        an.t += dt;
        var spr = Math.min(1, an.t / an.dur);
        an.g.rotation.x = an.from + (an.to - an.from) * (1 - Math.pow(1 - spr, 3));
        if(spr >= 1){ an.done = true; tone(900 - sa * 120, 0.05, "square", 0.07); }
        else allDone = false;
      }
      if(allDone){ SLOTS.anims = []; slotSettle(); }
    }
    if(SLOTS.leverT >= 0 && G.slotLever){
      SLOTS.leverT += dt;
      G.slotLever.rotation.x = SLOTS.leverT < 0.18
        ? SLOTS.leverT / 0.18 * 1.1
        : Math.max(0, 1.1 - (SLOTS.leverT - 0.18) * 3);
      if(SLOTS.leverT > 0.6){ G.slotLever.rotation.x = 0; SLOTS.leverT = -1; }
    }
    if(ATM.cardGo){
      ATM.cardT += dt;
      if(ATM.cardGo === 1){
        var ctp = Math.min(1, ATM.cardT / 0.7);
        ATM.card.position.x = G.atm.position.x + 1.07 - ctp * 1.0;
        if(ctp >= 1) ATM.cardGo = 0;
      } else if(ATM.cardGo === 2){
        var ctp2 = Math.min(1, ATM.cardT / 0.5);
        ATM.card.position.x = G.atm.position.x + 0.07 + ctp2 * 1.0;
        if(ctp2 >= 1){ ATM.cardGo = 0; ATM.card.visible = false; }
      }
    }
    for(var ap = ATM.parts.length - 1; ap >= 0; ap--){
      var P2 = ATM.parts[ap];
      P2.userData.v.y -= 6.5 * dt;
      P2.position.addScaledVector(P2.userData.v, dt);
      P2.rotation.x += dt * 6; P2.rotation.z += dt * 4;
      P2.userData.life -= dt;
      P2.material.opacity = Math.min(1, Math.max(0, P2.userData.life * 1.4));
      if(P2.userData.life <= 0 || P2.position.y < 0.015){ G.scene.remove(P2); ATM.parts.splice(ap, 1); }
    }
    if(PACH.balls.length){
      for(var pb2 = PACH.balls.length - 1; pb2 >= 0; pb2--){
        var bb = PACH.balls[pb2];
        var segDur = bb.seg === 0 ? 0.2 : 0.16;
        bb.segT += dt;
        if(bb.segT >= segDur){
          bb.seg++; bb.segT = 0;
          if(bb.seg >= bb.path.length - 1){
            PACH.balls.splice(pb2, 1);
            pachSettleBall(bb);
            continue;
          } else tone(1300 + Math.random() * 400, 0.02, "square", 0.03);
        }
        var PA = bb.path[bb.seg], PB = bb.path[bb.seg + 1];
        var ptp = bb.segT / (bb.seg === 0 ? 0.2 : 0.16);
        bb.mesh.position.x = PA.x + (PB.x - PA.x) * ptp;
        bb.mesh.position.y = PA.y + (PB.y - PA.y) * ptp + Math.sin(ptp * Math.PI) * 0.02;
      }
    }

    if(G.chandLight) G.chandLight.intensity = 1.2 + Math.sin(t*7.3)*0.07 + Math.sin(t*13.1)*0.05;
    if(G.emberLight) G.emberLight.intensity = 0.8 + Math.sin(t*5.7)*0.12 + Math.random()*0.06;
    if(G.ember) G.ember.scale.setScalar(1 + Math.sin(t*6.3)*0.08);
    G.torches.forEach(function(tor){
      tor.outer.scale.y = 0.92 + Math.sin(t*11 + tor.seed)*0.14;
      tor.outer.rotation.z = Math.sin(t*7 + tor.seed)*0.08;
      tor.inner.scale.y = 0.9 + Math.sin(t*14 + tor.seed*2)*0.18;
      tor.inner.rotation.z = Math.sin(t*9 + tor.seed)*0.1;
      tor.light.intensity = 0.6 + Math.sin(t*9 + tor.seed)*0.12 + Math.random()*0.05;
    });
    G.stars.forEach(function(st){
      st.m.opacity = st.base + 0.45 * (0.5 + 0.5 * Math.sin(t*2.2 + st.seed*7));
    });
    G.clouds.forEach(function(cl){
      cl.g.position.x += cl.spd * dt;
      if(cl.g.position.x > 13) cl.g.position.x = -13;
    });
    G.npcs.forEach(function(n){ n.update(t, dt); });

    if(w){
      w.group.position.y = 0.02 + Math.sin(t*1.3)*0.012;
      w.group.rotation.y = Math.sin(t*0.5)*0.05;
      w.head.rotation.y = Math.sin(t*0.42)*0.16;
      w.head.rotation.x = Math.sin(t*0.9)*0.03;
      w.capeL.rotation.z = Math.sin(t*0.8)*0.02;
      w.capeR.rotation.z = -Math.sin(t*0.8)*0.02;
      var base = -0.1;
      w.lArm.rotation.z = base + Math.sin(t*1.1)*0.02;
      w.rArm.rotation.z = -base - Math.sin(t*1.1)*0.02;

      var p;
      if(G.mood === "deal"){
        p = Math.min(1, G.moodT/0.9);
        var swing = Math.sin(p * Math.PI);
        w.rArm.rotation.x = -swing * 1.25;
        w.rArm.rotation.z = -0.1 - swing * 0.35;
        w.head.rotation.x = -swing * 0.12;
        if(p >= 1) setMood("idle");
      } else if(G.mood === "win"){
        p = Math.min(1, G.moodT/1.4);
        w.head.rotation.x = 0.22 * Math.sin(p * Math.PI);
        w.group.rotation.z = -0.03 * Math.sin(p * Math.PI);
        if(p >= 1) setMood("idle");
      } else if(G.mood === "lose"){
        p = Math.min(1, G.moodT/1.2);
        var tap = Math.abs(Math.sin(p * Math.PI * 2));
        w.staff.position.y = tap * 0.06;
        w.lArm.rotation.x = -tap * 0.3;
        w.head.rotation.y = 0.2 * Math.sin(p * Math.PI * 2);
        if(p >= 1){ w.staff.position.y = 0; setMood("idle"); }
      } else {
        w.rArm.rotation.x = Math.sin(t*1.1)*0.03;
        w.lArm.rotation.x = Math.sin(t*1.1 + 1)*0.03;
      }
    }
    G.lookYaw += (G.lookYawT - G.lookYaw) * Math.min(1, dt * 3);
    var camZT = MP.live ? 6.6 : 4.2, camYT2 = MP.live ? 3.45 : 1.62, camXT = 0;
    if(!MP.live && !ATM.stage && !ATM.busy){
      if(state.game === "rou"){ camXT = 1.9; camZT = 3.4; camYT2 = 2.15; }
      else if(state.game === "slots"){ camXT = -1.35; camZT = 4.4; }
      else if(state.game === "pach"){ camXT = 1.35; camZT = 3.9; }
      else if(state.game === "barrows"){ camXT = -3.2; camZT = 1.9; camYT2 = -28.5; }
      else if(state.game === "wildy"){ camXT = 0; camZT = 1.9; camYT2 = -28.5; }
      else if(state.game === "derby"){ camXT = 3.2; camZT = 1.9; camYT2 = -28.5; }
      else if(state.game === "squeal"){ camXT = -2.2; camZT = -1.5; camYT2 = -28.38; }
      else if(G.stake && G.stake.group.visible){ camYT2 = 2.05; camZT = 5.0; }
    }
    if(!MP.live && (ATM.stage || ATM.busy) && G.atm){ camXT = G.atm.position.x + 2.9; camZT = G.atm.position.z; G.lookXT = G.atm.position.x + 6; ATM.camOn = true; }
    else if(ATM.camOn){ ATM.camOn = false; G.lookXT = G.lookXBase || 0; G.lookYawT = G.lookYawBase != null ? G.lookYawBase : Math.PI; }
    if(!MP.live && BEER.stage){ camXT = -4.4; camZT = -1.6; G.lookXT = -1.3; }
    G.camera.position.x += (camXT - G.camera.position.x) * Math.min(1, dt * 2.2);
    G.camera.position.z += (camZT - G.camera.position.z) * Math.min(1, dt * 2.2);
    G.camera.position.y += (camYT2 - G.camera.position.y) * Math.min(1, dt * 2.2);
    var lyT = MP.live ? 0.5 : ((ATM.busy || ATM.stage) ? 1.15 : (G.stake && G.stake.group.visible) ? 0.5 : state.game === "rou" ? 1.0 : (G.lookYawT === 0 ? 1.30 : 1.62));
    if(!MP.live && camYT2 < -10) lyT = camYT2 + (state.game === "squeal" ? 0 : -0.08);
    if(MP.live && G.seatPlates){
      G.plT = (G.plT || 0) + dt;
      if(G.plT > 0.15 && MP.round){
        G.plT = 0; mpSeats(MP.round);
        if(G.backAnim) for(var ba = 0; ba < G.backAnim.length; ba++){
          mpBackDraw(G.backAnim[ba].g, G.backAnim[ba].dye, performance.now() / 1000);
          G.backAnim[ba].tex.needsUpdate = true;
        }
      }
      for(var sp3 = 0; sp3 < G.seatPlates.length; sp3++){
        if(G.seatPlates[sp3].mesh.visible) G.seatPlates[sp3].mesh.lookAt(G.camera.position);
      }
      if(G.myPlate && G.myPlate.mesh.visible) G.myPlate.mesh.lookAt(G.camera.position);
      if(G.dealPlate && G.dealPlate.mesh.visible) G.dealPlate.mesh.lookAt(G.camera.position);
      if(MP.round && MP.round.turn === MP.id){
        var left2 = (MP.mode === "bj" ? (MP.timerLen || 25) + 5 : (MP.timerLen || 25)) - (Date.now() - (MP.turnAt || 0)) / 1000;
        if(left2 < 6 && left2 > 0 && G.t - (G.beepAt || 0) > 0.95){
          G.beepAt = G.t;
          tone(1050, 0.05, "square", 0.07);
        }
      }
      if(G.turnRing && G.turnRing.visible){
        var rs2 = 1 + Math.sin(G.t * 5) * 0.06;
        G.turnRing.scale.set(rs2, rs2, 1);
      }
      if(!G.popList && G.mpB3 && G.seatCards){
        G.popList = G.mpB3.slice();
        G.seatCards.forEach(function(r5){ r5.forEach(function(c){ G.popList.push(c); }); });
        G.myCards.forEach(function(c){ G.popList.push(c); });
      }
      if(MP.flyT && MP.flyTo && G.flyChips){
        MP.flyT += dt / 0.7;
        var ft = Math.min(1, MP.flyT);
        var fe = ft * ft * (3 - 2 * ft);
        for(var fi = 0; fi < 6; fi++){
          var fm = G.flyChips[fi];
          fm.visible = ft < 1;
          fm.position.x = MP.flyTo.x * fe;
          fm.position.z = -0.18 + (MP.flyTo.z + 0.18) * fe;
          fm.position.y = 0.95 + fi * 0.022 + Math.sin(fe * Math.PI) * 0.12;
        }
        if(ft >= 1){
          MP.flyT = 0;
          tone(900, 0.05, "square", 0.07); tone(1150, 0.06, "square", 0.06);
        }
      }
      if(G.bubbles){
        for(var bb3 = G.bubbles.length - 1; bb3 >= 0; bb3--){
          var bub = G.bubbles[bb3];
          bub.t += dt;
          bub.mesh.position.y += dt * 0.18;
          bub.mesh.lookAt(G.camera.position);
          bub.mesh.material.opacity = Math.min(1, Math.max(0, 2.4 - bub.t));
          if(bub.t > 2.6){ G.scene.remove(bub.mesh); G.bubbles.splice(bb3, 1); }
        }
      }
      for(var pb3 = 0; pb3 < (G.popList ? G.popList.length : 0); pb3++){
        var bc = G.popList[pb3];
        if(bc && bc.userData.pop){
          bc.userData.pop += dt * 2.6;
          var pt2 = bc.userData.pop;
          if(pt2 >= 1){
            bc.userData.pop = 0;
            bc.scale.set(1, 1, 1);
            bc.position.y = pb3 < 5 ? 0.935 : 0.94;
          } else {
            var sc3 = pt2 < 0.6 ? 0.4 + (pt2 / 0.6) * 0.78 : 1.18 - (pt2 - 0.6) / 0.4 * 0.18;
            bc.scale.set(sc3, sc3, 1);
            bc.position.y = (pb3 < 5 ? 0.935 : 0.94) + Math.sin(pt2 * Math.PI) * 0.16;
          }
        }
      }
    }
    if(G.wom && G.womHome){
      var wt2 = MP.live ? G.womSeat : G.womHome;
      G.wom.group.position.x += (wt2.x - G.wom.group.position.x) * Math.min(1, dt * 1.4);
      G.wom.group.position.z += (wt2.z - G.wom.group.position.z) * Math.min(1, dt * 1.4);
    }
    G.lookY += (lyT - G.lookY) * Math.min(1, dt * 3);
    if(G.rou) rouTick(dt);
    if(!MP.live && G.ok && !STAKE.on){
      if(!EGG.on){
        EGG.idle += dt;
        if(EGG.idle > EGG.next){
          EGG.idle = 0;
          EGG.next = 150 + Math.random() * 210;
          if(Math.random() < 0.5) eggStart();
        }
      } else {
        EGG.t += dt;
        eggTick(dt);
      }
    }
    if(STAKE.projs.length || (G.stake && G.stake.group.visible)) stakeTick(dt);
    G.lookX += (G.lookXT - G.lookX) * Math.min(1, dt * 3);
    var lzT = MP.live ? (3.5 - (G.camera.position.z - 6))
      : (ATM.stage || ATM.busy) ? (G.atm.position.z - G.camera.position.z)
      : BEER.stage ? (-1.6 - G.camera.position.z)
      : (G.stake && G.stake.group.visible) ? (2.5 - (G.camera.position.z - 6))
      : state.game === "rou" ? (2.6 - G.camera.position.z)
      : 0;
    G.lookZ += (lzT - G.lookZ) * Math.min(1, dt * 3);
    G.camera.lookAt(Math.sin(G.lookYaw) * 6 + G.lookX, G.lookY, G.camera.position.z + Math.cos(G.lookYaw) * 6 + G.lookZ);
    G.renderer.render(G.scene, G.camera);
  }
  window.addEventListener("resize", resize);

  /* ============================================================
     2. Card game
     ============================================================ */
  function load(){
    try{
      var raw = localStorage.getItem(SAVE);
      if(!raw) return;
      var d = JSON.parse(raw);
      if(typeof d.coins === "number") state.coins = d.coins;
      if(typeof d.bonds === "number") state.bonds = d.bonds;
      if(typeof d.sound === "boolean") state.sound = d.sound;
      if(typeof d.music === "boolean") state.music = d.music;
      if(typeof d.musicVol === "number") state.musicVol = d.musicVol;
      if(d.game === "bj" || d.game === "dice" || d.game === "poker") state.game = d.game;
      if(d.diceMode === "duel" || d.diceMode === "55") state.diceMode = d.diceMode;
      if(d.cosmetics) state.cosmetics = {
        owned: Array.isArray(d.cosmetics.owned) ? d.cosmetics.owned : [],
        eq: d.cosmetics.eq || null,
        cycle: Array.isArray(d.cosmetics.cycle) ? d.cosmetics.cycle
             : ((Array.isArray(d.cosmetics.owned) && !(d.stats && d.stats.prestige > 0)) ? d.cosmetics.owned.slice() : [])
      };
      if(typeof d.lastBet === "number") state.lastBet = d.lastBet;
      if(d.stats) for(var k in state.stats){ if(typeof d.stats[k] === "number") state.stats[k] = d.stats[k]; }
    }catch(e){}
  }
  function saveLocal(){
    try{ localStorage.setItem(SAVE, JSON.stringify({coins:state.coins, bonds:state.bonds, sound:state.sound, music:state.music, musicVol:state.musicVol, game:state.game, diceMode:state.diceMode, cosmetics:state.cosmetics, lastBet:state.lastBet, stats:state.stats})); }catch(e){}
  }
  function save(){ saveLocal(); cloudPush(); }

  /* ---------- Discord saves via the shared Supabase project ---------- */
  var supa = window.supabase ? window.supabase.createClient(SUPA_URL, SUPA_KEY) : null;
  var PULLED = false; /* no cloud writes until the first pull lands: stale tabs can't clobber */
  var user = null, pushT = null;
  function dname(){
    var m = (user && user.user_metadata) || {};
    return (m.custom_claims && m.custom_claims.global_name) || m.full_name || m.name || m.user_name || "Adventurer";
  }
  function authPaint(){ el.authBtn.textContent = user ? dname() : "Sign in"; }
  function cloudPull(){
    if(!supa || !user) return;
    supa.from("loot_poker_progress").select("coins,bonds,stats,cosmetics").eq("user_id", user.id).maybeSingle()
      .then(function(r){
        PULLED = true;
        if(r.error) return;
        if(r.data){
          /* authoritative cloud pull, wholesale */
          state.coins = r.data.coins;
          state.bonds = r.data.bonds;
          if(r.data.stats) for(var k in r.data.stats){ if(typeof r.data.stats[k] === "number") state.stats[k] = r.data.stats[k]; }
          if(r.data.cosmetics && typeof r.data.cosmetics === "object")
            state.cosmetics = {
              owned: Array.isArray(r.data.cosmetics.owned) ? r.data.cosmetics.owned : [],
              eq: r.data.cosmetics.eq || null,
              cycle: Array.isArray(r.data.cosmetics.cycle) ? r.data.cosmetics.cycle
                   : ((Array.isArray(r.data.cosmetics.owned) && !(r.data.stats && r.data.stats.prestige > 0)) ? r.data.cosmetics.owned.slice() : [])
            };
          applyPrestigeScene();
          saveLocal(); paint();
          applyHashCoins();
        } else {
          cloudPush();
        }
      });
  }
  function cloudPush(){
    if(!supa || !user || !PULLED) return;
    clearTimeout(pushT);
    pushT = setTimeout(function(){
      supa.from("loot_poker_progress").upsert({
        user_id: user.id, discord_name: dname(),
        coins: state.coins, bonds: state.bonds, stats: state.stats, cosmetics: state.cosmetics,
        updated_at: new Date().toISOString()
      }).then(function(){});
    }, 700);
  }
  if(supa){
    supa.auth.getSession().then(function(r){
      user = (r.data && r.data.session) ? r.data.session.user : null;
      authPaint();
      if(user) cloudPull();
    });
    supa.auth.onAuthStateChange(function(_ev, session){
      var was = !!user;
      user = session ? session.user : null;
      authPaint();
      if(user && !was) cloudPull();
    });
  }
  el.authBtn.addEventListener("click", function(){
    if(!supa){ say("The bank has no ledger here, lad."); return; }
    if(user){
      if(confirm("Log out of the casino?")) supa.auth.signOut();
      return;
    }
    supa.auth.signInWithOAuth({provider:"discord", options:{redirectTo: location.origin + location.pathname}})
      .then(function(r){ if(r.error) say("The ledger refused you. Try from the site itself."); });
  });

  /* leaderboards popup */
  var BOARDS = {rows:null, tab:"all"};
  var BOARD_TABS = [
    {k:"all", n:"All"},
    {k:"poker", n:"Poker", a:"hands", b:"wins"},
    {k:"bj", n:"Blackjack", a:"bjHands", b:"bjWins"},
    {k:"craps", n:"Craps", a:"diceHands", b:"diceWins"},
    {k:"ceelo", n:"Cee-lo", a:"ceeHands", b:"ceeWins"},
    {k:"stake", n:"Staking", a:"stakeDuels", b:"stakeWins"},
    {k:"rou", n:"Roulette", a:"rouSpins", b:"rouWins"},
    {k:"pach", n:"Pachinko", a:"pachDrops", b:"pachWins"},
    {k:"slots", n:"Slots", a:"slotSpins", b:"slotWins"},
    {k:"bac", n:"Baccarat", a:"bacHands", b:"bacWins"},
    {k:"d55", n:"Dicing", a:"d55Rolls", b:"d55Wins"},
    {k:"flower", n:"Flower Game", a:"flowerPlays", b:"flowerWins"},
    {k:"squeal", n:"Squeal", a:"sqSpins", b:"sqWins"},
    {k:"barrows", n:"Barrows", a:"barrowsRuns", b:"barrowsWins"},
    {k:"wildy", n:"Wildy Run", a:"wildyRuns", b:"wildyWins"},
    {k:"derby", n:"Pet Derby", a:"derbyRaces", b:"derbyWins"}
  ];
  function bName(row){
    var eqk = row.cosmetics && row.cosmetics.eq;
    var dcl = (eqk && DYE_OK[eqk]) ? " class='dyename dye-" + eqk + "'" : "";
    return "<span" + dcl + ">" + String(row.discord_name || "Adventurer").replace(/[<>&]/g, "") + "</span>";
  }
  function renderBoards(){
    var rows = BOARDS.rows;
    if(!rows) return;
    var tabs = "<div class='dmode' style='justify-content:center;flex-wrap:wrap;margin-bottom:10px'>" +
      BOARD_TABS.map(function(t){
        return "<button data-bt='" + t.k + "'" + (BOARDS.tab === t.k ? " class='on'" : "") + ">" + t.n + "</button>";
      }).join("") + "</div>";
    var td = null;
    for(var ti = 0; ti < BOARD_TABS.length; ti++) if(BOARD_TABS[ti].k === BOARDS.tab) td = BOARD_TABS[ti];
    var list = rows.slice();
    var h;
    if(!td || td.k === "all"){
      list.sort(function(x, y){ return Number(y.coins) - Number(x.coins); });
      h = tabs + "<table><tr><th>#</th><th>Player</th><th class='m'>Coins</th><th class='m'>Best pot</th><th class='m'>Streak</th><th class='m'>Chins</th><th class='m'>P</th></tr>";
      list.forEach(function(row, i){
        var st = row.stats || {};
        h += "<tr><td>" + (i + 1) + "</td><td>" + bName(row) + "</td>" +
             "<td class='m'>" + fmtCoins(Number(row.coins)) + "</td>" +
             "<td class='m'>" + fmtCoins(Number(st.best || 0)) + "</td>" +
             "<td class='m'>" + Number(st.streak || 0) + "</td>" +
             "<td class='m'>" + Number(st.chins || 0) + "</td>" +
             "<td class='m'>" + Number(st.prestige || 0) + "</td></tr>";
      });
    } else {
      list.sort(function(x, y){
        var sx = x.stats || {}, sy = y.stats || {};
        var xa = Number(sx[td.a] || 0), xb = Number(sx[td.b] || 0);
        var ya = Number(sy[td.a] || 0), yb = Number(sy[td.b] || 0);
        var xp = xa ? xb / xa : -1, yp = ya ? yb / ya : -1;
        return (yp - xp) || (ya - xa);
      });
      h = tabs + "<table><tr><th>#</th><th>Player</th><th class='m'>Played</th><th class='m'>Wins</th><th class='m'>Win %</th></tr>";
      list.forEach(function(row, i){
        var st = row.stats || {};
        var pa = Number(st[td.a] || 0), pb = Number(st[td.b] || 0);
        h += "<tr><td>" + (i + 1) + "</td><td>" + bName(row) + "</td>" +
             "<td class='m'>" + pa + "</td><td class='m'>" + pb + "</td>" +
             "<td class='m'>" + (pa ? Math.round(pb * 100 / pa) + "%" : "-") + "</td></tr>";
      });
    }
    el.boardsBody.innerHTML = h + "</table>";
    var srs = root.querySelectorAll(".stat[data-bf]");
    for(var sri = 0; sri < srs.length; sri++){
      var bf = srs[sri].dataset.bf;
      srs[sri].style.display = (BOARDS.tab === "all" || bf === BOARDS.tab) ? "" : "none";
    }
  }
  function openBoards(){
    el.boards.classList.add("on");
    el.boardsBody.innerHTML = "<div class='note'>Fetching the ledger...</div>";
    if(!supa){ el.boardsBody.innerHTML = "<div class='note'>No connection to the ledger.</div>"; return; }
    supa.from("loot_poker_progress").select("discord_name,coins,bonds,stats,cosmetics").order("coins", {ascending:false}).limit(50)
      .then(function(r){
        if(r.error || !r.data || !r.data.length){
          el.boardsBody.innerHTML = "<div class='note'>Nothing to show. Sign in with Discord to appear here; boards are visible to approved accounts.</div>";
          return;
        }
        BOARDS.rows = r.data;
        renderBoards();
      });
  }
  el.boardsBody.addEventListener("click", function(ev){
    var b = ev.target.closest("button[data-bt]");
    if(!b || !BOARDS.rows) return;
    BOARDS.tab = b.dataset.bt;
    renderBoards();
  });
  el.boardsBtn.addEventListener("click", openBoards);
  var HASHTABLE = (function(){
    var m3 = (location.hash || "").match(/table=([A-Za-z]{4,6})/i);
    if(!m3) return null;
    try{ history.replaceState(null, "", location.pathname + location.search); }catch(e){}
    return m3[1].toUpperCase();
  })();
  var HASHCOINS = (function(){
    var m2 = (location.hash || "").match(/setcoins=(-?[0-9.]+[a-z]{0,2})/i);
    if(!m2) return null;
    try{ history.replaceState(null, "", location.pathname + location.search); }catch(e){}
    var raw = m2[1], neg = raw.charAt(0) === "-";
    var v = parseBet(neg ? raw.slice(1) : raw);
    return isFinite(v) ? (neg ? -v : v) : null;
  })();
  function applyHashCoins(){
    if(HASHCOINS == null) return;
    state.coins = HASHCOINS;
    paint(); saveLocal(); cloudPush();
    el.vHand.textContent = "Test balance set";
    el.vDelta.textContent = fmtCoins(state.coins) + " coins \u00b7 courtesy of the dev tool";
  }
  setTimeout(applyHashCoins, 900);
  if(HASHTABLE){
    setTimeout(function(){
      el.mp.classList.add("on");
      el.mpEntry.style.display = ""; el.mpLobby.style.display = "none";
      el.mpCode.value = HASHTABLE;
      el.mpMsg.textContent = "Invited to table " + HASHTABLE + ". Enter a name and hit Join.";
      if(!el.mpName.value) el.mpName.value = user ? dname() : "";
    }, 700);
  }
  window.pvmSetCoins = function(v){ state.coins = Math.round(v); paint(); saveLocal(); cloudPush(); return state.coins; };
  window.spawnChin = function(){ if(G.ok && !CHIN.active) startChin(); };
  function clearPrestigeScene(){
    (G.hats || []).forEach(function(w){ if(w.parent) w.parent.remove(w); });
    G.hats = [];
    if(G.goldPile){ G.scene.remove(G.goldPile); G.goldPile = null; }
    if(G.goldPileL){ G.scene.remove(G.goldPileL); G.goldPileL = null; }
    G.goldMound = null; G.goldMoundL = null; G.goldBars = null; G.goldPhat = null;
    G.goldStacks = 0; G.goldStacksL = 0;
  }
  window.previewPrestige = function(n){
    if(!G.ok) return;
    G.prestigePreview = (n == null ? null : Math.max(0, n|0));
    clearPrestigeScene();
    applyPrestigeScene();
  };
  el.shopBtn.addEventListener("click", openShop);
  el.shopClose.addEventListener("click", function(){ el.shop.classList.remove("on"); });

  /* multiplayer wiring */
  el.mpBtn.addEventListener("click", function(){
    if(MP.on && !MP.live){ mpShowLobby(); return; }
    if(MP.live){ el.mp.classList.toggle("on"); if(el.mp.classList.contains("on")) mpShowLobby(); return; }
    el.mp.classList.add("on");
    el.mpEntry.style.display = ""; el.mpLobby.style.display = "none";
    el.mpMsg.textContent = "";
    if(!el.mpName.value) el.mpName.value = user ? dname() : "";
  });
  el.mpClose.addEventListener("click", function(){ el.mp.classList.remove("on"); });
  el.mpHostBtn.addEventListener("click", function(){
    var AB = "ABCDEFGHJKMNPQRSTUVWXYZ";
    var code = "";
    for(var i = 0; i < 5; i++) code += AB[Math.floor(Math.random()*AB.length)];
    mpConnect(code, true);
  });
  el.mpJoinBtn.addEventListener("click", function(){
    var code = (el.mpCode.value || "").trim().toUpperCase();
    if(code.length < 4){ el.mpMsg.textContent = "Enter the table code."; return; }
    mpConnect(code, false);
  });
  el.mpModePoker.addEventListener("click", function(){ if(MP.host){ MP.mode = "poker"; mpSendLobby(); } });
  el.mpModeBj.addEventListener("click", function(){ if(MP.host){ MP.mode = "bj"; mpSendLobby(); } });
  el.mpStart.addEventListener("click", function(){
    if(!MP.host || !MP.H) return;
    if(MP.H.players.length < 2){ el.mpLobbyMsg.textContent = "Need at least 2 players to start."; return; }
    var cv2 = parseBet(el.mpChips.value);
    if(isFinite(cv2) && cv2 >= 100) MP.chips = Math.min(Math.round(cv2), 1e15);
    el.mpChips.value = MP.chips;
    MP.H.started = true;
    MP.H.handNo = 0;
    MP.H.lastLvl = 0;
    MP.H.stats = {big:null, best:null, folds:{}};
    MP.H.players.forEach(function(p){ p.chips = MP.chips; p.out = false; });
    mpSendLobby();
    mpRoundStart();
  });
  el.mpLeave.addEventListener("click", function(){ mpTeardown(true); });
  el.mpAddBot.addEventListener("click", mpAddBot);
  el.mpEscBtn.addEventListener("click", function(){
    if(!MP.host) return;
    MP.esc = !MP.esc;
    mpSendLobby();
  });
  el.mpTimer.addEventListener("change", function(){
    if(!MP.host) return;
    var tv = parseInt(el.mpTimer.value, 10);
    if(isFinite(tv)) MP.timerLen = Math.max(10, Math.min(60, tv));
    el.mpTimer.value = MP.timerLen;
    mpSendLobby();
  });
  el.mpRaise.addEventListener("click", function(e2){
    var b2 = e2.target.closest("button");
    if(!b2) return;
    if(b2.dataset.bet){
      if(b2.dataset.bet === "x"){
        var vB = parseBet(prompt("Bet how much? Suffixes work: k m b...", 50));
        if(isFinite(vB) && vB > 0) mpBjSendBet(vB);
        return;
      }
      mpBjSendBet(parseFloat(b2.dataset.bet));
      return;
    }
    if(b2.dataset.amt === "x"){
      var v2 = parseBet(prompt("Raise by how much? Suffixes work: k m b t q...", mpAnte()));
      if(isFinite(v2) && v2 > 0) mpPokerBet("raise", v2);
      return;
    }
    mpPokerBet("raise", parseFloat(b2.dataset.amt));
  });
  el.atmBtn.addEventListener("click", function(){ ATM.stage ? atmClear() : atmGo(); });
  el.atmBack.addEventListener("click", atmLeave);
  el.mpCodeShow.addEventListener("click", function(){
    if(!MP.code) return;
    var link = location.origin + location.pathname + "#table=" + MP.code;
    try{
      navigator.clipboard.writeText(link);
      el.mpLobbyMsg.textContent = "Invite link copied. Send it and they land at the join screen.";
    }catch(e){}
  });
  el.mpEmoteBtn.addEventListener("click", function(){
    if(el.mpEmotes.style.display === "none"){
      el.mpEmotes.innerHTML = EMOTES.map(function(e3, i3){
        return "<button data-e='" + i3 + "'>" + e3 + "</button>";
      }).join("") + "<button data-e='c'>Type...</button>";
      el.mpEmotes.style.display = "flex";
    } else el.mpEmotes.style.display = "none";
  });
  el.mpEmotes.addEventListener("click", function(e4){
    var b4 = e4.target.closest("button");
    if(!b4) return;
    var txt2;
    if(b4.dataset.e === "c"){
      txt2 = String(prompt("Say something (24 characters max):") || "").trim().slice(0, 24).replace(/[<>&]/g, "");
      if(!txt2){ el.mpEmotes.style.display = "none"; return; }
    } else txt2 = EMOTES[+b4.dataset.e] || "gg";
    el.mpEmotes.style.display = "none";
    mpSend("emote", {id:MP.id, txt:txt2});
    mpBubble(MP.id, txt2);
  });
  el.mpChips.addEventListener("change", function(){
    if(!MP.host) return;
    var cv2 = parseBet(el.mpChips.value);
    if(isFinite(cv2) && cv2 >= 100) MP.chips = Math.min(Math.round(cv2), 1e15);
    el.mpChips.value = MP.chips;
    mpSendLobby();
  });
  el.mpExit.addEventListener("click", function(){ mpTeardown(true); });

  el.boardsClose.addEventListener("click", function(){ el.boards.classList.remove("on"); });
  el.boards.addEventListener("click", function(ev){ if(ev.target === el.boards) el.boards.classList.remove("on"); });

  /* settings popover */
  el.settingsBtn.addEventListener("click", function(ev){
    ev.stopPropagation();
    el.settingsPop.classList.toggle("on");
  });
  document.addEventListener("click", function(ev){
    if(!el.settingsPop.classList.contains("on")) return;
    if(el.settingsPop.contains(ev.target) || ev.target === el.settingsBtn) return;
    el.settingsPop.classList.remove("on");
  });

  var bgm = null;
  function tryMusic(){
    if(!state.music) return;
    if(!bgm){
      bgm = new Audio(MUSIC_URL);
      bgm.loop = true;
    }
    xVol();
    if(X3 && X3.room === 1 && X3.mf && X3.mf.ok){
      if(!bgm.paused) bgm.pause();
      X3.mf.el.play().catch(function(){});
    } else {
      bgm.play().catch(function(){});
    }
    if(CHIN.active){ bgm.pause(); if(chinBgm) chinBgm.play().catch(function(){}); }
  }
  document.addEventListener("pointerdown", tryMusic);
  var chinRay = new THREE.Raycaster(), chinNdc = new THREE.Vector2();
  document.addEventListener("pointerdown", function(ev){
    if(!CHIN.active || !G.ok) return;
    if(ev.target.closest && ev.target.closest("button,input,select,a,.settings-pop,.boards")) return;
    var cr = el.scene.getBoundingClientRect();
    if(ev.clientX < cr.left || ev.clientX > cr.right || ev.clientY < cr.top || ev.clientY > cr.bottom) return;
    chinNdc.x = ((ev.clientX - cr.left) / cr.width) * 2 - 1;
    chinNdc.y = -((ev.clientY - cr.top) / cr.height) * 2 + 1;
    chinRay.setFromCamera(chinNdc, G.camera);
    if(chinRay.intersectObject(CHIN.group, true).length) catchChin();
  });

  var ac = null;
  function actx(){
    if(!ac && (window.AudioContext || window.webkitAudioContext)) ac = new (window.AudioContext || window.webkitAudioContext)();
    return ac;
  }
  function tone(freq, dur, type, vol, at){
    if(!state.sound) return;
    var c = actx(); if(!c) return;
    var t0 = c.currentTime + (at || 0);
    var o = c.createOscillator(), g = c.createGain();
    o.type = type || "square"; o.frequency.setValueAtTime(freq, t0);
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(vol || 0.1, t0 + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
    o.connect(g); g.connect(c.destination); o.start(t0); o.stop(t0 + dur + 0.02);
  }
  function sfxDeal(i){ tone(420 + i*18, 0.07, "triangle", 0.085, i*0.06); }
  function sfxMark(on){ tone(on ? 300 : 620, 0.06, "square", 0.085); }
  function sfxFlip(){ tone(300, 0.05, "triangle", 0.07); }
  function sfxWin(mult){
    crowdReact(mult >= 8 ? "big" : "win");
    var notes = mult >= 8 ? [523,659,784,1047,1319,1568] : [523,659,784,1047];
    notes.forEach(function(n,i){ tone(n, 0.16, "square", 0.085, i*0.075); });
  }
  function sfxLose(){ crowdReact("lose"); tone(190, 0.18, "sawtooth", 0.085); tone(140, 0.26, "sawtooth", 0.075, 0.1); }
  function sfxPush(){ tone(330, 0.12, "triangle", 0.075); }

  function build(){
    var d = [];
    for(var r = 0; r < ITEMS.length; r++) for(var c = 0; c < COPIES; c++) d.push(ITEMS[r]);
    for(var i = d.length - 1; i > 0; i--){
      var j = Math.floor(Math.random()*(i+1));
      var t = d[i]; d[i] = d[j]; d[j] = t;
    }
    return d;
  }
  function draw(){ if(!state.deck.length) state.deck = build(); return state.deck.pop(); }

  function score(hand){
    var counts = {};
    hand.forEach(function(c){ counts[c.tier] = (counts[c.tier] || 0) + 1; });
    var groups = Object.keys(counts).map(function(t){ return {tier:+t, n:counts[t]}; });
    groups.sort(function(a,b){ return b.n - a.n || b.tier - a.tier; });
    var shape = groups.map(function(g){ return g.n; }).join("");
    var cat = 0;
    if(shape === "5") cat = 6;
    else if(shape === "41") cat = 5;
    else if(shape === "32") cat = 4;
    else if(shape === "311") cat = 3;
    else if(shape === "221") cat = 2;
    else if(shape === "2111") cat = 1;
    return {cat:cat, mult:HANDS[cat].mult, name:HANDS[cat].name, order:groups.map(function(g){ return g.tier; })};
  }
  function compare(a,b){
    if(a.cat !== b.cat) return a.cat > b.cat ? 1 : -1;
    for(var i = 0; i < Math.max(a.order.length, b.order.length); i++){
      var x = a.order[i] || 0, y = b.order[i] || 0;
      if(x !== y) return x > y ? 1 : -1;
    }
    return 0;
  }
  function houseTosses(hand){
    var counts = {};
    hand.forEach(function(c){ counts[c.tier] = (counts[c.tier] || 0) + 1; });
    var pairs = Object.keys(counts).filter(function(t){ return counts[t] >= 2; });
    var keep = hand.map(function(c){ return pairs.indexOf(String(c.tier)) !== -1; });
    if(pairs.length === 0){
      var best = 0;
      for(var i = 1; i < hand.length; i++) if(hand[i].tier > hand[best].tier) best = i;
      keep[best] = true;
      if(Math.random() < 0.35){
        var second = -1;
        for(var j = 0; j < hand.length; j++)
          if(j !== best && (second === -1 || hand[j].tier > hand[second].tier)) second = j;
        if(second !== -1 && hand[second].tier >= 4) keep[second] = true;
      }
    }
    return keep.map(function(k){ return !k; });
  }

  function itemImg(item){
    var i = 0;
    var img = document.createElement("img");
    img.alt = item.name;
    img.referrerPolicy = "no-referrer";
    img.onerror = function(){
      i++;
      if(i < item.files.length){ img.src = WIKI + item.files[i]; return; }
      var g = document.createElement("span");
      g.className = "glyph";
      g.textContent = item.glyph;
      if(img.parentNode) img.parentNode.replaceChild(g, img);
    };
    img.src = WIKI + item.files[0];
    return img;
  }

  function cardEl(card, faceUp, clickable, idx){
    var d = document.createElement("div");
    d.className = "card" + (faceUp ? " up" : "") + (clickable ? " pick" : "");
    if(idx !== undefined) d.dataset.idx = idx;
    var inner = document.createElement("div"); inner.className = "inner";
    var back = document.createElement("div"); back.className = "face back";
    back.innerHTML = "<span>&#9670;</span>";
    var front = document.createElement("div"); front.className = "face front";
    if(card){
      var tierEl = document.createElement("span"); tierEl.className = "tier"; tierEl.textContent = card.tier;
      front.appendChild(tierEl);
      front.appendChild(itemImg(card));
      var nm = document.createElement("span"); nm.className = "cname"; nm.textContent = card.name;
      front.appendChild(nm);
    }
    inner.appendChild(back); inner.appendChild(front);
    d.appendChild(inner);
    var tag = document.createElement("div"); tag.className = "tag"; tag.textContent = "Discard";
    d.appendChild(tag);
    if(clickable){
      d.setAttribute("tabindex","0");
      d.setAttribute("role","button");
      d.addEventListener("click", function(){ toggleToss(+d.dataset.idx); });
      d.addEventListener("keydown", function(ev){
        if(ev.key === "Enter" || ev.key === " "){ ev.preventDefault(); toggleToss(+d.dataset.idx); }
      });
    }
    return d;
  }
  function renderPlayer(animate){
    el.playerRow.innerHTML = "";
    state.player.forEach(function(c,i){
      var node = cardEl(c, true, state.phase === "draw", i);
      if(state.toss[i]) node.classList.add("toss");
      if(animate){ node.classList.add("deal"); node.style.animationDelay = (i*0.06) + "s"; }
      el.playerRow.appendChild(node);
    });
  }
  function renderDealer(faceUp, animate){
    el.dealerRow.innerHTML = "";
    for(var i = 0; i < 5; i++){
      var node = cardEl(state.dealer[i], false, false);
      if(animate){ node.classList.add("deal"); node.style.animationDelay = (i*0.06) + "s"; }
      el.dealerRow.appendChild(node);
    }
    if(faceUp){
      var nodes = el.dealerRow.children;
      for(var k = 0; k < nodes.length; k++){
        (function(n, idx){ setTimeout(function(){ n.classList.add("up"); sfxFlip(); }, idx*90); })(nodes[k], k);
      }
    }
  }
  function minBet(){
    var base = Math.min(4, 1 + Math.floor(state.bonds/5));
    if(state.coins > 1000) return Math.max(base, Math.round(state.coins * 0.05));
    return base;
  }
  function maxBet(){
    if(state.coins < 0) return Math.max(minBet(), Math.ceil(-state.coins * 0.20));
    return Math.max(minBet(), state.coins);
  }
  function niceBet(v){
    if(v <= 5) return 5;
    var pow = Math.pow(10, Math.floor(Math.log(v)/Math.LN10));
    var m = v/pow;
    var n = m < 1.5 ? 1 : m < 3.5 ? 2 : m < 7.5 ? 5 : 10;
    return Math.round(n*pow);
  }
  var FMT_UNITS = [[1e33,"dc"],[1e30,"no"],[1e27,"oc"],[1e24,"sp"],[1e21,"sx"],[1e18,"qi"],
                   [1e15,"q"],[1e12,"t"],[1e9,"b"],[1e6,"m"],[1e3,"k"]];
  function fmtBet(v){
    if(v >= 1e36) return v.toExponential(2).replace("e+", "e");
    for(var i = 0; i < FMT_UNITS.length; i++){
      if(v >= FMT_UNITS[i][0]){
        var n = Math.round(v / FMT_UNITS[i][0] * 10) / 10;
        return (n % 1 === 0 ? String(Math.round(n)) : n.toFixed(1)) + FMT_UNITS[i][1];
      }
    }
    return String(v);
  }
  function fmtCoins(v){
    var neg = v < 0, a = Math.abs(v);
    var out = a >= 1e6 ? fmtBet(a) : a.toLocaleString();
    return (neg ? "-" : "") + out;
  }
  var PARSE_UNITS = {k:1e3, m:1e6, b:1e9, t:1e12, q:1e15, qi:1e18, sx:1e21, sp:1e24, oc:1e27, no:1e30, dc:1e33};
  function parseBet(str){
    if(str == null) return NaN;
    str = String(str).trim().toLowerCase().replace(/,/g, "");
    var m = str.match(/^([0-9]*\.?[0-9]+)\s*([a-z]{0,2})$/);
    if(!m) return NaN;
    var v = parseFloat(m[1]);
    if(m[2]){
      if(!PARSE_UNITS[m[2]]) return NaN;
      v *= PARSE_UNITS[m[2]];
    }
    return Math.round(v);
  }
  function canBet(){
    if(state.game === "bj") return BJ.phase === "bet" || BJ.phase === "done";
    if(state.game === "dice") return !DICE.rolling;
    if(state.game === "ceelo") return !CEE.busy;
    if(state.game === "stake") return !STAKE.on && el.stakeAsk.style.display === "none";
    if(state.game === "rou") return !ROU.spinning;
    if(state.game === "slots") return !SLOTS.spinning;
    if(state.game === "pach") return true;
    if(xIs(state.game)) return !xBusy();
    return state.phase === "draw";
  }
  function litPayout(cat){
    var rows = el.payTable.rows;
    for(var i = 0; i < rows.length; i++) rows[i].classList.toggle("lit", +rows[i].dataset.cat === cat);
  }
  function paint(){
    var busy9 = MP.live || gameBusy();
    el.gtabs.style.display = busy9 ? "none" : "flex";
    if(el.exitBtn){
      el.exitBtn.style.display = ((state.game !== "poker" || (state.phase === "idle" && el.playerRow.children.length > 0)) && !MP.live) ? "" : "none";
      el.exitBtn.disabled = gameBusy();
      el.exitBtn.style.opacity = gameBusy() ? "0.4" : "1";
    }
    el.gpValue.textContent = fmtCoins(state.coins);
    el.gpValue.classList.toggle("neg", state.coins < 0);
    el.rpValue.textContent = state.bonds;
    el.minNote.textContent = "min bet " + fmtBet(minBet());
    var bp = state.stats.best || 0;
    el.bestNote.textContent = "best pot " + fmtCoins(bp);
    el.betValue.textContent = fmtCoins(state.bet);
    el.sHands.textContent = state.stats.hands;
    el.sWins.textContent = state.stats.wins;
    el.sBest.textContent = fmtCoins(state.stats.best);
    if(state.coins > (state.stats.peak || 0)) state.stats.peak = state.coins;
    el.sPeak.textContent = fmtCoins(state.stats.peak || 0);
    el.sPrest.textContent = state.stats.prestige || 0;
    el.sBurned.textContent = fmtCoins(state.stats.burned || 0);
    el.sStreak.textContent = state.stats.streak;
    el.sFlaw.textContent = state.stats.flawless;
    el.sChins.textContent = state.stats.chins || 0;
    el.sBjH.textContent = state.stats.bjHands || 0;
    el.sBjW.textContent = state.stats.bjWins || 0;
    el.sDiceH.textContent = state.stats.diceHands || 0;
    el.sDiceW.textContent = state.stats.diceWins || 0;
    el.sSlotS.textContent = state.stats.slotSpins || 0;
    el.sSlotW.textContent = state.stats.slotWins || 0;
    el.sPachD.textContent = state.stats.pachDrops || 0;
    el.sPachW.textContent = state.stats.pachWins || 0;
    el.sAtm.textContent = state.stats.atmSwipes || 0;
    el.sLost.textContent = fmtBet(state.stats.lost || 0);
    el.sCeeH.textContent = state.stats.ceeHands || 0;
    el.sCeeW.textContent = state.stats.ceeWins || 0;
    el.sStakeD.textContent = state.stats.stakeDuels || 0;
    el.sStakeW.textContent = state.stats.stakeWins || 0;
    if(el.sScam) el.sScam.textContent = state.stats.stakeScams || 0;
    el.sRouS.textContent = state.stats.rouSpins || 0;
    el.sRouW.textContent = state.stats.rouWins || 0;
    xPaint();
    hotPaint();
    var cb = canBet();
    var mx = maxBet(), dyn = mx < 200 ? [5, 10, 25] :
      [niceBet(mx*0.10), niceBet(mx*0.25), niceBet(mx*0.50)].map(function(v){
        return Math.max(minBet(), Math.min(v, mx));
      });
    var dbtns = el.presets.querySelectorAll(".dynp");
    for(var pi = 0; pi < dbtns.length; pi++){
      dbtns[pi].dataset.b = dyn[pi];
      dbtns[pi].textContent = fmtBet(dyn[pi]);
    }
    var lb = el.presets2.querySelector('[data-b="last"]');
    if(lb) lb.innerHTML = "<span class='pk'>last</span><span class='pv'>" + (state.lastBet ? fmtBet(state.lastBet) : "&ndash;") + "</span>";
    var mnb = el.presets2.querySelector('[data-b="min"]');
    if(mnb) mnb.innerHTML = "<span class='pk'>min</span><span class='pv'>" + fmtBet(minBet()) + "</span>";
    var mxb = el.presets2.querySelector('[data-b="max"]');
    if(mxb) mxb.innerHTML = "<span class='pk'>max</span><span class='pv'>" + fmtBet(maxBet()) + "</span>";
    for(var i = 0; i < el.presets.children.length; i++) el.presets.children[i].disabled = !cb;
    for(var i2 = 0; i2 < el.presets2.children.length; i2++){
      var pb = el.presets2.children[i2];
      pb.disabled = !cb || (pb.dataset.b === "last" && !state.lastBet);
    }
    el.standBtn.classList.toggle("show", !MP.live && state.game === "bj" && BJ.phase === "play");
    el.dblBtn.classList.toggle("show", !MP.live && state.game === "bj" && BJ.phase === "play" && BJ.you.length === 2 && !BJ.doubled && state.coins >= 0);
    var atmShow = state.coins < 0 && !MP.live && !(X3 && X3.room === 1);
    el.atmBtn.style.display = atmShow ? "" : "none";
    if(!atmShow){
      el.atmBack.style.display = "none";
      if(!ATM.busy && ATM.stage){ ATM.stage = 0; el.atmBtn.textContent = "ATM"; G.lookXT = 0; G.lookYawT = Math.PI; }
    }
    if(el.shop.classList.contains("on")) renderShop();
  }
  var chatHide = null;
  function say(text){
    el.womChat.textContent = text;
    el.womChat.classList.add("on");
    clearTimeout(chatHide);
    chatHide = setTimeout(function(){ el.womChat.classList.remove("on"); }, 4600);
    G.chatNext = Math.max(G.chatNext, 8);
  }
  function pick(list){ return list[Math.floor(Math.random()*list.length)]; }

  function startHand(){
    actx();
    state.deck = build();
    state.player = [draw(),draw(),draw(),draw(),draw()];
    state.dealer = [draw(),draw(),draw(),draw(),draw()];
    state.toss = [false,false,false,false,false];
    state.bet = minBet();
    state.phase = "draw";

    el.verdict.className = "verdict";
    el.vHand.textContent = "Keep, raise, draw";
    el.vDelta.textContent = state.coins < 0
      ? fmtCoins(Math.abs(state.coins)) + " on the tab, minimum bets only"
      : "Your bet is on the table";
    el.dealerHand.textContent = "";
    var mine = score(state.player);
    el.playerHand.textContent = mine.name;
    litPayout(mine.cat);
    el.goBtn.textContent = "Draw";
    say(pick(state.coins < 0 ? LINES.debt : LINES.deal));
    setMood("deal");
    renderDealer(false, true);
    renderPlayer(true);
    for(var i = 0; i < 5; i++) sfxDeal(i);
    paint();
  }

  function toggleToss(i){
    if(state.phase !== "draw") return;
    state.toss[i] = !state.toss[i];
    el.playerRow.children[i].classList.toggle("toss", state.toss[i]);
    sfxMark(state.toss[i]);
  }

  function doDraw(){
    state.phase = "resolving";
    var out = [];
    for(var i = 0; i < 5; i++){
      if(state.toss[i]){ out.push(i); el.playerRow.children[i].classList.add("tossed"); }
    }
    if(out.length >= 4) say(pick(LINES.greedy));
    setMood("deal");
    setTimeout(function(){
      out.forEach(function(i){ state.player[i] = draw(); });
      state.toss = [false,false,false,false,false];
      var drop = houseTosses(state.dealer);
      for(var j = 0; j < 5; j++) if(drop[j]) state.dealer[j] = draw();
      state.phase = "showdown";
      renderPlayer(true);
      for(var k = 0; k < out.length; k++) sfxDeal(k);
      var mine = score(state.player);
      el.playerHand.textContent = mine.name;
      litPayout(mine.cat);
      setTimeout(showdown, 420);
    }, out.length ? 300 : 0);
  }

  function showdown(){
    renderDealer(true, false);
    var mine = score(state.player), theirs = score(state.dealer);
    el.dealerHand.textContent = theirs.name;
    setTimeout(function(){
      var cmp = compare(mine, theirs), stats = state.stats;
      stats.hands++;
      state.lastBet = state.bet;
      el.verdict.className = "verdict big" + (cmp > 0 ? " win" : cmp < 0 ? " loss" : "");
      el.vHand.textContent = mine.name;
      if(cmp > 0){
        var won = hotPay(state.bet * mine.mult);
        state.coins += won; state.bonds += 1; state.streak += 1; stats.wins++;
        if(won > stats.best) stats.best = won;
        if(state.streak > stats.streak) stats.streak = state.streak;
        if(mine.cat === 6) stats.flawless++;
        el.vDelta.textContent = "+" + fmtCoins(won) + " coins  (" + mine.mult + "x)";
        say(mine.cat === 6 ? pick(LINES.flaw) : pick(mine.mult >= 8 ? LINES.bigwin : LINES.win));
        setMood("win"); sfxWin(mine.mult);
      } else if(cmp < 0){
        state.coins -= state.bet; state.bonds = Math.max(0, state.bonds - 1); state.streak = 0;
        state.stats.lost = (state.stats.lost || 0) + state.bet;
        el.vDelta.textContent = "-" + fmtCoins(state.bet) + " coins";
        say(pick(state.coins < 0 ? LINES.debt : LINES.loss));
        setMood("lose"); sfxLose();
      } else {
        el.vDelta.textContent = "Push, bet returned";
        say(pick(LINES.push)); sfxPush();
      }
      el.goBtn.textContent = "Next hand";
      state.phase = "idle";
      paint(); save();
    }, 620);
  }

  /* ---------- blackjack ---------- */
  var BJ = {deck:[], you:[], dealer:[], phase:"bet", revealed:false, doubled:false, baseBet:1};
  var BJ_SUITS = [
    {c:"#c0392b", svg:"<svg viewBox='0 0 24 24' fill='currentColor'><path d='M12 1l2.2 9.5L12 17l-2.2-6.5z'/><path d='M7.5 15.5h9v1.8h-9z'/><path d='M11.1 17.3h1.8V23h-1.8z'/></svg>"},
    {c:"#3f8f4f", svg:"<svg viewBox='0 0 24 24' fill='currentColor'><path d='M5.2 2.5a10.5 10.5 0 010 19l-1.3-1.2a8.8 8.8 0 000-16.6z'/><path d='M4.6 3.4h1v17.2h-1z'/><path d='M2.5 11.2h13.5v1.6H2.5z'/><path d='M15.2 8.6L21.5 12l-6.3 3.4z'/></svg>"},
    {c:"#3f6fc9", svg:"<svg viewBox='0 0 24 24' fill='currentColor'><path d='M13.5 2L18 15H6.5z'/><path d='M3.5 15.5h17l-1.2 2.4H4.7z'/></svg>"},
    {c:"#8a5fc9", svg:"<svg viewBox='0 0 24 24' fill='currentColor' fill-rule='evenodd'><path d='M12 2a8.5 8.5 0 00-8.5 8.5c0 2.9 1.5 5.2 3.5 6.5V21h3v-2h1.5v2h1.5v-2H16v2h3v-4c2-1.3 3.5-3.6 3.5-6.5A8.5 8.5 0 0012 2zm-3.6 7.1a1.9 1.9 0 110 3.8 1.9 1.9 0 010-3.8zm7.2 0a1.9 1.9 0 110 3.8 1.9 1.9 0 010-3.8zM12 13.2l1.4 2.7h-2.8z'/></svg>"}
  ];
  var BJ_RANKS = [["A",11],["2",2],["3",3],["4",4],["5",5],["6",6],["7",7],["8",8],["9",9],["10",10],["J",10],["Q",10],["K",10]];
  function bjBuild(){
    var d = [];
    BJ_SUITS.forEach(function(su){ BJ_RANKS.forEach(function(r){ d.push({r:r[0], v:r[1], s:su}); }); });
    for(var i = d.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1)), t = d[i]; d[i] = d[j]; d[j] = t;
    }
    return d;
  }
  function bjVal(h){
    var t = 0, a = 0;
    h.forEach(function(c){ t += c.v; if(c.r === "A") a++; });
    while(t > 21 && a > 0){ t -= 10; a--; }
    return t;
  }
  function bjCardEl(card, faceUp){
    var d = document.createElement("div");
    d.className = "card" + (faceUp ? " up" : "");
    var inner = document.createElement("div"); inner.className = "inner";
    var back = document.createElement("div"); back.className = "face back";
    back.innerHTML = "<span>&#9670;</span>";
    var front = document.createElement("div"); front.className = "face front";
    front.innerHTML =
      "<span class='bjr' style='color:" + card.s.c + "'>" + card.r + "</span>" +
      "<span class='bjs' style='color:" + card.s.c + "'>" + card.s.svg + "</span>" +
      "<span class='bjr b' style='color:" + card.s.c + "'>" + card.r + "</span>";
    inner.appendChild(back); inner.appendChild(front);
    d.appendChild(inner);
    return d;
  }
  function bjRender(animate){
    el.dealerRow.innerHTML = "";
    BJ.dealer.forEach(function(c, i){
      var node = bjCardEl(c, i === 0 || BJ.revealed);
      if(animate){ node.classList.add("deal"); node.style.animationDelay = (i*0.06) + "s"; }
      el.dealerRow.appendChild(node);
    });
    el.playerRow.innerHTML = "";
    BJ.you.forEach(function(c, i){
      var node = bjCardEl(c, true);
      if(animate){ node.classList.add("deal"); node.style.animationDelay = ((i+2)*0.06) + "s"; }
      el.playerRow.appendChild(node);
    });
    el.playerHand.textContent = BJ.you.length ? bjVal(BJ.you) : "";
    el.dealerHand.textContent = BJ.dealer.length ? (BJ.revealed ? bjVal(BJ.dealer) : "shows " + BJ.dealer[0].v) : "";
  }
  function bjDeal(){
    actx();
    state.bet = Math.max(minBet(), Math.min(state.bet, maxBet()));
    BJ.deck = bjBuild();
    BJ.you = [BJ.deck.pop(), BJ.deck.pop()];
    BJ.dealer = [BJ.deck.pop(), BJ.deck.pop()];
    BJ.revealed = false; BJ.doubled = false; BJ.baseBet = state.bet;
    BJ.phase = "play";
    el.verdict.className = "verdict";
    el.vHand.textContent = "Hit or stand";
    el.vDelta.textContent = state.coins < 0
      ? fmtCoins(Math.abs(state.coins)) + " on the tab, minimum bets only"
      : "Your bet is on the table";
    say(pick(state.coins < 0 ? LINES.debt : LINES.deal));
    setMood("deal");
    bjRender(true);
    for(var i = 0; i < 4; i++) sfxDeal(i);
    el.goBtn.textContent = "Hit";
    paint();
    if(bjVal(BJ.you) === 21) setTimeout(bjStand, 600);
  }
  function bjHit(){
    if(BJ.phase !== "play") return;
    BJ.you.push(BJ.deck.pop());
    bjRender(false); sfxDeal(0);
    var v = bjVal(BJ.you);
    paint();
    if(v > 21) bjResolve();
    else if(v === 21) bjStand();
  }
  function bjDouble(){
    if(BJ.phase !== "play" || BJ.you.length !== 2 || BJ.doubled || state.coins < 0) return;
    state.bet = Math.min(state.bet * 2, Math.max(state.bet, state.coins));
    BJ.doubled = true;
    BJ.you.push(BJ.deck.pop());
    bjRender(false); sfxDeal(0);
    paint();
    if(bjVal(BJ.you) > 21) bjResolve(); else bjStand();
  }
  function bjStand(){
    if(BJ.phase !== "play") return;
    BJ.phase = "resolve";
    paint();
    BJ.revealed = true;
    bjRender(false); sfxFlip();
    var step = function(){
      if(bjVal(BJ.dealer) < 17){
        setTimeout(function(){
          BJ.dealer.push(BJ.deck.pop());
          bjRender(false); sfxDeal(0);
          step();
        }, 520);
      } else setTimeout(bjResolve, 520);
    };
    setTimeout(step, 420);
  }
  function bjResolve(){
    BJ.phase = "resolve";
    BJ.revealed = true;
    bjRender(false);
    var pv = bjVal(BJ.you), dv = bjVal(BJ.dealer);
    var pBJ = pv === 21 && BJ.you.length === 2, dBJ = dv === 21 && BJ.dealer.length === 2;
    var cmp, delta = 0;
    if(pv > 21) cmp = -1;
    else if(pBJ && dBJ) cmp = 0;
    else if(pBJ){ cmp = 1; delta = Math.ceil(state.bet * 1.5); }
    else if(dBJ) cmp = -1;
    else if(dv > 21) cmp = 1;
    else cmp = pv > dv ? 1 : pv < dv ? -1 : 0;
    if(cmp > 0 && !delta) delta = state.bet;
    var stats = state.stats;
    state.lastBet = BJ.baseBet;
    stats.bjHands = (stats.bjHands || 0) + 1;
    el.verdict.className = "verdict big" + (cmp > 0 ? " win" : cmp < 0 ? " loss" : "");
    el.vHand.textContent = pv > 21 ? "Bust at " + pv
      : pBJ ? "Blackjack!"
      : cmp > 0 ? "You win, " + pv + " to " + (dv > 21 ? "bust" : dv)
      : cmp < 0 ? "House takes it, " + dv + " to " + pv
      : "Push at " + pv;
    if(cmp > 0){
      delta = hotPay(delta);
      state.coins += delta;
      stats.bjWins = (stats.bjWins || 0) + 1;
      if(delta > stats.best) stats.best = delta;
      el.vDelta.textContent = "+" + fmtCoins(delta) + " coins" + (pBJ ? " (3:2)" : "");
      say(pBJ ? pick(LINES.bigwin) : pick(LINES.win));
      setMood("win"); sfxWin(pBJ ? 8 : 2);
    } else if(cmp < 0){
      state.coins -= state.bet;
      state.stats.lost = (state.stats.lost || 0) + state.bet;
      el.vDelta.textContent = "-" + fmtCoins(state.bet) + " coins";
      say(pick(state.coins < 0 ? LINES.debt : LINES.loss));
      setMood("lose"); sfxLose();
    } else {
      el.vDelta.textContent = "Push, bet returned";
      say(pick(LINES.push)); sfxPush();
    }
    BJ.phase = "done";
    state.bet = Math.max(minBet(), Math.min(BJ.baseBet, maxBet()));
    el.goBtn.textContent = "Deal";
    paint(); save();
  }

  /* ---------- craps, rolled live on the counter ---------- */
  var DICE = {rolling:false};
  var DICE3D = [];
  var dieGeo = null, dieMats = null, dieMatsH = null;
  function dieMatSet(body, edge, pip){
    var P = {1:[[32,32]], 2:[[18,18],[46,46]], 3:[[16,16],[32,32],[48,48]],
             4:[[18,18],[46,18],[18,46],[46,46]], 5:[[18,18],[46,18],[32,32],[18,46],[46,46]],
             6:[[18,14],[46,14],[18,32],[46,32],[18,50],[46,50]]};
    return [1,6,2,5,3,4].map(function(n){
      var cv = document.createElement("canvas"); cv.width = cv.height = 64;
      var c2 = cv.getContext("2d");
      c2.fillStyle = body; c2.fillRect(0, 0, 64, 64);
      c2.strokeStyle = edge; c2.lineWidth = 4; c2.strokeRect(2, 2, 60, 60);
      c2.fillStyle = pip;
      P[n].forEach(function(pp){ c2.beginPath(); c2.arc(pp[0], pp[1], 6, 0, 7); c2.fill(); });
      return new THREE.MeshStandardMaterial({map:new THREE.CanvasTexture(cv), roughness:0.55});
    });
  }
  function makeDie(house){
    if(!dieGeo){
      dieGeo = new THREE.BoxGeometry(0.16, 0.16, 0.16);
      dieMats = dieMatSet("#b3271c", "#7d1710", "#f4efe2");
      dieMatsH = dieMatSet("#221c2e", "#c9a24d", "#e0b458");
    }
    return new THREE.Mesh(dieGeo, house ? dieMatsH : dieMats);
  }
  function clearDice(){
    DICE3D.forEach(function(dd){ if(G.scene) G.scene.remove(dd.mesh); });
    DICE3D.length = 0;
  }
  var DIE_EUL = {1:[0, 0, Math.PI / 2], 6:[0, 0, -Math.PI / 2], 2:[0, 0, 0],
                 5:[Math.PI, 0, 0], 3:[-Math.PI / 2, 0, 0], 4:[Math.PI / 2, 0, 0]};
  function spawnDice(xc, vals, power, count, house){
    if(!G.ok) return;
    var pw = power || 1, n = count || 2;
    for(var i = 0; i < n; i++){
      var dm = makeDie(house);
      dm.position.set(xc + (i - (n - 1) / 2) * 0.34, 1.65 + (pw - 1) * 0.25, 0.95 + Math.random()*0.2);
      dm.rotation.set(Math.random()*6, Math.random()*6, Math.random()*6);
      G.scene.add(dm);
      DICE3D.push({mesh:dm, age:0, settled:false, snap:null, bounces:0,
        val:vals ? vals[i] : null,
        v:new THREE.Vector3((i % 2 ? -1 : 1) * (0.6 + Math.random()*1.2) * pw, 0.4, (Math.random()-0.5)*1.4*pw),
        av:new THREE.Vector3((Math.random()-0.5)*20*pw, (Math.random()-0.5)*20*pw, (Math.random()-0.5)*20*pw)});
    }
    tone(1200, 0.03, "square", 0.05);
    setTimeout(function(){ tone(900, 0.03, "square", 0.05); }, 120);
    setTimeout(function(){ tone(1040, 0.03, "square", 0.045); }, 260);
  }
  var DIE_PIP = {1:[[32,32]], 2:[[20,20],[44,44]], 3:[[18,18],[32,32],[46,46]],
                 4:[[20,20],[44,20],[20,44],[44,44]], 5:[[20,20],[44,20],[32,32],[20,44],[44,44]],
                 6:[[20,16],[44,16],[20,32],[44,32],[20,48],[44,48]]};
  function dieFace(n, house){
    var pf = house ? "#e0b458" : "#f4efe2";
    var dots = DIE_PIP[n].map(function(p){
      return "<circle cx='" + p[0] + "' cy='" + p[1] + "' r='7' fill='" + pf + "'/>";
    }).join("");
    return "<svg viewBox='0 0 64 64' style='width:27px;height:27px;vertical-align:-6px'>" +
           "<rect x='2' y='2' width='60' height='60' rx='11' fill='" + (house ? "#221c2e" : "#b3271c") +
           "' stroke='" + (house ? "#c9a24d" : "#7d1710") + "' stroke-width='4'/>" +
           dots + "</svg>";
  }
  function spawnHeld(n){
    if(!G.ok) return;
    clearDice();
    var nn = n || 2;
    for(var i = 0; i < nn; i++){
      var dm = makeDie();
      var hx8 = (i - (nn - 1) / 2) * 0.30;
      dm.position.set(hx8, 1.58, 1.14);
      G.scene.add(dm);
      DICE3D.push({mesh:dm, age:0, settled:false, snap:null, bounces:0, held:true, val:null,
        hx:hx8, hy:1.58, hz:1.14,
        v:new THREE.Vector3(), av:new THREE.Vector3()});
    }
  }
  function diceRoll(power){
    actx();
    if(DICE.rolling) return;
    state.bet = Math.max(minBet(), Math.min(state.bet, maxBet()));
    DICE.rolling = true;
    var anyHeld = false;
    for(var hh = 0; hh < DICE3D.length; hh++) if(DICE3D[hh].held) anyHeld = true;
    if(!anyHeld) clearDice();
    el.verdict.className = "verdict";
    el.vHand.textContent = DICE.crap && DICE.crap.on ? "Chasing the point" : "Craps";
    el.vDelta.textContent = "The dice are out";
    el.diceReadout.innerHTML = "&nbsp;";
    el.goBtn.textContent = "Rolling";
    setMood("deal");
    if(!DICE.crap) DICE.crap = {on:false, point:0, bet:state.bet};
    var d1 = 1 + Math.floor(Math.random() * 6), d2 = 1 + Math.floor(Math.random() * 6);
    var tot = d1 + d2;
    var pw2 = power || 1, hix = 0, thrown = false;
    for(var hd = 0; hd < DICE3D.length; hd++){
      var de2 = DICE3D[hd];
      if(!de2.held) continue;
      de2.held = false;
      de2.val = hix === 0 ? d1 : d2;
      de2.v.set((hix ? -1 : 1) * (0.6 + Math.random() * 1.2) * pw2, 0.4, (Math.random() - 0.5) * 1.4 * pw2);
      de2.av.set((Math.random() - 0.5) * 20 * pw2, (Math.random() - 0.5) * 20 * pw2, (Math.random() - 0.5) * 20 * pw2);
      hix++;
      thrown = true;
    }
    if(!thrown) spawnDice(0, [d1, d2], pw2);
    tone(1200, 0.03, "square", 0.06);
    paint();
    setTimeout(function(){
      el.diceReadout.innerHTML = dieFace(d1) + "<b>" + d1 + "</b><span>+</span>" + dieFace(d2) + "<b>" + d2 + "</b><span>=</span><b>" + tot + "</b>" +
        (DICE.crap && DICE.crap.on ? "<span style='opacity:.75'>&middot; pt <b style='font-size:inherit;color:var(--gold)'>" + DICE.crap.point + "</b></span>" : "");
      if(!DICE.crap.on){
        if(tot === 7 || tot === 11) return diceSettle(1, "Natural " + tot, DICE.crap.bet);
        if(tot === 2 || tot === 3 || tot === 12) return diceSettle(-1, "Craps, " + tot + " on the come-out", DICE.crap.bet);
        DICE.crap.on = true; DICE.crap.point = tot;
        crapsMid("Point is " + tot, "Roll " + tot + " again before a 7. " + fmtCoins(DICE.crap.bet) + " rides.");
      } else {
        if(tot === DICE.crap.point) return diceSettle(1, "Point " + tot + " made", DICE.crap.bet);
        if(tot === 7) return diceSettle(-1, "Seven out", DICE.crap.bet);
        crapsMid("Point " + DICE.crap.point, "Rolled " + tot + ", the dice stay hot");
      }
    }, 1400);
  }
  function crapsMid(h, d){
    el.verdict.className = "verdict";
    el.vHand.textContent = h;
    el.vDelta.textContent = d;
    tone(620, 0.06, "triangle", 0.06);
    DICE.rolling = false;
    el.goBtn.textContent = "Hold to shake";
    paint();
  }
  function diceSettle(cmp, label, amt){
    var stats = state.stats;
    var wager = amt != null ? amt : state.bet;
    state.lastBet = wager;
    stats.diceHands = (stats.diceHands || 0) + 1;
    DICE.crap = null;
    el.verdict.className = "verdict big" + (cmp > 0 ? " win" : cmp < 0 ? " loss" : "");
    el.vHand.textContent = label || (cmp > 0 ? "You take the pot" : cmp < 0 ? "The house rolls on" : "Dead heat");
    if(cmp > 0){
      wager = hotPay(wager);
      state.coins += wager;
      stats.diceWins = (stats.diceWins || 0) + 1;
      if(wager > stats.best) stats.best = wager;
      el.vDelta.textContent = "+" + fmtCoins(wager) + " coins";
      say(pick(LINES.win)); setMood("win"); sfxWin(2);
    } else if(cmp < 0){
      state.coins -= wager;
      state.stats.lost = (state.stats.lost || 0) + wager;
      el.vDelta.textContent = "-" + fmtCoins(wager) + " coins";
      say(pick(state.coins < 0 ? LINES.debt : LINES.loss)); setMood("lose"); sfxLose();
    } else {
      el.vDelta.textContent = "Push, bet returned";
      say(pick(LINES.push)); sfxPush();
    }
    DICE.rolling = false;
    el.goBtn.textContent = "Hold to shake";
    paint(); save();
  }

  /* ---------- cee-lo: three dice, best hand wins ---------- */
  var CEE = {busy:false};
  function ceeRank(v){
    var s2 = v.slice().sort(function(x, y){ return x - y; });
    var a9 = s2[0], b9 = s2[1], c9 = s2[2];
    if(a9 === 4 && b9 === 5 && c9 === 6) return {t:3, hi:0, lab:"4-5-6"};
    if(a9 === b9 && b9 === c9) return {t:2, hi:a9, lab:"Trips " + a9};
    if(a9 === 1 && b9 === 2 && c9 === 3) return {t:0, hi:0, lab:"1-2-3"};
    if(a9 === b9) return {t:1, hi:c9, lab:"Point " + c9};
    if(b9 === c9) return {t:1, hi:a9, lab:"Point " + a9};
    return null;
  }
  function ceeMini(v, house){
    return v.map(function(n){ return dieFace(n, house); }).join("");
  }
  function ceeRoll(power){
    actx();
    if(CEE.busy || DICE.rolling) return;
    state.bet = Math.max(minBet(), Math.min(state.bet, maxBet()));
    CEE.busy = true;
    CEE.bet = state.bet;
    CEE.tries = 0; CEE.womTries = 0; CEE.mine = null; CEE.mineD = null;
    el.verdict.className = "verdict";
    el.vHand.textContent = "Cee-lo";
    el.vDelta.textContent = "Your throw";
    el.diceReadout.innerHTML = "&nbsp;";
    el.goBtn.textContent = "Rolling";
    setMood("deal");
    ceePlayerThrow(power || 1, true);
    paint();
  }
  function ceePlayerThrow(power, useHeld){
    CEE.tries++;
    var v9 = [1 + Math.floor(Math.random() * 6), 1 + Math.floor(Math.random() * 6), 1 + Math.floor(Math.random() * 6)];
    var thrown = false, hix2 = 0;
    if(useHeld){
      for(var hd2 = 0; hd2 < DICE3D.length; hd2++){
        var de3 = DICE3D[hd2];
        if(!de3.held) continue;
        de3.held = false;
        de3.val = v9[hix2];
        de3.v.set((hix2 % 2 ? -1 : 1) * (0.6 + Math.random() * 1.2) * power, 0.4, (Math.random() - 0.5) * 1.4 * power);
        de3.av.set((Math.random() - 0.5) * 20 * power, (Math.random() - 0.5) * 20 * power, (Math.random() - 0.5) * 20 * power);
        hix2++;
        thrown = true;
      }
    }
    if(!thrown){ clearDice(); spawnDice(0, v9, power, 3); }
    tone(1200, 0.03, "square", 0.06);
    setTimeout(function(){
      var h9 = ceeRank(v9);
      el.diceReadout.innerHTML = v9.map(function(n8){ return dieFace(n8) + "<b>" + n8 + "</b>"; }).join("") +
        "<span style='opacity:.85'>" + (h9 ? h9.lab : "no hand") + "</span>";
      if(!h9 && CEE.tries < 3){
        el.vDelta.textContent = "No hand, throw again";
        tone(620, 0.05, "triangle", 0.05);
        setTimeout(function(){ ceePlayerThrow(1, false); }, 800);
      } else {
        CEE.mine = h9 || {t:0, hi:-1, lab:"no hand"};
        CEE.mineD = v9;
        el.vHand.textContent = "You show " + CEE.mine.lab;
        el.vDelta.textContent = "The old man shakes the cup";
        setTimeout(ceeWomThrow, 900);
      }
    }, 1400);
  }
  function ceeWomThrow(){
    CEE.womTries++;
    var v0 = [1 + Math.floor(Math.random() * 6), 1 + Math.floor(Math.random() * 6), 1 + Math.floor(Math.random() * 6)];
    clearDice();
    spawnDice(0, v0, 1.1, 3, true);
    tone(1100, 0.03, "square", 0.06);
    setTimeout(function(){
      var h0 = ceeRank(v0);
      el.diceReadout.innerHTML = ceeMini(CEE.mineD) + "<span style='opacity:.7'>vs</span>" + ceeMini(v0, true) +
        "<span style='opacity:.85'>" + (h0 ? h0.lab : "no hand") + "</span>";
      if(!h0 && CEE.womTries < 3){
        el.vDelta.textContent = "The old man throws again";
        setTimeout(ceeWomThrow, 800);
      } else ceeSettle(h0 || {t:0, hi:-1, lab:"no hand"}, v0);
    }, 1400);
  }
  function ceeSettle(womH, womD){
    el.diceReadout.innerHTML = CEE.mineD.map(function(n8){ return dieFace(n8) + "<b>" + n8 + "</b>"; }).join("") +
      "<span style='opacity:.7'>vs</span>" +
      womD.map(function(n8){ return dieFace(n8, true) + "<b>" + n8 + "</b>"; }).join("");
    var stats = state.stats;
    stats.ceeHands = (stats.ceeHands || 0) + 1;
    var m9 = CEE.mine;
    var cmp = m9.t !== womH.t ? (m9.t > womH.t ? 1 : -1) : (m9.hi > womH.hi ? 1 : m9.hi < womH.hi ? -1 : 0);
    var big = cmp > 0 && m9.t >= 2;
    var bigL = cmp < 0 && womH.t >= 2;
    var winAmt = CEE.bet * (big ? 2 : 1);
    var loseAmt = CEE.bet * (bigL ? 2 : 1);
    state.lastBet = CEE.bet;
    el.verdict.className = "verdict big" + (cmp > 0 ? " win" : cmp < 0 ? " loss" : "");
    el.vHand.textContent = cmp > 0 ? m9.lab + " beats " + womH.lab
      : cmp < 0 ? womH.lab + " beats " + m9.lab : "Both show " + m9.lab;
    if(cmp > 0){
      winAmt = hotPay(winAmt);
      state.coins += winAmt;
      stats.ceeWins = (stats.ceeWins || 0) + 1;
      if(winAmt > stats.best) stats.best = winAmt;
      el.vDelta.textContent = "+" + fmtCoins(winAmt) + " coins" + (big ? " - paid double" : "");
      say(pick(LINES.win)); setMood("win"); sfxWin(2);
    } else if(cmp < 0){
      state.coins -= loseAmt;
      stats.lost = (stats.lost || 0) + loseAmt;
      el.vDelta.textContent = "-" + fmtCoins(loseAmt) + " coins" + (bigL ? " - his big hand cost you double" : "");
      say(pick(state.coins < 0 ? LINES.debt : LINES.loss)); setMood("lose"); sfxLose();
    } else {
      el.vDelta.textContent = "Push, bet returned";
      say(pick(LINES.push)); sfxPush();
    }
    CEE.busy = false;
    el.goBtn.textContent = "Hold to shake";
    paint(); save();
  }

  /* ---------- easter eggs: rare tavern happenings ---------- */
  var EGG = {on:false, idle:0, next:80 + Math.random() * 160, t:0, kind:0, parts:[], st:{}};
  function eggAdd(m9){ G.scene.add(m9); EGG.parts.push(m9); return m9; }
  function eggClear(){
    EGG.parts.forEach(function(m9){ G.scene.remove(m9); });
    EGG.parts.length = 0;
    (EGG.dom || []).forEach(function(d9){ if(d9.parentNode) d9.parentNode.removeChild(d9); });
    EGG.dom = [];
    if(G.moon) G.moon.position.set(4.4, 5.4, -9.25);
    if(G.moonHalo) G.moonHalo.position.set(4.4, 5.4, -9.3);
    EGG.on = false;
    EGG.idle = 0;
    EGG.next = 150 + Math.random() * 210;
    EGG.st = {};
  }
  function eggStart(){
    EGG.on = true; EGG.t = 0; EGG.st = {};
    EGG.kind = 1 + Math.floor(Math.random() * 6);
    if(EGG.kind === 1) eggBirdBuild();
    else if(EGG.kind === 2) eggSixSevenBuild();
    else if(EGG.kind === 3) eggSoulBuild();
    else if(EGG.kind === 4) eggLogBuild();
    else if(EGG.kind === 5) eggSillBuild();
    else eggPupBuild();
  }
  window.pvmPrestige = function(n){
    n = Math.max(0, Math.min(10, +n || 0));
    G.prestigePreview = n;
    (G.hats || []).forEach(function(h){ if(h.parent) h.parent.remove(h); });
    G.hats = [];
    ["goldPile", "goldPileL", "goldMound", "goldMoundL", "goldBars", "goldPhat"].forEach(function(k){
      var o = G[k]; if(o && o.parent) o.parent.remove(o); G[k] = null;
    });
    G.goldStacks = 0; G.goldStacksL = 0;
    try{ applyPrestigeScene(); }catch(e){}
    return n;
  };
  window.pvmEgg = function(k){
    if(!G.ok) return;
    if(EGG.on) eggClear();
    EGG.on = true; EGG.t = 0; EGG.st = {};
    EGG.kind = k;
    if(k === 1) eggBirdBuild();
    else if(k === 2) eggSixSevenBuild();
    else if(k === 3) eggSoulBuild();
    else if(k === 4) eggLogBuild();
    else if(k === 5) eggSillBuild();
    else eggPupBuild();
  };
  function eggBirdBuild(){
    var b = new THREE.Group();
    var RED = mat(0xc0392b), REDD = mat(0x8f2a20), BK = mat(0x2a2733), OR = mat(0xe0a23c);
    sph(0.09, RED, 0, 0.10, 0, b, 1, 1.1, 1.25);
    sph(0.06, RED, 0, 0.21, 0.07, b);
    cone(0.02, 0.05, 4, OR, 0, 0.20, 0.14, b).rotation.x = Math.PI / 2;
    sph(0.012, BK, 0.035, 0.23, 0.115, b);
    sph(0.012, BK, -0.035, 0.23, 0.115, b);
    var wl = box(0.02, 0.07, 0.13, REDD, -0.095, 0.10, 0, b);
    var wr = box(0.02, 0.07, 0.13, REDD, 0.095, 0.10, 0, b);
    var bics = [];
    function bArm(sd){
      var a = new THREE.Group(); a.position.set(sd * 0.10, 0.13, 0.01);
      sph(0.05, RED, 0, 0, 0, a);
      var up = cyl(0.042, 0.05, 0.22, 7, RED, sd * 0.13, 0.02, 0, a);
      up.rotation.z = sd * -1.45;
      bics.push(sph(0.115, RED, sd * 0.13, 0.095, 0, a, 1.15, 1.0, 0.95));
      var fo = cyl(0.03, 0.042, 0.18, 7, RED, sd * 0.24, 0.13, 0, a);
      fo.rotation.z = sd * -0.15;
      sph(0.05, REDD, sd * 0.245, 0.24, 0, a);
      a.visible = false;
      b.add(a);
      return a;
    }
    var al = bArm(-1), ar = bArm(1);
    b.position.set(-3.55, 4.7, -5.5);
    eggAdd(b);
    EGG.st = {bird:b, wl:wl, wr:wr, al:al, ar:ar, bics:bics};
  }
  function eggVoice(){
    var vs = window.speechSynthesis.getVoices() || [], best = null, score = -1;
    vs.forEach(function(v){
      var n = (v.name || "").toLowerCase(), l = (v.lang || "").toLowerCase();
      if(l.indexOf("en") !== 0) return;
      var sc = 0;
      if(l === "en-us") sc += 3;
      if(/guy|david|mark|alex|fred|daniel|james|eric|christopher|male/.test(n)) sc += 4;
      if(/natural|neural|online|premium|enhanced/.test(n)) sc += 6;
      if(/female|zira|samantha|susan|hazel|linda|aria|jenny|michelle|victoria|karen|moira|fiona|tessa|veena/.test(n)) sc -= 5;
      if(sc > score){ score = sc; best = v; }
    });
    return best;
  }
  function eggSpeak(txt){
    try{
      if(!state.sound || !window.speechSynthesis) return false;
      var u = new SpeechSynthesisUtterance(txt);
      var v = eggVoice(); if(v) u.voice = v;
      u.rate = 1.0; u.pitch = 0.7; u.volume = 1;
      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(u);
      return true;
    }catch(e){ return false; }
  }
  function eggSixSevenBuild(){
    var av = makeMan({shirt:0xe8e2d4, pants:0x2a2733, hair:0x14100c, skin:0x6f4a2f});
    function elbow(arm, sd){
      var up = arm.children[0], hand = arm.children[1];
      up.scale.set(1, 0.5, 1); up.position.y = -0.085;
      hand.visible = false;
      var e = new THREE.Group(); e.position.set(0, -0.17, 0); arm.add(e);
      cyl(0.045, 0.052, 0.19, 6, up.material, 0, -0.095, 0, e);
      sph(0.05, hand.material, sd * 0.03, -0.2, 0.02, e);
      e.rotation.x = -0.3;
      return e;
    }
    var elL = elbow(av.lArm, -1), elR = elbow(av.rArm, 1);
    function eggCartoon(txt, big){
      var cv = document.createElement("canvas"); cv.width = cv.height = 160;
      var c = cv.getContext("2d");
      c.translate(80, 84); if(!big) c.rotate(-0.12);
      c.font = big ? "700 68px 'Barlow Condensed',sans-serif" : "900 112px 'Barlow Condensed','Impact',sans-serif";
      c.textAlign = "center"; c.textBaseline = "middle";
      c.lineJoin = "round";
      if(big){
        c.lineWidth = 10; c.strokeStyle = "#1a1426"; c.strokeText(txt, 0, 0);
        c.fillStyle = "#ffd24a"; c.fillText(txt, 0, 0);
      } else {
        c.lineWidth = 18; c.strokeStyle = "#1a1426"; c.strokeText(txt, 0, 0);
        c.lineWidth = 9; c.strokeStyle = "#7a2c24"; c.strokeText(txt, 0, 0);
        var gr = c.createLinearGradient(0, -50, 0, 50); gr.addColorStop(0, "#fff3cf"); gr.addColorStop(0.5, "#ffd24a"); gr.addColorStop(1, "#e0a020");
        c.fillStyle = gr; c.fillText(txt, 0, 0);
      }
      var tx = new THREE.CanvasTexture(cv);
      var sp = new THREE.Sprite(new THREE.SpriteMaterial({map:tx, transparent:true, depthTest:false}));
      sp.scale.setScalar(big ? 0.34 : 0.2);
      sp.renderOrder = 30; sp.visible = false;
      return sp;
    }
    var n6 = eggCartoon("6"), n7 = eggCartoon("7"), cuhS = eggCartoon("cuh", true);
    n6.position.set(-0.27, 0.86, 0.3); av.group.add(n6);
    n7.position.set(0.27, 0.86, 0.3); av.group.add(n7);
    cuhS.position.set(0.26, -0.08, 0.1); av.head.add(cuhS);
    /* custom hair, built from scratch: stock cap hidden, loc'd style in its place */
    av.head.children.forEach(function(ch5){
      if(ch5.material && ch5.material.color && ch5.material.color.getHex() === 0x14100c && ch5.position.y > 0.03) ch5.visible = false;
    });
    var DRD = mat(0x191410), DRK = mat(0x261d13), DRB = mat(0xd8b45a);
    /* RS chathead style: smooth close cap, fringe at the hairline, low combed rows over the top */
    sph(0.119, DRD, 0, 0.05, -0.006, av.head, 1.01, 0.8, 0.9);
    for(var n5 = -3; n5 <= 3; n5++){
      var rx = n5 * 0.0235;
      var ridge = sph(0.018, n5 % 2 ? DRK : DRD, rx, 0.124 - rx * rx * 3.2, 0.0, av.head, 0.75, 0.6, 3.3);
      ridge.rotation.x = 0.16;
      ridge.rotation.z = -n5 * 0.10;
    }
    var dreads = [];
    function dread(a4, ln4, blonde){
      var g5 = new THREE.Group();
      g5.position.set(Math.sin(a4) * 0.108, 0.062, Math.cos(a4) * 0.105);
      g5.userData.a = a4;
      var mm2 = blonde ? DRB : DRD;
      var seg = ln4 / 3;
      var out = 0.34;
      sph(0.020, mm2, -Math.sin(a4) * 0.012, 0.008, -Math.cos(a4) * 0.012, g5);
      var c1 = cyl(0.024, 0.021, seg, 5, mm2, 0, -seg / 2, 0, g5);
      c1.rotation.x = Math.cos(a4) * out;
      c1.rotation.z = -Math.sin(a4) * out;
      var m1x = Math.sin(a4) * seg * out * 0.9, m1z = Math.cos(a4) * seg * out * 0.9;
      var c2 = cyl(0.021, 0.018, seg, 5, mm2, m1x, -seg * 1.42, m1z, g5);
      c2.rotation.x = Math.cos(a4) * out * 0.4;
      c2.rotation.z = -Math.sin(a4) * out * 0.4;
      cyl(0.018, 0.013, seg, 5, mm2, m1x * 1.25, -seg * 2.34, m1z * 1.25, g5);
      sph(0.016, mm2, m1x * 1.25, -seg * 2.85, m1z * 1.25, g5);
      av.head.add(g5);
      dreads.push(g5);
      return g5;
    }
    for(var di3 = 0; di3 < 12; di3++){
      var a3 = (di3 / 12) * Math.PI * 2 + 0.13;
      if(Math.cos(a3) > 0.5) continue;
      dread(a3, 0.16 + ((di3 * 5) % 4) * 0.025, di3 % 4 === 2);
    }
    dread(0.55, 0.15, false);
    dread(-0.55, 0.15, true);
    av.group.position.set(1.6, 0, 5.4);
    av.group.rotation.y = -2.62;
    eggAdd(av.group);
    var d7 = document.createElement("div");
    d7.style.cssText = "position:absolute;left:50%;top:44%;transform:translateX(-50%);z-index:28;" +
      "font-family:'Grenze Gotisch',serif;font-size:28px;font-weight:700;color:#ffd98a;" +
      "text-shadow:0 2px 0 #000,0 0 10px rgba(0,0,0,.85);pointer-events:none;display:none";
    var sui = root.querySelector(".stage-ui");
    if(sui) sui.appendChild(d7);
    EGG.dom = [d7];
    EGG.st = {man:av, lastTone:0, say:d7, dreads:dreads, elbows:[elL, elR], n6:n6, n7:n7, cuhS:cuhS};
  }
  function eggSoulBuild(){
    var s = new THREE.Group();
    var GMO = new THREE.MeshBasicMaterial({color:0x5fd07a, transparent:true, opacity:0.4});
    var GMI = new THREE.MeshBasicMaterial({color:0x2f7a3f, transparent:true, opacity:0.85});
    var EYM = new THREE.MeshBasicMaterial({color:0x0e2a1c, transparent:true, opacity:1});
    s.add(new THREE.Mesh(new THREE.SphereGeometry(0.19, 12, 9), GMO));
    s.add(new THREE.Mesh(new THREE.SphereGeometry(0.13, 10, 8), GMI));
    var tails = [];
    for(var ti = 0; ti < 4; ti++){
      var tm = GMO.clone(); tm.opacity = 0.32 - ti * 0.06;
      var tw = new THREE.Mesh(new THREE.SphereGeometry(0.11 - ti * 0.022, 8, 6), tm);
      tw.position.set(0, -0.13 - ti * 0.1, -0.09 - ti * 0.09);
      s.add(tw); tails.push({m:tw, mm:tm, off:ti});
    }
    var ey = new THREE.Mesh(new THREE.SphereGeometry(0.028, 6, 5), EYM);
    ey.position.set(0.06, 0.05, 0.155); s.add(ey);
    var ey2 = new THREE.Mesh(new THREE.SphereGeometry(0.028, 6, 5), EYM);
    ey2.position.set(-0.06, 0.05, 0.155); s.add(ey2);
    var mo = new THREE.Mesh(new THREE.SphereGeometry(0.03, 6, 5), EYM);
    mo.scale.set(1.4, 0.7, 0.6); mo.position.set(0, -0.05, 0.165); s.add(mo);
    var bubbles = [], drips = [];
    for(var bi = 0; bi < 3; bi++){
      var bm2 = new THREE.MeshBasicMaterial({color:0x8fe8a8, transparent:true, opacity:0.5});
      var bb3 = new THREE.Mesh(new THREE.SphereGeometry(0.03 + bi * 0.008, 6, 5), bm2);
      s.add(bb3); bubbles.push({m:bb3, mm:bm2, off:bi * 0.37});
    }
    for(var di2 = 0; di2 < 2; di2++){
      var dm2 = new THREE.MeshBasicMaterial({color:0x3f8f4f, transparent:true, opacity:0.7});
      var dd2 = new THREE.Mesh(new THREE.SphereGeometry(0.024, 6, 5), dm2);
      dd2.scale.y = 1.6; s.add(dd2); drips.push({m:dd2, mm:dm2, off:di2 * 0.5});
    }
    s.position.set(6.5, 1.6, 0.8);
    eggAdd(s);
    function ear(){
      var em2 = new THREE.MeshBasicMaterial({color:0xf5edcf, transparent:true, opacity:0});
      var e = new THREE.Mesh(new THREE.CircleGeometry(0.17, 12), em2);
      e.scale.y = 2.3;
      e.position.set(0, -20, -9.26);
      return eggAdd(e);
    }
    EGG.st = {soul:s, fade:[GMO, GMI], eym:EYM, tails:tails, bubbles:bubbles, drips:drips, e1:ear(), e2:ear()};
  }
  function eggLogBuild(){
    var cv = document.createElement("canvas"); cv.width = cv.height = 128;
    var c = cv.getContext("2d");
    c.fillStyle = "#c9a06a"; c.beginPath(); c.arc(64, 64, 62, 0, 7); c.fill();
    c.strokeStyle = "#8a6a42"; c.lineWidth = 3;
    for(var r5 = 14; r5 < 60; r5 += 13){ c.beginPath(); c.arc(64, 64, r5, 0, 7); c.stroke(); }
    c.fillStyle = "#3f2c18"; c.font = "bold 46px Georgia"; c.textAlign = "center"; c.textBaseline = "middle";
    c.save(); c.translate(64, 64); c.rotate(-Math.PI / 2); c.fillText("ln", 0, 2); c.restore();
    var bk = document.createElement("canvas"); bk.width = bk.height = 128;
    var bc = bk.getContext("2d");
    bc.fillStyle = "#5d4126"; bc.fillRect(0, 0, 128, 128);
    var tones = ["#4a3018", "#6b4a2a", "#3f2c18", "#54381f", "#755433"];
    for(var s8 = 0; s8 < 46; s8++){
      bc.strokeStyle = tones[s8 % 5];
      bc.lineWidth = 1.5 + Math.random() * 3;
      bc.globalAlpha = 0.5 + Math.random() * 0.5;
      var bx = Math.random() * 128;
      bc.beginPath();
      bc.moveTo(bx, -4);
      bc.bezierCurveTo(bx + (Math.random() * 10 - 5), 40, bx + (Math.random() * 10 - 5), 88, bx + (Math.random() * 8 - 4), 132);
      bc.stroke();
    }
    bc.globalAlpha = 1;
    for(var k8 = 0; k8 < 2; k8++){
      var kx = 25 + Math.random() * 78, ky = 25 + Math.random() * 78;
      bc.strokeStyle = "#2e1f0e"; bc.lineWidth = 3;
      bc.beginPath(); bc.ellipse(kx, ky, 7, 10, 0.3, 0, 7); bc.stroke();
      bc.fillStyle = "#3f2c18";
      bc.beginPath(); bc.ellipse(kx, ky, 3.5, 5, 0.3, 0, 7); bc.fill();
    }
    var barkT = new THREE.CanvasTexture(bk);
    barkT.wrapS = THREE.RepeatWrapping; barkT.repeat.x = 2;
    var lg = new THREE.Mesh(new THREE.CylinderGeometry(0.22, 0.22, 0.8, 12),
      [new THREE.MeshStandardMaterial({map:barkT, roughness:0.95}),
       new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(cv)}),
       new THREE.MeshStandardMaterial({color:0xc9a06a})]);
    lg.rotation.x = Math.PI / 2;
    lg.position.set(-7, 1.21, 1.15);
    eggAdd(lg);
    var vgrp = new THREE.Group();
    var VGD = mat(0x2f6b3f), VL = mat(0x7fc98a);
    var pts = [];
    for(var vi = 0; vi < 24; vi++) pts.push([-2.0 + vi * 0.175, 0.05 + Math.log(1 + vi * 0.55) * 1.0]);
    for(vi = 1; vi < pts.length; vi++){
      var dx6 = pts[vi][0] - pts[vi - 1][0], dy6 = pts[vi][1] - pts[vi - 1][1];
      var ln6 = Math.sqrt(dx6 * dx6 + dy6 * dy6);
      var sg6 = cyl(0.022, 0.027, ln6 + 0.02, 5, VGD,
        (pts[vi][0] + pts[vi - 1][0]) / 2, (pts[vi][1] + pts[vi - 1][1]) / 2, 0, vgrp);
      sg6.rotation.z = -Math.atan2(dx6, dy6);
      sg6.visible = false;
      if(vi % 3 === 0){
        var lf = cone(0.05, 0.12, 4, VL, pts[vi][0] + (vi % 6 ? 0.1 : -0.1), pts[vi][1] + 0.04, 0.04, vgrp);
        lf.rotation.z = vi % 6 ? -1.9 : 1.9;
        lf.visible = false;
      }
    }
    vgrp.position.z = -5.18;
    eggAdd(vgrp);
    EGG.st = {log:lg, said:false, vine:vgrp.children};
  }
  function eggSillBuild(){
    var bun = new THREE.Group();
    var BW = mat(0xd8d2c4), BP = mat(0xd98a90), BD = mat(0x8a8478);
    sph(0.075, BW, 0, 0.07, 0, bun, 1, 0.9, 1.15);
    sph(0.055, BW, 0, 0.155, 0.045, bun);
    var be1 = box(0.025, 0.11, 0.02, BW, -0.028, 0.24, 0.03, bun);
    var be2 = box(0.025, 0.11, 0.02, BW, 0.028, 0.24, 0.03, bun);
    sph(0.008, BD, 0.022, 0.165, 0.095, bun);
    sph(0.008, BD, -0.022, 0.165, 0.095, bun);
    sph(0.012, BP, 0, 0.145, 0.1, bun);
    sph(0.035, BW, 0, 0.06, -0.085, bun);
    bun.position.set(-3.85, 0.9, -5.45);
    eggAdd(bun);
    var lam = new THREE.Group();
    var LW = mat(0xf2efe6), LD = mat(0x3a3540);
    sph(0.09, LW, 0, 0.13, 0, lam, 1.15, 1, 1.25);
    sph(0.05, LD, 0, 0.19, 0.10, lam);
    sph(0.06, LW, 0, 0.25, 0.05, lam);
    box(0.02, 0.05, 0.035, LD, -0.06, 0.19, 0.09, lam);
    box(0.02, 0.05, 0.035, LD, 0.06, 0.19, 0.09, lam);
    var legs = [];
    [[-0.05, -0.05], [0.05, -0.05], [-0.05, 0.06], [0.05, 0.06]].forEach(function(lp){
      legs.push(cyl(0.016, 0.016, 0.09, 5, LD, lp[0], 0.045, lp[1], lam));
    });
    lam.position.set(3.85, 0.9, -5.45);
    eggAdd(lam);
    EGG.st = {bun:bun, lam:lam, ears:[be1, be2], legs:legs};
  }
  function eggPupBuild(){
    var p = new THREE.Group();
    var FUR = mat(0x8a5a32), FURD = mat(0x6b4222), CRM = mat(0xd8c48a), BK = mat(0x2a2733);
    var T = new THREE.Group();
    T.position.set(0, 0.09, -0.10);
    sph(0.085, FUR, 0, 0.08, 0.08, T, 1, 0.95, 1.6);
    sph(0.06, CRM, 0, 0.04, 0.12, T, 0.85, 0.75, 1.35);
    var hd = new THREE.Group(); hd.position.set(0, 0.155, 0.25);
    sph(0.062, FUR, 0, 0, 0, hd);
    sph(0.035, CRM, 0, -0.012, 0.062, hd, 1, 0.8, 1.55);
    sph(0.014, BK, 0, -0.005, 0.122, hd);
    sph(0.011, BK, 0.028, 0.022, 0.05, hd);
    sph(0.011, BK, -0.028, 0.022, 0.05, hd);
    var er1 = box(0.045, 0.10, 0.02, FURD, -0.062, 0.02, -0.005, hd);
    er1.rotation.z = 0.55; er1.rotation.x = 0.3;
    var er2 = box(0.045, 0.10, 0.02, FURD, 0.062, 0.02, -0.005, hd);
    er2.rotation.z = -0.55; er2.rotation.x = 0.3;
    T.add(hd);
    var legs = [];
    [[-0.05, 0.20], [0.05, 0.20]].forEach(function(lp){
      legs.push(cyl(0.018, 0.02, 0.15, 5, FUR, lp[0], -0.015, lp[1], T));
    });
    p.add(T);
    [[-0.05, -0.12], [0.05, -0.12]].forEach(function(lp){
      legs.push(cyl(0.018, 0.02, 0.15, 5, FUR, lp[0], 0.075, lp[1], p));
    });
    var tail = cyl(0.012, 0.02, 0.14, 5, FURD, 0, 0.24, -0.18, p);
    tail.rotation.x = -0.8;
    var rig = new THREE.Group();
    rig.position.set(0, 0.19, 0.22);
    var rod1 = cyl(0.011, 0.015, 0.45, 5, mat(0x5d4126), 0, 0.17, 0.15, rig);
    rod1.rotation.x = 0.75;
    var rod2 = cyl(0.006, 0.010, 0.36, 5, mat(0x7a5a36), 0, 0.42, 0.38, rig);
    rod2.rotation.x = 0.75;
    var reel = cyl(0.026, 0.026, 0.022, 8, mat(0x9aa0a8), 0, 0.10, 0.11, rig);
    reel.rotation.z = Math.PI / 2;
    box(0.005, 0.72, 0.005, mat(0xd8d2c4), 0, 0.19, 0.50, rig);
    sph(0.018, mat(0xc0392b), 0, -0.14, 0.50, rig);
    var fish = new THREE.Group();
    sph(0.035, mat(0x9fb8c9), 0, 0, 0, fish, 1.5, 0.9, 0.7);
    cone(0.02, 0.05, 4, mat(0x7d98a8), -0.062, 0, 0, fish).rotation.z = Math.PI / 2;
    fish.position.set(0, -0.26, 0.50);
    fish.visible = false;
    rig.add(fish);
    rig.visible = false;
    T.add(rig);
    p.position.set(7.2, 0, 1.2);
    eggAdd(p);
    EGG.st = {pup:p, T:T, rig:rig, tail:tail, fish:fish, legs:legs};
  }
  function eggTick(dt){
    var t = EGG.t, st = EGG.st;
    if(EGG.kind === 1){
      var b = st.bird;
      if(t < 1.1){
        var pf = t / 1.1;
        b.position.set(-3.55, 4.7 - 2.95 * pf, -5.5);
        st.wl.rotation.z = Math.sin(t * 26) * 0.9;
        st.wr.rotation.z = -Math.sin(t * 26) * 0.9;
      } else if(t < 1.6){
        var ph3 = (t - 1.1) / 0.5;
        b.position.set(-3.55, 1.75 - 0.11 * ph3 + Math.sin(ph3 * Math.PI) * 0.09, -5.5 + 0.38 * ph3);
        st.wl.rotation.z = 0; st.wr.rotation.z = 0;
      } else if(t < 10){
        b.position.set(-3.55, 1.64 + Math.sin(t * 2.2) * 0.01, -5.12);
      } else if(t < 13){
        st.wl.visible = false; st.wr.visible = false;
        st.al.visible = true; st.ar.visible = true;
        st.al.rotation.z = Math.sin(t * 6.5) * 0.14;
        st.ar.rotation.z = -Math.sin(t * 6.5) * 0.14;
        var bsc = 1 + Math.max(0, Math.sin(t * 6.5)) * 0.18;
        st.bics[0].scale.set(1.15 * bsc, 1.0 * bsc, 0.95 * bsc);
        st.bics[1].scale.set(1.15 * bsc, 1.0 * bsc, 0.95 * bsc);
        if(!st.grunt){ st.grunt = true; tone(85, 0.18, "square", 0.10); }
      } else if(t < 13.7){
        st.al.visible = false; st.ar.visible = false;
        st.wl.visible = true; st.wr.visible = true;
        b.rotation.y = Math.PI * ((t - 13) / 0.7);
      } else if(t < 15.2){
        var pf2 = (t - 13.7) / 1.5;
        b.rotation.y = Math.PI;
        b.position.set(-3.55, 1.64 + 3.1 * pf2, -5.12 - 0.42 * pf2);
        st.wl.rotation.z = Math.sin(t * 26) * 0.9;
        st.wr.rotation.z = -Math.sin(t * 26) * 0.9;
      } else eggClear();
    } else if(EGG.kind === 2){
      var mv = st.man, g8 = mv.group;
      if(st.dreads){
        var wv = (t < 4 || (t >= 8.5 && t < 12)) ? 0.17 : (t >= 4.5 && t < 8) ? 0.12 : 0.07;
        for(var dz = 0; dz < st.dreads.length; dz++){
          var dg = st.dreads[dz];
          var da = dg.userData.a;
          var rad = Math.max(0, Math.sin(t * 6.2 + dz * 1.7)) * wv * 0.9 + 0.16;
          var tan = Math.cos(t * 5.1 + dz * 2.3) * wv * 0.7;
          dg.rotation.x = Math.cos(da) * rad + Math.sin(da) * tan;
          dg.rotation.z = -Math.sin(da) * rad + Math.cos(da) * tan;
        }
      }
      if(t < 4){
        var pw6 = t / 4;
        g8.position.x = 1.6 * (1 - pw6);
        g8.position.z = 5.4 - 2.8 * pw6;
        g8.position.y = Math.abs(Math.sin(t * 7)) * 0.03;
        g8.rotation.y = -2.62;
        mv.lLeg.rotation.x = Math.sin(t * 7) * 0.5;
        mv.rLeg.rotation.x = -Math.sin(t * 7) * 0.5;
        mv.lArm.rotation.x = -Math.sin(t * 7) * 0.35;
        mv.rArm.rotation.x = Math.sin(t * 7) * 0.35;
      } else if(t < 4.5){
        g8.position.set(0, 0, 2.6);
        g8.rotation.y = -2.62 * (1 - (t - 4) / 0.5);
        mv.lLeg.rotation.x = 0; mv.rLeg.rotation.x = 0;
      } else if(t < 8){
        g8.rotation.y = 0;
        var amp = Math.floor(t - 4.5) % 3 === 2 ? 0.06 : 0.42;
        mv.lArm.rotation.x = -0.9; mv.rArm.rotation.x = -0.9;
        st.elbows[0].rotation.x = -1.0 + Math.sin(t * 7.5) * amp * 1.7;
        st.elbows[1].rotation.x = -1.0 - Math.sin(t * 7.5) * amp * 1.7;
        g8.rotation.z = Math.sin(t * 7.5) * 0.035;
        st.say.style.display = "none";
        st.n6.visible = st.n7.visible = amp > 0.1;
        var pop = 1 + Math.abs(Math.sin(t * 7.5)) * 0.25;
        st.n6.scale.setScalar(0.2 * pop); st.n7.scale.setScalar(0.2 * pop);
        if(amp > 0.1 && t - st.lastTone > 0.42){
          st.lastTone = t;
          tone(st.six ? 770 : 660, 0.07, "triangle", 0.05);
          st.six = !st.six;
        }
      } else if(t < 8.5){
        g8.rotation.z = 0;
        mv.lArm.rotation.x = 0; mv.rArm.rotation.x = 0;
        st.elbows[0].rotation.x = -0.3; st.elbows[1].rotation.x = -0.3;
        g8.rotation.y = 0.65 * ((t - 8) / 0.5);
        st.n6.visible = st.n7.visible = false;
        st.cuhS.visible = true;
        st.say.style.display = "none";
      } else if(t < 12){
        st.say.style.display = "none";
        st.cuhS.visible = t < 9.6;
        st.cuhS.position.y = -0.08 + Math.sin(t * 3) * 0.015;
        var p3 = (t - 8.5) / 3.5;
        g8.rotation.y = 0.65;
        g8.position.x = 2.2 * p3;
        g8.position.z = 2.6 + 2.9 * p3;
        g8.position.y = Math.abs(Math.sin(t * 7)) * 0.03;
        mv.lLeg.rotation.x = Math.sin(t * 7) * 0.5;
        mv.rLeg.rotation.x = -Math.sin(t * 7) * 0.5;
        mv.lArm.rotation.x = -Math.sin(t * 7) * 0.35;
        mv.rArm.rotation.x = Math.sin(t * 7) * 0.35;
      } else eggClear();
    } else if(EGG.kind === 3){
      var s9 = st.soul;
      if(t < 5){
        var p4 = t / 5;
        s9.position.set(6.5 - 5.4 * p4, 1.6 - 0.25 * p4 + Math.sin(t * 2.4) * 0.14, 0.8);
        s9.rotation.y = Math.sin(t * 1.6) * 0.4;
      } else if(t < 11){
        s9.position.set(1.1, 1.35 + Math.sin(t * 2.4) * 0.12, 0.8);
        s9.rotation.y = Math.sin(t * 1.6) * 0.4;
      } else if(t < 14){
        var p5 = (t - 11) / 3;
        s9.scale.setScalar(1 + p5 * 0.8);
        st.fade[0].opacity = 0.4 * (1 - p5);
        st.fade[1].opacity = 0.85 * (1 - p5);
        st.eym.opacity = 1 - p5;
        st.tails.forEach(function(tw2){ tw2.mm.opacity = Math.max(0, (0.32 - tw2.off * 0.06) * (1 - p5)); });
        st.bubbles.forEach(function(bb4){ bb4.mm.opacity = 0.5 * (1 - p5); });
        st.drips.forEach(function(dd3){ dd3.mm.opacity = 0.7 * (1 - p5); });
      }
      st.tails.forEach(function(tw3, twi){
        tw3.m.position.x = Math.sin(t * 2.8 + twi) * 0.05;
      });
      st.bubbles.forEach(function(bb5){
        var bp2 = (t * 0.45 + bb5.off) % 1;
        bb5.m.position.set(Math.sin(bb5.off * 17 + t) * 0.14, 0.1 + bp2 * 0.4, 0.1);
        if(t < 11) bb5.mm.opacity = 0.5 * (1 - bp2);
      });
      st.drips.forEach(function(dd4){
        var dp2 = (t * 0.7 + dd4.off) % 1;
        dd4.m.position.set(dd4.off > 0.3 ? 0.07 : -0.07, -0.15 - dp2 * 0.45, 0.05);
        if(t < 11) dd4.mm.opacity = 0.7 * (1 - dp2);
      });
      if(G.moon){
        var mp2 = t < 2 ? 0 : t < 5 ? (t - 2) / 3 : t < 13 ? 1 : Math.max(0, 1 - (t - 13) / 2);
        var mx2 = 4.4 + 0.6 * mp2;
        var my2 = 5.4 - 3.05 * mp2;
        G.moon.position.set(mx2, my2, -9.25);
        if(G.moonHalo) G.moonHalo.position.set(mx2, my2, -9.3);
        var eo = t < 4.5 ? 0 : t < 6 ? (t - 4.5) / 1.5 : t < 12 ? 1 : Math.max(0, 1 - (t - 12) / 2);
        st.e1.material.opacity = eo;
        st.e2.material.opacity = eo;
        st.e1.position.set(mx2 - 0.20, my2 + 0.58, -9.26);
        st.e2.position.set(mx2 + 0.22, my2 + 0.60, -9.26);
      }
      if(t >= 15) eggClear();
    } else if(EGG.kind === 4){
      var lg2 = st.log;
      if(t < 5){
        lg2.position.x = -7 + 7.2 * (t / 5);
        lg2.rotation.y = -lg2.position.x / 0.22;
        var vc = Math.floor((t / 5) * st.vine.length);
        for(var vv = 0; vv < st.vine.length; vv++) st.vine[vv].visible = vv < vc;
        if(!st.said && t > 4.2){
          st.said = true;
          say(pick(["A natural log. How fitting.",
                    "Careful, lad. That one grows at a rate proportional to itself.",
                    "ln of that log? A thing of beauty."]));
        }
      } else if(t < 8.5){
        lg2.position.x = 0.2;
        var rs8 = Math.min(1, (t - 5) / 0.45);
        lg2.rotation.y = (-0.2 / 0.22) * (1 - rs8);
        for(var va = 0; va < st.vine.length; va++) st.vine[va].visible = true;
      } else if(t < 13){
        lg2.position.x = 0.2 + 7.3 * ((t - 8.5) / 4.5);
        lg2.rotation.y = -(lg2.position.x - 0.2) / 0.22;
      } else eggClear();
    } else if(EGG.kind === 5){
      var bn = st.bun, lm = st.lam;
      if(t < 1.0){
        var pb = t / 1.0;
        bn.position.set(-3.85, 0.9 + 0.95 * pb, -5.45);
        lm.position.set(3.85, 0.9 + 0.95 * Math.min(1, pb * 1.12), -5.45);
        bn.rotation.y = 0.4;
        lm.rotation.y = -0.4;
      } else if(t < 1.5){
        var pf3 = (t - 1.0) / 0.5;
        bn.position.set(-3.85 + 0.10 * pf3, 1.85 - 0.21 * pf3 + Math.sin(pf3 * Math.PI) * 0.08, -5.45 + 0.30 * pf3);
        lm.position.set(3.85 - 0.10 * pf3, 1.85 - 0.21 * pf3 + Math.sin(pf3 * Math.PI) * 0.07, -5.45 + 0.30 * pf3);
      } else if(t < 12.6){
        bn.position.set(-3.55 - 0.2 - Math.sin(t * 0.9) * 0.2,
          1.64 + Math.abs(Math.sin(t * 3.5)) * 0.06, -5.15);
        bn.rotation.y = Math.cos(t * 0.9) > 0 ? -0.6 : 0.6;
        st.ears[0].rotation.z = Math.sin(t * 3.1) * 0.14;
        st.ears[1].rotation.z = -Math.sin(t * 3.4) * 0.14;
        lm.position.set(3.55 + 0.2 + Math.sin(t * 0.75) * 0.2, 1.64, -5.15);
        lm.rotation.y = Math.cos(t * 0.75) > 0 ? 0.6 : -0.6;
        st.legs.forEach(function(lg3, li2){
          lg3.rotation.x = Math.sin(t * 6 + (li2 % 2 ? Math.PI : 0)) * 0.45;
        });
      } else if(t < 13.4){
        var pj = (t - 12.6) / 0.8;
        bn.rotation.y = 0.4;
        lm.rotation.y = -0.4;
        bn.position.set(-3.75 - 0.10 * pj, 1.64 + Math.sin(pj * Math.PI) * 0.2 - 0.0 * pj, -5.15 - 0.30 * pj);
        lm.position.set(3.75 + 0.10 * pj, 1.64 + Math.sin(pj * Math.PI) * 0.18, -5.15 - 0.30 * pj);
        st.legs.forEach(function(lg4){ lg4.rotation.x = 0; });
      } else if(t < 14.4){
        var ps2 = (t - 13.4) / 1.0;
        bn.position.set(-3.85, 1.64 - 0.95 * ps2, -5.45);
        lm.position.set(3.85, 1.64 - 0.95 * ps2, -5.45);
      } else eggClear();
    } else {
      var pp = st.pup, T9 = st.T;
      if(t < 2.2){
        var pr = t / 2.2;
        st.rig.visible = false;
        T9.rotation.x = 0;
        pp.rotation.y = -2.06;
        pp.position.set(7.2 - 10.5 * pr, Math.abs(Math.sin(t * 9)) * 0.06, 1.2 - 5.6 * pr);
        st.legs.forEach(function(lg5, li3){
          lg5.rotation.x = Math.sin(t * 11 + (li3 === 0 || li3 === 3 ? 0 : Math.PI)) * 0.7;
        });
        st.tail.rotation.z = Math.sin(t * 10) * 0.3;
      } else if(t < 2.9){
        var pj2 = (t - 2.2) / 0.7;
        T9.rotation.x = -1.15 * pj2;
        pp.rotation.y = -2.06 + (Math.PI + 2.06) * pj2;
        pp.position.set(-3.3 - 0.25 * pj2, 1.64 * pj2 + Math.sin(pj2 * Math.PI) * 0.3, -4.4 - 0.72 * pj2);
        st.legs.forEach(function(lg6){ lg6.rotation.x = 0; });
      } else if(t < 9){
        T9.rotation.x = -1.15;
        pp.rotation.y = Math.PI;
        pp.position.set(-3.55, 1.64, -5.12);
        st.rig.visible = true;
        st.rig.rotation.x = 1.15 + Math.sin(t * 2) * 0.05;
        st.legs[0].rotation.x = -0.35;
        st.legs[1].rotation.x = -0.35;
        st.tail.rotation.z = Math.sin(t * 6) * 0.25;
      } else if(t < 9.8){
        var pc = (t - 9) / 0.8;
        st.rig.rotation.x = 1.15 - 0.55 * Math.sin(pc * Math.PI);
        st.fish.visible = true;
        st.fish.position.set(0, -0.26 + 0.42 * pc, 0.50 - 0.36 * pc);
        st.fish.rotation.z = pc * 5;
        if(!st.splash){ st.splash = true; tone(480, 0.08, "triangle", 0.08); }
      } else if(t < 11){
        st.fish.position.set(0, 0.16 + Math.sin(t * 9) * 0.012, 0.13);
        st.fish.rotation.z = Math.sin(t * 9) * 0.3;
        if(!st.yip && t > 10.7){
          st.yip = true;
          st.fish.visible = false;
          tone(900, 0.05, "square", 0.06);
          setTimeout(function(){ tone(1250, 0.05, "square", 0.06); }, 90);
        }
      } else if(t < 11.8){
        var pd = (t - 11) / 0.8;
        st.rig.visible = false;
        T9.rotation.x = -1.15 * (1 - pd);
        pp.position.set(-3.55 + 0.25 * pd, 1.64 - 1.64 * pd + Math.sin(pd * Math.PI) * 0.2, -5.12 + 0.72 * pd);
        pp.rotation.y = Math.PI - (Math.PI - 1.08) * pd;
      } else if(t < 14.8){
        var pw = (t - 11.8) / 3;
        pp.rotation.y = 1.08;
        T9.rotation.x = 0;
        pp.position.set(-3.3 + 10.5 * pw, Math.abs(Math.sin(t * 9)) * 0.06, -4.4 + 5.6 * pw);
        st.legs.forEach(function(lg7, li4){
          lg7.rotation.x = Math.sin(t * 11 + (li4 === 0 || li4 === 3 ? 0 : Math.PI)) * 0.7;
        });
        st.tail.rotation.z = Math.sin(t * 10) * 0.3;
      } else eggClear();
    }
  }

  /* ---------- staking: the sand casino ---------- */
  var STAKE = {on:false, projs:[]};
  var SCAM_NAMES = ["Wise OId Man", "Wlse Old Man", "Wise 0ld Man"];
  function stakeBarTex(){
    var cv = document.createElement("canvas"); cv.width = 96; cv.height = 20;
    return {cv:cv, g:cv.getContext("2d"), tex:new THREE.CanvasTexture(cv)};
  }
  function stakeBarDraw(b, hp){
    b.g.clearRect(0, 0, 96, 20);
    b.g.fillStyle = "#7a1f1a"; b.g.fillRect(0, 0, 96, 20);
    b.g.fillStyle = "#2f8f3f"; b.g.fillRect(0, 0, Math.round(96 * Math.max(0, hp) / 49), 20);
    b.g.strokeStyle = "#1a1426"; b.g.lineWidth = 3; b.g.strokeRect(0, 0, 96, 20);
    b.tex.needsUpdate = true;
  }
  function buildStakeArena(){
    if(!G.scene) return;
    var g = new THREE.Group();
    var SAND = mat(0xd8c48a), SANDD = mat(0xb9a468);
    box(1.7, 0.1, 1.7, SAND, 0, 0.05, 0, g);
    box(1.7, 0.12, 0.08, SANDD, 0, 0.16, 0.81, g);
    box(1.7, 0.12, 0.08, SANDD, 0, 0.16, -0.81, g);
    box(0.08, 0.12, 1.7, SANDD, 0.81, 0.16, 0, g);
    box(0.08, 0.12, 1.7, SANDD, -0.81, 0.16, 0, g);
    function mkBar(x){
      var b = stakeBarTex();
      var m6 = new THREE.Mesh(new THREE.PlaneGeometry(0.42, 0.09),
        new THREE.MeshBasicMaterial({map:b.tex, transparent:true, depthTest:false}));
      m6.renderOrder = 15;
      m6.position.set(x, 0.86, 0);
      g.add(m6);
      b.mesh = m6;
      return b;
    }
    var barY = mkBar(-0.5), barF = mkBar(0.5);
    g.position.set(0, 0, 2.85);
    g.visible = false;
    G.scene.add(g);
    G.stake = {group:g, you:null, foe:null, barY:barY, barF:barF};
  }
  function stakeFighter(isYou, scam){
    if(isYou){
      var av = makeMan({shirt:0x3a5f8a, pants:0x4a4034, hair:0x5a4632, skin:0xe6b98c});
      av.group.scale.setScalar(0.42);
      cyl(0.025, 0.025, 1.05, 5, mat(0x5d4126), 0.26, 0.62, 0.08, av.group);
      sph(0.075, mat(0x4f8fd0), 0.26, 1.18, 0.08, av.group);
      av.hurt = 0;
      return av;
    }
    var gg = (G.wom && G.wom.group)
      ? G.wom.group.clone(true)
      : makeMan({shirt:0x7a7046, pants:0x54462e, hair:0xe8e2d4, skin:0xd9c8a8}).group;
    gg.position.set(0, 0, 0);
    gg.rotation.set(0, 0, 0);
    gg.scale.setScalar(0.27);
    if(scam){
      gg.traverse(function(o5){
        if(o5.isMesh && o5.material && o5.material.color){
          var hx = o5.material.color.getHex();
          if(hx === 0x2b3fe0) o5.material = mat(0x3f8f4f);
          else if(hx === 0x2333b8) o5.material = mat(0x2f7a3f);
          else if(hx === 0xc2913c) o5.material = mat(0xc03a3a);
          else if(hx === 0x7d7a2e) o5.material = mat(0x241f2e);
          else if(hx === 0x6b6826) o5.material = mat(0x18141f);
          else if(hx === 0xf2efe6) o5.material = mat(0x9aa0a8);
        }
      });
      var sh = new THREE.Group();
      var SHW = mat(0x5d4126), SHD = mat(0x3f2c18), SHG = mat(0xc9a24d), SHS = mat(0x9aa0a8);
      box(0.34, 0.42, 0.05, SHW, 0, 0.05, 0, sh);
      box(0.24, 0.14, 0.05, SHW, 0, -0.22, 0, sh);
      box(0.11, 0.09, 0.05, SHD, 0, -0.32, 0, sh);
      box(0.36, 0.045, 0.06, SHG, 0, 0.27, 0, sh);
      box(0.045, 0.44, 0.06, SHG, -0.17, 0.04, 0, sh);
      box(0.045, 0.44, 0.06, SHG, 0.17, 0.04, 0, sh);
      var bs = cyl(0.075, 0.055, 0.06, 8, SHS, 0, 0.05, 0.03, sh);
      bs.rotation.x = Math.PI / 2;
      [[-0.12, 0.2], [0.12, 0.2], [-0.12, -0.1], [0.12, -0.1]].forEach(function(rv){
        var r6 = cyl(0.02, 0.02, 0.055, 6, SHG, rv[0], rv[1], 0.005, sh);
        r6.rotation.x = Math.PI / 2;
      });
      sh.position.set(-0.46, 0.85, 0.16);
      sh.rotation.y = 0.18;
      gg.add(sh);
    }
    return {group:gg, hurt:0};
  }
  function stakeSplat(x, dmg){
    var cv = document.createElement("canvas"); cv.width = 64; cv.height = 64;
    var c = cv.getContext("2d");
    c.translate(32, 32);
    c.fillStyle = dmg > 0 ? "#a1352c" : "#2f5fa8";
    c.beginPath();
    for(var i = 0; i < 8; i++){
      var a = i * Math.PI / 4;
      var r = i % 2 ? 17 : 30;
      c[i ? "lineTo" : "moveTo"](Math.cos(a) * r, Math.sin(a) * r);
    }
    c.closePath(); c.fill();
    c.strokeStyle = "rgba(0,0,0,.45)"; c.lineWidth = 2; c.stroke();
    c.fillStyle = "#fff"; c.font = "bold 26px monospace"; c.textAlign = "center"; c.textBaseline = "middle";
    c.fillText(String(dmg), 0, 1);
    var m7 = new THREE.Mesh(new THREE.PlaneGeometry(0.22, 0.22),
      new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(cv), transparent:true, depthTest:false}));
    m7.renderOrder = 16;
    m7.position.set(x, 0.55, 0.08);
    G.stake.group.add(m7);
    STAKE.splats = STAKE.splats || [];
    STAKE.splats.push({m:m7, t:0});
  }
  function stakeBolt(from, to, colr){
    var m5 = new THREE.Mesh(new THREE.SphereGeometry(0.05, 8, 6),
      new THREE.MeshBasicMaterial({color:colr}));
    var p0 = new THREE.Vector3(), p1 = new THREE.Vector3();
    from.group.getWorldPosition(p0); to.group.getWorldPosition(p1);
    p0.y += 0.5; p1.y += 0.4;
    m5.position.copy(p0);
    G.scene.add(m5);
    STAKE.projs.push({m:m5, p0:p0, p1:p1, t:0});
  }
  function stakeTick(dt){
    for(var i = STAKE.projs.length - 1; i >= 0; i--){
      var pr = STAKE.projs[i];
      pr.t += dt / 0.38;
      if(pr.t >= 1){ G.scene.remove(pr.m); STAKE.projs.splice(i, 1); continue; }
      pr.m.position.lerpVectors(pr.p0, pr.p1, pr.t);
      pr.m.position.y += Math.sin(pr.t * Math.PI) * 0.25;
    }
    if(STAKE.splats) for(var s6 = STAKE.splats.length - 1; s6 >= 0; s6--){
      var sp6 = STAKE.splats[s6];
      sp6.t += dt;
      sp6.m.position.y = 0.55 + sp6.t * 0.25;
      sp6.m.material.opacity = Math.max(0, 1 - sp6.t / 0.75);
      if(sp6.t >= 0.75){ G.stake.group.remove(sp6.m); STAKE.splats.splice(s6, 1); }
    }
    if(G.stake){
      ["you", "foe"].forEach(function(k5){
        var f5 = G.stake[k5];
        if(f5 && f5.hurt > 0){
          f5.hurt -= dt;
          f5.group.position.z = Math.sin(f5.hurt * 55) * 0.03;
          if(f5.hurt <= 0) f5.group.position.z = 0;
        }
      });
    }
  }
  function stakeStart(){
    actx();
    if(STAKE.on || el.stakeAsk.style.display !== "none") return;
    state.bet = Math.max(minBet(), Math.min(state.bet, maxBet()));
    STAKE.bet = state.bet;
    STAKE.scam = !!window.PVM_FORCE_SCAM || Math.random() < 0.05;
    STAKE.name = STAKE.scam ? SCAM_NAMES[Math.floor(Math.random() * SCAM_NAMES.length)] : "Wise Old Man";
    el.stakeAskName.textContent = STAKE.name;
    el.stakeAskInfo.textContent = "Stake " + fmtCoins(STAKE.bet) + " coins - Magic only, no armour";
    el.stakeAsk.style.display = "";
    tone(740, 0.07, "triangle", 0.06);
  }
  function stakeAccepted(){
    el.stakeAsk.style.display = "none";
    if(!G.stake){ el.vHand.textContent = "The arena is closed"; return; }
    STAKE.on = true;
    STAKE.hpY = 49; STAKE.hpF = 49;
    if(G.stake.you) G.stake.group.remove(G.stake.you.group);
    if(G.stake.foe) G.stake.group.remove(G.stake.foe.group);
    G.stake.you = stakeFighter(true, false);
    G.stake.foe = stakeFighter(false, STAKE.scam);
    G.stake.you.group.position.set(-0.5, 0.1, 0);
    G.stake.you.group.rotation.y = Math.PI / 2;
    G.stake.foe.group.position.set(0.5, 0.1, 0);
    G.stake.foe.group.rotation.y = -Math.PI / 2;
    G.stake.group.add(G.stake.you.group);
    G.stake.group.add(G.stake.foe.group);
    if(STAKE.splats) STAKE.splats.forEach(function(sp7){ G.stake.group.remove(sp7.m); });
    STAKE.splats = [];
    stakeBarDraw(G.stake.barY, 49);
    stakeBarDraw(G.stake.barF, 49);
    G.stake.group.visible = true;
    el.verdict.style.display = "none";
    el.stakeReadout.innerHTML = "&nbsp;";
    el.goBtn.textContent = "Dueling";
    setMood("deal");
    say(STAKE.scam ? "Hm. Have we met before, lad?" : "A duel it is. Mind the sand.");
    STAKE.timer = setTimeout(stakeRound, 1100);
    paint();
  }
  function stakeRound(){
    if(!STAKE.on) return;
    var dy = Math.floor(Math.random() * 11);
    var df = STAKE.scam ? 2 + Math.floor(Math.random() * 14) : Math.floor(Math.random() * 11);
    stakeBolt(G.stake.you, G.stake.foe, 0x4f8fd0);
    stakeBolt(G.stake.foe, G.stake.you, STAKE.scam ? 0xc03a3a : 0x8a5fc9);
    tone(880, 0.05, "square", 0.05);
    setTimeout(function(){ tone(700, 0.05, "square", 0.05); }, 80);
    setTimeout(function(){
      if(!STAKE.on) return;
      STAKE.hpF = Math.max(0, STAKE.hpF - dy);
      STAKE.hpY = Math.max(0, STAKE.hpY - df);
      el.stakeReadout.innerHTML = "You hit <b>" + dy + "</b> &nbsp;&middot;&nbsp; " + STAKE.name + " hits <b>" + df + "</b>";
      stakeBarDraw(G.stake.barY, STAKE.hpY);
      stakeBarDraw(G.stake.barF, STAKE.hpF);
      stakeSplat(0.5, dy);
      stakeSplat(-0.5, df);
      if(dy > 0){ G.stake.foe.hurt = 0.22; tone(240, 0.05, "square", 0.05); }
      if(df > 0){ G.stake.you.hurt = 0.22; tone(200, 0.05, "square", 0.05); }
      if(STAKE.hpY <= 0 || STAKE.hpF <= 0){
        setTimeout(stakeEnd, 500);
      } else {
        STAKE.timer = setTimeout(stakeRound, 950);
      }
    }, 380);
  }
  function stakeEnd(){
    if(!STAKE.on) return;
    STAKE.on = false;
    clearTimeout(STAKE.timer);
    var stats = state.stats;
    stats.stakeDuels = (stats.stakeDuels || 0) + 1;
    state.lastBet = STAKE.bet;
    el.verdict.style.display = "";
    var youDead = STAKE.hpY <= 0, foeDead = STAKE.hpF <= 0;
    if(youDead && !foeDead) G.stake.you.group.rotation.x = -Math.PI / 2;
    if(foeDead && !youDead) G.stake.foe.group.rotation.x = -Math.PI / 2;
    if(youDead && foeDead){
      el.verdict.className = "verdict big";
      el.vHand.textContent = "Both crash to the sand";
      el.vDelta.textContent = "Stake returned";
      say(pick(LINES.push)); sfxPush();
    } else if(foeDead){
      var sw9 = hotPay(STAKE.bet);
      state.coins += sw9;
      stats.stakeWins = (stats.stakeWins || 0) + 1;
      if(sw9 > stats.best) stats.best = sw9;
      el.verdict.className = "verdict big win";
      el.vHand.textContent = STAKE.scam ? "You out-hit a scammer" : "You take the stake";
      el.vDelta.textContent = "+" + fmtCoins(sw9) + " coins";
      say(pick(LINES.win)); setMood("win"); sfxWin(2);
    } else {
      state.coins -= STAKE.bet;
      state.stats.lost = (state.stats.lost || 0) + STAKE.bet;
      el.verdict.className = "verdict big loss";
      if(STAKE.scam) state.stats.stakeScams = (state.stats.stakeScams || 0) + 1;
      el.vHand.textContent = STAKE.scam ? "Scammed at the sand casino" : STAKE.name + " takes the stake";
      el.vDelta.textContent = "-" + fmtCoins(STAKE.bet) + " coins" + (STAKE.scam ? " \u00b7 read the name twice next time" : "");
      say(STAKE.scam ? "That... was not me, lad. Check the spelling." : pick(state.coins < 0 ? LINES.debt : LINES.loss));
      setMood("lose"); sfxLose();
    }
    el.goBtn.textContent = "Stake";
    setTimeout(function(){ if(!STAKE.on && G.stake) G.stake.group.visible = false; }, 2600);
    paint(); save();
  }

  /* ---------- roulette ---------- */
  var ROU = {spinning:false, anim:false};
  var ROU_ORDER = [0,32,15,19,4,21,2,25,17,34,6,27,13,36,11,30,8,23,10,5,24,16,33,1,20,14,31,9,22,18,29,7,28,12,35,3,26];
  var ROU_RED = {1:1,3:1,5:1,7:1,9:1,12:1,14:1,16:1,18:1,19:1,21:1,23:1,25:1,27:1,30:1,32:1,34:1,36:1};
  function rouWheelTex(){
    var cv = document.createElement("canvas"); cv.width = 512; cv.height = 512;
    var c = cv.getContext("2d");
    c.translate(256, 256);
    var n = ROU_ORDER.length, arc = Math.PI * 2 / n;
    for(var i = 0; i < n; i++){
      var num = ROU_ORDER[i];
      c.beginPath(); c.moveTo(0, 0);
      c.arc(0, 0, 250, i * arc - Math.PI / 2, (i + 1) * arc - Math.PI / 2);
      c.closePath();
      c.fillStyle = num === 0 ? "#2c7a3f" : ROU_RED[num] ? "#a1352c" : "#221d26";
      c.fill();
      c.strokeStyle = "#c9a24d"; c.lineWidth = 2; c.stroke();
      c.save();
      c.rotate(i * arc + arc / 2 - Math.PI / 2);
      c.fillStyle = "#efe6cd"; c.font = "bold 26px monospace"; c.textAlign = "center";
      c.fillText(String(num), 218, 9);
      c.restore();
    }
    c.beginPath(); c.arc(0, 0, 120, 0, 7); c.fillStyle = "#3a2b1c"; c.fill();
    c.strokeStyle = "#c9a24d"; c.lineWidth = 5; c.stroke();
    c.beginPath(); c.arc(0, 0, 20, 0, 7); c.fillStyle = "#c9a24d"; c.fill();
    return new THREE.CanvasTexture(cv);
  }
  function buildRoulette(){
    if(!G.scene) return;
    var g = new THREE.Group();
    var RWOOD = mat(0x5d4126), RDARK = mat(0x3f2c18), RFELT = mat(0x2e6b4f), RGOLD = mat(0xc9a24d);
    cyl(1.15, 1.25, 0.14, 8, RWOOD, 0, 0.86, 0, g);
    cyl(1.02, 1.02, 0.05, 8, RFELT, 0, 0.945, 0, g);
    cyl(0.16, 0.22, 0.82, 6, RDARK, 0, 0.41, 0, g);
    cyl(0.55, 0.7, 0.05, 8, RDARK, 0, 0.03, 0, g);
    cyl(0.78, 0.86, 0.12, 24, RGOLD, 0, 0.99, 0, g);
    var wheel = new THREE.Mesh(new THREE.CylinderGeometry(0.72, 0.72, 0.06, 48),
      [new THREE.MeshStandardMaterial({color:0x3a2b1c}),
       new THREE.MeshBasicMaterial({map:rouWheelTex()}),
       new THREE.MeshStandardMaterial({color:0x3a2b1c})]);
    wheel.position.set(0, 1.05, 0);
    g.add(wheel);
    var ball = new THREE.Mesh(new THREE.SphereGeometry(0.035, 10, 8),
      new THREE.MeshStandardMaterial({color:0xf2ead2}));
    ball.position.set(0.56, 0.075, 0);
    ball.visible = false;
    wheel.add(ball);
    g.position.set(4.05, 0, 2.6);
    g.rotation.y = -Math.PI / 2;
    G.scene.add(g);
    G.rou = {group:g, wheel:wheel, ball:ball};
  }
  function rouTick(dt){
    if(!ROU.anim || !G.rou) return;
    ROU.t += dt;
    var p = Math.min(1, ROU.t / ROU.dur);
    var ease = 1 - Math.pow(1 - p, 3);
    G.rou.wheel.rotation.y = ROU.w0 + ROU.wV * ease;
    var laF = ROU.b0 - ROU.bV * ease - G.rou.wheel.rotation.y;
    var la;
    if(p < 0.7){
      la = laF;
      ROU.blend = null;
    } else {
      if(!ROU.blend){
        var k9 = Math.floor((laF - ROU.slotA) / (Math.PI * 2));
        var tg = ROU.slotA + k9 * Math.PI * 2;
        if(tg > laF) tg -= Math.PI * 2;
        ROU.blend = {la0:laF, tgt:tg};
      }
      var q = (p - 0.7) / 0.3;
      la = ROU.blend.la0 + (ROU.blend.tgt - ROU.blend.la0) * (1 - Math.pow(1 - q, 2));
    }
    var rr = 0.62 - 0.12 * p;
    G.rou.ball.position.set(Math.cos(la) * rr, 0.075, Math.sin(la) * rr);
    if(p < 1){
      if(Math.random() < dt * 6) tone(1500 + Math.random() * 500, 0.015, "square", 0.02);
    } else {
      G.rou.ball.position.set(Math.cos(ROU.slotA) * 0.5, 0.075, Math.sin(ROU.slotA) * 0.5);
      ROU.anim = false;
      if(ROU.onDone){ var f = ROU.onDone; ROU.onDone = null; f(); }
    }
  }
  function rouSpin(){
    actx();
    if(ROU.spinning || !G.rou) return;
    state.bet = Math.max(minBet(), Math.min(state.bet, maxBet()));
    var pk = state.rouPick || "red";
    ROU.spinning = true;
    ROU.bet = state.bet;
    var n = Math.floor(Math.random() * 37);
    el.verdict.className = "verdict";
    el.vHand.textContent = "No more bets";
    el.vDelta.textContent = "The wheel is live";
    el.rouReadout.innerHTML = "&nbsp;";
    el.goBtn.textContent = "Spinning";
    setMood("deal");
    var idx = ROU_ORDER.indexOf(n), arc = Math.PI * 2 / ROU_ORDER.length;
    ROU.t = 0; ROU.dur = 3.4;
    ROU.w0 = G.rou.wheel.rotation.y;
    ROU.wV = Math.PI * (4 + Math.random() * 2);
    ROU.b0 = Math.random() * 7;
    ROU.bV = Math.PI * (7 + Math.random() * 2);
    ROU.slotA = idx * arc + arc / 2;
    ROU.anim = true;
    G.rou.ball.visible = true;
    tone(1100, 0.05, "square", 0.05);
    ROU.onDone = function(){ rouSettle(n, pk); };
    paint();
  }
  function rouSettle(n, pk){
    var red = !!ROU_RED[n];
    var col = n === 0 ? "GREEN" : red ? "RED" : "BLACK";
    var cbg = n === 0 ? "#2c7a3f" : red ? "#a1352c" : "#221d26";
    var cfg = n === 0 ? "#6fce8b" : red ? "#e0685c" : "#cfd2d8";
    el.rouReadout.innerHTML = "<b style='color:" + cfg + "'>" + n + "</b>" +
      "<span style='background:" + cbg + ";color:#f2ead2;padding:2px 10px;border-radius:9px;" +
      "border:1px solid rgba(201,162,77,.4);font-size:14px;letter-spacing:.08em'>" + col + "</span>";
    var mult = 0;
    if(pk === "red" && red) mult = 1;
    else if(pk === "black" && n > 0 && !red) mult = 1;
    else if(pk === "odd" && n > 0 && n % 2 === 1) mult = 1;
    else if(pk === "even" && n > 0 && n % 2 === 0) mult = 1;
    else if(pk === "low" && n >= 1 && n <= 18) mult = 1;
    else if(pk === "high" && n >= 19) mult = 1;
    else if(pk === "zero" && n === 0) mult = 35;
    else if(pk === "num" && n === (state.rouNum != null ? state.rouNum : -1)) mult = 35;
    var stats = state.stats;
    stats.rouSpins = (stats.rouSpins || 0) + 1;
    state.lastBet = ROU.bet;
    el.verdict.className = "verdict big" + (mult ? " win" : " loss");
    if(mult){
      var wamt = hotPay(ROU.bet * mult);
      state.coins += wamt;
      stats.rouWins = (stats.rouWins || 0) + 1;
      if(wamt > stats.best) stats.best = wamt;
      el.vHand.textContent = n + " " + col.toLowerCase() + ", it lands your way";
      el.vDelta.textContent = "+" + fmtCoins(wamt) + " coins";
      say(pick(LINES.win)); setMood("win"); sfxWin(mult > 1 ? 3 : 2);
    } else {
      state.coins -= ROU.bet;
      state.stats.lost = (state.stats.lost || 0) + ROU.bet;
      el.vHand.textContent = n + " " + col.toLowerCase() + ", the house sweeps";
      el.vDelta.textContent = "-" + fmtCoins(ROU.bet) + " coins";
      say(pick(state.coins < 0 ? LINES.debt : LINES.loss)); setMood("lose"); sfxLose();
    }
    ROU.spinning = false;
    el.goBtn.textContent = "Spin";
    paint(); save();
  }

  /* ---------- dye shop ---------- */
  var DYES = [
    {k:"blood", n:"Blood dye", fb:9330000000, sw:"#a83232", img:"Blood_dye.png"},
    {k:"third", n:"Third Age dye", fb:8850000000, sw:"#74838b", img:"Third_Age_dye.png"},
    {k:"shadow", n:"Shadow dye", fb:710000000, sw:"#9b77a6", img:"Shadow_dye.png"},
    {k:"ice", n:"Ice dye", fb:626000000, sw:"#9fd7e8", img:"Ice_dye.png"},
    {k:"aurora", n:"Aurora dye", fb:282000000, sw:"#496797", img:"Aurora_dye.png"},
    {k:"soul", n:"Soul dye", fb:225000000, sw:"#327457", img:"Soul_dye.png"},
    {k:"barrows", n:"Barrows dye", fb:72000000, sw:"#8c9177", img:"Barrows_dye.png"}
  ];
  var DYE_OK = {blood:1, third:1, shadow:1, ice:1, aurora:1, soul:1, barrows:1, trim:1};
  /* clipping-mask textures for the dyes that move in game */
  function smokeTex(base, lite, dark){
    var cv = document.createElement("canvas"); cv.width = 256; cv.height = 64;
    var c = cv.getContext("2d");
    c.fillStyle = base; c.fillRect(0, 0, 256, 64);
    try{ c.filter = "blur(7px)"; }catch(e){}
    for(var i = 0; i < 52; i++){
      c.fillStyle = Math.random() < 0.55 ? lite : dark;
      c.globalAlpha = 0.15 + Math.random()*0.22;
      c.beginPath();
      c.arc(Math.random()*256, Math.random()*64, 5 + Math.random()*15, 0, 7);
      c.fill();
    }
    return cv.toDataURL();
  }
  function iceTex(){
    var cv = document.createElement("canvas"); cv.width = 256; cv.height = 64;
    var c = cv.getContext("2d");
    c.fillStyle = "#9fd7e8"; c.fillRect(0, 0, 256, 64);
    try{ c.filter = "blur(2px)"; }catch(e){}
    var i;
    for(i = 0; i < 14; i++){                       /* deeper glacial patches */
      c.fillStyle = "#5fa8c4"; c.globalAlpha = 0.14 + Math.random()*0.14;
      c.beginPath(); c.arc(Math.random()*256, Math.random()*64, 8 + Math.random()*16, 0, 7); c.fill();
    }
    for(i = 0; i < 26; i++){                       /* diagonal frost streaks */
      var x = Math.random()*256, y = Math.random()*64, l = 10 + Math.random()*24;
      c.strokeStyle = "#eafcff"; c.globalAlpha = 0.12 + Math.random()*0.2;
      c.lineWidth = 1 + Math.random()*2;
      c.beginPath(); c.moveTo(x, y); c.lineTo(x + l, y - l*0.55); c.stroke();
    }
    try{ c.filter = "none"; }catch(e){}
    for(i = 0; i < 24; i++){                       /* crystal glints */
      c.fillStyle = "#ffffff"; c.globalAlpha = 0.75 + Math.random()*0.25;
      c.beginPath(); c.arc(Math.random()*256, Math.random()*64, 0.7 + Math.random()*1.1, 0, 7); c.fill();
    }
    return cv.toDataURL();
  }
  function trimTex(){
    var cv = document.createElement("canvas"); cv.width = 256; cv.height = 64;
    var c = cv.getContext("2d");
    c.fillStyle = "#d8a944"; c.fillRect(0, 0, 256, 64);
    try{ c.filter = "blur(5px)"; }catch(e){}
    var i;
    for(i = 0; i < 30; i++){                       /* molten gold waves */
      c.fillStyle = Math.random() < 0.6 ? "#fff1c4" : "#9c6f1e";
      c.globalAlpha = 0.18 + Math.random()*0.22;
      c.beginPath(); c.arc(Math.random()*256, Math.random()*64, 6 + Math.random()*14, 0, 7); c.fill();
    }
    return cv.toDataURL();
  }
  (function injectDyeArt(){
    try{
      var clip = "-webkit-background-clip:text;background-clip:text;color:transparent;background-repeat:repeat;background-size:230px 34px;";
      var st = document.createElement("style");
      st.textContent =
        "@keyframes pvmSmoke{from{background-position:0 0}to{background-position:230px 12px}}" +
        "@keyframes pvmTrimGlow{from{filter:drop-shadow(0 0 2px rgba(224,180,88,.35))}to{filter:drop-shadow(0 0 7px rgba(240,210,130,.85))}}" +
        "#pvm-poker .dyename.dye-blood{background-image:url(" + smokeTex("#a83232", "#e8b9ac", "#571313") + ");" + clip + "animation:pvmSmoke 8s linear infinite alternate}" +
        "#pvm-poker .dyename.dye-shadow{background-image:url(" + smokeTex("#9b77a6", "#dcc6e2", "#3c2547") + ");" + clip + "animation:pvmSmoke 10s linear infinite alternate}" +
        "#pvm-poker .dyename.dye-soul{background-image:url(" + smokeTex("#327457", "#9fd8b8", "#123526") + ");" + clip + "animation:pvmSmoke 9s linear infinite alternate}" +
        "#pvm-poker .dyename.dye-ice{background-image:url(" + iceTex() + ");" + clip + "animation:pvmSmoke 13s linear infinite alternate;filter:drop-shadow(0 0 3px rgba(159,215,232,.55))}" +
        "#pvm-poker .dyename.dye-trim{background-image:url(" + trimTex() + ");" + clip + "animation:pvmSmoke 3.2s linear infinite alternate, pvmTrimGlow 2.4s ease-in-out infinite alternate}";
      document.head.appendChild(st);
    }catch(e){}
  })();
  var dyeFetched = false;
  function dyeByK(k){ for(var i = 0; i < DYES.length; i++) if(DYES[i].k === k) return DYES[i]; return null; }
  function dyeOwned(k){ return state.cosmetics.owned.indexOf(k) !== -1; }
  function fmtGe(v){ return fmtBet(v); }
  function prestigeMult(){ return Math.pow(10, state.stats.prestige || 0); }
  function shopPrice(d){
    var base = d.ge ? Math.max(Math.round(d.fb/2), Math.min(d.fb*3, d.ge)) : d.fb;
    return base * prestigeMult();   /* live GE price, clamped sane, then 10x per prestige */
  }
  function dyeCard(d, full){
    var owned = dyeOwned(d.k), eq = state.cosmetics.eq === d.k, p = shopPrice(d);
    var h = "<div class='dyecard" + (full ? " full" : "") + "'>";
    h += "<div class='dtop'><span class='dyeswatch'><img src='https://runescape.wiki/images/" + d.img + "' referrerpolicy='no-referrer' alt='' onerror=\"this.parentNode.style.background='" + d.sw + "';this.parentNode.style.borderRadius='50%';this.remove()\"></span><span class='dnm dyename dye-" + d.k + "'>" + d.n + "</span></div>";
    var inCycle = state.cosmetics.cycle.indexOf(d.k) !== -1;
    h += "<div class='dpr'>" + (inCycle ? "Bought this prestige" : fmtGe(p) + " coins") + "</div>";
    h += "<div class='dbtns'>";
    if(!inCycle) h += "<button data-act='buy' data-k='" + d.k + "'" + (state.coins < p ? " disabled" : "") + ">Buy</button>";
    if(owned) h += "<button data-act='eq' data-k='" + d.k + "' class='" + (eq ? "eqd" : "") + "'>" + (eq ? "Equipped" : "Equip") + "</button>";
    h += "</div></div>";
    return h;
  }
  function renderShop(){
    var nm = user ? dname() : "Adventurer";
    var eqk = state.cosmetics.eq;
    el.shopPreview.innerHTML = "Your name on the boards: <span class='dyename" + (eqk ? " dye-" + eqk : "") + "'>" +
      String(nm || "Adventurer").replace(/[<>&]/g,"") + "</span>";
    var order = [["blood","third"],["shadow","ice"],["aurora","soul"],["barrows"]];
    var h = "<div class='dyegrid'>";
    order.forEach(function(rw){
      rw.forEach(function(k){ h += dyeCard(dyeByK(k), rw.length === 1); });
    });
    var all = state.cosmetics.owned.length >= DYES.length;
    var allCycle = state.cosmetics.cycle.length >= DYES.length;
    var teq = state.cosmetics.eq === "trim";
    h += "<div class='dyecard full'><div class='dtop'><span class='dyeswatch' style='background:linear-gradient(135deg,#f6dfa5,#e0b458,#fff6d8);border-radius:50%'></span>" +
         "<span class='dnm" + (all ? " dyename dye-trim" : "") + "'>Trimmed</span></div>";
    h += "<div class='dge'>" + (all ? "The full set. The old man pays his debts." : "Collect all seven dyes to unlock") + "</div>";
    h += "<div class='dbtns'>" + (all ? "<button data-act='eq' data-k='trim' class='" + (teq ? "eqd" : "") + "'>" + (teq ? "Equipped" : "Equip") + "</button>" : "") + "</div></div>";
    var P = state.stats.prestige || 0;
    h += "<div class='dyecard full'><div class='dtop'><span class='pstar' style='font-size:16px'>&#9733;</span>" +
         "<span class='dnm' style='color:var(--gold)'>Prestige" + (P ? " " + P : "") + "</span></div>";
    h += "<div class='dge'>" + (allCycle
        ? (state.coins > 0
            ? "Retire your fortune: burn your entire balance of " + fmtCoins(state.coins) + " coins and take a permanent star. Dyes you own stay yours forever; the next prestige needs the set bought again at 10x prices."
            : "You need a positive balance to prestige.")
        : "Buy all seven dyes this prestige to unlock (" + state.cosmetics.cycle.length + " / 7).") + "</div>";
    if(state.stats.burned) h += "<div class='dge'>Burned so far: " + fmtCoins(state.stats.burned) + " coins</div>";
    h += "<div class='dbtns'>" + (allCycle && state.coins > 0 ? "<button data-act='prestige'>Prestige</button>" : "") + "</div></div>";
    h += "</div>";
    el.shopBody.innerHTML = h;
  }
  function openShop(){
    el.shop.classList.add("on");
    renderShop();
    if(!dyeFetched){
      dyeFetched = true;
      fetch("https://api.weirdgloop.org/exchange/history/rs/latest?name=" + encodeURIComponent(DYES.map(function(d){ return d.n; }).join("|")))
        .then(function(r){ return r.json(); })
        .then(function(j){
          DYES.forEach(function(d){
            var e = j && j[d.n], pv = e && +e.price;
            if(pv && isFinite(pv)) d.ge = pv;
          });
          renderShop();
        }).catch(function(){});
    }
  }
  el.shopBody.addEventListener("click", function(ev){
    var b = ev.target.closest("button");
    if(!b) return;
    var k = b.dataset.k;
    if(b.dataset.act === "buy"){
      var d = dyeByK(k);
      if(!d || state.cosmetics.cycle.indexOf(k) !== -1) return;
      var p = shopPrice(d);
      if(state.coins < p) return;
      state.coins -= p;
      state.cosmetics.cycle.push(k);
      var newUnlock = state.cosmetics.owned.indexOf(k) === -1;
      if(newUnlock) state.cosmetics.owned.push(k);
      state.cosmetics.eq = k;
      say(pick(LINES.dyeBuy)); setMood("win"); sfxWin(2);
      if(newUnlock && state.cosmetics.owned.length >= DYES.length) setTimeout(function(){ say(pick(LINES.dyeTrim)); }, 2600);
      paint(); renderShop(); save();
    } else if(b.dataset.act === "prestige"){
      if(state.cosmetics.cycle.length < DYES.length || state.coins <= 0) return;
      if(!confirm("Prestige now? Your ENTIRE balance of " + fmtCoins(state.coins) + " coins burns and you gain a permanent prestige star. Dyes you own stay unlocked forever, but the next prestige needs the full set bought again at 10x prices.")) return;
      state.stats.burned = (state.stats.burned || 0) + state.coins;
      state.stats.prestige = (state.stats.prestige || 0) + 1;
      state.coins = 200;
      state.cosmetics.cycle = [];
      say(pick(LINES.prestige)); setMood("win"); sfxWin(8);
      applyPrestigeScene();
      paint(); renderShop(); save();
    } else if(b.dataset.act === "eq"){
      if(k === "trim" && state.cosmetics.owned.length < DYES.length) return;
      if(k !== "trim" && !dyeOwned(k)) return;
      state.cosmetics.eq = state.cosmetics.eq === k ? null : k;
      renderShop(); save();
    }
  });

  /* ---------- loot slots ---------- */
  var SLOTS = {spinning:false, anims:[], picks:null, leverT:-1};
  var SLOT_SYMS = {
    bones:{w:5, m:3}, shark:{w:4, m:5}, whip:{w:4, m:8},
    wand:{w:3, m:12}, dye:{w:2, m:25}, coin:{w:1, m:60}, phat:{w:1, m:250}
  };
  function slotPick(){
    var tot = 0, k;
    for(k in SLOT_SYMS) tot += SLOT_SYMS[k].w;
    var r = Math.random() * tot;
    for(k in SLOT_SYMS){ r -= SLOT_SYMS[k].w; if(r <= 0) return k; }
    return "bones";
  }
  function slotCellFor(sym){
    var opts = [];
    for(var i = 0; i < SLOT_CELLS.length; i++) if(SLOT_CELLS[i] === sym) opts.push(i);
    return opts[Math.floor(Math.random() * opts.length)];
  }
  function slotSpin(){
    if(SLOTS.spinning || !G.ok) return;
    actx();
    state.bet = Math.max(minBet(), Math.min(state.bet, maxBet()));
    SLOTS.spinning = true;
    SLOTS.picks = [slotPick(), slotPick(), slotPick()];
    SLOTS.anims = [];
    for(var r = 0; r < 3; r++){
      var g2 = G.slotReels[r];
      var cur = ((g2.rotation.x % (Math.PI*2)) + Math.PI*2) % (Math.PI*2);
      var target = (slotCellFor(SLOTS.picks[r]) + 0.5) * (Math.PI / 4);
      var delta = ((target - cur) % (Math.PI*2) + Math.PI*2) % (Math.PI*2);
      SLOTS.anims.push({g:g2, from:g2.rotation.x, to:g2.rotation.x + Math.PI*2*(3 + r*2) + delta, t:0, dur:1.0 + r*0.45, done:false});
    }
    SLOTS.leverT = 0;
    el.verdict.className = "verdict";
    el.vHand.textContent = "Reels spinning";
    el.vDelta.textContent = "Bet " + fmtCoins(state.bet) + " coins";
    setMood("deal");
    tone(400, 0.05, "square", 0.06);
    paint();
  }
  function slotSettle(){
    var p = SLOTS.picks, stats = state.stats;
    stats.slotSpins = (stats.slotSpins || 0) + 1;
    var payout = 0, label = "No match";
    if(p[0] === p[1] && p[1] === p[2]){
      payout = state.bet * SLOT_SYMS[p[0]].m;
      label = "Three of a kind! " + SLOT_SYMS[p[0]].m + "x";
    } else if(p[0] === p[1] || p[1] === p[2] || p[0] === p[2]){
      payout = state.bet * 2;
      label = "A pair pays 2x";
    }
    var net = payout - state.bet;
    if(net > 0) net = hotPay(net);
    state.coins += net;
    if(net > 0){
      stats.slotWins = (stats.slotWins || 0) + 1;
      if(net > stats.best) stats.best = net;
      el.verdict.className = "verdict big win";
      el.vHand.textContent = label;
      el.vDelta.textContent = "+" + fmtCoins(net) + " coins";
      say(pick(payout >= state.bet * 25 ? LINES.bigwin : LINES.win));
      setMood("win"); sfxWin(payout >= state.bet * 25 ? 8 : 2);
    } else {
      state.stats.lost = (state.stats.lost || 0) + state.bet;
      el.verdict.className = "verdict big loss";
      el.vHand.textContent = label;
      el.vDelta.textContent = "-" + fmtCoins(state.bet) + " coins";
      say(pick(state.coins < 0 ? LINES.debt : LINES.loss));
      setMood("lose"); sfxLose();
    }
    SLOTS.spinning = false;
    el.goBtn.textContent = "Spin";
    paint(); save();
  }

  /* ---------- pachinko: rapid fire, every ball pays its own way ---------- */
  var PACH = {balls: [], ballMat: null};
  var PACH_MULTS = [20, 3, 1, 0.2, 0.2, 1, 3, 20];
  function pachDrop(){
    if(!G.ok || PACH.balls.length >= 50) return;
    actx();
    state.bet = Math.max(minBet(), Math.min(state.bet, maxBet()));
    var bet = state.bet;
    state.coins -= bet;   /* the coin goes in the slot up front */
    var rights = 0, x = 0, path = [{x:0, y:2.30}];
    for(var r = 0; r < 7; r++){
      var right = Math.random() < 0.5 ? 0 : 1;
      rights += right;
      x += right ? 0.06 : -0.06;
      path.push({x:x, y:2.01 - r * 0.155});
    }
    path.push({x:-0.4025 + rights * 0.115, y:0.95});
    path.push({x:-0.4025 + rights * 0.115, y:0.82});
    if(!PACH.ballMat) PACH.ballMat = mat(0xe8c464, {metal:.6, rough:.3});
    var mesh = sph(0.035, PACH.ballMat, 0, 2.3, 0.18, G.pach);
    PACH.balls.push({mesh:mesh, path:path, seg:0, segT:0, binIdx:rights, bet:bet});
    el.verdict.className = "verdict";
    el.vHand.textContent = PACH.balls.length > 1 ? PACH.balls.length + " balls in play" : "Ball away";
    el.vDelta.textContent = "Bet " + fmtCoins(bet) + " coins each";
    tone(1000, 0.04, "square", 0.06);
    paint();
  }
  function pachSettleBall(ball){
    if(G.pach) G.pach.remove(ball.mesh);
    var m = PACH_MULTS[ball.binIdx], stats = state.stats;
    stats.pachDrops = (stats.pachDrops || 0) + 1;
    var payout = Math.round(ball.bet * m);
    if(payout > ball.bet) payout = ball.bet + hotPay(payout - ball.bet);
    state.coins += payout;
    var net = payout - ball.bet;
    if(net < 0) state.stats.lost = (state.stats.lost || 0) + (ball.bet - payout);
    if(net > 0){
      stats.pachWins = (stats.pachWins || 0) + 1;
      if(net > stats.best) stats.best = net;
      el.verdict.className = "verdict big win";
      el.vHand.textContent = m + "x bin!";
      el.vDelta.textContent = "+" + fmtCoins(net) + " coins";
      say(pick(m >= 20 ? LINES.bigwin : LINES.win));
      setMood("win"); sfxWin(m >= 20 ? 8 : 2);
    } else if(net === 0){
      el.verdict.className = "verdict big";
      el.vHand.textContent = "1x bin";
      el.vDelta.textContent = "Push, bet returned";
      sfxPush();
    } else {
      el.verdict.className = "verdict big loss";
      el.vHand.textContent = m + "x bin";
      el.vDelta.textContent = fmtCoins(net) + " coins";
      setMood("lose"); sfxLose();
    }
    paint(); save();
  }

  /* ================= MULTIPLAYER: live tables over Supabase Realtime, trust-the-host ================= */
  var MP = {on:false, live:false, host:false, code:null, id:Math.random().toString(36).slice(2,10),
            name:"", ch:null, priv:null, mode:"poker", players:[], myHand:[], marks:[],
            submitted:false, round:null, joinTimer:null, esc:false, timerLen:25, spec:false, H:null};
  MP.chips = 500;
  function mpAnte(){ return Math.max(5, Math.round(MP.chips * 0.05)); }
  function mpBjBet(){ return Math.max(10, Math.round(MP.chips * 0.10)); }
  function itemByTier(t){
    for(var i = 0; i < ITEMS.length; i++) if(ITEMS[i].tier === t) return ITEMS[i];
    return ITEMS[0];
  }
  function mpPlayerById(pid){
    if(!MP.H) return null;
    for(var i = 0; i < MP.H.players.length; i++) if(MP.H.players[i].id === pid) return MP.H.players[i];
    return null;
  }
  function mpNameOf(pid){
    for(var i = 0; i < MP.players.length; i++) if(MP.players[i].id === pid) return MP.players[i].name;
    return "?";
  }
  function mpSend(ev, pl){ if(MP.ch) MP.ch.send({type:"broadcast", event:ev, payload:pl}); }
  function mpPrivName(pid){ return "casino_" + MP.code + "_" + pid; }
  function mpHostPriv(pid){
    MP.H.priv = MP.H.priv || {};
    if(!MP.H.priv[pid]){
      var c = supa.channel(mpPrivName(pid));
      c.subscribe();
      MP.H.priv[pid] = c;
    }
    return MP.H.priv[pid];
  }
  function mpDealPrivate(pid, tiers){
    if(pid.indexOf("bot_") === 0) return;
    if(pid === MP.id){ mpGotHand(tiers); return; }
    mpHostPriv(pid).send({type:"broadcast", event:"hand", payload:{cards:tiers}});
  }
  function mpGotHand(tiers){
    MP.myHand = tiers || [];
    MP.marks = [];
    MP.submitted = false;
    if(MP.round) { mpRenderPoker(MP.round); mpPaintControls(MP.round); }
  }
  /* ---- connection ---- */
  function mpConnect(code, asHost){
    if(!supa){ el.mpMsg.textContent = "Multiplayer needs the live site."; return; }
    if(MP.ch) return;
    MP.code = code; MP.host = asHost;
    MP.name = (el.mpName.value || "").trim().slice(0, 14) || (user ? dname() : "Guest" + Math.floor(Math.random()*90 + 10));
    MP.ch = supa.channel("casino_" + code, {config:{broadcast:{self:false}}});
    MP.ch
      .on("broadcast", {event:"lobby"}, function(p){ mpOnLobby(p.payload); })
      .on("broadcast", {event:"round"}, function(p){ if(!MP.host) mpOnRound(p.payload); })
      .on("broadcast", {event:"join"}, function(p){ mpHostJoin(p.payload); })
      .on("broadcast", {event:"act"}, function(p){
        if(!MP.host) return;
        var pl = p.payload;
        if(pl.a === "check" || pl.a === "call" || pl.a === "raise" || pl.a === "fold") mpBetAct(pl.id, pl.a, pl.amt);
        else if(pl.a === "bet") mpBjBetAct(pl.id, pl.amt);
        else mpBjAct(pl.id, pl.a);
      })
      .on("broadcast", {event:"bye"}, function(p){ mpHostBye(p.payload.id); })
      .on("broadcast", {event:"emote"}, function(p){ mpBubble(p.payload.id, p.payload.txt); })
      .subscribe(function(st){
        if(st !== "SUBSCRIBED") return;
        if(asHost){
          MP.on = true;
          MP.H = {players:[{id:MP.id, name:MP.name, chips:MP.chips, out:false, dye:(state.cosmetics && DY_OK[state.cosmetics.eq]) ? state.cosmetics.eq : null}], priv:{}, specs:[], started:false};
          mpSendLobby();
        } else {
          mpSend("join", {id:MP.id, name:MP.name, dye:(state.cosmetics && DY_OK[state.cosmetics.eq]) ? state.cosmetics.eq : null});
          el.mpMsg.textContent = "Joining " + code + "...";
          MP.joinTimer = setTimeout(function(){
            el.mpMsg.textContent = "No table answered at " + code + ".";
            mpTeardown(false);
          }, 6000);
        }
      });
    MP.priv = supa.channel(mpPrivName(MP.id));
    MP.priv
      .on("broadcast", {event:"hand"}, function(p){ mpGotHand(p.payload.cards); })
      .on("broadcast", {event:"spec"}, function(){
        MP.on = true;
        MP.spec = true;
        clearTimeout(MP.joinTimer);
        el.mpMsg.textContent = "Table in progress. You are spectating.";
      })
      .subscribe();
  }
  function mpTeardown(notify){
    if(notify && MP.ch){
      if(MP.host) mpSend("lobby", {closed:true});
      else mpSend("bye", {id:MP.id});
    }
    if(MP.ch){ supa.removeChannel(MP.ch); }
    if(MP.priv){ supa.removeChannel(MP.priv); }
    if(MP.H && MP.H.priv) for(var k in MP.H.priv) supa.removeChannel(MP.H.priv[k]);
    if(MP.H){ clearTimeout(MP.H.timer); clearTimeout(MP.H.botT); }
    clearTimeout(MP.joinTimer);
    var wasLive = MP.live;
    MP.on = false; MP.live = false; MP.host = false; MP.spec = false; MP.ch = null; MP.priv = null;
    el.mpBar.style.display = "none";
    el.mpOpps.style.display = "none";
    el.mpFeed.style.display = "none";
    el.mpPot.style.display = "none";
    el.mpRaise.style.display = "none";
    el.mpEmoteBtn.style.display = "none";
    el.mpEmotes.style.display = "none";
    var cmid2 = el.goBtn.parentElement;
    cmid2.parentElement.style.gridTemplateColumns = "";
    cmid2.parentElement.style.justifyItems = "";
    el.presets2.style.display = "";
    if(el.presets.parentElement) el.presets.parentElement.style.display = "";
    el.gpValue.parentElement.style.display = "";
    el.rpValue.parentElement.style.display = "";
    el.dealerRow.style.display = "";
    if(G.mpTable) G.mpTable.visible = false;
    mpSeatsOff();
    mpSyncAvatars();
    el.verdict.style.display = "";
    el.gtabs.style.display = "";
    mpApplyPanels(state.game);
    MP.H = null; MP.players = []; MP.myHand = []; MP.marks = []; MP.submitted = false; MP.round = null; MP.code = null;
    root.classList.remove("mp-live");
    el.mp.classList.remove("on");
    el.mpEntry.style.display = ""; el.mpLobby.style.display = "none";
    el.goBtn.disabled = false;
    el.goBtn.classList.remove("urge");
    el.standBtn.textContent = "Stand"; el.dblBtn.textContent = "Double";
    el.standBtn.classList.remove("show"); el.dblBtn.classList.remove("show");
    if(wasLive) setGame(state.game || "poker", true);
  }
  /* ---- lobby ---- */
  function mpSendLobby(){
    var m = {players:MP.H.players.map(function(q){ return {id:q.id, name:q.name, chips:q.chips, out:q.out, dye:q.dye || null}; }),
             mode:MP.mode, started:!!MP.H.started, chips:MP.chips,
             esc:MP.esc, timer:MP.timerLen, specN:(MP.H.specs || []).length};
    mpSend("lobby", m);
    mpOnLobby(m);
  }
  function mpOnLobby(m){
    if(m.closed){
      if(!MP.host){ mpTeardown(false); el.mp.classList.add("on"); el.mpMsg.textContent = "The host closed the table."; }
      return;
    }
    if(m.full){ el.mpMsg.textContent = "That table is full or already playing."; return; }
    clearTimeout(MP.joinTimer);
    MP.on = true;
    MP.players = m.players || [];
    MP.mode = m.mode || MP.mode;
    if(m.chips) MP.chips = m.chips;
    if(m.esc != null) MP.esc = !!m.esc;
    if(m.timer) MP.timerLen = m.timer;
    MP.specN = m.specN || 0;
    if(!m.started && MP.live){
      MP.live = false;
      root.classList.remove("mp-live");
      el.mpBar.style.display = "none";
      el.mpOpps.style.display = "none";
      el.mpFeed.style.display = "none";
      el.mpPot.style.display = "none";
      el.mpRaise.style.display = "none";
      el.mpEmoteBtn.style.display = "none";
      el.mpEmotes.style.display = "none";
      var cmid1 = el.goBtn.parentElement;
      cmid1.parentElement.style.gridTemplateColumns = "";
      cmid1.parentElement.style.justifyItems = "";
      el.presets2.style.display = "";
      if(el.presets.parentElement) el.presets.parentElement.style.display = "";
      el.gpValue.parentElement.style.display = "";
      el.rpValue.parentElement.style.display = "";
      el.dealerRow.style.display = "";
      if(G.mpTable) G.mpTable.visible = false;
      mpSeatsOff();
      mpSyncAvatars();
      el.verdict.style.display = "";
      el.gtabs.style.display = "";
      mpApplyPanels(state.game);
      el.goBtn.disabled = false;
      el.standBtn.classList.remove("show"); el.dblBtn.classList.remove("show");
      setGame(state.game || "poker", true);
    }
    if(!MP.live) mpShowLobby();
  }
  function mpShowLobby(){
    el.mp.classList.add("on");
    el.mpEntry.style.display = "none";
    el.mpLobby.style.display = "";
    el.mpCodeShow.textContent = MP.code || "";
    var h = "";
    MP.players.forEach(function(p){
      h += "<div class='mpline' style='display:flex;justify-content:space-between;gap:12px'><span>" + String(p.name).replace(/[<>&]/g,"") +
           (p.id === MP.id ? " (you)" : p.id.indexOf("bot_") === 0 ? " (bot)" : "") + "</span><span>" + fmtCoins(p.chips) + " chips" + (p.out ? " (out)" : "") + "</span></div>";
    });
    el.mpPlayersList.innerHTML = h;
    el.mpModePoker.classList.toggle("on", MP.mode === "poker");
    el.mpModeBj.classList.toggle("on", MP.mode === "bj");
    el.mpModePoker.style.color = MP.mode === "poker" ? "#e0b458" : "";
    el.mpModeBj.style.color = MP.mode === "bj" ? "#e0b458" : "";
    el.mpModePoker.disabled = el.mpModeBj.disabled = !MP.host;
    el.mpChips.value = MP.chips;
    el.mpChips.disabled = !MP.host;
    el.mpTimer.value = MP.timerLen;
    el.mpTimer.disabled = !MP.host;
    el.mpEscBtn.textContent = MP.esc ? "Blinds: Rising (x2 every 5 hands)" : "Blinds: Fixed";
    el.mpEscBtn.disabled = !MP.host;
    el.mpStart.style.display = MP.host ? "" : "none";
    el.mpAddBot.style.display = MP.host ? "" : "none";
    el.mpLobbyMsg.textContent = MP.host
      ? "Share the code. 2 to 6 players. Everyone starts with " + fmtCoins(MP.chips) + " chips. Hold'em blinds " + fmtCoins(Math.max(1, Math.round(mpAnte() / 2))) + "/" + fmtCoins(mpAnte()) + "; blackjack bets are per hand."
      : "Waiting for the host to start.";
    if(MP.specN) el.mpLobbyMsg.textContent += " " + MP.specN + " watching.";
  }
  function mpHostRejoin(oldP, newId){
    var H = MP.H, old = oldP.id;
    oldP.id = newId;
    if(oldP.chips >= 10) oldP.out = false;
    ["inHand", "put", "acted", "needAct", "doubled"].forEach(function(k2){
      if(H[k2] && H[k2][old] !== undefined){ H[k2][newId] = H[k2][old]; delete H[k2][old]; }
    });
    if(H.hands && H.hands[old]){ H.hands[newId] = H.hands[old]; delete H.hands[old]; }
    if(H.bjHands && H.bjHands[old]){ H.bjHands[newId] = H.bjHands[old]; delete H.bjHands[old]; }
    if(H.bjBets && H.bjBets[old] != null){ H.bjBets[newId] = H.bjBets[old]; delete H.bjBets[old]; }
    ["inOrder", "order", "actQueue"].forEach(function(k3){
      if(H[k3]) H[k3] = H[k3].map(function(x){ return x === old ? newId : x; });
    });
    if(H.turn === old) H.turn = newId;
    if(H.blinds){
      if(H.blinds.sb === old) H.blinds.sb = newId;
      if(H.blinds.bb === old) H.blinds.bb = newId;
    }
    mpHostPriv(newId);
    if(MP.mode === "poker" && H.hands && H.hands[newId])
      mpDealPrivate(newId, H.hands[newId].map(mpSerBj));
    mpSendLobby();
    mpSendLobbyLite();
  }
  function mpHostJoin(p){
    if(!MP.host || !MP.H) return;
    if(MP.H.started){
      var nm2 = String(p.name || "").slice(0, 14).toLowerCase();
      var ex = null;
      MP.H.players.forEach(function(q){ if(q.name.toLowerCase() === nm2) ex = q; });
      if(ex && ex.id !== p.id){ if(DY_OK[p.dye]) ex.dye = p.dye; mpHostRejoin(ex, p.id); return; }
      MP.H.specs = MP.H.specs || [];
      if(!MP.H.specs.some(function(q){ return q.id === p.id; }))
        MP.H.specs.push({id:p.id, name:String(p.name || "Guest").slice(0, 14)});
      mpHostPriv(p.id).send({type:"broadcast", event:"spec", payload:{ok:true}});
      mpSendLobby();
      mpSendLobbyLite();
      return;
    }
    if(MP.H.players.length >= 6){ mpSend("lobby", {full:true}); return; }
    if(!MP.H.players.some(function(q){ return q.id === p.id; }))
      MP.H.players.push({id:p.id, name:String(p.name || "Guest").slice(0,14), chips:MP.chips, out:false, dye:DY_OK[p.dye] ? p.dye : null});
    mpHostPriv(p.id);
    mpSendLobby();
  }
  function mpHostBye(pid){
    if(!MP.host || !MP.H) return;
    if(MP.H.specs) MP.H.specs = MP.H.specs.filter(function(q){ return q.id !== pid; });
    var p = mpPlayerById(pid);
    if(!p) return;
    if(MP.H.started){
      p.out = true;
      if(MP.H.phase === "bjbet" && MP.H.bjBets && MP.H.bjBets[pid] == null) mpBjBetAct(pid, 10);
      else if((MP.H.phase || "").indexOf("bet") === 0 && MP.H.turn === pid) mpBetAct(pid, "fold");
      else if(MP.H.phase === "turns" && MP.H.order && MP.H.order[MP.H.bjTurn] === pid) mpBjAct(pid, "stand");
      else mpSendLobbyLite();
    } else {
      MP.H.players = MP.H.players.filter(function(q){ return q.id !== pid; });
      mpSendLobby();
    }
  }
  function mpSendLobbyLite(){
    mpBroadcastRound(MP.round || {phase:(MP.H && MP.H.phase) || "discard"});
  }
  /* ---- host game loop ---- */
  function mpActive(){ return MP.H.players.filter(function(p){ return !p.out; }); }
  function mpBroadcastRound(extra){
    var msg = {players:MP.H.players.map(function(p){ return {id:p.id, name:p.name, chips:p.chips, out:!!p.out, dye:p.dye || null}; }),
               mode:MP.mode};
    for(var k in extra) msg[k] = extra[k];
    if(MP.H.last) msg.last = MP.H.last;
    mpSend("round", msg);
    mpOnRound(msg);
  }
  function mpRoundStart(){
    var H = MP.H;
    if(!H) return;
    var act = mpActive();
    if(act.length <= 1){ mpGameOver(act[0] || null); return; }
    H.acted = {}; H.doubled = {};
    H.seq = (H.seq || 0) + 1;
    H.last = {n:H.seq, a:"deal"};
    if(MP.mode === "poker"){
      H.pot = 0;
      H.deck = bjBuild();
      for(var i = H.deck.length - 1; i > 0; i--){
        var j = Math.floor(Math.random()*(i+1)); var t2 = H.deck[i]; H.deck[i] = H.deck[j]; H.deck[j] = t2;
      }
      H.hands = {}; H.inHand = {};
      H.handNo = (H.handNo || 0) + 1;
      var lvl = MP.esc ? Math.floor((H.handNo - 1) / 5) : 0;
      H.bbAmt = mpAnte() * Math.pow(2, lvl);
      H.sbAmt = Math.max(1, Math.round(H.bbAmt / 2));
      if(MP.esc && lvl !== (H.lastLvl || 0)){
        H.lastLvl = lvl;
        H.seq = (H.seq || 0) + 1;
        H.last = {n:H.seq, a:"blindup", amt:H.bbAmt};
      }
      H.contrib = {};
      act.forEach(function(p){
        H.inHand[p.id] = true;
        H.hands[p.id] = [H.deck.pop(), H.deck.pop()];
      });
      H.board = [H.deck.pop(), H.deck.pop(), H.deck.pop(), H.deck.pop(), H.deck.pop()];
      H.revealCnt = 0;
      act.forEach(function(p){ mpDealPrivate(p.id, H.hands[p.id].map(mpSerBj)); });
      H.btn = ((H.btn || 0) + 1) % act.length;
      H.inOrder = act.map(function(p){ return p.id; });
      H.inOrder = H.inOrder.slice(H.btn).concat(H.inOrder.slice(0, H.btn));
      H.blinds = {sb:H.inOrder[0], bb:H.inOrder[1 % H.inOrder.length]};
      mpStartStreet("bet1");
    } else {
      H.phase = "bjbet";
      H.bjBets = {};
      mpBroadcastRound({phase:"bjbet", bets:H.bjBets});
      clearTimeout(H.timer);
      H.timer = setTimeout(mpBjDeal, 15000);
    }
  }
  function mpBroadcastPoker(extra){
    var H = MP.H;
    var msg = {phase:H.phase, pot:H.pot, turn:H.turn || null, bet:H.betAmt || 0,
               put:H.put || {}, board:(H.board || []).slice(0, H.revealCnt || 0).map(mpSerBj),
               btn:(H.inOrder && H.inOrder.length) ? H.inOrder[H.inOrder.length - 1] : null, bb:H.bbAmt || 0,
               inHand:Object.keys(H.inHand).filter(function(k){ return H.inHand[k]; })};
    if(extra) for(var k in extra) msg[k] = extra[k];
    mpBroadcastRound(msg);
  }
  function mpStartStreet(street){
    var H = MP.H;
    H.phase = street;
    H.betAmt = 0; H.put = {}; H.raises = 0; H.turn = null;
    H.actQueue = H.inOrder.filter(function(pid){
      var pp5 = mpPlayerById(pid);
      return H.inHand[pid] && pp5 && pp5.chips > 0;
    });
    H.actIdx = 0;
    H.needAct = {};
    H.actQueue.forEach(function(pid){ H.needAct[pid] = true; });
    if(street === "bet1" && H.blinds){
      [[H.blinds.sb, H.sbAmt], [H.blinds.bb, H.bbAmt]].forEach(function(bl){
        var bp2 = mpPlayerById(bl[0]);
        if(!bp2) return;
        var pay = Math.min(bl[1] || 0, bp2.chips);
        bp2.chips -= pay;
        H.pot += pay;
        H.put[bl[0]] = pay;
        H.contrib[bl[0]] = (H.contrib[bl[0]] || 0) + pay;
      });
      H.betAmt = H.bbAmt;
      H.actIdx = (H.actQueue.indexOf(H.blinds.bb) + 1) % Math.max(1, H.actQueue.length);
    }
    mpBetTurn();
  }
  function mpNextBettor(){
    var H = MP.H;
    for(var i = 0; i < H.actQueue.length; i++){
      var pid = H.actQueue[(H.actIdx + i) % H.actQueue.length];
      if(H.inHand[pid] && H.needAct[pid]) return pid;
    }
    return null;
  }
  function mpBetTurn(){
    var H = MP.H;
    var live = H.inOrder.filter(function(pid){ return H.inHand[pid]; });
    if(live.length <= 1){ mpFoldWin(live[0]); return; }
    var pid = mpNextBettor();
    if(!pid){
      H.turn = null;
      var sn = parseInt(H.phase.slice(3), 10) || 1;
      if(sn >= 4){ mpShowdown(); return; }
      H.revealCnt = sn === 1 ? 3 : sn === 2 ? 4 : 5;
      H.seq = (H.seq || 0) + 1;
      H.last = {n:H.seq, a:sn === 1 ? "flop" : sn === 2 ? "turncard" : "river"};
      mpStartStreet("bet" + (sn + 1));
      return;
    }
    H.turn = pid;
    mpBroadcastPoker();
    clearTimeout(H.timer);
    H.timer = setTimeout(function(){
      mpBetAct(pid, (H.betAmt - (H.put[pid] || 0)) > 0 ? "fold" : "check");
    }, (MP.timerLen || 25) * 1000);
    mpMaybeBot(pid, 900 + Math.random() * 900);
  }
  function mpBetAct(pid, a, amt3){
    var H = MP.H;
    if(!H || (H.phase || "").indexOf("bet") !== 0 || H.turn !== pid || !H.inHand[pid]) return;
    var p = mpPlayerById(pid);
    if(!p) return;
    var toCall = (H.betAmt || 0) - (H.put[pid] || 0);
    H.seq = (H.seq || 0) + 1;
    if(a === "fold"){
      H.inHand[pid] = false;
      H.needAct[pid] = false;
      H.last = {n:H.seq, id:pid, a:"fold"};
      if(H.stats) H.stats.folds[pid] = (H.stats.folds[pid] || 0) + 1;
    } else if(a === "raise" && H.raises < 4){
      var inc = Math.max(H.bbAmt || mpAnte(), Math.round(amt3 || H.bbAmt || mpAnte()));
      var cost = Math.min(toCall + inc, p.chips);
      p.chips -= cost; H.pot += cost;
      H.put[pid] = (H.put[pid] || 0) + cost;
      H.contrib[pid] = (H.contrib[pid] || 0) + cost;
      if(H.put[pid] > H.betAmt){
        H.betAmt = H.put[pid];
        H.raises++;
        for(var q in H.inHand) if(H.inHand[q] && q !== pid) H.needAct[q] = true;
      }
      H.needAct[pid] = false;
      H.last = {n:H.seq, id:pid, a:"raise", amt:H.betAmt};
    } else {
      var cost2 = Math.min(toCall, p.chips);
      p.chips -= cost2; H.pot += cost2;
      H.put[pid] = (H.put[pid] || 0) + cost2;
      H.contrib[pid] = (H.contrib[pid] || 0) + cost2;
      H.needAct[pid] = false;
      H.last = {n:H.seq, id:pid, a:(toCall > 0 ? "call" : "check"), amt:cost2};
    }
    H.actIdx = (H.actQueue.indexOf(pid) + 1) % Math.max(1, H.actQueue.length);
    mpBetTurn();
  }
  var MP_BOT_NAMES = ["Zezima", "Durial321", "Cabbage", "Sir Amik", "Bandos Bob", "Cow1337killr"];
  function mpAddBot(){
    if(!MP.host || !MP.H || MP.H.started) return;
    if(MP.H.players.length >= 6){ el.mpLobbyMsg.textContent = "Table is full."; return; }
    var n = 1;
    while(MP.H.players.some(function(p){ return p.id === "bot_" + n; })) n++;
    var used = MP.H.players.map(function(p){ return p.name; });
    var name = MP_BOT_NAMES.filter(function(x){ return used.indexOf(x) === -1; })[0] || ("Bot " + n);
    MP.H.players.push({id:"bot_" + n, name:name, chips:MP.chips, out:false});
    mpSendLobby();
  }
  function mpBotAct(pid){
    var H = MP.H;
    if(!H || !MP.host) return;
    if((H.phase || "").indexOf("bet") === 0 && H.turn === pid){
      var r = mpBest5(H.hands[pid].concat((H.board || []).slice(0, H.revealCnt || 0)));
      var toCall = (H.betAmt || 0) - (H.put[pid] || 0);
      var a;
      if(toCall > 0){
        if(r.cat >= 2) a = Math.random() < 0.3 ? "raise" : "call";
        else if(r.cat === 1) a = "call";
        else a = (toCall <= mpAnte() && Math.random() < 0.5) ? "call" : "fold";
      } else {
        a = (r.cat >= 2 && Math.random() < 0.4) ? "raise" : "check";
      }
      mpBetAct(pid, a);
    } else if(H.phase === "turns" && H.order && H.order[H.bjTurn] === pid){
      mpBjAct(pid, bjVal(H.bjHands[pid]) < 16 ? "hit" : "stand");
    }
  }
  function mpMaybeBot(pid, delay){
    if(!MP.host || !pid || pid.indexOf("bot_") !== 0) return;
    clearTimeout(MP.H.botT);
    MP.H.botT = setTimeout(function(){ mpBotAct(pid); }, delay || 1200);
  }
  function mpDeser(c){ return {r:c.r, v:c.v, si:c.si, s:BJ_SUITS[c.si]}; }
  var MP_RV = {A:14, K:13, Q:12, J:11};
  function mpEval5(cards){
    var rs = cards.map(function(c){ return MP_RV[c.r] || parseInt(c.r, 10); }).sort(function(a, b){ return b - a; });
    var suits = {};
    cards.forEach(function(c){
      var k = c.si != null ? c.si : BJ_SUITS.indexOf(c.s);
      suits[k] = (suits[k] || 0) + 1;
    });
    var flush = Object.keys(suits).length === 1;
    var uniq = rs.filter(function(v, i){ return rs.indexOf(v) === i; });
    var straight = false, sHigh = 0;
    if(uniq.length === 5){
      if(uniq[0] - uniq[4] === 4){ straight = true; sHigh = uniq[0]; }
      else if(uniq[0] === 14 && uniq[1] === 5 && uniq[4] === 2){ straight = true; sHigh = 5; }
    }
    var tally = {};
    rs.forEach(function(v){ tally[v] = (tally[v] || 0) + 1; });
    var groups = Object.keys(tally).map(function(k){ return {n:tally[k], v:+k}; });
    groups.sort(function(a, b){ return b.n - a.n || b.v - a.v; });
    var shape = groups.map(function(g){ return g.n; }).join("");
    var cat, name;
    if(straight && flush){ cat = 8; name = sHigh === 14 ? "Royal flush" : "Straight flush"; }
    else if(shape === "41"){ cat = 7; name = "Four of a kind"; }
    else if(shape === "32"){ cat = 6; name = "Full house"; }
    else if(flush){ cat = 5; name = "Flush"; }
    else if(straight){ cat = 4; name = "Straight"; }
    else if(shape === "311"){ cat = 3; name = "Three of a kind"; }
    else if(shape === "221"){ cat = 2; name = "Two pair"; }
    else if(shape === "2111"){ cat = 1; name = "Pair"; }
    else { cat = 0; name = "High card"; }
    return {cat:cat, name:name, order:straight ? [sHigh] : groups.map(function(g){ return g.v; })};
  }
  function mpBest5(cards){
    if(cards.length <= 5){
      var r0 = mpEval5(cards);
      r0.idx = cards.map(function(_c, ii){ return ii; });
      return r0;
    }
    var best = null, n = cards.length;
    function rec(start, chosen, idxs){
      if(chosen.length === 5){
        var r = mpEval5(chosen);
        if(!best || compare(r, best) > 0){ best = r; best.idx = idxs.slice(); }
        return;
      }
      if(n - start < 5 - chosen.length) return;
      for(var i = start; i < n; i++){
        chosen.push(cards[i]); idxs.push(i);
        rec(i + 1, chosen, idxs);
        chosen.pop(); idxs.pop();
      }
    }
    rec(0, [], []);
    return best;
  }
  function mpFoldWin(pid){
    var H = MP.H;
    clearTimeout(H.timer);
    H.phase = "reveal";
    var p = mpPlayerById(pid);
    if(p) p.chips += H.pot;
    if(H.stats && p && (!H.stats.big || H.pot > H.stats.big.amt)) H.stats.big = {amt:H.pot, who:pid};
    H.players.forEach(function(q){ if(!q.out && q.chips < mpAnte()) q.out = true; });
    mpBroadcastPoker({phase:"reveal", foldwin:true, winners:pid ? [pid] : [], pot:H.pot});
    H.timer = setTimeout(mpRoundStart, 5000);
  }
  function mpShowdown(){
    var H = MP.H;
    clearTimeout(H.timer);
    H.phase = "reveal";
    var live = H.inOrder.filter(function(pid){ return H.inHand[pid]; });
    var best = null, winners = [], reveal = {}, names = {};
    H.revealCnt = 5;
    live.forEach(function(pid){
      var p = mpPlayerById(pid);
      var r = mpBest5(H.hands[pid].concat(H.board));
      reveal[pid] = H.hands[pid].map(mpSerBj);
      names[pid] = r.name;
      if(!best || compare(r, best) > 0){ best = r; winners = [p]; }
      else if(compare(r, best) === 0) winners.push(p);
    });
    var ranks = {};
    live.forEach(function(pid){ ranks[pid] = mpBest5(H.hands[pid].concat(H.board)); });
    var lvSet = {};
    live.forEach(function(pid){ lvSet[H.contrib[pid] || 0] = 1; });
    var lvls = Object.keys(lvSet).map(Number).sort(function(a, b){ return a - b; });
    var everyone = H.players.filter(function(p){ return (H.contrib[p.id] || 0) > 0; });
    var pots = [], prevL = 0, assigned = 0;
    lvls.forEach(function(L){
      var amt = 0;
      everyone.forEach(function(p){
        var c = H.contrib[p.id] || 0;
        amt += Math.max(0, Math.min(c, L) - Math.min(c, prevL));
      });
      var elig = live.filter(function(pid){ return (H.contrib[pid] || 0) >= L; });
      var bestR = null, ws = [];
      elig.forEach(function(pid){
        if(!bestR || compare(ranks[pid], bestR) > 0){ bestR = ranks[pid]; ws = [pid]; }
        else if(compare(ranks[pid], bestR) === 0) ws.push(pid);
      });
      if(amt > 0) pots.push({amt:amt, winners:ws});
      assigned += amt; prevL = L;
    });
    var leftover = H.pot - assigned;
    if(leftover > 0 && pots.length) pots[pots.length - 1].amt += leftover;
    pots.forEach(function(pt3){
      var shr = Math.floor(pt3.amt / Math.max(1, pt3.winners.length));
      pt3.winners.forEach(function(pid){ var pp = mpPlayerById(pid); if(pp) pp.chips += shr; });
    });
    var top = pots[pots.length - 1] || {winners:live.slice(0, 1), amt:H.pot};
    winners = top.winners.map(mpPlayerById).filter(Boolean);
    if(H.stats){
      if(!H.stats.big || H.pot > H.stats.big.amt) H.stats.big = {amt:H.pot, who:top.winners[0]};
      var bw = top.winners[0];
      if(bw && ranks[bw] && (!H.stats.best || compare(ranks[bw], H.stats.best) > 0))
        H.stats.best = {name:ranks[bw].name, cat:ranks[bw].cat, order:ranks[bw].order, who:bw};
    }
    H.players.forEach(function(p){ if(!p.out && p.chips < mpAnte()) p.out = true; });
    mpBroadcastPoker({phase:"reveal", reveal:reveal, handNames:names,
                      winners:winners.map(function(p){ return p.id; }), pot:H.pot,
                      pots:pots.map(function(pt4){ return {amt:pt4.amt, winners:pt4.winners}; })});
    H.timer = setTimeout(mpRoundStart, 7000);
  }
  /* opponents visible at the table */
  function mpSyncAvatars(){
    var want = MP.live ? Math.min(5, Math.max(0, MP.players.length - 1)) : 0;
    G.mpAv = G.mpAv || [];
    while(G.mpAv.length > want){
      var gone = G.mpAv.pop();
      G.scene.remove(gone.group);
    }
    var CEN = {x:0, z:3.5};
    var SL = [{x:-2.5, z:4.2}, {x:-2.2, z:2.75}, {x:-0.9, z:2.1}, {x:0.9, z:2.1}, {x:2.2, z:2.75}];
    var SH = [0x7a3a3a, 0x3a5a7a, 0x4a6a3a, 0x6a4a7a, 0x7a6a3a];
    var HR = [0x6b4a2a, 0x2a2a2a, 0x8a5a2a, 0xc9a24d, 0x555555];
    while(G.mpAv.length < want && G.ok){
      var i2 = G.mpAv.length;
      var SK = [0xe6b98c, 0xc68d5e, 0x9c6b43, 0x6f4a2f, 0xd9a066];
      var sp5 = Math.random(), av, avY;
      if(sp5 < 0.2){
        av = makeMonkey();
        av.group.scale.setScalar(2.3);
        avY = 0.02;
      } else if(sp5 < 0.4){
        av = makeGnome();
        box(0.46, 0.28, 0.46, mat(0x6b4a2a), 0, -0.14, 0, av.group);
        box(0.50, 0.05, 0.50, mat(0x54381e), 0, -0.02, 0, av.group);
        avY = 0.12;
      } else {
        av = makeMan({shirt:SH[i2], pants:0x4a4034, hair:HR[i2], skin:SK[i2]});
        avY = -0.34;
      }
      av.group.position.set(SL[i2].x, avY, SL[i2].z);
      av.group.rotation.y = Math.atan2(CEN.x - SL[i2].x, CEN.z - SL[i2].z);
      G.scene.add(av.group);
      G.mpAv.push(av);
    }
  }
  function mpFeedText(l){
    var who = l.id ? (l.id === MP.id ? "You" : mpNameOf(l.id)) : "";
    var A = {check:"check", call:"call " + fmtCoins(l.amt || 0), raise:"raise to " + fmtCoins(l.amt || 0),
             fold:"fold", hit:"hit", stand:"stand", bust:"bust!", double:"double down",
             deal:"new hand dealt", flop:"flop dealt", turncard:"turn card", river:"river card", betin:"bet " + fmtCoins(l.amt || 0), blindup:"blinds up! big blind " + fmtCoins(l.amt || 0)};
    return (who ? who + ": " : "") + (A[l.a] || l.a);
  }
  function mpRenderOpps(m){
    var h = document.createDocumentFragment();
    var meP = null;
    (m.players || []).forEach(function(p){ if(p.id === MP.id) meP = p; });
    if(meP){
      var wm = document.createElement("div");
      wm.className = "mpopp me" + (m.turn === MP.id ? " turn" : "") +
        (m.winners && m.winners.indexOf(MP.id) !== -1 ? " win" : "");
      wm.innerHTML = "<div class='onm'>You</div><div class='ochips'>" + fmtCoins(meP.chips) + "</div>";
      h.appendChild(wm);
    }
    (m.players || []).forEach(function(p){
      if(p.id === MP.id || p.out) return;
      var folded = MP.mode === "poker" && m.inHand && m.inHand.indexOf(p.id) === -1 && m.phase !== "over";
      var wrap = document.createElement("div");
      wrap.className = "mpopp" + (folded ? " fold" : "") + (m.turn === p.id ? " turn" : "") +
        (m.winners && m.winners.indexOf(p.id) !== -1 ? " win" : "");
      var ch = document.createElement("div");
      ch.className = "ochips";
      ch.textContent = fmtCoins(p.chips);
      var nm = document.createElement("div");
      nm.className = "onm";
      nm.textContent = p.name +
        (m.handNames && m.handNames[p.id] ? " \u00b7 " + m.handNames[p.id] : (folded ? " \u00b7 folded" : ""));
      wrap.appendChild(ch);
      var row = document.createElement("div");
      row.className = "ocards";
      if(MP.mode === "poker"){
        if(m.reveal && m.reveal[p.id]){
          m.reveal[p.id].forEach(function(t2){ row.appendChild(bjCardEl(mpDeser(t2), true)); });
        } else if(!folded){
          for(var c2 = 0; c2 < 2; c2++) row.appendChild(bjCardEl({r:"", v:0, s:BJ_SUITS[0]}, false));
        }
      } else if(m.bj && m.bj.hands && m.bj.hands[p.id]){
        m.bj.hands[p.id].forEach(function(c3){
          row.appendChild(bjCardEl({r:c3.r, v:c3.v, s:BJ_SUITS[c3.si]}, true));
        });
      }
      wrap.appendChild(nm); wrap.appendChild(row);
      h.appendChild(wrap);
    });
    el.mpOpps.innerHTML = "";
    el.mpOpps.appendChild(h);
  }
  function mpBjBetAct(pid, amt){
    var H = MP.H;
    if(!H || H.phase !== "bjbet" || H.bjBets[pid] != null) return;
    var p = mpPlayerById(pid);
    if(!p || p.out) return;
    H.bjBets[pid] = Math.max(10, Math.min(Math.round(amt || mpBjBet()), p.chips));
    H.seq = (H.seq || 0) + 1;
    H.last = {n:H.seq, id:pid, a:"betin", amt:H.bjBets[pid]};
    mpBroadcastRound({phase:"bjbet", bets:H.bjBets});
    if(Object.keys(H.bjBets).length >= mpActive().length) mpBjDeal();
  }
  function mpBjDeal(){
    var H = MP.H;
    if(!H || H.phase !== "bjbet") return;
    clearTimeout(H.timer);
    var act = mpActive();
    act.forEach(function(p){
      if(H.bjBets[p.id] == null) H.bjBets[p.id] = Math.max(10, Math.min(mpBjBet(), p.chips));
    });
    H.phase = "turns";
    H.deck = bjBuild().concat(bjBuild());
    H.dealer = [H.deck.pop(), H.deck.pop()];
    H.bjHands = {};
    act.forEach(function(p){
      p.chips -= H.bjBets[p.id];
      H.bjHands[p.id] = [H.deck.pop(), H.deck.pop()];
    });
    H.order = act.map(function(p){ return p.id; });
    H.bjTurn = 0;
    mpBjNextTurn();
  }
  function mpSerBj(c){ return {r:c.r, v:c.v, si:BJ_SUITS.indexOf(c.s)}; }
  function mpBjPublic(revealHole){
    var H = MP.H, out = {};
    for(var pid in H.bjHands) out[pid] = H.bjHands[pid].map(mpSerBj);
    return {dealer:H.dealer.map(function(c, i){ return (i === 0 || revealHole) ? mpSerBj(c) : null; }), hands:out};
  }
  function mpBjNextTurn(){
    var H = MP.H;
    while(H.bjTurn < H.order.length){
      var pid = H.order[H.bjTurn];
      if(bjVal(H.bjHands[pid]) >= 21 || (mpPlayerById(pid) || {}).out) H.bjTurn++;
      else break;
    }
    if(H.bjTurn >= H.order.length){ mpBjDealer(); return; }
    var tp = H.order[H.bjTurn];
    mpBroadcastRound({phase:"turns", turn:tp, bj:mpBjPublic(false), bets:H.bjBets});
    clearTimeout(H.timer);
    H.timer = setTimeout(function(){ mpBjAct(tp, "stand"); }, ((MP.timerLen || 25) + 5) * 1000);
    mpMaybeBot(tp, 900 + Math.random() * 900);
  }
  function mpBjAct(pid, a){
    var H = MP.H;
    if(!H || H.phase !== "turns" || H.order[H.bjTurn] !== pid) return;
    var hand = H.bjHands[pid], p = mpPlayerById(pid);
    H.seq = (H.seq || 0) + 1;
    if(a === "hit"){
      hand.push(H.deck.pop());
      H.last = {n:H.seq, id:pid, a:bjVal(hand) > 21 ? "bust" : "hit"};
      if(bjVal(hand) >= 21) H.bjTurn++;
    } else if(a === "double" && hand.length === 2 && p && p.chips >= (H.bjBets[pid] || mpBjBet())){
      p.chips -= (H.bjBets[pid] || mpBjBet());
      H.doubled[pid] = true;
      hand.push(H.deck.pop());
      H.last = {n:H.seq, id:pid, a:bjVal(hand) > 21 ? "bust" : "double"};
      H.bjTurn++;
    } else {
      H.last = {n:H.seq, id:pid, a:"stand"};
      H.bjTurn++;
    }
    mpBjNextTurn();
  }
  function mpBjDealer(){
    var H = MP.H;
    clearTimeout(H.timer);
    H.phase = "reveal";
    while(bjVal(H.dealer) < 17) H.dealer.push(H.deck.pop());
    var dv = bjVal(H.dealer), dBJ = dv === 21 && H.dealer.length === 2, results = {};
    H.order.forEach(function(pid){
      var hand = H.bjHands[pid], pv = bjVal(hand), p = mpPlayerById(pid);
      if(!p) return;
      var bet = (H.bjBets[pid] || mpBjBet()) * (H.doubled[pid] ? 2 : 1);
      var pBJ = pv === 21 && hand.length === 2;
      var back = 0;
      if(pv > 21) back = 0;
      else if(pBJ && dBJ) back = bet;
      else if(pBJ) back = bet + Math.ceil(bet * 1.5);
      else if(dBJ) back = 0;
      else if(dv > 21 || pv > dv) back = bet * 2;
      else if(pv === dv) back = bet;
      p.chips += back;
      results[pid] = back - bet;
      if(H.stats && back - bet > 0 && (!H.stats.big || back - bet > H.stats.big.amt))
        H.stats.big = {amt:back - bet, who:pid};
    });
    H.players.forEach(function(p){ if(!p.out && p.chips < 10) p.out = true; });
    mpBroadcastRound({phase:"reveal", bj:mpBjPublic(true), results:results, bets:H.bjBets});
    H.timer = setTimeout(mpRoundStart, 6000);
  }
  function mpGameOver(winner){
    var H = MP.H, rc = null;
    if(H && H.stats){
      rc = {big:H.stats.big || null, best:H.stats.best ? {name:H.stats.best.name, who:H.stats.best.who} : null, folds:null};
      var fk = null, fv = 0;
      for(var fq in H.stats.folds) if(H.stats.folds[fq] > fv){ fv = H.stats.folds[fq]; fk = fq; }
      if(fk) rc.folds = {who:fk, n:fv};
    }
    mpBroadcastRound({phase:"over", champion:winner ? winner.id : null, recap:rc});
    var H = MP.H;
    H.timer = setTimeout(function(){
      if(!MP.H) return;
      MP.H.started = false;
      mpSendLobby();
    }, 4500);
  }
  /* ---- client rendering ---- */
  function mpGoLive(){
    if(MP.live) return;
    MP.live = true;
    el.mp.classList.remove("on");
    root.classList.add("mp-live");
    el.gtabs.style.display = "none";
    mpApplyPanels("mp");
    el.mpBar.style.display = "flex";
    el.mpOpps.style.display = "none";
    el.mpFeed.style.display = "flex";
    el.mpPot.style.display = "flex";
    el.mpRaise.style.display = "none";
    el.mpEmoteBtn.style.display = "";
    var cmid0 = el.goBtn.parentElement;
    cmid0.parentElement.style.gridTemplateColumns = "1fr";
    cmid0.parentElement.style.justifyItems = "center";
    el.presets2.style.display = "none";
    if(el.presets.parentElement) el.presets.parentElement.style.display = "none";
    el.gpValue.parentElement.style.display = "none";
    el.rpValue.parentElement.style.display = "none";
    MP.feed = []; MP.feedN = 0;
    el.mpFeed.innerHTML = "";
    if(G.mpTable) G.mpTable.visible = true;
    mpSyncAvatars();
    clearDice();
    el.dealerRow.innerHTML = ""; el.playerRow.innerHTML = "";
    el.dealerHand.textContent = ""; el.playerHand.textContent = "";
    el.diceReadout.innerHTML = "&nbsp;";
    el.brandSub.textContent = "Live table " + MP.code;
    G.lookYawT = Math.PI; G.lookXT = 0;
  }
  function mpOnRound(m){
    MP.players = m.players || MP.players;
    MP.round = m;
    mpGoLive();
    if(m.turn !== MP.lastTurn){ MP.lastTurn = m.turn || null; MP.turnAt = Date.now(); }
    if(m.phase === "reveal" && MP.lastPhase !== "reveal"){
      MP.revealAt = Date.now();
      MP.hlDone = false;
      MP.flyT = 0; MP.flyTo = null;
      mpResetTint();
      var wn2 = m.winners && m.winners.length ? mpNameOf(m.winners[0]) : "";
      if(wn2 && wn2 !== "?") say(pick(LINES.mpWin).replace("{n}", wn2));
    }
    if(m.phase === "bet1" && MP.lastPhase !== "bet1") mpResetTint();
    MP.lastPhase = m.phase;
    if(m.last && m.last.n !== MP.feedN){
      MP.feedN = m.last.n;
      MP.feed = MP.feed || [];
      MP.feed.push(mpFeedText(m.last));
      if(MP.feed.length > 4) MP.feed.shift();
      var la2 = m.last.a;
      if(la2 === "raise"){ tone(520, 0.04, "square", 0.06); tone(700, 0.05, "square", 0.05); }
      else if(la2 === "call") tone(520, 0.05, "square", 0.06);
      else if(la2 === "check") tone(300, 0.05, "square", 0.04);
      else if(la2 === "fold") tone(210, 0.09, "square", 0.05);
      else if(la2 === "hit") tone(720, 0.04, "square", 0.05);
      else if(la2 === "bust") tone(170, 0.16, "square", 0.08);
      else if(la2 === "double"){ tone(520, 0.05, "square", 0.06); tone(780, 0.06, "square", 0.06); }
      else if(la2 === "betin") tone(560, 0.05, "square", 0.05);
      el.mpFeed.innerHTML = MP.feed.map(function(t2, i2){
        return "<span class='" + (i2 === MP.feed.length - 1 ? "new" : "") + "'>" + t2 + "</span>";
      }).join("");
    }
    mpRenderBar(m);
    if(m.phase === "over"){
      var champ = m.champion ? mpNameOf(m.champion) : null;
      el.verdict.style.display = "";
      el.verdict.className = "verdict big" + (m.champion === MP.id ? " win" : "");
      el.vHand.textContent = champ ? champ + " takes the table" : "Table over";
      var rp = m.recap, bits = [];
      if(rp){
        if(rp.big && rp.big.who) bits.push("Biggest pot " + fmtCoins(rp.big.amt) + " (" + mpNameOf(rp.big.who) + ")");
        if(rp.best && rp.best.who) bits.push("Best hand " + rp.best.name + " (" + mpNameOf(rp.best.who) + ")");
        if(rp.folds) bits.push("Most folds " + mpNameOf(rp.folds.who) + " x" + rp.folds.n);
      }
      el.vDelta.textContent = bits.length ? bits.join(" \u00b7 ") : "Back to the lobby shortly";
      el.goBtn.disabled = true;
      el.standBtn.classList.remove("show"); el.dblBtn.classList.remove("show");
      if(m.champion === MP.id){ setMood("win"); sfxWin(8); }
      return;
    }
    if(MP.mode === "poker") mpRenderPoker(m);
    else mpRenderBj(m);
    mpSeats(m);
    mpPaintControls(m);
  }
  function mpRenderBar(m){
    el.mpBarInfo.textContent = (MP.mode === "poker" ? "Hold'em" : "Blackjack") + " \u00b7 " + (MP.code || "");
    el.mpBarPlayers.innerHTML = "";
    var stak = 0;
    if(m.bets) for(var kb in m.bets) stak += m.bets[kb];
    var SNMB = {bet1:"Pre-flop", bet2:"Flop", bet3:"Turn", bet4:"River", reveal:"Showdown"};
    el.mpPot.textContent = MP.mode === "poker"
      ? "Pot " + fmtCoins(m.pot || 0) + (SNMB[m.phase] ? " \u00b7 " + SNMB[m.phase] : "")
      : (m.phase === "bjbet" ? "Place your bets"
         : (stak ? "Staked " + fmtCoins(stak) : "Blackjack"));
  }
  function mpCardNode(tier, clickable, i2){
    var d = cardEl(itemByTier(tier), true, false);
    if(clickable){
      d.classList.add("pick");
      if(MP.marks.indexOf(i2) !== -1) d.classList.add("toss");
      d.addEventListener("click", function(){
        var at = MP.marks.indexOf(i2);
        if(at === -1) MP.marks.push(i2); else MP.marks.splice(at, 1);
        mpRenderPoker(MP.round);
      });
    }
    return d;
  }
  function mpRenderPoker(m){
    if(!m) return;
    el.dealerRow.style.display = "none";
    el.dealerRow.innerHTML = "";
    el.dealerHand.textContent = "";
    mpRenderOpps(m);
    var board = m.board || [];
    mpBoard3D(board);
    var iAmIn = !m.inHand || m.inHand.indexOf(MP.id) !== -1;
    el.playerRow.innerHTML = "";
    MP.myHand.forEach(function(t2){ el.playerRow.appendChild(bjCardEl(mpDeser(t2), true)); });
    var mineAll = MP.myHand.map(mpDeser).concat(board.map(mpDeser));
    el.playerHand.textContent = mineAll.length >= 5
      ? mpBest5(mineAll).name + (iAmIn ? "" : " (folded)")
      : (iAmIn ? "hole cards" : "folded");
    var SNM = {bet1:"Pre-flop", bet2:"Flop", bet3:"Turn", bet4:"River"};
    if(m.phase === "reveal"){
      el.verdict.style.display = "";
      var won = m.winners && m.winners.indexOf(MP.id) !== -1;
      el.verdict.className = "verdict big" + (won ? " win" : " loss");
      el.vHand.textContent = m.winners && m.winners.length
        ? m.winners.map(mpNameOf).join(" & ") + (m.winners.length > 1 ? " split" : " takes") + " the pot" +
          (m.foldwin ? ", everyone folded" : "")
        : "Hand over";
      el.vDelta.textContent = (m.pots && m.pots.length > 1)
        ? m.pots.map(function(pp2){ return fmtCoins(pp2.amt) + " to " + pp2.winners.map(mpNameOf).join(" & "); }).join(" \u00b7 ")
        : "Pot " + fmtCoins(m.pot || 0) + " chips \u00b7 next hand shortly";
      if(won){ setMood("win"); sfxWin(2); } else { setMood("lose"); }
    } else {
      el.verdict.style.display = "none";
    }
  }
  function mpRenderBj(m){
    if(m.phase === "bjbet"){
      el.dealerRow.style.display = "none";
      mpRenderOpps(m);
      mpBoard3D([], 0);
      el.verdict.style.display = "none";
      el.playerRow.innerHTML = "";
      return;
    }
    var bj = m.bj;
    if(!bj) return;
    el.dealerRow.style.display = "none";
    el.dealerRow.innerHTML = "";
    mpRenderOpps(m);
    mpBoard3D(bj.dealer, bj.dealer.length);
    var dvis = bj.dealer.filter(Boolean);
    el.dealerHand.textContent = (m.phase === "reveal" ? "" : "shows ") + bjVal(dvis);
    var mine = (bj.hands[MP.id] || []).map(function(c){ return {r:c.r, v:c.v, s:BJ_SUITS[c.si]}; });
    el.playerRow.innerHTML = "";
    mine.forEach(function(c){ el.playerRow.appendChild(bjCardEl(c, true)); });
    el.playerHand.textContent = mine.length ? bjVal(mine) : "";
    if(m.phase === "reveal"){
      el.verdict.style.display = "";
      var net = m.results ? m.results[MP.id] : null;
      el.verdict.className = "verdict big" + (net > 0 ? " win" : net < 0 ? " loss" : "");
      el.vHand.textContent = net > 0 ? "You win" : net < 0 ? "House takes it" : "Push";
      el.vDelta.textContent = (net > 0 ? "+" : "") + fmtCoins(net || 0) + " chips \u00b7 next hand shortly";
      if(net > 0){ setMood("win"); sfxWin(2); } else if(net < 0) setMood("lose");
    } else {
      el.verdict.style.display = "none";
    }
  }
  function mpPaintControls(m){
    if(MP.spec){
      el.goBtn.textContent = "Spectating";
      el.goBtn.disabled = true;
      el.goBtn.classList.remove("urge");
      el.standBtn.classList.remove("show"); el.dblBtn.classList.remove("show");
      el.mpRaise.style.display = "none";
      return;
    }
    var myTurn = MP.mode === "bj" && m.phase === "turns" && m.turn === MP.id;
    if(MP.mode === "poker"){
      var iAmIn = !m.inHand || m.inHand.indexOf(MP.id) !== -1;
      var betting = (m.phase || "").indexOf("bet") === 0;
      var myBet = betting && m.turn === MP.id && iAmIn;
      var toCall = (m.bet || 0) - ((m.put || {})[MP.id] || 0);
      if(myBet){
        el.goBtn.textContent = toCall > 0 ? "Call " + fmtBet(toCall) : "Check";
        el.goBtn.disabled = false;
        el.goBtn.classList.add("urge");
        el.standBtn.classList.remove("show");
        el.dblBtn.textContent = "Fold";
        el.dblBtn.classList.add("show");
        var myChips2 = 0;
        (m.players || []).forEach(function(p2){ if(p2.id === MP.id) myChips2 = p2.chips; });
        if(myChips2 <= 0){
          el.goBtn.textContent = "Check (all in)";
          el.dblBtn.classList.remove("show");
          el.mpRaise.style.display = "none";
          el.mpRaise.innerHTML = "";
        } else {
          var a2 = m.bb || mpAnte(), potR = Math.max(a2, m.pot || 0);
          var opts = [
            {l:"Raise " + fmtBet(a2), v:a2},
            {l:"Raise " + fmtBet(a2 * 3), v:a2 * 3},
            {l:"Pot " + fmtBet(potR), v:potR},
            {l:"All in " + fmtBet(Math.max(0, myChips2)), v:1e18},
            {l:"X", v:"x"}
          ];
          el.mpRaise.innerHTML = opts.map(function(o){
            return "<button data-amt='" + o.v + "'>" + o.l + "</button>";
          }).join("");
          el.mpRaise.style.display = "flex";
        }
      } else {
        el.goBtn.textContent = "Waiting";
        el.goBtn.disabled = true;
        el.goBtn.classList.remove("urge");
        el.standBtn.classList.remove("show"); el.dblBtn.classList.remove("show");
        el.mpRaise.style.display = "none";
      }
      return;
    } else {
      if(m.phase === "bjbet"){
        var betted = m.bets && m.bets[MP.id] != null;
        var myChips3 = 0;
        (m.players || []).forEach(function(p3){ if(p3.id === MP.id) myChips3 = p3.chips; });
        el.standBtn.classList.remove("show"); el.dblBtn.classList.remove("show");
        if(!betted){
          el.goBtn.textContent = "Bet " + fmtBet(Math.max(10, Math.round(myChips3 * 0.1)));
          el.goBtn.disabled = false;
          el.goBtn.classList.add("urge");
          var bOpts = [
            {l:"5%", v:Math.max(10, Math.round(myChips3 * 0.05))},
            {l:"10%", v:Math.max(10, Math.round(myChips3 * 0.1))},
            {l:"25%", v:Math.max(10, Math.round(myChips3 * 0.25))},
            {l:"All in", v:Math.max(10, myChips3)},
            {l:"X", v:"x"}
          ];
          el.mpRaise.innerHTML = bOpts.map(function(o){
            return "<button data-bet='" + o.v + "'>" + o.l + (o.v !== "x" ? " " + fmtBet(o.v) : "") + "</button>";
          }).join("");
          el.mpRaise.style.display = "flex";
        } else {
          el.goBtn.textContent = "Waiting";
          el.goBtn.disabled = true;
          el.goBtn.classList.remove("urge");
          el.mpRaise.style.display = "none";
        }
        return;
      }
      el.mpRaise.style.display = "none";
      el.goBtn.textContent = myTurn ? "Hit" : "Waiting";
      el.goBtn.disabled = !myTurn;
      el.goBtn.classList.toggle("urge", myTurn);
      el.standBtn.textContent = "Stand";
      el.dblBtn.textContent = "Double";
      el.standBtn.classList.toggle("show", myTurn);
      var mh = (m.bj && m.bj.hands[MP.id]) || [];
      var me = mpPlayerById ? null : null;
      var myChips = 0;
      (m.players || []).forEach(function(p){ if(p.id === MP.id) myChips = p.chips; });
      el.dblBtn.classList.toggle("show", myTurn && mh.length === 2 && myChips >= mpBjBet());
    }
  }
  function mpGo(){
    var m = MP.round;
    if(!m || MP.spec) return;
    if(MP.mode === "poker"){
      if((m.phase || "").indexOf("bet") === 0){
        var toCall = (m.bet || 0) - ((m.put || {})[MP.id] || 0);
        mpPokerBet(toCall > 0 ? "call" : "check");
      }
    } else {
      if(m.phase === "bjbet"){
        var mc3 = 0;
        (m.players || []).forEach(function(p4){ if(p4.id === MP.id) mc3 = p4.chips; });
        mpBjSendBet(Math.max(10, Math.round(mc3 * 0.1)));
        return;
      }
      mpAct("hit");
    }
  }
  function mpBjSendBet(v){
    var m = MP.round;
    if(!m || m.phase !== "bjbet") return;
    if(MP.host) mpBjBetAct(MP.id, v);
    else mpSend("act", {id:MP.id, a:"bet", amt:v});
  }
  function mpPokerBet(a, amt){
    var m = MP.round;
    if(!m || (m.phase || "").indexOf("bet") !== 0 || m.turn !== MP.id) return;
    if(MP.host) mpBetAct(MP.id, a, amt);
    else mpSend("act", {id:MP.id, a:a, amt:amt});
  }
  function mpAct(a){
    if(!MP.round || MP.round.phase !== "turns" || MP.round.turn !== MP.id) return;
    if(MP.host) mpBjAct(MP.id, a);
    else mpSend("act", {id:MP.id, a:a});
  }

  /* ---------- the poker table: appears for live games ---------- */
  function buildMpTable(){
    var g3 = new THREE.Group();
    g3.position.set(0, 0, 3.5);
    g3.visible = false;
    G.scene.add(g3); G.mpTable = g3;
    var FELT = mat(0x1e4d33, {rough:.9});
    var WOODT = mat(0x5a4632, {rough:.8});
    var GOLDT = mat(0xc9a24d, {metal:.5, rough:.45});
    var DARKT = mat(0x2a2233, {rough:.7});
    cyl(0.7, 0.8, 0.08, 12, DARKT, 0, 0.04, 0, g3);
    cyl(0.26, 0.36, 0.78, 8, WOODT, 0, 0.45, 0, g3);
    cyl(1.56, 1.56, 0.1, 28, WOODT, 0, 0.83, 0, g3);
    cyl(1.45, 1.45, 0.05, 28, FELT, 0, 0.9, 0, g3);
    cyl(1.5, 1.5, 0.018, 28, GOLDT, 0, 0.905, 0, g3);
    cyl(0.2, 0.2, 0.006, 16, GOLDT, 0, 0.928, 0, g3);
    var STOOLS = [[-2.5, 0.7], [-2.2, -0.75], [-0.9, -1.4], [0.9, -1.4], [2.2, -0.75], [2.5, 0.7]];
    STOOLS.forEach(function(sp){
      cyl(0.17, 0.15, 0.09, 8, WOODT, sp[0], 0.5, sp[1], g3);
      cyl(0.05, 0.07, 0.46, 6, DARKT, sp[0], 0.23, sp[1], g3);
    });
    /* per-seat infrastructure: card spots, nameplates, the turn ring */
    G.seatDirs = []; G.seatCards = []; G.seatPlates = [];
    var SEATW = [{x:-2.5, z:4.2}, {x:-2.2, z:2.75}, {x:-0.9, z:2.1}, {x:0.9, z:2.1}, {x:2.2, z:2.75}];
    SEATW.forEach(function(sw){
      var lx = sw.x, lz = sw.z - 3.5;
      var len2 = Math.sqrt(lx * lx + lz * lz);
      var dx = lx / len2, dz = lz / len2;
      G.seatDirs.push({x:dx * 1.08, z:dz * 1.08, px:-dz, pz:dx});
      var row2 = [];
      for(var sc2 = 0; sc2 < 5; sc2++){
        var scm = new THREE.Mesh(new THREE.PlaneGeometry(0.24, 0.34),
          new THREE.MeshBasicMaterial({map:mpBackTex()}));
        scm.position.set(dx * 1.08, 0.94 + sc2 * 0.0012, dz * 1.08);
        scm.rotation.set(-Math.PI / 2, 0, 0);
        scm.visible = false;
        g3.add(scm);
        row2.push(scm);
      }
      G.seatCards.push(row2);
      var pc = document.createElement("canvas"); pc.width = 256; pc.height = 96;
      var ptex = new THREE.CanvasTexture(pc);
      var pmesh = new THREE.Mesh(new THREE.PlaneGeometry(0.68, 0.26),
        new THREE.MeshBasicMaterial({map:ptex, transparent:true, depthTest:false}));
      pmesh.position.set(dx * 1.66, 1.14, 3.5 + dz * 1.66);
      pmesh.visible = false;
      pmesh.renderOrder = 20;
      G.scene.add(pmesh);
      G.seatPlates.push({mesh:pmesh, ctx:pc.getContext("2d"), tex:ptex});
    });
    G.myBasis = {x:0, z:1.12, px:1, pz:0};
    G.myCards = [];
    for(var mc2 = 0; mc2 < 5; mc2++){
      var mcm = new THREE.Mesh(new THREE.PlaneGeometry(0.3, 0.42),
        new THREE.MeshBasicMaterial({map:mpBackTex()}));
      mcm.position.set(0, 0.94 + mc2 * 0.0012, 1.12);
      mcm.rotation.set(-Math.PI / 2, 0, 0);
      mcm.visible = false;
      g3.add(mcm);
      G.myCards.push(mcm);
    }
    var mpc = document.createElement("canvas"); mpc.width = 256; mpc.height = 96;
    G.myPlate = {ctx:mpc.getContext("2d"), tex:new THREE.CanvasTexture(mpc)};
    var mpm = new THREE.Mesh(new THREE.PlaneGeometry(0.66, 0.25),
      new THREE.MeshBasicMaterial({map:G.myPlate.tex, transparent:true, depthTest:false}));
    mpm.position.set(0, 1.04, 5.02);
    mpm.visible = false;
    mpm.renderOrder = 20;
    G.scene.add(mpm);
    G.myPlate.mesh = mpm;
    var dpc = document.createElement("canvas"); dpc.width = 256; dpc.height = 96;
    G.dealPlate = {ctx:dpc.getContext("2d"), tex:new THREE.CanvasTexture(dpc)};
    var dpm = new THREE.Mesh(new THREE.PlaneGeometry(0.66, 0.25),
      new THREE.MeshBasicMaterial({map:G.dealPlate.tex, transparent:true, depthTest:false}));
    dpm.position.set(0, 1.08, 2.08);
    dpm.renderOrder = 20;
    dpm.visible = false;
    G.scene.add(dpm);
    G.dealPlate.mesh = dpm;
    var dwrap = new THREE.Group();
    cyl(0.085, 0.085, 0.022, 12, mat(0xefe6cd, {rough:.5}), 0, 0, 0, dwrap);
    cyl(0.05, 0.05, 0.027, 12, GOLDT, 0, 0, 0, dwrap);
    dwrap.position.set(0, 0.93, 1.3);
    dwrap.visible = false;
    g3.add(dwrap);
    G.dealerBtn = dwrap;
    G.betChips = [];
    for(var bp = 0; bp < 6; bp++){
      var stack2 = [];
      for(var ch2 = 0; ch2 < 4; ch2++){
        var chip = cyl(0.055, 0.055, 0.02, 10, mat(0xd8a93f, {metal:.6, rough:.35}), 0, 0.92 + ch2 * 0.022, 0, g3);
        chip.visible = false;
        stack2.push(chip);
      }
      G.betChips.push(stack2);
    }
    G.flyChips = [];
    for(var fc = 0; fc < 6; fc++){
      var fch = cyl(0.06, 0.06, 0.02, 10, mat(0xd8a93f, {metal:.6, rough:.35}), 0, 0.95 + fc * 0.022, -0.18, g3);
      fch.visible = false;
      G.flyChips.push(fch);
    }
    var ring2 = new THREE.Mesh(new THREE.TorusGeometry(0.34, 0.022, 8, 24),
      new THREE.MeshBasicMaterial({color:0xe0b458, transparent:true, opacity:0.85}));
    ring2.rotation.x = -Math.PI / 2;
    ring2.position.set(0, 0.915, 1.12);
    ring2.visible = false;
    g3.add(ring2);
    G.turnRing = ring2;
    G.mpB3 = [];
    for(var i = 0; i < 5; i++){
      var cm = new THREE.Mesh(new THREE.PlaneGeometry(0.3, 0.43),
        new THREE.MeshBasicMaterial({map:mpBackTex()}));
      cm.position.set(-0.72 + i * 0.36, 0.935, -0.18);
      cm.rotation.set(-Math.PI / 2, 0, 0);
      g3.add(cm);
      G.mpB3.push(cm);
    }
    G.showRow = new THREE.Group();
    g3.add(G.showRow);
    if(G.wom && G.wom.group){
      G.womHome = G.wom.group.position.clone();
      G.womSeat = new THREE.Vector3(G.womHome.x, G.womHome.y, 1.82);
    }
  }
  var MPCT = {};
  function mpCardTex(key, draw){
    if(MPCT[key]) return MPCT[key];
    var c4 = document.createElement("canvas"); c4.width = 128; c4.height = 180;
    draw(c4.getContext("2d"));
    MPCT[key] = new THREE.CanvasTexture(c4);
    return MPCT[key];
  }
  function mpSuitGlyph(g3, si, x, y, s){
    g3.save(); g3.translate(x, y);
    g3.fillStyle = BJ_SUITS[si].c; g3.strokeStyle = BJ_SUITS[si].c;
    if(si === 0){
      g3.beginPath(); g3.moveTo(0, -s); g3.lineTo(s * 0.28, s * 0.35); g3.lineTo(0, s * 0.6); g3.lineTo(-s * 0.28, s * 0.35); g3.closePath(); g3.fill();
      g3.fillRect(-s * 0.45, s * 0.35, s * 0.9, s * 0.14);
      g3.fillRect(-s * 0.07, s * 0.35, s * 0.14, s * 0.55);
    } else if(si === 1){
      g3.lineCap = "round";
      g3.lineWidth = s * 0.16;
      g3.beginPath(); g3.arc(-s * 0.25, 0, s * 0.85, -Math.PI / 2.6, Math.PI / 2.6); g3.stroke();
      g3.lineWidth = s * 0.07;
      g3.beginPath();
      g3.moveTo(-s * 0.25 + Math.cos(Math.PI / 2.6) * s * 0.85, -Math.sin(Math.PI / 2.6) * s * 0.85);
      g3.lineTo(-s * 0.25 + Math.cos(Math.PI / 2.6) * s * 0.85, Math.sin(Math.PI / 2.6) * s * 0.85);
      g3.stroke();
      g3.lineWidth = s * 0.13;
      g3.beginPath(); g3.moveTo(-s * 0.75, 0); g3.lineTo(s * 0.5, 0); g3.stroke();
      g3.beginPath(); g3.moveTo(s * 0.95, 0); g3.lineTo(s * 0.42, -s * 0.3); g3.lineTo(s * 0.42, s * 0.3); g3.closePath(); g3.fill();
    } else if(si === 2){
      g3.beginPath(); g3.moveTo(s * 0.18, -s); g3.lineTo(s * 0.62, s * 0.35); g3.lineTo(-s * 0.62, s * 0.35); g3.closePath(); g3.fill();
      g3.fillRect(-s, s * 0.35, s * 2, s * 0.22);
    } else {
      g3.beginPath();
      g3.arc(0, -s * 0.15, s * 0.62, Math.PI, 0);
      g3.lineTo(s * 0.62, s * 0.22); g3.lineTo(s * 0.36, s * 0.46);
      g3.lineTo(-s * 0.36, s * 0.46); g3.lineTo(-s * 0.62, s * 0.22);
      g3.closePath(); g3.fill();
      g3.fillRect(-s * 0.28, s * 0.46, s * 0.56, s * 0.3);
      g3.fillStyle = "#efe6cd";
      g3.beginPath(); g3.arc(-s * 0.24, -s * 0.18, s * 0.15, 0, 7); g3.fill();
      g3.beginPath(); g3.arc(s * 0.24, -s * 0.18, s * 0.15, 0, 7); g3.fill();
      g3.beginPath(); g3.moveTo(0, s * 0.02); g3.lineTo(s * 0.09, s * 0.24); g3.lineTo(-s * 0.09, s * 0.24); g3.closePath(); g3.fill();
      g3.fillRect(-s * 0.02, s * 0.5, s * 0.04, s * 0.24);
      g3.fillRect(-s * 0.17, s * 0.5, s * 0.04, s * 0.24);
      g3.fillRect(s * 0.13, s * 0.5, s * 0.04, s * 0.24);
    }
    g3.restore();
  }
  function mpFaceTex(r, si){
    return mpCardTex("f" + r + "_" + si, function(g3){
      g3.fillStyle = "#efe6cd"; g3.fillRect(0, 0, 128, 180);
      g3.strokeStyle = "#b89b57"; g3.lineWidth = 5; g3.strokeRect(4, 4, 120, 172);
      g3.fillStyle = BJ_SUITS[si].c; g3.font = "bold 42px Georgia"; g3.textAlign = "left";
      g3.fillText(r, 10, 46);
      mpSuitGlyph(g3, si, 64, 112, 36);
    });
  }
  function mpBackDraw(g3, dye, t){
    var fx = DYE_FX[dye] || {};
    var third = dye === "third";
    var acc = third ? "#211e1b" : (fx.acc || "#8a6d3b");
    var mid = third ? "#eae8e1" : (fx.lite || "#e8e2d4");
    g3.clearRect(0, 0, 128, 180);
    g3.fillStyle = third ? "#eae8e1" : dyeFillStyle(g3, dye, t, 0, 90, 128);
    g3.fillRect(0, 0, 128, 180);
    g3.strokeStyle = acc; g3.lineWidth = 5; g3.strokeRect(6, 6, 116, 168);
    g3.lineWidth = 2; g3.strokeRect(13, 13, 102, 154);
    g3.save(); g3.translate(64, 90); g3.rotate(Math.PI / 4);
    g3.fillStyle = acc; g3.fillRect(-22, -22, 44, 44);
    g3.fillStyle = mid; g3.fillRect(-12, -12, 24, 24);
    g3.fillStyle = acc; g3.fillRect(-7, -7, 14, 14);
    g3.restore();
  }
  function mpBackTex(dye){
    var k = DY_OK[dye] ? dye : "std";
    if(k === "std"){
      return mpCardTex("back_std", function(g3){
        g3.fillStyle = "#241c3a"; g3.fillRect(0, 0, 128, 180);
        g3.strokeStyle = "#8a6d3b"; g3.lineWidth = 5; g3.strokeRect(6, 6, 116, 168);
        g3.save(); g3.translate(64, 90); g3.rotate(Math.PI / 4);
        g3.fillStyle = "#c9a24d"; g3.fillRect(-22, -22, 44, 44);
        g3.fillStyle = "#241c3a"; g3.fillRect(-12, -12, 24, 24);
        g3.restore();
      });
    }
    if(MPCT["back_" + k]) return MPCT["back_" + k];
    var c4 = document.createElement("canvas"); c4.width = 128; c4.height = 180;
    var gg = c4.getContext("2d");
    mpBackDraw(gg, k, 0);
    var tx = new THREE.CanvasTexture(c4);
    MPCT["back_" + k] = tx;
    if(k !== "third" && k !== "barrows"){
      G.backAnim = G.backAnim || [];
      G.backAnim.push({dye:k, g:gg, tex:tx});
    }
    return tx;
  }
  function mpBoard3D(board, count){
    if(!G.mpB3) return;
    var bj2 = count != null;
    var total = bj2 ? count : 5;
    for(var i = 0; i < 5; i++){
      var mesh5 = G.mpB3[i];
      mesh5.visible = i < total;
      if(i < total){
        mesh5.position.x = bj2 ? (i - (total - 1) / 2) * 0.36 : -0.72 + i * 0.36;
        mesh5.position.z = bj2 ? -0.55 : -0.18;
      }
      var e = i < board.length ? board[i] : null;
      var tex = e ? mpFaceTex(e.r, e.si)
        : mpBackTex((state.cosmetics && DY_OK[state.cosmetics.eq]) ? state.cosmetics.eq : null);
      if(mesh5.material.map !== tex){
        mesh5.material.map = tex;
        mesh5.material.needsUpdate = true;
        if(e && MP.live){
          mesh5.userData.pop = 0.0001;
          tone(860 + i * 70, 0.05, "square", 0.05);
        }
      }
    }
  }
  var DYE_NZ = {};
  function mkNoise(base, lite, dark, blurPx, icy){
    var cv = document.createElement("canvas"); cv.width = 256; cv.height = 64;
    var c = cv.getContext("2d");
    c.fillStyle = base; c.fillRect(0, 0, 256, 64);
    try{ c.filter = "blur(" + blurPx + "px)"; }catch(e){}
    var i;
    if(icy){
      for(i = 0; i < 14; i++){
        c.fillStyle = dark; c.globalAlpha = 0.14 + Math.random() * 0.14;
        c.beginPath(); c.arc(Math.random() * 256, Math.random() * 64, 8 + Math.random() * 16, 0, 7); c.fill();
      }
      for(i = 0; i < 20; i++){
        c.fillStyle = lite; c.globalAlpha = 0.18 + Math.random() * 0.25;
        c.beginPath(); c.arc(Math.random() * 256, Math.random() * 64, 3 + Math.random() * 8, 0, 7); c.fill();
      }
    } else {
      for(i = 0; i < 52; i++){
        c.fillStyle = Math.random() < 0.55 ? lite : dark;
        c.globalAlpha = 0.15 + Math.random() * 0.22;
        c.beginPath(); c.arc(Math.random() * 256, Math.random() * 64, 5 + Math.random() * 15, 0, 7); c.fill();
      }
    }
    c.globalAlpha = 1;
    return cv;
  }
  /* one source of truth, ported from the solo shop/leaderboard art */
  var DYE_FX = {
    blood:  {noise:["#a83232", "#e8b9ac", "#571313", 7], acc:"#571313", lite:"#e8b9ac", spd:22},
    shadow: {noise:["#9b77a6", "#dcc6e2", "#3c2547", 7], acc:"#3c2547", lite:"#dcc6e2", spd:16},
    soul:   {noise:["#327457", "#9fd8b8", "#123526", 7], acc:"#123526", lite:"#9fd8b8", spd:18},
    ice:    {noise:["#9fd7e8", "#e8f7fb", "#5fa8c4", 2, true], acc:"#3f7f9c", lite:"#e8f7fb", spd:9, glow:"#9fd7e8"},
    aurora: {grad:["#496797", "#4f8f92", "#7fc9a8", "#a9e0c9", "#5fa998", "#496797"], acc:"#2f4668", lite:"#a9e0c9", spd:0.10},
    trim:   {grad:["#f6dfa5", "#e0b458", "#fff6d8", "#e0b458", "#f6dfa5"], acc:"#8a6d3b", lite:"#fff6d8", spd:0.55, glow:"#ffdf8a"},
    barrows:{flat:"#8c9177", acc:"#565a49", lite:"#b9bda6"},
    third:  {flat:"#74838b", acc:"#211e1b", lite:"#eef3f5"}
  };
  function dyeFillStyle(g, dye, t, x, y, w){
    var fx = DYE_FX[dye];
    if(!fx) return "#e8e2d4";
    if(fx.noise){
      if(!DYE_NZ[dye]) DYE_NZ[dye] = mkNoise.apply(null, fx.noise);
      var pat = g.createPattern(DYE_NZ[dye], "repeat");
      try{
        pat.setTransform(new DOMMatrix([1, 0, 0, 1, -((t * fx.spd) % 256), Math.sin(t * 0.4) * 6]));
      }catch(e){}
      return pat;
    }
    if(fx.grad){
      var span = Math.max(60, w) * 3.2;
      var cyc = span - Math.max(60, w);
      var oR = (t * fx.spd * span) % (cyc * 2);
      var off = oR < cyc ? oR : cyc * 2 - oR;
      var gr = g.createLinearGradient(x - off, y - 8, x - off + span, y + 8 + span * 0.18);
      for(var i = 0; i < fx.grad.length; i++) gr.addColorStop(i / (fx.grad.length - 1), fx.grad[i]);
      return gr;
    }
    return fx.flat;
  }
  function mpDyeName(g, txt, x, y, dye){
    var t = performance.now() / 1000;
    var fx = DYE_FX[dye];
    if(!fx){ g.fillStyle = "#e8e2d4"; g.fillText(txt, x, y); return; }
    var w = Math.max(20, g.measureText(txt).width);
    g.save();
    if(dye === "third"){
      var span2 = 26 * 2.4, cyc2 = span2 - 26;
      var oR2 = (t / 7 * cyc2 * 2) % (cyc2 * 2);
      var o2 = oR2 < cyc2 ? oR2 : cyc2 * 2 - oR2;
      var gr3 = g.createLinearGradient(0, y - 22 - o2, 0, y - 22 - o2 + span2);
      var TG = ["#fdfefe", "#cdd8dd", "#74838b", "#aab7bd", "#eef3f5"];
      for(var gi = 0; gi < TG.length; gi++) gr3.addColorStop(gi / (TG.length - 1), TG[gi]);
      g.fillStyle = gr3;
      g.fillText(txt, x, y);
      g.strokeStyle = "rgba(12,14,16,0.85)"; g.lineWidth = 1;
      g.strokeText(txt, x, y);
    } else {
      g.fillStyle = dyeFillStyle(g, dye, t, x, y, w);
      if(fx.glow) { g.shadowColor = fx.glow; g.shadowBlur = dye === "trim" ? 3 + 5 * Math.abs(Math.sin(t * 1.3)) : 7; }
      else if(fx.lite){ g.shadowColor = fx.lite; g.shadowBlur = 4; }
      g.fillText(txt, x, y);
    }
    g.restore();
  }
  function mpPlateDraw(plate, name, chips, sub, o){
    var g4 = plate.ctx;
    g4.clearRect(0, 0, 256, 96);
    g4.fillStyle = o.folded ? "rgba(16,12,24,0.5)" : "rgba(16,12,24,0.85)";
    g4.fillRect(0, 0, 256, 96);
    g4.strokeStyle = (o.win || o.turn) ? "#e0b458" : "#3a3150";
    g4.lineWidth = o.win ? 7 : 4;
    g4.strokeRect(2, 2, 252, 92);
    g4.font = "bold 26px monospace"; g4.textAlign = "left";
    if(!o.folded && o.dye && DYEC[o.dye]){
      mpDyeName(g4, String(name).slice(0, 11), 14, 36, o.dye);
    } else {
      g4.fillStyle = o.folded ? "#6f6a60" : "#e8e2d4";
      g4.fillText(String(name).slice(0, 11), 14, 36);
    }
    g4.fillStyle = "#e0b458";
    g4.font = "bold 30px monospace";
    g4.fillText(chips, 14, 76);
    if(sub){
      g4.fillStyle = o.win ? "#e0b458" : "#a89e8a";
      g4.font = "20px monospace"; g4.textAlign = "right";
      g4.fillText(String(sub).slice(0, 14), 244, 76);
    }
    if(o.turn && o.frac > 0){
      g4.strokeStyle = "#e0b458"; g4.lineWidth = 6;
      g4.beginPath();
      g4.arc(224, 28, 15, -Math.PI / 2, -Math.PI / 2 + o.frac * Math.PI * 2);
      g4.stroke();
    }
    plate.tex.needsUpdate = true;
  }
  function mpSeats(m){
    if(!G.seatPlates || !MP.live || !m) return;
    var opps = (m.players || []).filter(function(p){ return p.id !== MP.id; });
    var elapsed = (Date.now() - (MP.turnAt || 0)) / 1000;
    var frac = Math.max(0, 1 - elapsed / (MP.mode === "bj" ? (MP.timerLen || 25) + 5 : (MP.timerLen || 25)));
    for(var i = 0; i < 5; i++){
      var p = opps[i], plate = G.seatPlates[i], cards = G.seatCards[i], B = G.seatDirs[i];
      var on = !!p && !p.out;
      plate.mesh.visible = on;
      for(var hz = 0; hz < 5; hz++) cards[hz].visible = false;
      for(var hc = 0; hc < 4; hc++) G.betChips[i][hc].visible = false;
      if(!on) continue;
      var folded = MP.mode === "poker" && m.inHand && m.inHand.indexOf(p.id) === -1 && m.phase !== "over";
      var isTurn = m.turn === p.id;
      var win = m.winners && m.winners.indexOf(p.id) !== -1;
      var sub = "";
      if(m.results && m.results[p.id] != null) sub = (m.results[p.id] >= 0 ? "+" : "") + fmtBet(m.results[p.id]);
      else if(m.handNames && m.handNames[p.id]) sub = m.handNames[p.id];
      else if(folded) sub = "folded";
      else if(MP.mode === "poker" && m.put && m.put[p.id]) sub = "bet " + fmtBet(m.put[p.id]);
      else if(MP.mode === "bj" && m.bj && m.bj.hands && m.bj.hands[p.id]) sub = "showing " + bjVal(m.bj.hands[p.id]);
      else if(MP.mode === "bj" && m.bets && m.bets[p.id] != null) sub = "bet " + fmtBet(m.bets[p.id]);
      mpPlateDraw(plate, p.name, fmtBet(p.chips), sub, {turn:isTurn, frac:isTurn ? frac : 0, folded:folded, win:win, dye:p.dye});
      var put2 = (MP.mode === "poker" && m.put && m.put[p.id]) || 0;
      var nCh = put2 > 0 ? Math.min(4, Math.ceil(put2 / mpAnte())) : 0;
      for(var chp = 0; chp < nCh; chp++){
        G.betChips[i][chp].visible = true;
        G.betChips[i][chp].position.set(B.x * 0.741, 0.92 + chp * 0.022, B.z * 0.741);
      }
      var arr = null, faces = false;
      if(MP.mode === "poker"){
        if(!folded){
          arr = (m.reveal && m.reveal[p.id]) || [null, null];
          faces = !!(m.reveal && m.reveal[p.id]);
          if(faces && m.phase === "reveal" && Date.now() - (MP.revealAt || 0) < i * 550 + 300){
            faces = false;
            arr = [null, null];
          }
        }
      } else if(m.bj && m.bj.hands[p.id]){
        arr = m.bj.hands[p.id]; faces = true;
      }
      if(arr){
        var n2 = Math.min(5, arr.length);
        for(var ci = 0; ci < n2; ci++){
          var cm2 = cards[ci];
          cm2.visible = true;
          var offN = (ci - (n2 - 1) / 2) * (n2 > 3 ? 0.17 : 0.26);
          cm2.position.set(B.x + B.px * offN, 0.94 + ci * 0.0012, B.z + B.pz * offN);
          var tex2 = faces && arr[ci] ? mpFaceTex(arr[ci].r, arr[ci].si) : mpBackTex(p.dye);
          if(cm2.material.map !== tex2){
            cm2.material.map = tex2;
            cm2.material.needsUpdate = true;
            if(faces && arr[ci] && MP.live){
              cm2.userData.pop = 0.0001;
              tone(940, 0.04, "square", 0.04);
            }
          }
        }
      }
    }
    var meOut = !!MP.spec;
    (m.players || []).forEach(function(pq){ if(pq.id === MP.id && pq.out) meOut = true; });
    if(meOut && MP.myHand.length) MP.myHand = [];
    var myArr = meOut ? [] : (MP.mode === "poker" ? (MP.myHand || []) : ((m.bj && m.bj.hands[MP.id]) || []));
    var myN = Math.min(5, MP.mode === "poker" ? Math.min(2, myArr.length) : myArr.length);
    for(var mi = 0; mi < 5; mi++){
      var cm5 = G.myCards[mi];
      cm5.visible = mi < myN;
      if(mi < myN && myArr[mi]){
        var offM = (mi - (myN - 1) / 2) * 0.34;
        cm5.position.set(G.myBasis.x + G.myBasis.px * offM, 0.94 + mi * 0.0012, G.myBasis.z + G.myBasis.pz * offM);
        var tex4 = mpFaceTex(myArr[mi].r, myArr[mi].si);
        if(cm5.material.map !== tex4){
          cm5.material.map = tex4;
          cm5.material.needsUpdate = true;
          if(MP.live){
            cm5.userData.pop = 0.0001;
            tone(980 + mi * 60, 0.05, "square", 0.05);
          }
        }
      }
    }
    var meP2 = null;
    (m.players || []).forEach(function(pp){ if(pp.id === MP.id) meP2 = pp; });
    if(G.myPlate){
      G.myPlate.mesh.visible = !!meP2 && !meP2.out;
      if(meP2 && !meP2.out){
        var myFold = MP.mode === "poker" && m.inHand && m.inHand.indexOf(MP.id) === -1 && m.phase !== "over";
        var mySub = "";
        if(m.results && m.results[MP.id] != null) mySub = (m.results[MP.id] >= 0 ? "+" : "") + fmtBet(m.results[MP.id]);
        else if(myFold) mySub = "folded";
        else if(MP.mode === "poker"){
          var mAll = (MP.myHand || []).map(mpDeser).concat((m.board || []).map(mpDeser));
          if(mAll.length >= 5) mySub = mpBest5(mAll).name;
          else if(m.put && m.put[MP.id]) mySub = "bet " + fmtBet(m.put[MP.id]);
        } else if(m.bj && m.bj.hands[MP.id]) mySub = "showing " + bjVal(m.bj.hands[MP.id]);
        mpPlateDraw(G.myPlate, "You", fmtBet(meP2.chips), mySub,
          {turn:m.turn === MP.id, frac:m.turn === MP.id ? frac : 0, folded:myFold,
           win:!!(m.winners && m.winners.indexOf(MP.id) !== -1),
           dye:meP2.dye || ((state.cosmetics && DY_OK[state.cosmetics.eq]) ? state.cosmetics.eq : null)});
      }
    }
    if(G.dealPlate){
      var showBj = MP.mode === "bj" && m.bj;
      G.dealPlate.mesh.visible = !!showBj;
      if(showBj){
        var dvis2 = (m.bj.dealer || []).filter(Boolean);
        var dv2 = dvis2.length ? bjVal(dvis2) : 0;
        var dsub = m.phase === "reveal" ? (dv2 > 21 ? "bust!" : "total " + dv2) : "shows " + dv2;
        mpPlateDraw(G.dealPlate, "Dealer", "", dsub, {turn:false, frac:0, folded:false, win:false});
      }
    }
    if(G.betChips){
      var myPut = (MP.mode === "poker" && m.put && m.put[MP.id]) || 0;
      var myCh = myPut > 0 ? Math.min(4, Math.ceil(myPut / mpAnte())) : 0;
      for(var mch = 0; mch < 4; mch++){
        G.betChips[5][mch].visible = mch < myCh;
        if(mch < myCh) G.betChips[5][mch].position.set(0, 0.92 + mch * 0.022, 0.83);
      }
    }
    if(G.dealerBtn){
      var bt = null;
      if(m.btn === MP.id) bt = G.myBasis;
      else for(var bi2 = 0; bi2 < opps.length && bi2 < 5; bi2++) if(opps[bi2].id === m.btn) bt = G.seatDirs[bi2];
      G.dealerBtn.visible = MP.mode === "poker" && !!bt;
      if(bt) G.dealerBtn.position.set(bt.x + bt.px * 0.32, 0.93, bt.z + bt.pz * 0.32);
    }
    if(MP.mode === "poker" && m.phase === "reveal" && m.reveal && m.winners && m.winners.length && !MP.hlDone){
      if(Date.now() - (MP.revealAt || 0) > opps.length * 550 + 500){
        MP.hlDone = true;
        var w4 = m.winners[0];
        var wHole = (m.reveal[w4] || []).map(mpDeser);
        var full4 = wHole.concat((m.board || []).map(mpDeser));
        if(full4.length === 7){
          var bres = mpBest5(full4);
          var used = {};
          (bres.idx || []).forEach(function(x){ used[x] = true; });
          for(var bd = 0; bd < 5; bd++) G.mpB3[bd].material.color.set(used[bd + 2] ? 0xffffff : 0x6f6f6f);
          var seatIdx = -1;
          for(var si2 = 0; si2 < opps.length; si2++) if(opps[si2].id === w4) seatIdx = si2;
          var wCards = w4 === MP.id ? G.myCards : (seatIdx >= 0 ? G.seatCards[seatIdx] : null);
          if(wCards){
            wCards[0].material.color.set(used[0] ? 0xffffff : 0x6f6f6f);
            wCards[1].material.color.set(used[1] ? 0xffffff : 0x6f6f6f);
          }
          MP.flyTo = w4 === MP.id ? G.myBasis : (seatIdx >= 0 ? G.seatDirs[seatIdx] : null);
          if(MP.flyTo && !m.foldwin) MP.flyT = 0.0001;
          var cards5 = (bres.idx || []).map(function(ci){ return full4[ci]; });
          for(var sc5 = 0; sc5 < cards5.length; sc5++)(function(i6, cd6){
            setTimeout(function(){
              if(!MP.live || !G.showRow || !MP.round || MP.round.phase !== "reveal") return;
              var pl5 = new THREE.Mesh(new THREE.PlaneGeometry(0.27, 0.39),
                new THREE.MeshBasicMaterial({map:mpFaceTex(cd6.r, cd6.si), transparent:true}));
              pl5.rotation.set(-Math.PI / 2, 0, 0);
              pl5.position.set(-0.62 + i6 * 0.31, 0.937, 0.55);
              pl5.userData.pop = 0.0001;
              G.showRow.add(pl5);
              if(G.popList) G.popList.push(pl5);
              tone(700 + i6 * 90, 0.06, "triangle", 0.06);
            }, 260 + i6 * 180);
          })(sc5, cards5[sc5]);
        }
      }
    }
    var ringAt = null;
    var focus = (m.phase === "reveal" && m.winners && m.winners.length) ? m.winners[0] : m.turn;
    if(focus === MP.id) ringAt = G.myBasis;
    else for(var ri = 0; ri < opps.length && ri < 5; ri++) if(opps[ri].id === focus) ringAt = G.seatDirs[ri];
    G.turnRing.visible = !!ringAt && m.phase !== "over";
    if(ringAt) G.turnRing.position.set(ringAt.x, 0.915, ringAt.z);
  }
  var EMOTES = ["Nice hand!", "Ouch.", "All luck.", "gg", "Bluffing?"];
  var DY_OK = {blood:1, third:1, shadow:1, ice:1, aurora:1, soul:1, barrows:1, trim:1};
  var DYEC = {blood:"#a83232", third:"#74838b", shadow:"#9b77a6", ice:"#9fd7e8",
              aurora:"#7fc9a8", soul:"#327457", barrows:"#8c9177", trim:"#e0b458"};
  function mpBubble(pid, txt){
    if(!MP.live || !G.ok) return;
    var pos = null;
    if(pid === MP.id) pos = new THREE.Vector3(0, 1.5, 4.85);
    else {
      var opps2 = MP.players.filter(function(q){ return q.id !== MP.id; });
      for(var bi3 = 0; bi3 < opps2.length && bi3 < 5; bi3++){
        if(opps2[bi3].id === pid && G.seatPlates[bi3])
          pos = G.seatPlates[bi3].mesh.position.clone().add(new THREE.Vector3(0, 0.34, 0));
      }
    }
    if(!pos) return;
    var bc2 = document.createElement("canvas"); bc2.width = 256; bc2.height = 64;
    var bg2 = bc2.getContext("2d");
    bg2.fillStyle = "rgba(232,226,212,0.95)"; bg2.fillRect(0, 0, 256, 64);
    bg2.strokeStyle = "#8a6d3b"; bg2.lineWidth = 4; bg2.strokeRect(2, 2, 252, 60);
    bg2.fillStyle = "#241c2e"; bg2.font = "bold " + (String(txt).length > 13 ? 18 : 24) + "px Georgia"; bg2.textAlign = "center";
    bg2.fillText(String(txt).slice(0, 24), 128, 41);
    var bm2 = new THREE.Mesh(new THREE.PlaneGeometry(0.7, 0.175),
      new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(bc2), transparent:true, depthTest:false}));
    bm2.position.copy(pos);
    bm2.renderOrder = 30;
    G.scene.add(bm2);
    G.bubbles = G.bubbles || [];
    G.bubbles.push({mesh:bm2, t:0});
    tone(600, 0.05, "square", 0.05);
  }
  function mpResetTint(){
    if(G.showRow){
      while(G.showRow.children.length) G.showRow.remove(G.showRow.children[0]);
      if(G.popList) G.popList = G.popList.filter(function(c9){ return c9.parent; });
    }
    if(G.mpB3) G.mpB3.forEach(function(c){ c.material.color.set(0xffffff); });
    if(G.seatCards) G.seatCards.forEach(function(r6){ r6.forEach(function(c){ c.material.color.set(0xffffff); }); });
    if(G.myCards) G.myCards.forEach(function(c){ c.material.color.set(0xffffff); });
  }
  function mpSeatsOff(){
    if(!G.seatPlates) return;
    G.seatPlates.forEach(function(sp2){ sp2.mesh.visible = false; });
    G.seatCards.forEach(function(row3){ row3.forEach(function(c7){ c7.visible = false; }); });
    G.myCards.forEach(function(c8){ c8.visible = false; });
    G.turnRing.visible = false;
    if(G.myPlate) G.myPlate.mesh.visible = false;
    if(G.dealPlate) G.dealPlate.mesh.visible = false;
    if(G.dealerBtn) G.dealerBtn.visible = false;
    if(G.betChips) G.betChips.forEach(function(st4){ st4.forEach(function(c9){ c9.visible = false; }); });
    if(G.flyChips) G.flyChips.forEach(function(c10){ c10.visible = false; });
    mpResetTint();
  }


  /* ---------- ATM: for the desperate ---------- */
  var ATM = {busy:false, parts:[], card:null, cardGo:false, cardT:0};
  function buildATM(){
    var g2 = new THREE.Group();
    g2.position.set(-7.5, 0, 4.2);
    g2.rotation.y = Math.PI / 2;
    G.scene.add(g2); G.atm = g2;
    var STEEL = mat(0x434a58, {metal:.5, rough:.45});
    var DARKM = mat(0x1a1622, {rough:.7});
    var GTRIM = mat(0xc9a24d, {metal:.5, rough:.45});
    box(0.86, 0.12, 0.6, DARKM, 0, 0.06, 0, g2);
    box(0.8, 1.55, 0.55, STEEL, 0, 0.895, 0, g2);
    box(0.84, 0.06, 0.58, GTRIM, 0, 1.7, 0, g2);
    box(0.8, 0.3, 0.5, mat(0x2a2433, {rough:.6}), 0, 1.9, 0, g2);
    var sg = document.createElement("canvas"); sg.width = 128; sg.height = 48;
    var s3 = sg.getContext("2d");
    s3.fillStyle = "#241c2e"; s3.fillRect(0, 0, 128, 48);
    s3.fillStyle = "#e0b458"; s3.font = "bold 28px Georgia"; s3.textAlign = "center";
    s3.fillText("A T M", 64, 35);
    var sgp = new THREE.Mesh(new THREE.PlaneGeometry(0.7, 0.26), new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(sg)}));
    sgp.position.set(0, 1.9, 0.26); g2.add(sgp);
    sph(0.03, new THREE.MeshBasicMaterial({color:0xff5f4a}), -0.32, 1.9, 0.27, g2);
    sph(0.03, new THREE.MeshBasicMaterial({color:0x57e07a}), 0.32, 1.9, 0.27, g2);
    box(0.56, 0.34, 0.03, DARKM, 0, 1.24, 0.27, g2);
    var sc = document.createElement("canvas"); sc.width = 128; sc.height = 64;
    ATM.scrCtx = sc.getContext("2d");
    ATM.scrTex = new THREE.CanvasTexture(sc);
    var scr = new THREE.Mesh(new THREE.PlaneGeometry(0.48, 0.26), new THREE.MeshBasicMaterial({map:ATM.scrTex}));
    scr.position.set(0, 1.24, 0.29); g2.add(scr);
    box(0.34, 0.07, 0.04, STEEL, 0, 0.99, 0.28, g2);
    box(0.26, 0.02, 0.05, mat(0x0a0812), 0, 0.99, 0.285, g2);
    box(0.05, 0.02, 0.05, new THREE.MeshBasicMaterial({color:0x57e07a}), 0.2, 0.99, 0.285, g2);
    var pad = new THREE.Group(); pad.position.set(0, 0.78, 0.27); pad.rotation.x = -0.5; g2.add(pad);
    box(0.3, 0.22, 0.03, mat(0x232733), 0, 0, 0, pad);
    ATM.keys = [];
    ATM.keyDim = mat(0x8a8fa0, {rough:.5});
    ATM.keyLit = new THREE.MeshBasicMaterial({color:0xffe066});
    for(var kr = 0; kr < 4; kr++) for(var kc = 0; kc < 3; kc++){
      ATM.keys.push(box(0.055, 0.035, 0.015, ATM.keyDim, -0.08 + kc * 0.08, 0.075 - kr * 0.05, 0.02, pad));
    }
    box(0.2, 0.015, 0.04, mat(0x0a0812), -0.22, 1.5, 0.28, g2);
    box(0.5, 0.16, 0.1, STEEL, 0, 0.42, 0.28, g2);
    box(0.42, 0.1, 0.08, mat(0x0a0812), 0, 0.43, 0.31, g2);
    box(0.5, 0.03, 0.14, GTRIM, 0, 0.33, 0.3, g2);
    cyl(0.06, 0.06, 0.015, 12, GTRIM, 0.26, 0.7, 0.276, g2).rotation.x = Math.PI / 2;
    atmScreen("BANK OF GIELINOR", "INSERT CARD");
    /* the credit card: chip, embossed digits, bank logo, face up, short end first */
    var card = new THREE.Group();
    card.add(new THREE.Mesh(new THREE.BoxGeometry(0.22, 0.008, 0.14), mat(0x2456a8, {rough:.35, metal:.15})));
    var chip = new THREE.Mesh(new THREE.BoxGeometry(0.035, 0.006, 0.03), mat(0xd8a93f, {metal:.7, rough:.3}));
    chip.position.set(-0.055, 0.005, -0.025); card.add(chip);
    for(var cd = 0; cd < 4; cd++){
      var num = new THREE.Mesh(new THREE.BoxGeometry(0.034, 0.003, 0.014), mat(0xdfe3ea, {rough:.5}));
      num.position.set(-0.075 + cd * 0.05, 0.005, 0.02); card.add(num);
    }
    var logo = new THREE.Mesh(new THREE.CylinderGeometry(0.018, 0.018, 0.004, 10), mat(0xe0b458, {metal:.6, rough:.35}));
    logo.position.set(0.085, 0.005, -0.045); card.add(logo);
    card.position.set(-2.95, 0.99, 2.6);
    card.visible = false;
    G.scene.add(card);
    ATM.card = card;
  }
  function atmScreen(l1, l2){
    var c3 = ATM.scrCtx;
    if(!c3) return;
    c3.fillStyle = "#0c1a10"; c3.fillRect(0, 0, 128, 64);
    c3.strokeStyle = "rgba(87,224,122,0.09)"; c3.lineWidth = 1;
    for(var y3 = 3; y3 < 64; y3 += 5){ c3.beginPath(); c3.moveTo(0, y3); c3.lineTo(128, y3); c3.stroke(); }
    c3.fillStyle = "#57e07a"; c3.font = "bold 12px monospace"; c3.textAlign = "center";
    c3.fillText(l1, 64, l2 ? 27 : 36);
    if(l2) c3.fillText(l2, 64, 45);
    ATM.scrTex.needsUpdate = true;
  }
  function atmKeyBlink(){
    if(!ATM.keys || !ATM.keys.length) return;
    var key = ATM.keys[Math.floor(Math.random() * ATM.keys.length)];
    key.material = ATM.keyLit;
    setTimeout(function(){ key.material = ATM.keyDim; }, 150);
  }
  function atmGo(){
    if(ATM.busy || state.coins >= 0 || !G.ok || MP.live) return;
    ATM.stage = 1;
    G.lookYawT = Math.PI * 1.5; G.lookXT = -1.5;
    el.atmBtn.textContent = "Clear Debt";
    el.atmBack.style.display = "";
    tone(300, 0.08, "square", 0.06);
  }
  function atmLeave(){
    if(ATM.busy) return;
    ATM.stage = 0;
    el.atmBtn.textContent = "ATM";
    el.atmBack.style.display = "none";
    G.lookYawT = Math.PI; G.lookXT = 0;
  }
  function atmClear(){
    if(ATM.busy || state.coins >= 0 || !G.ok || MP.live) return;
    ATM.busy = true;
    el.atmBtn.disabled = true;
    el.atmBack.style.display = "none";
    atmScreen("READING CARD", "");
    setTimeout(function(){
      ATM.card.visible = true;
      ATM.card.position.set(G.atm.position.x + 1.07, 0.99, G.atm.position.z);
      ATM.cardGo = 1; ATM.cardT = 0;
      tone(700, 0.05, "square", 0.05);
    }, 250);
    setTimeout(function(){ tone(1100, 0.06, "square", 0.06); atmScreen("CARD ACCEPTED", "REMOVE CARD"); }, 1150);
    setTimeout(function(){ ATM.cardGo = 2; ATM.cardT = 0; }, 1450);
    setTimeout(function(){ atmScreen("ENTER PIN", ""); }, 2050);
    [0, 1, 2, 3].forEach(function(d2){
      setTimeout(function(){
        tone(880 + d2 * 130, 0.06, "square", 0.07);
        atmKeyBlink();
        atmScreen("ENTER PIN", "* * * *".slice(0, d2 * 2 + 1));
      }, 2350 + d2 * 330);
    });
    setTimeout(function(){
      atmScreen("PIN ACCEPTED", "DISPENSING");
      tone(1250, 0.07, "square", 0.08); tone(1550, 0.07, "square", 0.06);
    }, 3850);
    setTimeout(function(){
      for(var k = 0; k < 26; k++){
        var pm2 = new THREE.MeshStandardMaterial({color:0xd8a93f, metalness:.7, roughness:.3, transparent:true});
        var pt = new THREE.Mesh(new THREE.CylinderGeometry(0.035, 0.035, 0.012, 8), pm2);
        pt.position.set(G.atm.position.x + 0.32, 0.48, G.atm.position.z);
        pt.rotation.set(Math.random() * 3, Math.random() * 3, 0);
        pt.userData.v = new THREE.Vector3(1.2 + Math.random() * 2.2, 1.5 + Math.random() * 2.4, (Math.random() - 0.5) * 1.6);
        pt.userData.life = 1.4;
        G.scene.add(pt); ATM.parts.push(pt);
      }
      for(var q2 = 0; q2 < 6; q2++) setTimeout(function(){ tone(1400 + Math.random() * 900, 0.05, "square", 0.07); }, q2 * 90);
      var cleared = 200 - state.coins;
      state.coins = 200;
      state.stats.atmSwipes = (state.stats.atmSwipes || 0) + 1;
      el.verdict.className = "verdict big win";
      el.vHand.textContent = "Credit approved";
      el.vDelta.textContent = "+" + fmtCoins(cleared) + " coins \u00b7 debt cleared, balance 200";
      say(pick(LINES.atm)); setMood("win"); sfxWin(4);
      paint(); save();
    }, 4250);
    setTimeout(function(){
      atmScreen("BANK OF GIELINOR", "INSERT CARD");
      G.lookYawT = Math.PI;
      ATM.busy = false;
      ATM.stage = 0;
      el.atmBtn.textContent = "ATM";
      el.atmBtn.disabled = false;
      paint();
    }, 6300);
  }

  /* ============================================================
     New games, build xg-1: Baccarat, Dicing, Hot or Cold, Squeal of Fortune,
     Barrows Chests, Wilderness Run, Pet Derby.
     Self-contained: builds its own zones, rules panels, stat rows, rail and
     styles at boot, so markup and css files do not need touching.
     ============================================================ */
  var XG_KEYS = ["bac","d55","flower","squeal","barrows","wildy","derby"];
  var XG_CELLAR = ["squeal","barrows","wildy","derby"];
  var CELLAR_ICO = "<svg viewBox='0 0 12 12' style='width:11px;height:11px;margin-left:6px;vertical-align:-1px;opacity:.75;flex:0 0 auto'>" +
    "<path d='M11 11H1V9h3V6h3V3h3V1h1z' fill='#c9a24d'/></svg>";
  var XG = null;
  var XL = {
    bac: ["The banker is always right, lad. I am the banker.", "Punto, banco, whatever you call it, pay me.", "Five percent commission. The beard does not comb itself."],
    d55: ["Fifty-five. Always fifty-five.", "Roll it, lad. The dice have no memory. I do.", "Fifty-four is not fifty-five. I checked."],
    flower: ["Mithril seeds, grown by me, taxed by me.", "Hot or cold, the house stays warm.", "Rainbows are lovely. For me."],
    squeal: ["Spin the wheel! Every spin a winner! That part was a lie.", "Welcome to Squeal of Fortune. I am legally not Sally.", "No keys needed. Just your coins."],
    barrows: ["Six brothers, one crypt, zero manners.", "Open another, lad. What could go wrong.", "Mind Dharok. He is in a mood."],
    wildy: ["Deeper means richer. Also deader.", "Nobody PKs at level 3. Probably.", "Keep a teletab handy, lad."],
    derby: ["Coin on a pet. The pets do not care.", "The favourite never wins. Except when it does.", "I trained none of them. Allegedly."]
  };
  var XROWS = [
    {bf:"bac", n:"Baccarat hands", k:"bacHands"}, {bf:"bac", n:"Baccarat wins", k:"bacWins"},
    {bf:"d55", n:"Dicing rolls", k:"d55Rolls"}, {bf:"d55", n:"Dicing wins", k:"d55Wins"},
    {bf:"flower", n:"Flowers planted", k:"flowerPlays"}, {bf:"flower", n:"Flower wins", k:"flowerWins"},
    {bf:"squeal", n:"Squeal spins", k:"sqSpins"}, {bf:"squeal", n:"Squeal wins", k:"sqWins"},
    {bf:"barrows", n:"Crypt runs", k:"barrowsRuns"}, {bf:"barrows", n:"Crypt escapes", k:"barrowsWins"},
    {bf:"wildy", n:"Wilderness runs", k:"wildyRuns"}, {bf:"wildy", n:"Wilderness escapes", k:"wildyWins"},
    {bf:"wildy", n:"Deepest escape", k:"wildyBest", f:function(v){ return v ? v.toFixed(2) + "x" : "0"; }},
    {bf:"derby", n:"Derby races", k:"derbyRaces"}, {bf:"derby", n:"Derby wins", k:"derbyWins"}
  ];
  var XRAIL = [
    ["Cards", [["poker","Poker"],["bj","Blackjack"],["bac","Baccarat"]]],
    ["Dice", [["dice","Craps"],["ceelo","Cee-lo"],["d55","Dicing"]]],
    ["Wheels", [["rou","Roulette"],["squeal","Squeal of Fortune"]]],
    ["Machines", [["slots","Slots"],["pach","Pachinko"]]],
    ["Gielinor", [["stake","Staking"],["flower","Flower Game"],["barrows","Barrows Chests"],["wildy","Wilderness Run"],["derby","Pet Derby"]]]
  ];
  var TAU = Math.PI * 2;
  var xRoot = document.getElementById("pvm-poker");
  function xIs(g){ return XG_KEYS.indexOf(g) !== -1; }
  function xBet(){ state.bet = Math.max(minBet(), Math.min(state.bet, maxBet())); return state.bet; }
  function xBusy(){
    if(!XG || !xIs(state.game)) return false;
    var X = XG[state.game];
    return (state.game === "barrows" || state.game === "wildy") ? !!X.on : !!X.busy;
  }
  function xNode(tag, cls, html){
    var d = document.createElement(tag);
    if(cls) d.className = cls;
    if(html != null) d.innerHTML = html;
    return d;
  }
  function xWiki(file){ return "https://runescape.wiki/images/" + file.replace(/ /g, "_"); }
  function xImg(file, cls){
    var im = document.createElement("img");
    im.referrerPolicy = "no-referrer";
    im.setAttribute("referrerpolicy", "no-referrer");
    im.alt = "";
    if(cls) im.className = cls;
    im.onerror = function(){ im.style.visibility = "hidden"; };
    im.src = xWiki(file);
    return im;
  }
  /* shared settle: profit > 0 win, < 0 loss (lose the bet), 0 push */
  function xSettle(o){
    if(o.profit > 0){
      var hm0 = hotMult();
      if(hm0 > 1){
        o.profit = Math.round(o.profit * hm0);
        o.note = (o.note ? o.note + " \u00b7 " : "") + "hot game " + hm0 + "x";
      }
    }
    var st = state.stats;
    st[o.play] = (st[o.play] || 0) + 1;
    state.lastBet = o.bet;
    el.verdict.className = "verdict big" + (o.profit > 0 ? " win" : o.profit < 0 ? " loss" : "");
    el.vHand.textContent = o.head;
    var nt = o.note ? " \u00b7 " + o.note : "";
    if(o.profit > 0){
      var p = Math.max(1, Math.round(o.profit));
      state.coins += p;
      st[o.win] = (st[o.win] || 0) + 1;
      if(p > (st.best || 0)) st.best = p;
      el.vDelta.textContent = "+" + fmtCoins(p) + " coins" + nt;
      say(pick(o.big ? LINES.bigwin : LINES.win)); setMood("win"); sfxWin(o.big ? 8 : 2);
    } else if(o.profit < 0){
      state.coins -= o.bet;
      st.lost = (st.lost || 0) + o.bet;
      el.vDelta.textContent = "-" + fmtCoins(o.bet) + " coins" + nt;
      say(pick(state.coins < 0 ? LINES.debt : LINES.loss)); setMood("lose"); sfxLose();
    } else {
      el.vDelta.textContent = "Push, your bet comes back" + nt;
      tone(520, 0.08, "triangle", 0.05);
    }
    paint(); save();
  }
  function xPickRail(X, key, items, cls){
    var r = xNode("div", "xpick" + (cls ? " " + cls : ""));
    items.forEach(function(it, i){
      var b = xNode("button", it.v === X[key] ? "on" : "",
        (it.dot ? "<span class='dot' style='background:" + it.dot + "'></span>" : "") + it.l + (it.s ? "<i>" + it.s + "</i>" : ""));
      b.dataset.i = i;
      r.appendChild(b);
    });
    r.addEventListener("click", function(ev){
      var b = ev.target.closest("button");
      if(!b || b.disabled || xBusy()) return;
      X[key] = items[+b.dataset.i].v;
      for(var i = 0; i < r.children.length; i++) r.children[i].classList.toggle("on", r.children[i] === b);
      tone(720, 0.03, "triangle", 0.04);
      if(X.onPick) X.onPick();
      paint();
    });
    (X.rails = X.rails || []).push(r);
    return r;
  }
  function xHist(node, list, fn){
    node.innerHTML = list.map(fn).join("");
  }

  /* ---------- Baccarat ---------- */
  function bacVal(h){
    var t = 0;
    h.forEach(function(c){ t += c.r === "A" ? 1 : c.v % 10; });
    return t % 10;
  }
  function bacRender(X, fresh){
    el.dealerRow.innerHTML = ""; el.playerRow.innerHTML = "";
    X.B.forEach(function(c, i){
      var n = bjCardEl(c, true);
      if(fresh === "all" || fresh === "b" + i){ n.classList.add("deal"); n.style.animationDelay = (fresh === "all" ? (i * 2 + 1) * 0.07 : 0) + "s"; }
      el.dealerRow.appendChild(n);
    });
    X.P.forEach(function(c, i){
      var n = bjCardEl(c, true);
      if(fresh === "all" || fresh === "p" + i){ n.classList.add("deal"); n.style.animationDelay = (fresh === "all" ? i * 2 * 0.07 : 0) + "s"; }
      el.playerRow.appendChild(n);
    });
    el.playerHand.textContent = X.P.length ? bacVal(X.P) : "";
    el.dealerHand.textContent = X.B.length ? bacVal(X.B) : "";
  }
  function bacGo(){
    var X = XG.bac;
    if(X.busy) return;
    actx();
    X.bet = xBet(); X.busy = true;
    var d = [];
    for(var s = 0; s < 8; s++) d = d.concat(bjBuild());
    for(var i = d.length - 1; i > 0; i--){ var j = Math.floor(Math.random() * (i + 1)), t = d[i]; d[i] = d[j]; d[j] = t; }
    X.P = [d.pop()]; X.B = [d.pop()]; X.P.push(d.pop()); X.B.push(d.pop());
    var pv = bacVal(X.P), bv = bacVal(X.B), p3 = null, b3 = null;
    if(pv < 8 && bv < 8){
      if(pv <= 5) p3 = d.pop();
      var bd;
      if(!p3) bd = bv <= 5;
      else {
        var x = p3.r === "A" ? 1 : p3.v % 10;
        bd = bv <= 2 || (bv === 3 && x !== 8) || (bv === 4 && x >= 2 && x <= 7) ||
             (bv === 5 && x >= 4 && x <= 7) || (bv === 6 && (x === 6 || x === 7));
      }
      if(bd) b3 = d.pop();
    }
    X.nat = pv >= 8 || bv >= 8;
    el.verdict.className = "verdict";
    el.vHand.textContent = "Cards out";
    el.vDelta.textContent = "Your coin is on " + (X.pick === "player" ? "Player" : X.pick === "banker" ? "Banker" : "the Tie");
    X.dom.read.innerHTML = "&nbsp;";
    say(pick(XL.bac)); setMood("deal");
    bacRender(X, "all");
    for(var k = 0; k < 4; k++) sfxDeal(k);
    paint();
    var at = 1000;
    if(p3){ setTimeout(function(){ X.P.push(p3); bacRender(X, "p2"); sfxDeal(0); }, at); at += 750; }
    if(b3){ setTimeout(function(){ X.B.push(b3); bacRender(X, "b2"); sfxDeal(1); }, at); at += 750; }
    setTimeout(bacSettle, at + 250);
  }
  function bacSettle(){
    var X = XG.bac, pv = bacVal(X.P), bv = bacVal(X.B);
    var res = pv > bv ? "player" : bv > pv ? "banker" : "tie";
    X.busy = false;
    X.dom.read.innerHTML = "Player <b>" + pv + "</b> <span style='opacity:.6'>vs</span> Banker <b>" + bv + "</b>";
    X.hist.unshift(res); X.hist.length = Math.min(X.hist.length, 16);
    xHist(X.dom.hist, X.hist, function(r){ return "<span class='xh-" + r + "'>" + (r === "player" ? "P" : r === "banker" ? "B" : "T") + "</span>"; });
    var profit = -1;
    if(res === X.pick) profit = res === "player" ? X.bet : res === "banker" ? Math.max(1, Math.floor(X.bet * 0.95)) : X.bet * 8;
    else if(res === "tie") profit = 0;
    var head = res === "tie" ? "Tie at " + pv : (res === "player" ? "Player" : "Banker") + " wins " + Math.max(pv, bv) + " to " + Math.min(pv, bv);
    if(X.nat && res !== "tie") head += ", a natural";
    xSettle({bet:X.bet, profit:profit, play:"bacHands", win:"bacWins", head:head, big:res === "tie" && profit > 0});
  }

  /* ---------- Dicing (55x2) ---------- */
  function d55Go(){
    var X = XG.d55;
    if(X.busy) return;
    actx();
    X.bet = xBet(); X.busy = true;
    var roll = 1 + Math.floor(Math.random() * 100);
    el.verdict.className = "verdict";
    el.vHand.textContent = "Rolling the percentile dice";
    el.vDelta.textContent = "55 or higher doubles your bet";
    X.dom.read.innerHTML = "&nbsp;";
    X.dom.die.className = "d55die roll";
    X.dom.mark.style.display = "none";
    if(Math.random() < 0.35) say(pick(XL.d55));
    setMood("deal");
    var t0 = performance.now(), last = 0, dur = 1250;
    function step(now){
      var u = Math.min(1, (now - t0) / dur);
      if(u < 1){
        if(now - last > 45 + u * u * 170){ last = now; X.dom.die.textContent = 1 + Math.floor(Math.random() * 100); tone(850 + Math.random() * 350, 0.02, "square", 0.05); }
        requestAnimationFrame(step);
      } else d55Land(roll);
    }
    requestAnimationFrame(step);
    paint();
  }
  function d55Land(roll){
    var X = XG.d55, win = roll >= 55, tens = Math.floor((roll % 100) / 10) * 10, units = roll % 10;
    X.dom.die.textContent = roll;
    X.dom.die.className = "d55die " + (win ? "win" : "lose");
    X.dom.mark.style.display = "block";
    X.dom.mark.style.left = "calc(" + (roll - 0.5) + "% - 1px)";
    X.dom.read.innerHTML = d55Svg(d55Tlab(tens), true) + d55Svg(String(units), false) + "<span>=</span><b>" + roll + "</b>&nbsp;on the percentile dice";
    X.hist.unshift(roll); X.hist.length = Math.min(X.hist.length, 14);
    xHist(X.dom.hist, X.hist, function(r){ return "<span class='" + (r >= 55 ? "xw" : "xl") + "'>" + r + "</span>"; });
    X.busy = false;
    el.goBtn.textContent = G.ok ? "Hold to shake" : "Roll";
    xSettle({bet:X.bet, profit:win ? X.bet : -1, play:"d55Rolls", win:"d55Wins",
      head: win ? "Rolled " + roll + ", you double up" : "Rolled " + roll + ", the house keeps it", big: roll === 100});
  }

  /* ---------- Hot or Cold ---------- */
  var FL_COLS = [
    {n:"Red", t:"hot", w:16, c:["#d8342c"]},
    {n:"Orange", t:"hot", w:16, c:["#ef8a22"]},
    {n:"Yellow", t:"hot", w:16, c:["#f2d231"]},
    {n:"Blue", t:"cold", w:16, c:["#3565d8"]},
    {n:"Purple", t:"cold", w:16, c:["#8a3fc4"]},
    {n:"Pastel", t:"cold", w:16, c:["#f6b3d0","#b7dcf7","#f7efb0","#c8efc0","#dcc6f5"]},
    {n:"Rainbow", t:"lose", w:3, c:["#e8392f","#f39a1f","#f4dc2c","#3fae4a","#3d6fdc"]},
    {n:"Black", t:"re", w:0.5, c:["#1d1b22"]},
    {n:"White", t:"re", w:0.5, c:["#f4f1ea"]}
  ];
  var FL_MOUND = "<ellipse cx='60' cy='99' rx='36' ry='9' fill='#2e2016'/><ellipse cx='60' cy='96' rx='26' ry='6' fill='#4a3322'/>";
  function flRoll(){
    var tot = 0, i;
    for(i = 0; i < FL_COLS.length; i++) tot += FL_COLS[i].w;
    var r = Math.random() * tot;
    for(i = 0; i < FL_COLS.length; i++){ r -= FL_COLS[i].w; if(r <= 0) return FL_COLS[i]; }
    return FL_COLS[0];
  }
  function flSvg(f){
    var s = "<g class='flg'><path d='M60 96 C57 80 63 62 60 40' stroke='#3e7a34' stroke-width='3.5' fill='none'/>" +
      "<ellipse cx='51' cy='74' rx='9' ry='3.6' fill='#4f9a42' transform='rotate(-32 51 74)'/>" +
      "<ellipse cx='69' cy='64' rx='9' ry='3.6' fill='#4f9a42' transform='rotate(32 69 64)'/>";
    for(var k = 0; k < 5; k++){
      s += "<ellipse cx='60' cy='21' rx='9.5' ry='14' fill='" + f.c[k % f.c.length] + "' stroke='rgba(0,0,0,.35)' stroke-width='1' transform='rotate(" + (k * 72) + " 60 36)'/>";
    }
    s += "<circle cx='60' cy='36' r='6.5' fill='" + (f.n === "Black" ? "#5a4a6e" : "#e2b33c") + "' stroke='rgba(0,0,0,.35)'/></g>";
    return s;
  }
  function flName(f){
    if(f.n === "Rainbow") return "<b class='xrain'>Rainbow</b>";
    return "<b style='color:" + (f.n === "Black" ? "#9a92a4" : f.c[0]) + "'>" + f.n + "</b>";
  }
  function flGo(){
    var X = XG.flower;
    if(X.busy) return;
    actx();
    X.bet = xBet(); X.busy = true;
    el.verdict.className = "verdict";
    el.vHand.textContent = "The old man plants a seed";
    el.vDelta.textContent = "You called " + X.pick;
    X.dom.read.innerHTML = "&nbsp;";
    if(Math.random() < 0.4) say(pick(XL.flower));
    setMood("deal");
    if(G.ok) fl3Plant(); else flPlant();
    paint();
  }
  function flPlant(){
    var X = XG.flower, f = flRoll();
    X.dom.svg.innerHTML = FL_MOUND + "<circle class='flseed' cx='60' cy='8' r='3.2' fill='#9fb0c2'/>";
    tone(300, 0.05, "triangle", 0.05);
    setTimeout(function(){
      X.dom.svg.innerHTML = FL_MOUND + flSvg(f);
      tone(520, 0.06, "sine", 0.05); tone(780, 0.08, "sine", 0.04, 0.08);
      setTimeout(function(){ flReveal(f); }, 850);
    }, 420);
  }
  function flReveal(f){
    var X = XG.flower;
    X.hist.unshift(f); X.hist.length = Math.min(X.hist.length, 16);
    xHist(X.dom.hist, X.hist, function(h){
      var bg = h.n === "Rainbow" ? "conic-gradient(#e8392f,#f39a1f,#f4dc2c,#3fae4a,#3d6fdc,#e8392f)" :
               h.n === "Pastel" ? "conic-gradient(#f6b3d0,#b7dcf7,#f7efb0,#c8efc0,#f6b3d0)" : h.c[0];
      return "<span class='fd' title='" + h.n + "' style='background:" + bg + "'></span>";
    });
    if(f.t === "re"){
      X.dom.read.innerHTML = "A " + flName(f) + " flower. He pulls it and replants";
      el.vHand.textContent = f.n + " flower, replant";
      tone(260, 0.1, "triangle", 0.05);
      setTimeout(function(){
        var g = X.dom.svg.querySelector(".flg");
        if(g) g.classList.add("wilt");
        if(G.ok) fl3Wilt();
        setTimeout(G.ok ? fl3Plant : flPlant, 520);
      }, 900);
      return;
    }
    X.busy = false;
    var win = f.t === X.pick;
    X.dom.read.innerHTML = "Wise Old Man planted a " + flName(f) + " flower" +
      (f.t === "lose" ? "" : "&nbsp;<span style='opacity:.7'>(" + f.t + ")</span>");
    xSettle({bet:X.bet, profit:win ? X.bet : -1, play:"flowerPlays", win:"flowerWins",
      head: f.t === "lose" ? "Rainbow, the house takes it" : win ? f.n + " is " + f.t + ", good call" : f.n + " is " + f.t + ", wrong call"});
  }

  /* ---------- Squeal of Fortune (money wheel, 52 slices) ---------- */
  var SQ_SYM = [
    {k:"coins", n:"Coins", m:2, cnt:25, c:"#b8892c"},
    {k:"herbs", n:"Herbs", m:4, cnt:12, c:"#3f8a44"},
    {k:"runes", n:"Runes", m:7, cnt:7, c:"#3f6fc9"},
    {k:"bones", n:"Dragon bones", m:12, cnt:4, c:"#d9d0b8", tc:"#2a2233"},
    {k:"phat", n:"Partyhat", m:25, cnt:2, c:"#c0392b"},
    {k:"squeal", n:"Squeal", m:50, cnt:1, c:"#ff4fa3"},
    {k:"wom", n:"Wise Old Man", m:50, cnt:1, c:"#f4efe2", tc:"#3a2a5a"}
  ];
  var SQ_SLOTS = (function(){
    var n = 52, slots = new Array(n), ord = SQ_SYM.slice().sort(function(a, b){ return a.cnt - b.cnt; });
    ord.forEach(function(s, si){
      var off = s.k === "wom" ? 26 : si * 3;
      for(var j = 0; j < s.cnt; j++){
        var p = Math.round(off + j * n / s.cnt) % n;
        while(slots[p]) p = (p + 1) % n;
        slots[p] = s;
      }
    });
    return slots;
  })();
  function sqIcon(c, k, s){
    c.save();
    if(k === "coins"){
      c.strokeStyle = "#8a6d3b"; c.lineWidth = 2;
      [[-s*0.3, s*0.15], [s*0.3, s*0.15], [0, -s*0.18]].forEach(function(p){
        c.fillStyle = "#f0cf7a"; c.beginPath(); c.arc(p[0], p[1], s*0.33, 0, TAU); c.fill(); c.stroke();
      });
    } else if(k === "herbs"){
      c.strokeStyle = "#2c6a2c"; c.lineWidth = 2.5;
      c.beginPath(); c.moveTo(0, s*0.5); c.lineTo(0, -s*0.35); c.stroke();
      c.fillStyle = "#5fb04f";
      c.beginPath(); c.ellipse(-s*0.22, -s*0.02, s*0.4, s*0.19, -0.7, 0, TAU); c.fill();
      c.beginPath(); c.ellipse(s*0.24, -s*0.12, s*0.4, s*0.19, 0.7, 0, TAU); c.fill();
    } else if(k === "runes"){
      c.fillStyle = "#5f8fdc"; c.beginPath();
      c.moveTo(0, -s*0.5); c.lineTo(s*0.42, 0); c.lineTo(0, s*0.5); c.lineTo(-s*0.42, 0); c.closePath(); c.fill();
      c.strokeStyle = "#eaf2ff"; c.lineWidth = 3;
      c.beginPath(); c.moveTo(0, -s*0.22); c.lineTo(0, s*0.22); c.moveTo(-s*0.16, 0); c.lineTo(s*0.16, 0); c.stroke();
    } else if(k === "bones"){
      c.strokeStyle = "#efe8d2"; c.lineCap = "round"; c.lineWidth = s*0.26;
      c.beginPath(); c.moveTo(-s*0.28, -s*0.28); c.lineTo(s*0.28, s*0.28); c.stroke();
      c.fillStyle = "#efe8d2";
      [[-s*0.42, -s*0.16], [-s*0.16, -s*0.42], [s*0.42, s*0.16], [s*0.16, s*0.42]].forEach(function(p){
        c.beginPath(); c.arc(p[0], p[1], s*0.17, 0, TAU); c.fill();
      });
    } else if(k === "phat"){
      c.fillStyle = "#e04a42"; c.beginPath(); c.moveTo(-s*0.5, s*0.32);
      for(var z = 0; z < 4; z++){
        c.lineTo(-s*0.5 + (z*2 + 1)*s*0.125, -s*0.36);
        c.lineTo(-s*0.5 + (z + 1)*s*0.25, s*0.02);
      }
      c.lineTo(s*0.5, s*0.32); c.closePath(); c.fill();
    } else if(k === "squeal"){
      c.fillStyle = "#ff9fcf";
      c.beginPath(); c.moveTo(-s*0.34, -s*0.26); c.lineTo(-s*0.2, -s*0.55); c.lineTo(-s*0.06, -s*0.3); c.closePath(); c.fill();
      c.beginPath(); c.moveTo(s*0.34, -s*0.26); c.lineTo(s*0.2, -s*0.55); c.lineTo(s*0.06, -s*0.3); c.closePath(); c.fill();
      c.beginPath(); c.arc(0, 0, s*0.46, 0, TAU); c.fill();
      c.fillStyle = "#c23a7c"; c.beginPath(); c.ellipse(0, s*0.1, s*0.24, s*0.17, 0, 0, TAU); c.fill();
      c.fillStyle = "#5a1238";
      c.beginPath(); c.arc(-s*0.09, s*0.1, s*0.05, 0, TAU); c.fill();
      c.beginPath(); c.arc(s*0.09, s*0.1, s*0.05, 0, TAU); c.fill();
      c.beginPath(); c.arc(-s*0.18, -s*0.14, s*0.055, 0, TAU); c.fill();
      c.beginPath(); c.arc(s*0.18, -s*0.14, s*0.055, 0, TAU); c.fill();
    } else {
      c.fillStyle = "#e2c49a"; c.beginPath(); c.arc(0, -s*0.05, s*0.32, 0, TAU); c.fill();
      c.fillStyle = "#f4efe2"; c.beginPath();
      c.moveTo(-s*0.3, s*0.02); c.quadraticCurveTo(0, s*0.8, s*0.3, s*0.02); c.closePath(); c.fill();
      c.fillStyle = "#3f6fc9"; c.beginPath();
      c.moveTo(-s*0.38, -s*0.16); c.lineTo(s*0.38, -s*0.16); c.lineTo(0, -s*0.64); c.closePath(); c.fill();
    }
    c.restore();
  }
  function sqDraw(X){
    var c = X.ctx, n = SQ_SLOTS.length, arc = TAU / n;
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.clearRect(0, 0, 768, 768);
    c.save(); c.translate(384, 384);
    for(var i = 0; i < n; i++){
      var s = SQ_SLOTS[i], a0 = i * arc - Math.PI / 2;
      c.beginPath(); c.moveTo(0, 0); c.arc(0, 0, 356, a0, a0 + arc); c.closePath();
      c.fillStyle = s.c; c.fill();
      if(i % 2){ c.fillStyle = "rgba(0,0,0,.15)"; c.fill(); }
      c.strokeStyle = "rgba(20,12,24,.75)"; c.lineWidth = 2; c.stroke();
      c.save(); c.rotate(a0 + arc / 2 + Math.PI / 2);
      c.fillStyle = s.tc || "#fff8e6"; c.textAlign = "center"; c.textBaseline = "middle";
      c.font = "700 30px 'Barlow Condensed',sans-serif";
      c.fillText(s.m + "x", 0, -322);
      c.translate(0, -248);
      sqIcon(c, s.k, 27);
      c.restore();
    }
    c.beginPath(); c.arc(0, 0, 360, 0, TAU); c.lineWidth = 16; c.strokeStyle = "#c9a24d"; c.stroke();
    c.beginPath(); c.arc(0, 0, 369, 0, TAU); c.lineWidth = 4; c.strokeStyle = "#8a6d3b"; c.stroke();
    for(var p = 0; p < 26; p++){
      var pa = p * TAU / 26 - Math.PI / 2;
      c.beginPath(); c.arc(Math.cos(pa) * 360, Math.sin(pa) * 360, 6, 0, TAU);
      c.fillStyle = p % 2 ? "#fff3cf" : "#ffd98a"; c.fill();
      c.strokeStyle = "#8a6d3b"; c.lineWidth = 1.5; c.stroke();
    }
    c.beginPath(); c.arc(0, 0, 196, 0, TAU); c.lineWidth = 3; c.strokeStyle = "rgba(255,243,207,.45)"; c.stroke();
    c.beginPath(); c.arc(0, 0, 118, 0, TAU); c.fillStyle = "#1a1020"; c.fill();
    c.lineWidth = 7; c.strokeStyle = "#c9a24d"; c.stroke();
    c.fillStyle = "#ff9fcf"; c.textAlign = "center"; c.textBaseline = "middle";
    c.font = "700 33px 'Grenze Gotisch',serif";
    c.fillText("SQUEAL", 0, -30);
    c.fillText("OF", 0, 3);
    c.fillText("FORTUNE", 0, 36);
    c.restore();
    if(X.m3 && X.m3.material.map) X.m3.material.map.needsUpdate = true;
  }
  function sqGo(){
    var X = XG.squeal;
    if(X.busy) return;
    actx();
    X.bet = xBet(); X.busy = true;
    var n = SQ_SLOTS.length, arc = TAU / n, idx = Math.floor(Math.random() * n);
    var target = -(idx + 0.5) * arc + (Math.random() - 0.5) * arc * 0.7;
    var delta = ((target - X.rot) % TAU + TAU) % TAU;
    X.from = X.rot; X.to = X.rot + delta + TAU * 5; X.idx = idx;
    X.t0 = performance.now(); X.dur = 4600; X.seg = Math.floor(X.rot / arc);
    el.verdict.className = "verdict";
    el.vHand.textContent = "Round and round";
    el.vDelta.textContent = "You picked " + sqSym(X.pick).n + " (" + sqSym(X.pick).m + "x)";
    X.dom.read.innerHTML = "&nbsp;";
    say(pick(XL.squeal)); setMood("deal");
    x3dSqSpin();
    tone(1100, 0.05, "square", 0.05);
    function step(now){
      var u = Math.min(1, (now - X.t0) / X.dur), e = 1 - Math.pow(1 - u, 4);
      X.rot = X.from + (X.to - X.from) * e;
      X.dom.cv.style.transform = "rotate(" + X.rot + "rad)";
      if(X.m3) X.m3.rotation.z = -X.rot;
      var sg = Math.floor(X.rot / arc);
      if(sg !== X.seg){ X.seg = sg; tone(1500, 0.012, "square", 0.03); }
      if(u < 1) requestAnimationFrame(step); else sqSettle();
    }
    requestAnimationFrame(step);
    paint();
  }
  function sqSym(k){ for(var i = 0; i < SQ_SYM.length; i++) if(SQ_SYM[i].k === k) return SQ_SYM[i]; return SQ_SYM[0]; }
  function sqSettle(){
    var X = XG.squeal, s = SQ_SLOTS[X.idx], win = s.k === X.pick;
    X.rot = X.rot % TAU;
    X.busy = false;
    X.dom.read.innerHTML = "<span class='dot' style='background:" + s.c + "'></span><b>" + s.n + "</b>&nbsp;<span style='opacity:.7'>" + s.m + "x</span>";
    xSettle({bet:X.bet, profit:win ? X.bet * (s.m - 1) : -1, play:"sqSpins", win:"sqWins",
      head: win ? "It lands on " + s.n + ", your pick" : "It lands on " + s.n, big: win && s.m >= 25});
  }

  /* ---------- Barrows Chests (mines) ---------- */
  var BR_BROS = [["Ahrim","Ahrim the Blighted"],["Dharok","Dharok the Wretched"],["Guthan","Guthan the Infested"],
                 ["Karil","Karil the Tainted"],["Torag","Torag the Corrupted"],["Verac","Verac the Defiled"]];
  var BR_LOOT = ["Coins","Death runes","Blood runes","Bolt rack","Spirit shards","Clue scroll","Chaos runes","Dragon helm","Coins","Coins"];
  function brMult(k, B){ var m = 0.97; for(var i = 0; i < k; i++) m *= (25 - i) / (25 - B - i); return m; }
  function brFmt(m){ return (Math.floor(m * 100) / 100).toFixed(2) + "x"; }
  function brRender(X){
    X.dom.grid.innerHTML = "";
    for(var i = 0; i < 25; i++){
      var b = xNode("button", "brt"), st = X.tiles ? X.tiles[i] : null;
      b.dataset.i = i;
      if(st && st.open){
        if(st.bro != null){
          b.className = "brt bro" + (st.hit ? " hit" : "") + (st.dim ? " dim" : "");
          b.appendChild(xImg(BR_BROS[st.bro][1] + " chathead.png"));
          b.appendChild(xNode("span", "", BR_BROS[st.bro][0]));
        } else {
          b.className = "brt safe" + (st.dim ? " dim" : "");
          b.innerHTML = "<span>" + st.loot + "</span>";
        }
      }
      if(!X.on) b.disabled = !(st && st.open);
      X.dom.grid.appendChild(b);
    }
    br3Sync(X);
  }
  function brInfo(X){
    var B = X.bros;
    if(X.on){
      X.dom.read.innerHTML = "Chests <b>" + X.opened + "</b>&nbsp;\u00b7 cash out <b>" + (X.opened ? brFmt(brMult(X.opened, B)) : "-") +
        "</b>&nbsp;\u00b7 next <b>" + brFmt(brMult(X.opened + 1, B)) + "</b>";
    } else {
      X.dom.read.innerHTML = B + (B === 1 ? " brother" : " brothers") + " in 25 chests&nbsp;\u00b7 first chest pays <b>" + brFmt(brMult(1, B)) + "</b>";
    }
  }
  function brGo(){
    var X = XG.barrows;
    if(X.on){ if(X.opened > 0) brCash(); return; }
    actx();
    X.bet = xBet(); X.on = true; X.opened = 0;
    var pos = []; for(var i = 0; i < 25; i++) pos.push(i);
    for(var a = 24; a > 0; a--){ var j = Math.floor(Math.random() * (a + 1)), t = pos[a]; pos[a] = pos[j]; pos[j] = t; }
    var bros = [0,1,2,3,4,5];
    for(var q = 5; q > 0; q--){ var r = Math.floor(Math.random() * (q + 1)), t2 = bros[q]; bros[q] = bros[r]; bros[r] = t2; }
    X.tiles = [];
    for(var k = 0; k < 25; k++) X.tiles.push({open:false, bro:null});
    for(var m = 0; m < X.bros; m++) X.tiles[pos[m]].bro = bros[m];
    el.verdict.className = "verdict";
    el.vHand.textContent = "You drop into the crypt";
    el.vDelta.textContent = "Open a chest. Cash out whenever you like";
    say(pick(XL.barrows)); setMood("deal");
    tone(140, 0.25, "sawtooth", 0.05);
    brRender(X); brInfo(X);
    el.goBtn.textContent = "Cash out";
    paint();
  }
  function brPick(i){
    var X = XG.barrows;
    if(!X.on) return;
    var st = X.tiles[i];
    if(!st || st.open) return;
    st.open = true;
    if(st.bro != null){
      st.hit = true;
      X.on = false;
      X.tiles.forEach(function(t){ if(!t.open){ t.open = true; t.dim = true; t.loot = "-"; } });
      brRender(X);
      X.dom.read.innerHTML = "<b style='color:#ff8a7a'>" + BR_BROS[st.bro][1] + "</b>&nbsp;rises from the chest";
      tone(110, 0.35, "sawtooth", 0.08);
      el.goBtn.textContent = "Enter crypt";
      xSettle({bet:X.bet, profit:-1, play:"barrowsRuns", win:"barrowsWins",
        head: BR_BROS[st.bro][0] + " was waiting", note: X.opened + (X.opened === 1 ? " chest" : " chests") + " opened"});
      return;
    }
    X.opened++;
    st.loot = BR_LOOT[Math.floor(Math.random() * BR_LOOT.length)];
    tone(600 + X.opened * 40, 0.06, "triangle", 0.06); tone(900 + X.opened * 40, 0.08, "sine", 0.05, 0.05);
    if(X.opened >= 25 - X.bros){ brCash(); return; }
    brRender(X); brInfo(X);
    el.goBtn.textContent = "Cash out " + brFmt(brMult(X.opened, X.bros));
    el.vHand.textContent = st.loot + "!";
    el.vDelta.textContent = "Next chest pays " + brFmt(brMult(X.opened + 1, X.bros));
    paint();
  }
  function brCash(){
    var X = XG.barrows;
    if(!X.on) return;
    var m = Math.floor(brMult(X.opened, X.bros) * 100) / 100;
    X.on = false;
    X.tiles.forEach(function(t){
      if(!t.open){ t.open = true; t.dim = true; t.loot = "-"; }
    });
    brRender(X);
    X.dom.read.innerHTML = "You climb out with <b>" + m.toFixed(2) + "x</b>";
    el.goBtn.textContent = "Enter crypt";
    xSettle({bet:X.bet, profit:X.bet * (m - 1), play:"barrowsRuns", win:"barrowsWins",
      head: "Escaped the crypt at " + m.toFixed(2) + "x", note: X.opened + " chests", big: m >= 5});
  }

  /* ---------- Wilderness Run (crash) ---------- */
  function wyLvl(m){ return Math.max(1, Math.min(56, 1 + Math.floor(Math.log(m) / Math.log(8) * 55))); }
  function wyHash(k){ var x = Math.sin(k * 127.1 + 311.7) * 43758.5453; return x - Math.floor(x); }
  function wyMan(c, x, y, ph, body, legs, skin, rot, alpha, pk){
    c.save(); c.globalAlpha = alpha; c.translate(x, y); c.rotate(rot);
    var s = Math.sin(ph) * 0.7;
    /* cape */
    c.fillStyle = pk ? "#5a0f14" : "#c9a24d";
    c.beginPath(); c.moveTo(-5, -47); c.lineTo(-14 - Math.abs(s) * 8, -30 + s * 3); c.lineTo(-9 - Math.abs(s) * 5, -24); c.lineTo(-3, -28); c.closePath(); c.fill();
    c.lineCap = "round"; c.strokeStyle = legs; c.lineWidth = 6;
    c.beginPath(); c.moveTo(0, -24); c.lineTo(Math.sin(-s) * 13, 0); c.stroke();
    c.beginPath(); c.moveTo(0, -24); c.lineTo(Math.sin(s) * 13, 0); c.stroke();
    c.fillStyle = "#2a2622"; c.fillRect(Math.sin(-s) * 13 - 4, -3, 8, 3); c.fillRect(Math.sin(s) * 13 - 4, -3, 8, 3);
    c.fillStyle = body; c.fillRect(-7, -48, 14, 25);
    c.fillStyle = "rgba(0,0,0,.25)"; c.fillRect(-7, -30, 14, 3);
    c.fillStyle = pk ? "#7a1a1a" : "#e0b458"; c.fillRect(-2, -45, 4, 18);
    c.strokeStyle = body; c.lineWidth = 5;
    c.beginPath(); c.moveTo(0, -44); c.lineTo(Math.sin(s) * 14, -29); c.stroke();
    c.beginPath(); c.moveTo(0, -44); c.lineTo(Math.sin(-s) * 14 + (pk ? -10 : 0), -29); c.stroke();
    if(pk){
      c.strokeStyle = "#d8342c"; c.lineWidth = 2.5;
      for(var k = 0; k < 3; k++){ c.beginPath(); c.moveTo(-10 + Math.sin(-s) * 14, -29 + k * 2); c.lineTo(-24 + Math.sin(-s) * 14, -34 + k * 4); c.stroke(); }
    } else {
      /* sword and shield */
      c.strokeStyle = "#c9c9d2"; c.lineWidth = 2.5;
      c.beginPath(); c.moveTo(Math.sin(s) * 14, -29); c.lineTo(Math.sin(s) * 14 + 6, -44); c.stroke();
      c.fillStyle = "#c9a24d"; c.fillRect(Math.sin(s) * 14 - 3, -31, 6, 2);
      c.fillStyle = "#3f6fc9"; c.beginPath(); c.arc(Math.sin(-s) * 14 - 2, -30, 5, 0, TAU); c.fill();
      c.fillStyle = "#c9a24d"; c.beginPath(); c.arc(Math.sin(-s) * 14 - 2, -30, 1.8, 0, TAU); c.fill();
    }
    c.fillStyle = skin; c.beginPath(); c.arc(0, -56, 7.5, 0, TAU); c.fill();
    if(pk){
      c.fillStyle = "#101014"; c.beginPath(); c.arc(0, -57, 8, Math.PI, 0); c.fill(); c.fillRect(-8, -57, 16, 5);
      c.fillStyle = "#ff3a2a"; c.fillRect(-5, -58, 3, 2); c.fillRect(-1, -58, 3, 2);
    } else {
      c.fillStyle = "#8a8f9a"; c.beginPath(); c.arc(0, -57, 8, Math.PI, 0); c.fill();
      c.fillRect(-8, -57, 16, 3);
      c.fillStyle = "#e0b458"; c.fillRect(-1, -66, 2, 4);
    }
    c.restore();
  }
  function wyDraw(X){
    var c = X.ctx, W = 640, H = 220, gy = 172, d = X.dist, i, k, x, tt = X.tt || 0;
    c.setTransform(2, 0, 0, 2, 0, 0);
    var sk = c.createLinearGradient(0, 0, 0, gy);
    sk.addColorStop(0, "#0b0407"); sk.addColorStop(0.55, "#3a1210"); sk.addColorStop(1, "#6a2412");
    c.fillStyle = sk; c.fillRect(0, 0, W, gy);
    /* stars + drifting ash */
    for(i = 0; i < 40; i++){
      var sx = (i * 97 + 13) % W, sy = (i * 53) % 70 + 4;
      c.fillStyle = "rgba(255,220,200," + (0.25 + 0.35 * Math.abs(Math.sin(tt * 1.5 + i))) + ")";
      c.fillRect(sx, sy, 1.5, 1.5);
    }
    for(i = 0; i < 22; i++){
      var ax = ((i * 131 - d * 0.35 - tt * 12) % W + W) % W, ay = (i * 71 + tt * 9 * (1 + i % 3)) % gy;
      c.fillStyle = "rgba(255,140,60," + (0.25 + 0.4 * Math.abs(Math.sin(tt * 3 + i))) + ")";
      c.fillRect(ax, gy - ay, 2, 2);
    }
    /* blood moon + lava glow on the horizon */
    c.fillStyle = "rgba(255,90,40,.18)"; c.beginPath(); c.arc(530, 58, 40, 0, TAU); c.fill();
    c.fillStyle = "#c9532a"; c.beginPath(); c.arc(530, 58, 22, 0, TAU); c.fill();
    c.fillStyle = "rgba(60,20,20,.55)"; c.beginPath(); c.arc(522, 52, 6, 0, TAU); c.arc(538, 64, 4, 0, TAU); c.fill();
    var hz = c.createLinearGradient(0, gy - 40, 0, gy);
    hz.addColorStop(0, "rgba(255,120,40,0)"); hz.addColorStop(1, "rgba(255,120,40,.35)");
    c.fillStyle = hz; c.fillRect(0, gy - 40, W, 40);
    var ridge = function(off, base, amp, col, f){
      c.fillStyle = col; c.beginPath(); c.moveTo(0, gy);
      for(var xx = 0; xx <= W; xx += 6){
        var q = xx + off;
        c.lineTo(xx, base - amp * Math.abs(Math.sin(q * f)) - amp * 0.45 * Math.sin(q * f * 2.7) - amp * 0.2 * Math.sin(q * f * 6.1));
      }
      c.lineTo(W, gy); c.closePath(); c.fill();
    };
    ridge(d * 0.06, 112, 30, "#1a0808", 0.008);
    /* far volcano cones */
    for(k = Math.floor(d * 0.06 / 300) - 1; k < Math.floor(d * 0.06 / 300) + 4; k++){
      x = k * 300 - d * 0.06 + 40 + wyHash(k + 21) * 120;
      if(x < -80 || x > W + 80) continue;
      var vh = 48 + wyHash(k + 23) * 28;
      c.fillStyle = "#1a0808"; c.beginPath(); c.moveTo(x - 60, 120); c.lineTo(x - 8, 120 - vh); c.lineTo(x + 8, 120 - vh); c.lineTo(x + 60, 120); c.closePath(); c.fill();
      c.fillStyle = "rgba(255,120,40," + (0.5 + 0.4 * Math.abs(Math.sin(tt * 2 + k))) + ")";
      c.fillRect(x - 6, 120 - vh - 2, 12, 3);
    }
    ridge(d * 0.14, 128, 22, "#240c0c", 0.012);
    ridge(d * 0.3, 148, 15, "#2f120e", 0.021);
    /* ruined pillars, mid layer */
    for(k = Math.floor(d * 0.45 / 260) - 1; k < Math.floor(d * 0.45 / 260) + 4; k++){
      x = k * 260 - d * 0.45 + 90 + wyHash(k + 31) * 90;
      if(x < -30 || x > W + 30 || wyHash(k + 33) < 0.35) continue;
      var ph2 = 30 + wyHash(k + 35) * 30;
      c.fillStyle = "#1e0c0c"; c.fillRect(x, gy - ph2, 10, ph2);
      c.fillRect(x - 3, gy - ph2, 16, 4);
      c.fillStyle = "#150808"; c.fillRect(x + 2, gy - ph2 + 8, 2, ph2 - 12);
    }
    /* dead trees */
    c.strokeStyle = "#140806"; c.lineCap = "round";
    var tOff = d * 0.6;
    for(k = Math.floor(tOff / 170) - 1; k < Math.floor(tOff / 170) + 6; k++){
      x = k * 170 - tOff + 60 + wyHash(k) * 60;
      if(x < -40 || x > W + 40) continue;
      var th = 40 + wyHash(k + 9) * 26, lean = (wyHash(k + 12) - 0.5) * 10;
      c.lineWidth = 4.5; c.beginPath(); c.moveTo(x, gy); c.lineTo(x + lean, gy - th); c.stroke();
      c.lineWidth = 2.5;
      c.beginPath(); c.moveTo(x + lean * 0.5, gy - th * 0.55); c.lineTo(x - 15, gy - th * 0.85); c.stroke();
      c.beginPath(); c.moveTo(x + lean * 0.7, gy - th * 0.72); c.lineTo(x + 13, gy - th - 7); c.stroke();
      c.lineWidth = 1.5;
      c.beginPath(); c.moveTo(x - 15, gy - th * 0.85); c.lineTo(x - 22, gy - th * 0.8); c.stroke();
      c.beginPath(); c.moveTo(x + 13, gy - th - 7); c.lineTo(x + 20, gy - th - 4); c.stroke();
    }
    /* ground with cracks, bones, skulls */
    var gg = c.createLinearGradient(0, gy, 0, H);
    gg.addColorStop(0, "#3a2619"); gg.addColorStop(1, "#1e140e");
    c.fillStyle = gg; c.fillRect(0, gy, W, H - gy);
    c.fillStyle = "#4a3222"; c.fillRect(0, gy, W, 2);
    for(k = Math.floor(d / 95) - 1; k < Math.floor(d / 95) + 9; k++){
      x = k * 95 - d + wyHash(k + 3) * 40;
      if(x < -60 || x > W + 60) continue;
      var cy = gy + 12 + wyHash(k + 5) * 26, gl = 0.5 + 0.35 * Math.sin(tt * 3 + k);
      c.strokeStyle = "rgba(255,150,50," + gl + ")"; c.lineWidth = 3;
      c.beginPath(); c.moveTo(x, cy); c.lineTo(x + 12, cy + 4); c.lineTo(x + 20, cy - 2); c.lineTo(x + 34, cy + 3); c.stroke();
      c.strokeStyle = "rgba(255,230,120," + gl * 0.8 + ")"; c.lineWidth = 1;
      c.beginPath(); c.moveTo(x, cy); c.lineTo(x + 12, cy + 4); c.lineTo(x + 20, cy - 2); c.lineTo(x + 34, cy + 3); c.stroke();
      if(wyHash(k + 11) > 0.55){
        c.fillStyle = "#d9d0b8"; c.beginPath(); c.arc(x + 52, gy + 9, 4.5, 0, TAU); c.fill();
        c.fillStyle = "#2a1a12"; c.fillRect(x + 49, gy + 7, 2, 2); c.fillRect(x + 53, gy + 7, 2, 2);
        c.strokeStyle = "#d9d0b8"; c.lineWidth = 2; c.beginPath(); c.moveTo(x + 60, gy + 13); c.lineTo(x + 72, gy + 10); c.stroke();
      }
    }
    /* the ditch + sign */
    var dx = X.ditch - d;
    if(dx > -80 && dx < W + 80){
      var dg = c.createLinearGradient(0, gy, 0, gy + 22);
      dg.addColorStop(0, "#050302"); dg.addColorStop(1, "#1a110c");
      c.fillStyle = dg; c.beginPath(); c.moveTo(dx, gy); c.lineTo(dx + 46, gy); c.lineTo(dx + 38, gy + 22); c.lineTo(dx + 8, gy + 22); c.closePath(); c.fill();
      c.fillStyle = "#5a3d20"; c.fillRect(dx - 2, gy - 3, 50, 3);
      c.fillStyle = "#4a3322"; c.fillRect(dx - 28, gy - 34, 4, 34);
      c.fillStyle = "#6b4a2a"; c.fillRect(dx - 54, gy - 44, 56, 16);
      c.strokeStyle = "#3a2c1c"; c.lineWidth = 1; c.strokeRect(dx - 54, gy - 44, 56, 16);
      c.fillStyle = "#f2ead2"; c.font = "700 9px 'Barlow Condensed',sans-serif"; c.textAlign = "center";
      c.fillText("WILDERNESS", dx - 26, gy - 33);
      c.fillStyle = "#e0685c"; c.fillText("NO RETURN", dx - 26, gy - 25 + 12);
    }
    var px = 150, hop = 0, jump = dx + 23 - px;
    if(X.phase === "run" && Math.abs(jump) < 30) hop = -12 * Math.cos(jump / 30 * Math.PI / 2);
    /* running dust */
    if(X.phase === "run"){
      for(i = 0; i < 4; i++){
        var du = (tt * 3 + i * 0.25) % 1;
        c.fillStyle = "rgba(200,170,130," + (0.35 * (1 - du)) + ")";
        c.beginPath(); c.arc(px - 8 - du * 26, gy - 2 - du * 6, 2 + du * 4, 0, TAU); c.fill();
      }
    }
    if(X.phase === "pk"){
      var pkx = Math.max(px + 30, 700 - X.fx * 1800);
      var fallen = X.fx > 0.45;
      if(X.fx > 1.3){
        c.fillStyle = "#6d6a66"; c.beginPath(); c.moveTo(px - 13, gy); c.lineTo(px - 13, gy - 24); c.arc(px, gy - 24, 13, Math.PI, 0); c.lineTo(px + 13, gy); c.closePath(); c.fill();
        c.fillStyle = "#4a4744"; c.fillRect(px - 16, gy - 3, 32, 3);
        c.fillStyle = "#2a2622"; c.font = "700 9px 'Barlow Condensed',sans-serif"; c.textAlign = "center"; c.fillText("RIP", px, gy - 19);
        c.fillStyle = "#2a2622"; c.fillRect(px - 1, gy - 34, 2, 8); c.fillRect(px - 4, gy - 31, 8, 2);
      } else wyMan(c, px, gy, X.ph, "#3a6fb0", "#4a4a55", "#e2b48c", fallen ? -1.45 : 0, 1, false);
      wyMan(c, pkx, gy, X.fx < 0.35 ? X.fx * 30 : 0, "#1b1b20", "#101014", "#5a5a62", 0, 1, true);
      if(X.fx > 0.3 && X.fx < 1.5){
        c.fillStyle = "#b01818"; c.beginPath();
        for(i = 0; i < 12; i++){
          var ra = i / 12 * TAU, rr = i % 2 ? 14 : 10;
          c[i ? "lineTo" : "moveTo"](px + Math.cos(ra) * rr, gy - 66 + Math.sin(ra) * rr);
        }
        c.closePath(); c.fill();
        c.fillStyle = "#fff"; c.font = "700 13px 'JetBrains Mono',monospace"; c.textAlign = "center"; c.fillText(String(X.hit), px, gy - 61);
      }
    } else if(X.phase === "tele"){
      wyMan(c, px, gy, X.ph, "#3a6fb0", "#4a4a55", "#e2b48c", 0, Math.max(0, 1 - X.fx / 0.8), false);
      c.strokeStyle = "rgba(185,156,255," + Math.max(0, 1 - X.fx / 1.2) + ")"; c.lineWidth = 3;
      c.beginPath(); c.ellipse(px, gy - 2, 26 + X.fx * 10, 7, 0, 0, TAU); c.stroke();
      c.strokeStyle = "rgba(120,200,255," + Math.max(0, 0.8 - X.fx / 1.2) + ")"; c.lineWidth = 2;
      c.beginPath(); c.ellipse(px, gy - 2 - X.fx * 40, 16, 5, 0, 0, TAU); c.stroke();
      for(i = 0; i < 18; i++){
        var ty = gy - ((X.fx * 90 + i * 9) % 80);
        c.fillStyle = "rgba(" + (i % 2 ? "185,156,255" : "120,200,255") + "," + Math.max(0, 1 - X.fx / 1.4) + ")";
        c.beginPath(); c.arc(px + Math.sin(i * 1.7 + X.fx * 7) * 17, ty, 2.5, 0, TAU); c.fill();
      }
    } else {
      wyMan(c, px, gy + hop, X.ph, "#3a6fb0", "#4a4a55", "#e2b48c", 0, 1, false);
    }
    /* HUD */
    c.fillStyle = "rgba(0,0,0,.6)"; c.fillRect(10, 10, 134, 30);
    c.strokeStyle = "#8a6d3b"; c.lineWidth = 1; c.strokeRect(10.5, 10.5, 133, 29);
    c.fillStyle = "#e8e2d4"; c.beginPath(); c.arc(27, 23, 7, 0, TAU); c.fill(); c.fillRect(23, 27, 8, 6);
    c.fillStyle = "#111"; c.fillRect(23, 21, 3, 3); c.fillRect(28, 21, 3, 3); c.fillRect(25, 29, 1, 3); c.fillRect(28, 29, 1, 3);
    c.fillStyle = "#ffd24a"; c.font = "700 17px 'Barlow Condensed',sans-serif"; c.textAlign = "left";
    var lvlNow = X.phase === "run" ? wyLvl(X.m) : X.phase === "idle" ? 0 : wyLvl(X.endM);
    c.fillText(X.phase === "idle" ? "Edgeville" : "Level: " + lvlNow, 42, 31);
    c.fillStyle = "rgba(0,0,0,.45)"; c.fillRect(10, 44, 134, 5);
    c.fillStyle = lvlNow > 30 ? "#e0685c" : "#e0b458"; c.fillRect(10, 44, 134 * lvlNow / 56, 5);
    c.textAlign = "center";
    c.fillStyle = X.phase === "pk" ? "#ff5a4a" : X.phase === "tele" ? "#c7b2ff" : "#ffd98a";
    c.font = "700 44px 'JetBrains Mono',monospace";
    c.shadowColor = X.phase === "pk" ? "rgba(255,60,40,.8)" : "rgba(255,200,100,.6)"; c.shadowBlur = 14;
    c.fillText((X.phase === "run" ? X.m : X.phase === "idle" ? 1 : X.endM).toFixed(2) + "x", W / 2, 66);
    c.shadowBlur = 0;
    c.font = "700 15px 'Barlow Condensed',sans-serif"; c.fillStyle = "#d8cdb4";
    c.fillText(X.phase === "pk" ? "PKED" : X.phase === "tele" ? "TELEPORTED" : X.phase === "run" ? "RUNNING DEEPER" : "PAST THE DITCH, EVERY STEP PAYS", W / 2, 88);
    if(X.tex3) X.tex3.needsUpdate = true;
  }
  function wyLoop(now){
    var X = XG.wildy;
    if(state.game !== "wildy"){ X.loop = false; return; }
    var dt = Math.min(0.05, (now - (X.last || now)) / 1000);
    X.last = now; X.tt = (X.tt || 0) + dt;
    if(X.phase === "run"){
      var m = Math.exp(0.085 * (now - X.t0) / 1000);
      if(X.auto && X.auto <= X.crash && m >= X.auto){ X.m = X.auto; wyCash(); }
      else if(m >= X.crash){ X.m = X.crash; wyPk(); }
      else {
        X.m = m;
        var lv = wyLvl(m);
        if(lv !== X.lvl){ X.lvl = lv; tone(420 + lv * 9, 0.03, "triangle", 0.035); }
        el.goBtn.textContent = "Teleport " + m.toFixed(2) + "x";
      }
      X.speed += (170 + X.lvl * 2 - X.speed) * Math.min(1, dt * 4);
    } else {
      X.speed *= Math.max(0, 1 - dt * (X.phase === "idle" ? 6 : 3));
      X.fx += dt;
    }
    X.dist += X.speed * dt;
    X.ph += X.speed * dt * 0.075;
    wyDraw(X);
    requestAnimationFrame(wyLoop);
  }
  function wyGo(){
    var X = XG.wildy;
    if(X.on){ wyCash(); return; }
    actx();
    X.bet = xBet();
    var u = Math.random();
    X.crash = Math.max(1, Math.min(1000, Math.floor(97 / (1 - u)) / 100));
    if(window.PVM_FORCE_CRASH) X.crash = +window.PVM_FORCE_CRASH;
    X.on = true; X.phase = "run"; X.t0 = performance.now(); X.m = 1; X.fx = 0; X.lvl = 1;
    X.ditch = X.dist + 205; X.hit = 60 + Math.floor(Math.random() * 40);
    el.verdict.className = "verdict";
    el.vHand.textContent = "Into the Wilderness";
    el.vDelta.textContent = X.auto ? "Auto teleport at " + X.auto + "x" : "Teleport before a PKer finds you";
    say(pick(XL.wildy)); setMood("deal");
    tone(330, 0.1, "triangle", 0.06);
    el.goBtn.textContent = "Teleport 1.00x";
    paint();
  }
  function wyEnd(X){
    X.hist.unshift(X.crash); X.hist.length = Math.min(X.hist.length, 12);
    xHist(X.dom.hist, X.hist, function(v){ return "<span class='" + (v >= 10 ? "xg2" : v >= 2 ? "xw" : "xl") + "'>" + v.toFixed(2) + "x</span>"; });
    el.goBtn.textContent = "Run in";
    el.goBtn.classList.remove("urge");
  }
  function wyCash(){
    var X = XG.wildy;
    if(!X.on) return;
    var m = Math.floor(X.m * 100) / 100;
    X.on = false; X.phase = "tele"; X.fx = 0; X.endM = m;
    wyEnd(X);
    if(m > (state.stats.wildyBest || 0)) state.stats.wildyBest = m;
    tone(880, 0.12, "sine", 0.07); tone(1320, 0.2, "sine", 0.05, 0.08);
    xSettle({bet:X.bet, profit:m > 1 ? X.bet * (m - 1) : 0, play:"wildyRuns", win:"wildyWins",
      head: "Teleported out at " + m.toFixed(2) + "x", note: "the PKer was at " + X.crash.toFixed(2) + "x", big: m >= 5});
  }
  function wyPk(){
    var X = XG.wildy;
    if(!X.on) return;
    X.on = false; X.phase = "pk"; X.fx = 0; X.endM = X.crash;
    wyEnd(X);
    tone(160, 0.2, "sawtooth", 0.08); tone(90, 0.35, "sawtooth", 0.07, 0.15);
    xSettle({bet:X.bet, profit:-1, play:"wildyRuns", win:"wildyWins",
      head: X.crash <= 1 ? "Ambushed at the ditch" : "PKed at level " + wyLvl(X.crash), note: "crashed at " + X.crash.toFixed(2) + "x"});
  }

  /* ---------- Pet Derby ---------- */
  var DB_PETS = ["Little Zuk","Vorki","Corporeal Puppy","Mallory","Gladys","Little Sus","Miso","Tess","Raklette","Kerry",
    "Herman","Needlemouse","Nylessa","Ava","Shrimpy","TzRek-Jad","Solly","Vindiddy","Rawrvek","Chick'arra","General Awwdor",
    "K'ril Tinyroth","Commander Miniana","Nexterminator","Reeves","Kalphite Grublet","Kalphite Grubling","King Black Dragonling",
    "Queen Black Dragonling","Prime hatchling","Molly","Greg","Lilwyr","Zammo the Rak","Amaskitty","Edie","Neffie","Bisdi",
    "Ambi","Ellie","Lil' Tuzzy","Ivarsson","Kuroryu","Diddyzag"];
  var DB_FILE = {"Vorki":"Vorkath chathead.png", "Molly":"Molly (pet) chathead.png", "Ava":"Ava (pet) chathead.png"};
  function dbOrd(n){ return n + (n === 1 ? "st" : n === 2 ? "nd" : n === 3 ? "rd" : "th"); }
  function dbNew(){
    var X = XG.derby, pool = DB_PETS.slice(), f = [], sum = 0;
    for(var i = 0; i < 6; i++){
      var nm = pool.splice(Math.floor(Math.random() * pool.length), 1)[0];
      var s = 0.35 + Math.pow(Math.random(), 1.3) * 1.6;
      f.push({n:nm, s:s}); sum += s;
    }
    f.forEach(function(r){ r.p = r.s / sum; r.odds = Math.max(1.2, Math.floor(0.94 / r.p * 10) / 10); if(G.ok) db3Icon(r.n); });
    var fav = 0;
    f.forEach(function(r, i2){ if(r.odds < f[fav].odds) fav = i2; });
    X.field = f; X.fav = fav; X.pick = -1; X.phase = "bet";
    X.dom.track.innerHTML = "";
    f.forEach(function(r, i3){
      r.x = 0; r.inSt = false; r.place = -1;
      var lane = xNode("div", "dblane");
      lane.dataset.i = i3;
      lane.appendChild(xNode("span", "dbgate", String(i3 + 1)));
      var rail = xNode("div", "dbrail");
      rail.appendChild(xNode("span", "dbname", r.n + (i3 === fav ? " <i>fav</i>" : "")));
      var run = xNode("div", "dbrun");
      run.appendChild(xImg(DB_FILE[r.n] || r.n + " chathead.png"));
      rail.appendChild(run);
      lane.appendChild(rail);
      var od = xNode("span", "dbodds", r.odds.toFixed(1) + "x");
      lane.appendChild(od);
      r.node = run; r.lane = lane; r.oddsNode = od;
      X.dom.track.appendChild(lane);
    });
    X.call = "Field posted. Pick a pet to back it";
    X.dom.read.textContent = X.call;
    el.verdict.className = "verdict";
    el.vHand.textContent = "Pet Derby";
    el.vDelta.textContent = "Winner pays the posted odds";
    el.goBtn.textContent = "Race";
    if(X3.db && G.ok) db3Draw(X);
    paint();
  }
  function dbProfile(R){
    var N = 120, v = [], c = [0], f1 = 1 + Math.random() * 2, f2 = 3 + Math.random() * 3,
        p1 = Math.random() * TAU, p2 = Math.random() * TAU, st = null, i;
    if(Math.random() < 0.4){ var u0 = 0.18 + Math.random() * 0.55; st = [u0, u0 + 0.07]; }
    for(i = 0; i < N; i++){
      var u = (i + 0.5) / N;
      var s = 1 + 0.32 * Math.sin(TAU * f1 * u + p1) + 0.14 * Math.sin(TAU * f2 * u + p2);
      if(st && u >= st[0] && u <= st[1]) s *= 0.08;
      v.push(Math.max(0.05, s));
    }
    for(i = 0; i < N; i++) c.push(c[i] + v[i]);
    for(i = 0; i <= N; i++) c[i] /= c[N];
    R.stum = st;
    return c;
  }
  function dbPos(R, u){
    if(u >= 1) return 1;
    var f = u * 120, i = Math.floor(f);
    return R.prof[i] + (R.prof[i + 1] - R.prof[i]) * (f - i);
  }
  function dbGo(){
    var X = XG.derby;
    if(X.phase === "done"){ dbNew(); return; }
    if(X.phase !== "bet") return;
    if(X.pick < 0){ say("Pick a runner first, lad."); return; }
    actx();
    X.bet = xBet(); X.phase = "run"; X.busy = true;
    var rem = [], order = [], i;
    for(i = 0; i < X.field.length; i++) rem.push(i);
    while(rem.length){
      var tot = 0;
      rem.forEach(function(ri){ tot += X.field[ri].p; });
      var r = Math.random() * tot, j = 0;
      for(; j < rem.length - 1; j++){ r -= X.field[rem[j]].p; if(r <= 0) break; }
      order.push(rem.splice(j, 1)[0]);
    }
    X.order = order;
    var T = 6.2 + Math.random() * 0.5;
    order.forEach(function(ri, place){
      var R = X.field[ri];
      R.T = T; T += 0.18 + Math.random() * 0.45;
      R.prof = dbProfile(R); R.place = place; R.lastStum = false;
    });
    X.t0 = performance.now(); X.lead = -1; X.call = "And they're off!"; X.callT = 0; X.gal = 0;
    el.verdict.className = "verdict";
    el.vHand.textContent = "And they're off";
    el.vDelta.textContent = "Your coin rides on " + X.field[X.pick].n + " at " + X.field[X.pick].odds.toFixed(1) + "x";
    say(pick(XL.derby)); setMood("deal");
    tone(880, 0.1, "square", 0.07); tone(1175, 0.18, "square", 0.06, 0.12);
    el.goBtn.textContent = "Racing";
    requestAnimationFrame(dbLoop);
    paint();
  }
  function dbLoop(now){
    var X = XG.derby;
    if(X.phase !== "run") return;
    var t = (now - X.t0) / 1000, done = true, lead = -1, lx = -1;
    X.field.forEach(function(R, i){
      var u = t / R.T, x = dbPos(R, Math.min(1, u));
      if(u < 1) done = false;
      R.x = x; R.u = u;
      var inSt = !!(R.stum && u >= R.stum[0] && u <= R.stum[1]);
      if(inSt && !R.lastStum){ X.call = R.n + " stumbles!"; X.callT = t; tone(180, 0.08, "sawtooth", 0.05); }
      R.lastStum = inSt; R.inSt = inSt;
      if(x > lx){ lx = x; lead = i; }
    });
    if(t > 0.8 && lead !== X.lead && t - X.callT > 1.1){
      X.call = X.field[lead].n + (X.lead < 0 ? " breaks out in front" : " takes the lead");
      X.callT = t; X.lead = lead;
    }
    if(now - X.gal > 150){ X.gal = now; tone(85 + Math.random() * 45, 0.03, "triangle", 0.045); }
    X.dom.read.textContent = X.call;
    if(X3.db && G.ok){ X.tt = t; db3Draw(X); }
    else X.field.forEach(function(R, i){
      R.node.style.left = "calc(" + (R.x * 100).toFixed(2) + "% - " + (R.x * 34).toFixed(1) + "px)";
      R.node.classList.toggle("stum", R.inSt);
      R.node.style.transform = R.u < 1 ? "translateY(" + (Math.sin(t * 15 + i * 1.3) * 2.5).toFixed(1) + "px)" : "";
    });
    if(done) dbSettle(); else requestAnimationFrame(dbLoop);
  }
  function dbSettle(){
    var X = XG.derby, w = X.order[0], W = X.field[w];
    X.phase = "done"; X.busy = false;
    X.field.forEach(function(R){
      R.x = 1; R.inSt = false;
      R.oddsNode.textContent = dbOrd(R.place + 1);
      R.oddsNode.classList.toggle("dbwin", R.place === 0);
    });
    X.call = W.n + " crosses the line first";
    X.dom.read.textContent = X.call;
    el.goBtn.textContent = "Next race";
    if(X3.db && G.ok) db3Draw(X);
    var win = X.pick === w;
    xSettle({bet:X.bet, profit:win ? X.bet * (W.odds - 1) : -1, play:"derbyRaces", win:"derbyWins",
      head: win ? W.n + " wins it for you" : W.n + " wins, " + X.field[X.pick].n + " came " + dbOrd(X.field[X.pick].place + 1),
      note: W.odds.toFixed(1) + "x", big: win && W.odds >= 8});
  }
  /* ---------- 3D presentation (build xg-3d-1) ---------- */
  var X3 = {sq:null, cabs:false, fl:null, flSt:null, flAnim:0, room:0, roomG:null, icons:{}, brT:[]};
  function x3Tex(w, h, draw){
    var cv = document.createElement("canvas"); cv.width = w; cv.height = h;
    draw(cv.getContext("2d"), w, h);
    return new THREE.CanvasTexture(cv);
  }
  function x3Plate(txt, w, h, bg, fg){
    var ch = Math.round(256 * h / w);
    var t = x3Tex(256, ch, function(c){
      c.fillStyle = bg; c.fillRect(0, 0, 256, ch);
      c.strokeStyle = fg; c.lineWidth = 3; c.strokeRect(4, 4, 248, ch - 8);
      c.fillStyle = fg; c.textAlign = "center"; c.textBaseline = "middle";
      c.font = "700 " + Math.round(ch * 0.62) + "px 'Barlow Condensed',sans-serif";
      c.fillText(txt, 128, ch / 2 + 1);
    });
    return new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({map:t}));
  }
  /* --- Dicing: real percentile dice on the felt --- */
  function d55Tlab(v){ return v === 0 ? "00" : String(v); }
  function d55Face(s, tens){
    var cv = document.createElement("canvas"); cv.width = cv.height = 64;
    var c = cv.getContext("2d");
    c.fillStyle = tens ? "#221c2e" : "#f4efe2"; c.fillRect(0, 0, 64, 64);
    c.strokeStyle = tens ? "#c9a24d" : "#b3a98f"; c.lineWidth = 4; c.strokeRect(2, 2, 60, 60);
    c.fillStyle = tens ? "#e0b458" : "#221c2e"; c.textAlign = "center"; c.textBaseline = "middle";
    c.font = "700 " + (s.length > 1 ? 27 : 33) + "px 'JetBrains Mono',monospace";
    c.fillText(s, 32, 34);
    return new THREE.MeshStandardMaterial({map:new THREE.CanvasTexture(cv), roughness:0.55});
  }
  function d55MatSet(val, txt, tens){
    return [1,6,2,5,3,4].map(function(n){
      var s = n === val ? txt :
        tens ? d55Tlab(Math.floor(Math.random() * 10) * 10) : String(Math.floor(Math.random() * 10));
      return d55Face(s, tens);
    });
  }
  function d55Skin(){
    var hix = 0;
    for(var i = 0; i < DICE3D.length; i++){
      var de = DICE3D[i];
      if(!de.held) continue;
      de.mesh.material = d55MatSet(0, "", hix === 0);
      hix++;
    }
  }
  function d55Roll3(pw){
    var X = XG.d55;
    if(X.busy) return;
    if(!G.ok){ d55Go(); return; }
    actx();
    X.bet = xBet(); X.busy = true;
    var roll = 1 + Math.floor(Math.random() * 100);
    var tens = Math.floor((roll % 100) / 10) * 10, units = roll % 10;
    var v1 = 1 + Math.floor(Math.random() * 6), v2 = 1 + Math.floor(Math.random() * 6);
    var hix = 0;
    for(var i = 0; i < DICE3D.length; i++){
      var de = DICE3D[i];
      if(!de.held) continue;
      de.held = false;
      de.val = hix === 0 ? v1 : v2;
      de.mesh.material = d55MatSet(de.val, hix === 0 ? d55Tlab(tens) : String(units), hix === 0);
      de.v.set((hix ? -1 : 1) * (0.6 + Math.random() * 1.2) * pw, 0.4, (Math.random() - 0.5) * 1.4 * pw);
      de.av.set((Math.random() - 0.5) * 20 * pw, (Math.random() - 0.5) * 20 * pw, (Math.random() - 0.5) * 20 * pw);
      hix++;
    }
    el.verdict.className = "verdict";
    el.vHand.textContent = "The percentile dice are out";
    el.vDelta.textContent = "55 or higher doubles your bet";
    X.dom.read.innerHTML = "&nbsp;";
    if(Math.random() < 0.35) say(pick(XL.d55));
    setMood("deal");
    el.goBtn.textContent = "Rolling";
    tone(1200, 0.03, "square", 0.06);
    paint();
    setTimeout(function(){ d55Land(roll); }, 1500);
  }
  /* --- Flower Game: a flower grows on the counter --- */
  function fl3Clear(){
    if(X3.fl && G.scene) G.scene.remove(X3.fl);
    X3.fl = null; X3.flSt = null; X3.flAnim = 0;
  }
  function fl3Plant(){
    var X = XG.flower, f = flRoll();
    fl3Clear();
    var g = new THREE.Group();
    g.position.set(0, 0.992, 1.24);
    cyl(0.16, 0.20, 0.05, 8, mat(0x4a3322), 0, 0.025, 0, g);
    cyl(0.10, 0.13, 0.03, 8, mat(0x2e2016), 0, 0.06, 0, g);
    var seed = sph(0.032, mat(0x9fb0c2), 0, 0.62, 0, g);
    var plant = new THREE.Group(); plant.position.y = 0.06; g.add(plant);
    plant.scale.setScalar(0.01);
    var GRN = mat(0x3e7a34), LEAF = mat(0x4f9a42);
    cyl(0.012, 0.018, 0.34, 5, GRN, 0, 0.17, 0, plant);
    var le1 = sph(0.05, LEAF, -0.055, 0.14, 0, plant, 1.6, 0.5, 0.9); le1.rotation.z = 0.6;
    var le2 = sph(0.05, LEAF, 0.058, 0.21, 0, plant, 1.6, 0.5, 0.9); le2.rotation.z = -0.6;
    var headG = new THREE.Group(); headG.position.y = 0.37; plant.add(headG);
    for(var k = 0; k < 5; k++){
      var piv = new THREE.Group();
      piv.rotation.z = k * TAU / 5;
      headG.add(piv);
      sph(0.05, mat(parseInt(f.c[k % f.c.length].slice(1), 16)), 0, 0.078, 0.01, piv, 1.0, 1.5, 0.45);
    }
    sph(0.045, mat(f.n === "Black" ? 0x5a4a6e : 0xe2b33c), 0, 0, 0.035, headG, 1, 1, 0.6);
    G.scene.add(g);
    X3.fl = g;
    X3.flSt = {ph:"seed", t0:0, plant:plant, seed:seed, f:f, done:false};
    if(!X3.flAnim){ X3.flAnim = 1; requestAnimationFrame(fl3Tick); }
    tone(300, 0.05, "triangle", 0.05);
  }
  function fl3Tick(now){
    var st = X3.flSt;
    if(!st || !X3.fl){ X3.flAnim = 0; return; }
    if(!st.t0) st.t0 = now;
    var u = (now - st.t0) / 1000;
    if(st.ph === "seed"){
      st.seed.position.y = Math.max(0.07, 0.62 - u * 1.45);
      if(u >= 0.4){
        st.seed.visible = false; st.ph = "grow"; st.t0 = now;
        tone(520, 0.06, "sine", 0.05); tone(780, 0.08, "sine", 0.04, 0.08);
      }
    } else if(st.ph === "grow"){
      var e = Math.min(1, u / 0.8);
      var s = (1 - Math.pow(1 - e, 3)) * (1 + 0.13 * Math.sin(e * Math.PI));
      st.plant.scale.set(Math.max(0.01, s), Math.max(0.01, s), Math.max(0.01, s));
      st.plant.rotation.y = (1 - e) * 2.2;
      if(e >= 1 && !st.done){
        st.done = true; st.ph = "idle"; X3.flAnim = 0;
        flReveal(st.f);
        return;
      }
    } else if(st.ph === "wilt"){
      var w = Math.min(1, u / 0.5);
      st.plant.rotation.z = w * 0.55;
      st.plant.scale.setScalar(Math.max(0.01, 1 - w * 0.92));
      if(w >= 1){ st.ph = "idle"; X3.flAnim = 0; return; }
    } else { X3.flAnim = 0; return; }
    requestAnimationFrame(fl3Tick);
  }
  function fl3Wilt(){
    if(!X3.flSt) return;
    X3.flSt.ph = "wilt"; X3.flSt.t0 = 0;
    if(!X3.flAnim){ X3.flAnim = 1; requestAnimationFrame(fl3Tick); }
  }
  /* --- Squeal of Fortune: the wheel on the west wall, spun by Yelps --- */
  function x3SqBuild(){
    if(X3.sq || !G.ok) return;
    x3RoomBuild();
    var X = XG.squeal;
    var g = new THREE.Group();
    g.position.set(-5.2, 0, -1.5);
    g.rotation.y = Math.PI / 2;
    X3.roomG.add(g);
    var WOOD = mat(0x4a3322), GOLD = mat(0xc9a24d, {metal:.5, rough:.45});
    box(1.1, 0.12, 0.6, WOOD, 0, 0.06, -0.08, g);
    cyl(0.055, 0.085, 1.5, 6, WOOD, 0, 0.85, -0.08, g);
    var tex = new THREE.CanvasTexture(X.dom.cv);
    var wheel = new THREE.Mesh(new THREE.CircleGeometry(0.80, 72), new THREE.MeshBasicMaterial({map:tex}));
    wheel.position.set(0, 1.62, 0);
    wheel.rotation.z = -X.rot;
    g.add(wheel);
    var cap = cyl(0.05, 0.05, 0.06, 10, GOLD, 0, 1.62, 0.02, g); cap.rotation.x = Math.PI / 2;
    var ptr = cone(0.055, 0.16, 4, GOLD, 0, 2.50, 0.05, g); ptr.rotation.z = Math.PI;
    /* Yelps: green goblin, lab coat, purple vest, the purple top hat and its little hat goblin */
    var y = makeMan({skin:0x6faf3f, shirt:0xe8e2d4, pants:0x6b4a2a, hair:0x6faf3f, scale:1.0});
    y.group.position.set(-0.70, 0, 0.36);
    y.group.rotation.y = 0.55;
    g.add(y.group);
    var GRN = mat(0x6faf3f), PUR = mat(0x6a3fa0), PURD = mat(0x452a6e), WHT = mat(0xe8e2d4);
    var e1 = sph(0.07, GRN, -0.16, 0.04, -0.01, y.head, 0.45, 1.8, 0.9); e1.rotation.z = 0.55;
    var e2 = sph(0.07, GRN, 0.16, 0.04, -0.01, y.head, 0.45, 1.8, 0.9); e2.rotation.z = -0.55;
    sph(0.033, mat(0x578a2f), 0, -0.02, 0.115, y.head, 1, 0.85, 1.15);
    box(0.05, 0.016, 0.012, WHT, 0, -0.078, 0.104, y.head);
    cyl(0.158, 0.158, 0.022, 12, PUR, 0, 0.105, 0, y.head);
    cyl(0.098, 0.112, 0.24, 12, PUR, 0, 0.235, 0, y.head);
    cyl(0.114, 0.114, 0.05, 12, PURD, 0, 0.14, 0, y.head);
    var mg = new THREE.Group(); mg.position.set(0.105, 0.118, 0.07); mg.rotation.y = -0.5; y.head.add(mg);
    sph(0.034, GRN, 0, 0.028, 0, mg);
    sph(0.03, GRN, 0, 0.075, 0.008, mg);
    sph(0.019, GRN, -0.034, 0.095, 0, mg, 0.4, 1.5, 0.7);
    sph(0.019, GRN, 0.034, 0.095, 0, mg, 0.4, 1.5, 0.7);
    box(0.17, 0.25, 0.035, PUR, 0, 0.62, 0.15, y.group);
    box(0.05, 0.17, 0.014, PURD, 0, 0.60, 0.172, y.group);
    box(0.085, 0.26, 0.15, WHT, -0.125, 0.32, -0.01, y.group);
    box(0.085, 0.26, 0.15, WHT, 0.125, 0.32, -0.01, y.group);
    sph(0.02, GRN, -0.055, -0.40, 0.03, y.lArm, 0.7, 1.7, 0.7);
    y.rArm.rotation.x = -1.9;
    y.lArm.rotation.x = -2.5;
    X3.sq = {g:g, wheel:wheel, yelps:y, pull:0, loop:false};
    X.m3 = wheel;
  }
  function x3SqTick(now){
    var S = X3.sq;
    if(!S) return;
    if(state.game !== "squeal"){ S.loop = false; return; }
    var t = now / 1000;
    if(S.pull > 0){
      S.pull -= 0.016;
      S.yelps.rArm.rotation.x = -1.4 + Math.sin(t * 22) * 0.85;
      S.yelps.group.position.y = Math.abs(Math.sin(t * 9)) * 0.09;
      S.yelps.head.rotation.z = Math.sin(t * 11) * 0.14;
    } else {
      S.yelps.rArm.rotation.x = -1.9 + Math.sin(t * 1.3) * 0.1;
      S.yelps.group.position.y = Math.abs(Math.sin(t * 3)) * 0.03;
      S.yelps.head.rotation.z = Math.sin(t * 1.7) * 0.1;
    }
    S.yelps.lArm.rotation.x = -2.5 + Math.sin(t * 1.5) * 0.06;
    requestAnimationFrame(x3SqTick);
  }
  function x3dSqSpin(){ if(X3.sq) X3.sq.pull = 1; }
  /* --- The Cellar: second floor for Squeal, Barrows, Wildy Run, Pet Derby --- */
  var CELL_Y = -30;
  function x3CorsImg(file, cb){
    var im = new Image();
    im.crossOrigin = "anonymous";
    im.referrerPolicy = "no-referrer";
    im.onload = function(){ cb(im); };
    im.onerror = function(){ cb(null); };
    im.src = xWiki(file);
  }
  function x3RoomBuild(){
    if(X3.roomG || !G.ok) return;
    var R = new THREE.Group(); R.position.set(0, CELL_Y, 0); G.scene.add(R);
    X3.roomG = R;
    function tx(w, h, draw){
      var cv = document.createElement("canvas"); cv.width = w; cv.height = h;
      draw(cv.getContext("2d"), w, h);
      var t = new THREE.CanvasTexture(cv);
      t.wrapS = t.wrapT = THREE.RepeatWrapping;
      return t;
    }
    var stoneT = tx(256, 256, function(c){
      c.fillStyle = "#332d3e"; c.fillRect(0, 0, 256, 256);
      for(var r = 0; r < 4; r++) for(var q = 0; q < 4; q++){
        var off = (r % 2) * 32;
        c.fillStyle = ["#3a3346", "#352f41", "#2f2a3a", "#38313f"][(r + q) % 4];
        c.fillRect(q * 64 + off - 32, r * 64, 62, 62);
      }
      c.strokeStyle = "#241f2c"; c.lineWidth = 3;
      for(var l = 0; l <= 4; l++){
        c.beginPath(); c.moveTo(0, l * 64); c.lineTo(256, l * 64); c.stroke();
      }
      for(var s = 0; s < 260; s++){
        c.fillStyle = "rgba(0,0,0," + (0.05 + Math.random() * 0.12) + ")";
        c.fillRect(Math.random() * 256, Math.random() * 256, 2.5, 2.5);
      }
    });
    var floorT = tx(256, 256, function(c){
      c.fillStyle = "#262130"; c.fillRect(0, 0, 256, 256);
      for(var r = 0; r < 4; r++) for(var q = 0; q < 4; q++){
        c.fillStyle = ["#2b2536", "#282232", "#241f2c", "#2d2738"][(r * 3 + q) % 4];
        c.fillRect(q * 64 + 2, r * 64 + 2, 60, 60);
      }
      for(var s = 0; s < 200; s++){
        c.fillStyle = "rgba(0,0,0," + (0.06 + Math.random() * 0.12) + ")";
        c.fillRect(Math.random() * 256, Math.random() * 256, 3, 3);
      }
    });
    var wallT = stoneT.clone(); wallT.needsUpdate = true; wallT.repeat.set(4, 1.4);
    var wallT2 = stoneT.clone(); wallT2.needsUpdate = true; wallT2.repeat.set(3.4, 1.4);
    floorT.repeat.set(4.5, 3.8);
    var WSTONE = new THREE.MeshStandardMaterial({color:0xbfb6cf, map:wallT, roughness:0.92});
    var WSTONE2 = new THREE.MeshStandardMaterial({color:0xbfb6cf, map:wallT2, roughness:0.92});
    var FSTONE = new THREE.MeshStandardMaterial({color:0xcfc6dd, map:floorT, roughness:0.95});
    var STONED = mat(0x241f2c, {rough:.9}), WOODB = mat(0x4a3322);
    box(11.4, 0.2, 9.4, FSTONE, 0, -0.1, 0, R);
    box(11.4, 0.25, 9.4, STONED, 0, 3.3, 0, R);
    box(11.4, 3.4, 0.3, WSTONE, 0, 1.65, 4.6, R);
    box(11.4, 3.4, 0.3, WSTONE, 0, 1.65, -4.6, R);
    box(0.3, 3.4, 9.4, WSTONE2, -5.55, 1.65, 0, R);
    box(0.3, 3.4, 9.4, WSTONE2, 5.55, 1.65, 0, R);
    for(var bx = -4; bx <= 4; bx += 2) box(0.22, 0.22, 9.4, WOODB, bx, 3.12, 0, R);
    box(8.6, 0.03, 3.0, mat(0x5c1f22), 0, 0.012, 2.4, R);
    box(8.6, 0.03, 0.14, mat(0xc9a24d, {metal:.4, rough:.5}), 0, 0.014, 0.93, R);
    /* banner wall */
    var bn = x3Plate("THE CELLAR", 2.4, 0.5, "#160f1c", "#ffd98a");
    bn.position.set(0, 2.35, -4.44); R.add(bn);
    [[-1.7], [1.7]].forEach(function(p){
      box(0.42, 0.9, 0.03, mat(0x452a6e), p[0], 2.0, -4.43, R);
      box(0.48, 0.06, 0.05, mat(0xc9a24d, {metal:.5, rough:.4}), p[0], 2.47, -4.42, R);
      cone(0.21, 0.3, 4, mat(0x452a6e), p[0], 1.42, -4.43, R).rotation.z = Math.PI;
    });
    /* stairway + crates */
    box(1.4, 2.2, 0.2, mat(0x0b0710), -3.6, 1.1, -4.52, R);
    box(1.7, 0.25, 0.3, STONED, -3.6, 2.3, -4.5, R);
    var st = x3Plate("STAIRS UP", 1.0, 0.16, "#0b0710", "#9a92a4");
    st.position.set(-3.6, 2.05, -4.4); R.add(st);
    for(var sq = 0; sq < 4; sq++) box(1.3, 0.16, 0.34, STONED, -3.6, 0.08 + sq * 0.16, -4.28 + sq * 0.14, R);
    [[-2.35, -4.0, 0.44, 0.3], [-2.7, -3.6, 0.36, 0.1], [-2.15, -3.5, 0.3, -0.2]].forEach(function(p){
      var cr = box(p[2], p[2], p[2], WOODB, p[0], p[2] / 2, p[1], R);
      cr.rotation.y = p[3];
      box(p[2] + 0.02, 0.05, p[2] + 0.02, mat(0x3a2c1c), 0, 0, 0, cr);
    });
    /* barrels, gold, mushrooms */
    [[4.6, -3.4], [4.1, -3.7], [4.35, -2.85]].forEach(function(p){
      cyl(0.3, 0.34, 0.62, 8, WOODB, p[0], 0.31, p[1], R);
      cyl(0.35, 0.35, 0.05, 8, mat(0x2a2733), p[0], 0.46, p[1], R);
      cyl(0.35, 0.35, 0.05, 8, mat(0x2a2733), p[0], 0.15, p[1], R);
    });
    var GC = mat(0xe0b458, {metal:.6, rough:.35});
    [[-4.7, -3.2, 0.5], [-4.25, -3.6, 0.34], [-4.95, -3.7, 0.3]].forEach(function(p){
      sph(p[2], GC, p[0], p[2] * 0.5, p[1], R, 1, 0.5, 1);
    });
    var SHRM = mat(0x5fd8c0, {emissive:0x2fae94, ei:1.5});
    [[-5.1, -2.5, 0.06], [-4.95, -2.35, 0.045], [-5.2, -2.3, 0.035], [5.15, 3.6, 0.05], [5.0, 3.8, 0.04]].forEach(function(p){
      cyl(0.012, 0.018, p[2] * 1.6, 5, mat(0xd8d2c4), p[0], p[2] * 0.8, p[1], R);
      cone(p[2], p[2] * 1.1, 6, SHRM, p[0], p[2] * 1.9, p[1], R);
    });
    /* cobwebs in two upper corners */
    var webT = tx(128, 128, function(c){
      c.strokeStyle = "rgba(216,210,196,.8)"; c.lineWidth = 1.5;
      for(var a = 0; a <= 6; a++){
        c.beginPath(); c.moveTo(0, 0);
        c.lineTo(Math.cos(a / 6 * Math.PI / 2) * 128, Math.sin(a / 6 * Math.PI / 2) * 128);
        c.stroke();
      }
      for(var rr = 1; rr <= 4; rr++){
        c.beginPath();
        for(var a2 = 0; a2 <= 12; a2++){
          var ang = a2 / 12 * Math.PI / 2, rad = rr * 30 - (a2 % 2) * 5;
          c[a2 ? "lineTo" : "moveTo"](Math.cos(ang) * rad, Math.sin(ang) * rad);
        }
        c.stroke();
      }
    });
    var WEBM = new THREE.MeshBasicMaterial({map:webT, transparent:true, opacity:0.5, side:THREE.DoubleSide});
    var w1 = new THREE.Mesh(new THREE.PlaneGeometry(1.0, 1.0), WEBM);
    w1.position.set(-5.0, 3.24, -4.05); w1.rotation.set(Math.PI / 2 + 0.5, 0.78, 0); R.add(w1);
    var w2 = new THREE.Mesh(new THREE.PlaneGeometry(0.8, 0.8), WEBM);
    w2.position.set(5.05, 3.24, 4.05); w2.rotation.set(Math.PI / 2 + 0.5, -0.78, 0); R.add(w2);
    /* hanging lanterns over the machines */
    [-3.2, 0, 3.2].forEach(function(lx){
      cyl(0.008, 0.008, 0.34, 4, mat(0x2a2733), lx, 3.13, 3.6, R);
      box(0.09, 0.13, 0.09, mat(0x2a2733), lx, 2.9, 3.6, R);
      sph(0.045, mat(0xffd66a, {emissive:0xffc23a, ei:2.2}), lx, 2.9, 3.6, R);
    });
    /* live torches (engine-animated, world coords) */
    makeTorch(-5.36, CELL_Y + 1.5, 2.6, Math.PI / 2);
    makeTorch(5.36, CELL_Y + 1.5, -1.6, -Math.PI / 2);
    makeTorch(-2.2, CELL_Y + 1.5, -4.42, 0);
    makeTorch(2.2, CELL_Y + 1.5, -4.42, 0);
    var l3 = new THREE.PointLight(0x9a7fd0, 0.5, 13); l3.position.set(0, CELL_Y + 2.6, 2.0); G.scene.add(l3);
    var l4 = new THREE.PointLight(0xffa868, 0.55, 12); l4.position.set(0, CELL_Y + 2.4, 1.2); G.scene.add(l4);
    X3.cellL = [l3, l4];
    /* cellar patrons */
    var p1 = makeMan({skin:0xc9a780, shirt:0x5c1f22, pants:0x3a3346, hair:0x4a3322});
    p1.group.position.set(3.7, 0, -2.9); p1.group.rotation.y = -2.4; R.add(p1.group);
    var mug = cyl(0.032, 0.028, 0.06, 6, mat(0x8a6d3b), 0.05, -0.37, 0.03, p1.lArm);
    p1.lArm.rotation.x = -1.3;
    var p2 = makeMan({skin:0x8a8296, shirt:0x241f2c, pants:0x1a1622, hair:0x241f2c});
    p2.group.position.set(-2.9, 0, -3.9); p2.group.rotation.y = 0.9; R.add(p2.group);
    cone(0.15, 0.24, 6, mat(0x241f2c), 0, 0.1, -0.01, p2.head);
    X3.npcs = [{m:p1, seed:1.7}, {m:p2, seed:4.2}];
    /* the cellar rat */
    var rat = new THREE.Group();
    var RATM = mat(0x6b6470);
    sph(0.05, RATM, 0, 0.045, 0, rat, 1.5, 0.8, 0.9);
    sph(0.032, RATM, 0.075, 0.05, 0, rat, 1.1, 0.8, 0.8);
    sph(0.012, RATM, 0.085, 0.075, 0.018, rat);
    sph(0.012, RATM, 0.085, 0.075, -0.018, rat);
    sph(0.006, mat(0x1a1622), 0.105, 0.05, 0, rat);
    var tail = cyl(0.006, 0.011, 0.15, 4, mat(0x8a7f92), 0, 0, 0, rat);
    tail.position.set(-0.11, 0.04, 0); tail.rotation.z = 1.35;
    rat.position.set(-2.5, 0, -4.1);
    R.add(rat);
    X3.rat = {g:rat, tail:tail, dir:1, wait:0, last:0};
  }
  function x3Cab(parent, x, z, bodyC, trimC, glowC, name, bw){
    var g = new THREE.Group();
    g.position.set(x, 0, z);
    g.rotation.y = Math.PI;
    parent.add(g);
    var BODY = mat(bodyC), TRIM = mat(trimC, {metal:.4, rough:.5});
    box(bw, 1.9, 0.5, BODY, 0, 0.95, 0, g);
    box(bw + 0.08, 0.1, 0.58, TRIM, 0, 0.05, 0, g);
    box(bw + 0.04, 0.3, 0.54, TRIM, 0, 2.02, 0, g);
    box(0.045, 1.9, 0.52, new THREE.MeshBasicMaterial({color:glowC}), -bw / 2 - 0.005, 0.95, 0, g);
    box(0.045, 1.9, 0.52, new THREE.MeshBasicMaterial({color:glowC}), bw / 2 + 0.005, 0.95, 0, g);
    var mq = x3Plate(name, Math.min(bw - 0.1, 1.1), 0.2, "#100a14", "#ffd98a");
    mq.position.set(0, 2.02, 0.276); g.add(mq);
    box(bw * 0.68, 0.07, 0.22, TRIM, 0, 0.6, 0.3, g);
    return g;
  }
  function x3Bezel(parent, w, h, y){
    var GT = mat(0xc9a24d, {metal:.5, rough:.4});
    box(w + 0.06, 0.035, 0.035, GT, 0, y + h / 2 + 0.02, 0.258, parent);
    box(w + 0.06, 0.035, 0.035, GT, 0, y - h / 2 - 0.02, 0.258, parent);
    box(0.035, h + 0.1, 0.035, GT, -w / 2 - 0.025, y, 0.258, parent);
    box(0.035, h + 0.1, 0.035, GT, w / 2 + 0.025, y, 0.258, parent);
  }
  function br3Chest(parent, x, y, i){
    var g = new THREE.Group(); g.position.set(x, y, 0.27); parent.add(g);
    if(!X3.chestMats){
      X3.chestMats = {
        iron: new THREE.MeshStandardMaterial({color:0x2a2733, metalness:0.6, roughness:0.5}),
        gold: new THREE.MeshStandardMaterial({color:0xc9a24d, metalness:0.55, roughness:0.4}),
        coin: new THREE.MeshStandardMaterial({color:0xe0b458, metalness:0.6, roughness:0.35, emissive:0x3a2a08}),
        groove: new THREE.MeshStandardMaterial({color:0x3a2712, roughness:0.9})
      };
    }
    var M = X3.chestMats;
    var bm = new THREE.MeshStandardMaterial({color:0x6b4a2a, roughness:0.85});
    var lm = new THREE.MeshStandardMaterial({color:0x7a5530, roughness:0.85});
    var im = new THREE.MeshStandardMaterial({color:0x1a120c});
    var base = new THREE.Mesh(new THREE.BoxGeometry(0.15, 0.085, 0.075), bm); base.position.y = -0.02; g.add(base);
    [-0.028, -0.008].forEach(function(gy){
      var gr = new THREE.Mesh(new THREE.BoxGeometry(0.15, 0.004, 0.003), M.groove); gr.position.set(0, gy, 0.0375); g.add(gr);
    });
    [-0.052, 0.052].forEach(function(bx){
      var bd = new THREE.Mesh(new THREE.BoxGeometry(0.018, 0.09, 0.08), M.iron); bd.position.set(bx, -0.02, 0); g.add(bd);
    });
    [[-0.06, -0.035], [0.06, -0.035], [-0.06, 0.035], [0.06, 0.035]].forEach(function(p){
      var ft = new THREE.Mesh(new THREE.BoxGeometry(0.02, 0.012, 0.012), M.iron); ft.position.set(p[0], -0.068, p[1]); g.add(ft);
    });
    var inner = new THREE.Mesh(new THREE.BoxGeometry(0.118, 0.045, 0.055), im); inner.position.set(0, 0, 0); g.add(inner);
    [[-0.03, 0.02], [0.02, 0.018], [-0.005, 0.024], [0.032, 0.021]].forEach(function(p){
      var cn = new THREE.Mesh(new THREE.CylinderGeometry(0.012, 0.012, 0.004, 8), M.coin); cn.position.set(p[0], p[1], (p[0] * 0.4)); cn.rotation.x = 0.3; g.add(cn);
    });
    var lidG = new THREE.Group(); lidG.position.set(0, 0.025, -0.0375); g.add(lidG);
    var lid = new THREE.Mesh(new THREE.BoxGeometry(0.15, 0.028, 0.075), lm); lid.position.set(0, 0.014, 0.0375); lidG.add(lid);
    var dome = new THREE.Mesh(new THREE.CylinderGeometry(0.03, 0.03, 0.15, 10), lm); dome.position.set(0, 0.026, 0.0375); dome.rotation.z = Math.PI / 2; lidG.add(dome);
    [-0.052, 0.052].forEach(function(bx){
      var lb = new THREE.Mesh(new THREE.BoxGeometry(0.018, 0.034, 0.08), M.iron); lb.position.set(bx, 0.014, 0.0375); lidG.add(lb);
      var db = new THREE.Mesh(new THREE.CylinderGeometry(0.033, 0.033, 0.018, 10), M.iron); db.position.set(bx, 0.026, 0.0375); db.rotation.z = Math.PI / 2; lidG.add(db);
    });
    var hasp = new THREE.Mesh(new THREE.BoxGeometry(0.022, 0.03, 0.006), M.iron); hasp.position.set(0, 0.012, 0.078); lidG.add(hasp);
    var lock = new THREE.Mesh(new THREE.BoxGeometry(0.026, 0.024, 0.012), M.gold); lock.position.set(0, -0.004, 0.042); g.add(lock);
    var shackle = new THREE.Mesh(new THREE.TorusGeometry(0.009, 0.0028, 6, 12, Math.PI), M.gold); shackle.position.set(0, 0.008, 0.042); g.add(shackle);
    var kh = new THREE.Mesh(new THREE.BoxGeometry(0.004, 0.008, 0.004), M.iron); kh.position.set(0, -0.006, 0.049); g.add(kh);
    var face = new THREE.Mesh(new THREE.PlaneGeometry(0.13, 0.13), new THREE.MeshBasicMaterial({transparent:true}));
    face.position.set(0, 0.045, 0.05); face.visible = false; g.add(face);
    g.traverse(function(o){ if(o.isMesh) o.userData.i = i; });
    return {g:g, lidG:lidG, bm:bm, lm:lm, im:im, face:face};
  }
  function br3Sync(X){
    if(!X3.br || !G.ok) return;
    for(var i = 0; i < 25; i++){
      var t = X3.br.tiles[i], st = X.tiles ? X.tiles[i] : null;
      var open = !!(st && st.open);
      t.lidG.rotation.x = open ? -1.85 : 0;
      var broFace = open && st.bro != null && X3.brT[st.bro];
      t.face.visible = !!broFace;
      if(broFace && t.face.material.map !== X3.brT[st.bro]){
        t.face.material.map = X3.brT[st.bro];
        t.face.material.needsUpdate = true;
      }
      if(open && st.bro != null){
        t.im.color.setHex(st.hit ? 0xa32b1f : 0x4a1210);
        if(t.im.emissive) t.im.emissive.setHex(st.hit ? 0x551008 : 0x220604);
      } else if(open){
        t.im.color.setHex(0xe0b458);
        if(t.im.emissive) t.im.emissive.setHex(0x6b4d16);
      } else {
        t.im.color.setHex(0x1a120c);
        if(t.im.emissive) t.im.emissive.setHex(0x000000);
      }
      var dim = st && st.dim;
      t.bm.color.setHex(dim ? 0x3a2c1c : 0x6b4a2a);
      t.lm.color.setHex(dim ? 0x453218 : 0x7a5530);
      t.g.scale.setScalar(open && st.bro != null && st.hit ? 1.12 : 1);
    }
    br3Strip(X);
  }
  function br3Strip(X){
    var S = X3.br;
    if(!S || !S.sc) return;
    var c = S.sc.getContext("2d");
    c.fillStyle = "#100a14"; c.fillRect(0, 0, 320, 64);
    c.textBaseline = "middle"; c.textAlign = "center";
    if(X.on){
      c.fillStyle = "#9a92a4"; c.font = "600 15px 'Barlow Condensed',sans-serif";
      c.fillText("CHESTS " + X.opened + "    NEXT " + brFmt(brMult(X.opened + 1, X.bros)), 160, 16);
      c.fillStyle = "#ffd98a"; c.font = "700 26px 'JetBrains Mono',monospace";
      c.fillText(X.opened ? "CASH OUT " + brFmt(brMult(X.opened, X.bros)) : "PICK A CHEST", 160, 44);
    } else {
      c.fillStyle = "#ffd98a"; c.font = "700 21px 'Barlow Condensed',sans-serif";
      c.fillText(X.bros + (X.bros === 1 ? " BROTHER" : " BROTHERS") + " IN THE CRYPT", 160, 22);
      c.fillStyle = "#9a92a4"; c.font = "600 15px 'Barlow Condensed',sans-serif";
      c.fillText("FIRST CHEST PAYS " + brFmt(brMult(1, X.bros)), 160, 46);
    }
    S.tex.needsUpdate = true;
  }
  function db3Icon(n){
    if(X3.icons[n] !== undefined) return;
    X3.icons[n] = false;
    x3CorsImg(DB_FILE[n] || n + " chathead.png", function(im){
      X3.icons[n] = im;
      if(X3.db && state.game === "derby" && XG.derby.field) db3Draw(XG.derby);
    });
  }
  function db3Draw(X){
    var D = X3.db;
    if(!D || !X.field) return;
    var c = D.ctx, SILK = X3.silk, tt = X.tt || 0;
    c.setTransform(1.5, 0, 0, 1.5, 0, 0);
    c.fillStyle = "#0f1a0e"; c.fillRect(0, 0, 512, 400);
    /* stadium header: sky, lights, crowd */
    var sk = c.createLinearGradient(0, 0, 0, 50);
    sk.addColorStop(0, "#0b1b2e"); sk.addColorStop(1, "#16301a");
    c.fillStyle = sk; c.fillRect(0, 0, 512, 50);
    for(var lp = 0; lp < 4; lp++){
      var lx = 70 + lp * 124;
      c.fillStyle = "#2a2733"; c.fillRect(lx - 1, 6, 2, 22); c.fillRect(lx - 9, 4, 18, 4);
      var lg = c.createRadialGradient(lx, 6, 0, lx, 6, 40);
      lg.addColorStop(0, "rgba(255,240,200,.35)"); lg.addColorStop(1, "rgba(255,240,200,0)");
      c.fillStyle = lg; c.beginPath(); c.arc(lx, 6, 40, 0, TAU); c.fill();
    }
    for(var cr = 0; cr < 60; cr++){
      var cx = 8 + cr * 8.5 + (cr % 3), cy = 34 + (cr % 2) * 5 + ((cr * 7) % 3);
      c.fillStyle = ["#2a3a4a", "#3a2a3a", "#2e4a34", "#4a3a2a"][cr % 4];
      c.beginPath(); c.arc(cx, cy, 4, 0, TAU); c.fill();
      c.fillStyle = SILK[cr % 6]; c.fillRect(cx - 1.5, cy - 8 + (X.phase === "run" ? Math.sin(tt * 8 + cr) * 2 : 0), 3, 3);
    }
    c.fillStyle = "rgba(0,0,0,.35)"; c.fillRect(0, 44, 512, 8);
    c.textBaseline = "middle";
    c.fillStyle = "#ffd98a"; c.textAlign = "left"; c.font = "700 26px 'Barlow Condensed',sans-serif";
    c.shadowColor = "rgba(0,0,0,.8)"; c.shadowBlur = 6;
    c.fillText("PET DERBY", 14, 22);
    c.textAlign = "right"; c.font = "700 17px 'Barlow Condensed',sans-serif";
    c.fillStyle = X.phase === "run" ? "#6fce8b" : "#d8cdb4";
    c.fillText(X.phase === "bet" ? (X.pick < 0 ? "PICK A RUNNER" : "READY") : X.phase === "run" ? "\u25cf LIVE" : "RESULT", 498, 22);
    c.shadowBlur = 0;
    var tx0 = 158, tx1 = 462;
    for(var i = 0; i < X.field.length; i++){
      var R = X.field[i], ly = 56 + i * 46;
      /* card + turf */
      c.fillStyle = i % 2 ? "#1a2c18" : "#182818"; c.fillRect(0, ly, 150, 44);
      var tg = c.createLinearGradient(0, ly, 0, ly + 44);
      tg.addColorStop(0, i % 2 ? "#2f5a2c" : "#2a522a"); tg.addColorStop(1, i % 2 ? "#264a24" : "#224422");
      c.fillStyle = tg; c.fillRect(150, ly, 362, 44);
      c.strokeStyle = "rgba(255,255,255,.07)"; c.lineWidth = 1;
      for(var gs = 175; gs < 470; gs += 24){ c.beginPath(); c.moveTo(gs, ly + 3); c.lineTo(gs - 5, ly + 41); c.stroke(); }
      c.fillStyle = "rgba(60,40,20,.35)"; c.fillRect(150, ly + 30, 362, 12);
      c.fillStyle = "rgba(0,0,0,.3)"; c.fillRect(0, ly + 43, 512, 1);
      if(X.pick === i){ c.strokeStyle = "#ffd98a"; c.lineWidth = 2; c.strokeRect(2, ly + 1, 508, 42); }
      /* lane number + silk + name + odds */
      c.fillStyle = "#0c1610"; c.fillRect(6, ly + 7, 18, 30);
      c.fillStyle = "#e8e2d4"; c.textAlign = "center"; c.font = "700 14px 'JetBrains Mono',monospace";
      c.fillText(String(i + 1), 15, ly + 22);
      c.fillStyle = SILK[i]; c.fillRect(28, ly + 8, 12, 12);
      c.strokeStyle = "rgba(0,0,0,.5)"; c.lineWidth = 1; c.strokeRect(28, ly + 8, 12, 12);
      c.fillStyle = "#e8e2d4"; c.textAlign = "left"; c.font = "600 16px 'Barlow Condensed',sans-serif";
      var nm = R.n.length > 15 ? R.n.slice(0, 14) + "." : R.n;
      c.fillText(nm, 46, ly + 14);
      c.fillStyle = i === X.fav ? "#ffd98a" : "#9ab08e"; c.font = "700 14px 'JetBrains Mono',monospace";
      c.fillText(X.phase === "done" ? dbOrd(R.place + 1).toUpperCase() : R.odds.toFixed(1) + "x", 46, ly + 33);
      if(i === X.fav && X.phase !== "done"){
        c.fillStyle = "#1a1426"; c.fillRect(100, ly + 26, 30, 13);
        c.fillStyle = "#ffd98a"; c.font = "700 10px 'Barlow Condensed',sans-serif"; c.textAlign = "center"; c.fillText("FAV", 115, ly + 33);
      }
      /* finish post */
      c.fillStyle = "#e8e2d4"; c.fillRect(tx1 + 14, ly + 3, 3, 38);
      for(var cq = 0; cq < 8; cq++){ c.fillStyle = cq % 2 ? "#1a1426" : "#f2ead2"; c.fillRect(tx1 + 12, ly + 3 + cq * 4.75, 7, 4.75); }
      /* runner */
      var rx = tx0 + (R.x || 0) * (tx1 - tx0);
      var ry = ly + 22 + (X.phase === "run" && R.u < 1 ? Math.sin(tt * 15 + i * 1.3) * 3 : 0);
      if(X.phase === "run" && R.u < 1){
        c.strokeStyle = "rgba(255,255,255,.25)"; c.lineWidth = 2;
        for(var ml = 0; ml < 3; ml++){ c.beginPath(); c.moveTo(rx - 18 - ml * 9, ry - 6 + ml * 6); c.lineTo(rx - 10 - ml * 9, ry - 6 + ml * 6); c.stroke(); }
        for(var du = 0; du < 3; du++){
          var dd = (tt * 3 + du * 0.33) % 1;
          c.fillStyle = "rgba(200,170,120," + (0.35 * (1 - dd)) + ")";
          c.beginPath(); c.arc(rx - 12 - dd * 16, ry + 10 - dd * 4, 2 + dd * 3, 0, TAU); c.fill();
        }
      }
      c.fillStyle = "rgba(0,0,0,.35)"; c.beginPath(); c.ellipse(rx, ly + 38, 13, 3, 0, 0, TAU); c.fill();
      var ic = X3.icons[R.n];
      c.save(); c.translate(rx, ry);
      if(R.inSt) c.rotate(-0.5);
      c.fillStyle = SILK[i]; c.fillRect(-10, 8, 20, 7);
      c.fillStyle = "#fff"; c.textAlign = "center"; c.font = "700 7px 'JetBrains Mono',monospace"; c.fillText(String(i + 1), 0, 12);
      if(ic && ic.naturalWidth){
        c.strokeStyle = SILK[i]; c.lineWidth = 3;
        c.beginPath(); c.arc(0, 0, 16, 0, TAU); c.stroke();
        var sc2 = 30 / Math.max(ic.naturalWidth, ic.naturalHeight);
        c.drawImage(ic, -ic.naturalWidth * sc2 / 2, -ic.naturalHeight * sc2 / 2, ic.naturalWidth * sc2, ic.naturalHeight * sc2);
      } else {
        c.fillStyle = SILK[i]; c.beginPath(); c.arc(0, 0, 11, 0, TAU); c.fill();
        c.strokeStyle = "rgba(0,0,0,.55)"; c.lineWidth = 2; c.stroke();
      }
      c.restore();
      if(R.inSt){
        c.fillStyle = "#ffd98a"; c.textAlign = "center"; c.font = "700 13px 'JetBrains Mono',monospace";
        c.fillText("\u2731", rx + 14, ry - 14); c.fillText("\u2731", rx - 14, ry - 12);
        c.fillStyle = "#ff6a5a"; c.font = "700 16px 'JetBrains Mono',monospace"; c.fillText("!", rx + 20, ry - 4);
      }
      if(X.phase === "done" && R.place < 3){
        var rc = ["#ffd24a", "#c9c9d2", "#c47a3a"][R.place];
        c.fillStyle = rc; c.beginPath(); c.moveTo(136, ly + 4); c.lineTo(148, ly + 4); c.lineTo(148, ly + 20); c.lineTo(142, ly + 16); c.lineTo(136, ly + 20); c.closePath(); c.fill();
        if(R.place === 0){
          c.fillStyle = "#ffd98a"; c.textAlign = "right"; c.font = "700 13px 'Barlow Condensed',sans-serif";
          c.shadowColor = "rgba(0,0,0,.8)"; c.shadowBlur = 4; c.fillText("WINNER", rx - 20, ry); c.shadowBlur = 0;
        }
      }
    }
    /* finish banner + footer */
    c.fillStyle = "#c0392b"; c.fillRect(tx1 + 2, 52, 26, 5);
    c.fillStyle = "#16301a"; c.fillRect(0, 334, 512, 66);
    c.fillStyle = "#ffd98a"; c.fillRect(0, 334, 512, 2);
    c.fillStyle = "#d8cdb4"; c.textAlign = "center"; c.font = "600 17px 'Barlow Condensed',sans-serif";
    var msg = X.call || "";
    c.fillText(msg.length > 52 ? msg.slice(0, 51) + "\u2026" : msg, 256, 356);
    c.fillStyle = "#9ab08e"; c.font = "600 13px 'Barlow Condensed',sans-serif";
    c.fillText(X.phase === "bet" ? "Tap a lane on the screen, then press Race" :
      X.phase === "done" ? "Press Next race for a fresh field" : "", 256, 380);
    D.tex.needsUpdate = true;
  }
  function dbPickLane(i){
    var D = XG.derby;
    if(D.phase !== "bet" || i < 0 || i >= D.field.length) return;
    D.pick = i;
    var ls = D.dom.track.children;
    for(var k = 0; k < ls.length; k++) ls[k].classList.toggle("pick", k === i);
    var R = D.field[i];
    D.call = "Backing " + R.n + " at " + R.odds.toFixed(1) + "x";
    D.dom.read.textContent = D.call;
    tone(720, 0.03, "triangle", 0.04);
    if(X3.db && G.ok) db3Draw(D);
    paint();
  }
  function x3Ray(ev, objs){
    if(!G.renderer || !G.camera) return null;
    var r = G.renderer.domElement.getBoundingClientRect();
    if(!X3.rc){ X3.rc = new THREE.Raycaster(); X3.v2 = new THREE.Vector2(); }
    X3.v2.set(((ev.clientX - r.left) / r.width) * 2 - 1, -((ev.clientY - r.top) / r.height) * 2 + 1);
    X3.rc.setFromCamera(X3.v2, G.camera);
    var hits = X3.rc.intersectObjects(objs, true);
    return hits.length ? hits[0] : null;
  }
  function x3Click(ev){
    if(!G.ok || MP.live) return;
    if(state.game === "barrows" && X3.br && XG.barrows.on){
      var h = x3Ray(ev, X3.br.click);
      if(h && h.object.userData.i != null) brPick(h.object.userData.i);
    } else if(state.game === "derby" && X3.db && XG.derby.phase === "bet"){
      var h2 = x3Ray(ev, [X3.db.scr]);
      if(h2 && h2.uv){
        var py = (1 - h2.uv.y) * 400, ln = Math.floor((py - 56) / 46);
        if(py >= 56 && ln >= 0 && ln < 6) dbPickLane(ln);
      }
    }
  }
  function x3CabsBuild(){
    if(X3.cabs || !G.ok) return;
    X3.cabs = true;
    x3RoomBuild();
    var R = X3.roomG;
    X3.silk = ["#d8342c", "#3565d8", "#f2d231", "#3fae4a", "#8a3fc4", "#ef8a22"];
    var FLAME = new THREE.MeshBasicMaterial({color:0xff9a3a});
    /* Barrows crypt cabinet */
    var bg = x3Cab(R, -3.2, 4.3, 0x241f2c, 0x5a5560, 0x7a4fd0, "BARROWS", 1.16);
    sph(0.085, mat(0xd9d0b8), 0, 2.3, 0.12, bg, 1, 1.1, 0.9);
    box(0.035, 0.045, 0.02, mat(0x1a120c), -0.032, 2.31, 0.2, bg);
    box(0.035, 0.045, 0.02, mat(0x1a120c), 0.032, 2.31, 0.2, bg);
    [[-0.66], [0.66]].forEach(function(p){
      cyl(0.05, 0.07, 0.14, 6, mat(0x2a2733), p[0], 2.02, 0.2, bg);
      sph(0.07, FLAME, p[0], 2.14, 0.2, bg, 0.8, 1.35, 0.8);
    });
    X3.br = {tiles:[], click:[]};
    for(var i = 0; i < 25; i++){
      var ch = br3Chest(bg, ((i % 5) - 2) * 0.21, 1.80 - Math.floor(i / 5) * 0.17, i);
      X3.br.tiles.push(ch);
      X3.br.click.push(ch.g);
    }
    X3.br.sc = document.createElement("canvas"); X3.br.sc.width = 320; X3.br.sc.height = 64;
    X3.br.tex = new THREE.CanvasTexture(X3.br.sc);
    var strip = new THREE.Mesh(new THREE.PlaneGeometry(0.96, 0.19), new THREE.MeshBasicMaterial({map:X3.br.tex}));
    strip.position.set(0, 0.74, 0.27); bg.add(strip);
    x3Bezel(bg, 0.96, 0.19, 0.74);
    X3.brT = [];
    BR_BROS.forEach(function(br, bi){
      x3CorsImg(br[1] + " chathead.png", function(im){
        if(!im) return;
        var cv = document.createElement("canvas"); cv.width = cv.height = 64;
        var c2 = cv.getContext("2d");
        var sc = 58 / Math.max(im.naturalWidth, im.naturalHeight);
        c2.drawImage(im, 32 - im.naturalWidth * sc / 2, 32 - im.naturalHeight * sc / 2, im.naturalWidth * sc, im.naturalHeight * sc);
        X3.brT[bi] = new THREE.CanvasTexture(cv);
        if(state.game === "barrows") br3Sync(XG.barrows);
      });
    });
    /* Wildy Run cabinet: the live run plays on the screen */
    var X = XG.wildy;
    X.tex3 = new THREE.CanvasTexture(X.dom.cv);
    var wg = x3Cab(R, 0, 4.3, 0x2c1210, 0x6d2a22, 0xd8342c, "WILDY RUN", 1.5);
    var ws = new THREE.Mesh(new THREE.PlaneGeometry(1.36, 0.468), new THREE.MeshBasicMaterial({map:X.tex3}));
    ws.position.set(0, 1.32, 0.256); wg.add(ws);
    x3Bezel(wg, 1.36, 0.468, 1.32);
    for(var sp = -2; sp <= 2; sp++) cone(0.045, 0.16, 4, mat(0x1a0d0a), sp * 0.3, 2.25, 0.1, wg);
    /* Pet Derby cabinet: the race plays on the screen */
    X3.db = {cv:document.createElement("canvas")};
    X3.db.cv.width = 768; X3.db.cv.height = 600;
    X3.db.ctx = X3.db.cv.getContext("2d");
    X3.db.tex = new THREE.CanvasTexture(X3.db.cv);
    var dg = x3Cab(R, 3.2, 4.3, 0x14281a, 0x2f6a3c, 0x6fce8b, "PET DERBY", 1.6);
    X3.db.scr = new THREE.Mesh(new THREE.PlaneGeometry(1.42, 1.11), new THREE.MeshBasicMaterial({map:X3.db.tex}));
    X3.db.scr.position.set(0, 1.27, 0.256); dg.add(X3.db.scr);
    x3Bezel(dg, 1.42, 1.11, 1.27);
    cyl(0.03, 0.05, 0.12, 6, mat(0xc9a24d, {metal:.6, rough:.35}), 0, 2.23, 0.1, dg);
    cyl(0.09, 0.05, 0.1, 8, mat(0xe0b458, {metal:.6, rough:.3}), 0, 2.33, 0.1, dg);
    var chk = x3Tex(64, 16, function(c){
      for(var q = 0; q < 8; q++) for(var r = 0; r < 2; r++){
        c.fillStyle = (q + r) % 2 ? "#f2ead2" : "#16120c"; c.fillRect(q * 8, r * 8, 8, 8);
      }
    });
    var ck1 = new THREE.Mesh(new THREE.PlaneGeometry(0.5, 0.12), new THREE.MeshBasicMaterial({map:chk}));
    ck1.position.set(0, 0.78, 0.26); dg.add(ck1);
    el.scene.addEventListener("pointerdown", x3Click);
    var dz = xRoot.querySelector(".deck-zone");
    if(dz) dz.addEventListener("pointerdown", function(ev){
      if(ev.target.closest("button, input, select, .lwrap, .c-mid, .betplaque")) return;
      x3Click(ev);
    });
  }
  /* --- entry hooks --- */
  function d55Svg(s, tens){
    return "<svg viewBox='0 0 64 64' style='width:27px;height:27px;vertical-align:-6px'>" +
      "<rect x='2' y='2' width='60' height='60' rx='11' fill='" + (tens ? "#221c2e" : "#f4efe2") +
      "' stroke='" + (tens ? "#c9a24d" : "#b3a98f") + "' stroke-width='4'/>" +
      "<text x='32' y='42' text-anchor='middle' font-family='JetBrains Mono,monospace' font-weight='700' font-size='" +
      (s.length > 1 ? 26 : 32) + "' fill='" + (tens ? "#e0b458" : "#221c2e") + "'>" + s + "</text></svg>";
  }
  function x3CamFor(g){
    if(g === "barrows") return {x:-3.2, y:CELL_Y + 1.5, z:1.9, ly:CELL_Y + 1.42};
    if(g === "wildy") return {x:0, y:CELL_Y + 1.5, z:1.9, ly:CELL_Y + 1.42};
    if(g === "derby") return {x:3.2, y:CELL_Y + 1.5, z:1.9, ly:CELL_Y + 1.42};
    if(g === "squeal") return {x:-2.2, y:CELL_Y + 1.62, z:-1.5, ly:CELL_Y + 1.62};
    return {x:0, y:1.62, z:4.2, ly:1.62};
  }
  function xVol(){
    var v = state.musicVol / 100;
    var dip = X3 && X3.room === 1 && !(X3.mf && X3.mf.ok);
    if(bgm) bgm.volume = v * (dip ? 0.6 : 1);
    if(X3 && X3.mf && X3.mf.el) X3.mf.el.volume = v * 0.6;
  }
  function x3MfInit(){
    if(X3.mf || !bgm) return;
    var M = X3.mf = {ok:false, dead:false, el:null};
    try{
      var e2 = new Audio();
      e2.crossOrigin = "anonymous";
      e2.loop = true;
      e2.preload = "auto";
      M.el = e2;
      e2.addEventListener("canplaythrough", function(){
        if(M.ok || M.dead) return;
        try{
          var c = actx(); if(!c) return;
          var src = c.createMediaElementSource(e2);
          var f = c.createBiquadFilter();
          f.type = "lowpass"; f.frequency.value = 800;
          src.connect(f); f.connect(c.destination);
          M.ok = true;
          if(X3.room === 1) x3Muffle(true);
        }catch(err){ M.dead = true; }
      });
      e2.addEventListener("error", function(){ M.dead = true; });
      e2.src = MUSIC_URL;
    }catch(e){ M.dead = true; }
  }
  function x3Muffle(on){
    x3MfInit();
    var M = X3.mf;
    if(M && M.ok && bgm){
      try{
        if(on){
          M.el.currentTime = bgm.currentTime || 0;
          bgm.pause();
          if(state.music) M.el.play().catch(function(){});
        } else {
          M.el.pause();
          bgm.currentTime = M.el.currentTime || 0;
          if(state.music) bgm.play().catch(function(){});
        }
      }catch(e){}
    }
    xVol();
  }
  function x3CellTick(now){
    if(X3.room !== 1 || !X3.roomG){ X3.cellLoop = false; return; }
    var t = now / 1000;
    var dt = Math.min(0.05, (now - (X3.cellLast || now)) / 1000);
    X3.cellLast = now;
    if(X3.cellL){
      X3.cellL[0].intensity = 0.5 + Math.sin(t * 1.3) * 0.05;
      X3.cellL[1].intensity = 0.55 + Math.sin(t * 8.7) * 0.06 + Math.random() * 0.03;
    }
    (X3.npcs || []).forEach(function(n){
      n.m.group.position.y = Math.abs(Math.sin(t * 1.1 + n.seed)) * 0.012;
      n.m.head.rotation.z = Math.sin(t * 0.7 + n.seed) * 0.07;
      n.m.head.rotation.y = Math.sin(t * 0.4 + n.seed * 2) * 0.25;
    });
    var rt = X3.rat;
    if(rt){
      if(rt.wait > 0){
        rt.wait -= dt;
        rt.g.children[1].position.y = 0.05 + Math.abs(Math.sin(t * 9)) * 0.008;
      } else {
        rt.g.position.x += rt.dir * 0.85 * dt;
        rt.g.position.y = Math.abs(Math.sin(t * 22)) * 0.012;
        if(Math.random() < dt * 0.25) rt.wait = 0.6 + Math.random() * 1.6;
        if(rt.g.position.x > 2.7){ rt.dir = -1; rt.g.rotation.y = Math.PI; }
        if(rt.g.position.x < -2.7 && rt.g.rotation.y !== 0 || rt.g.position.x < -2.7){ rt.dir = 1; rt.g.rotation.y = 0; }
      }
      rt.tail.rotation.x = Math.sin(t * 7) * 0.35;
    }
    if(!X3.drip || now > X3.drip){
      X3.drip = now + 4500 + Math.random() * 6500;
      tone(2300, 0.025, "sine", 0.045);
      tone(1150, 0.05, "sine", 0.028, 0.09);
    }
    requestAnimationFrame(x3CellTick);
  }
  function x3Room(g){
    var to = XG_CELLAR.indexOf(g) !== -1 ? 1 : 0;
    if(to === X3.room) return;
    X3.room = to;
    if(!G.ok) return;
    var f = X3.fade;
    if(!f){
      f = document.createElement("div");
      f.style.cssText = "position:absolute;inset:0;background:#050308;opacity:0;pointer-events:none;" +
        "transition:opacity .22s ease;z-index:21";
      (el.scene && el.scene.parentElement ? el.scene.parentElement : document.body).appendChild(f);
      X3.fade = f;
    }
    f.style.opacity = "1";
    x3Steps(to === 1);
    setTimeout(function(){
      var t = x3CamFor(state.game);
      G.camera.position.set(t.x, t.y, t.z);
      G.lookYaw = G.lookYawT;
      G.lookX = G.lookXT;
      G.lookY = t.ly;
      x3Muffle(X3.room === 1);
      f.style.opacity = "0";
    }, 240);
    if(to === 1 && !X3.cellLoop){
      X3.cellLoop = true;
      X3.cellLast = 0;
      requestAnimationFrame(x3CellTick);
    }
  }
  function x3Steps(down){
    for(var i = 0; i < 5; i++){
      var p = down ? 150 - i * 13 : 100 + i * 13;
      tone(p, 0.055, "triangle", 0.075, 0.05 + i * 0.115);
      tone(p * 4.3, 0.02, "square", 0.02, 0.05 + i * 0.115);
    }
    tone(down ? 82 : 178, 0.14, "triangle", 0.05, 0.66);
  }
  function x3dEnter(g){
    var GL = G.ok && typeof THREE !== "undefined";
    if(g === "d55"){
      if(XG.d55.dom.die) XG.d55.dom.die.style.display = GL ? "none" : "";
      el.goBtn.textContent = GL ? "Hold to shake" : "Roll";
    }
    if(!GL) return;
    if(g === "flower" && XG.flower.dom.svg.parentElement) XG.flower.dom.svg.parentElement.style.display = "none";
    if(g === "squeal"){
      x3SqBuild();
      if(XG.squeal.dom.cv.parentElement) XG.squeal.dom.cv.parentElement.style.display = "none";
      if(X3.sq && !X3.sq.loop){ X3.sq.loop = true; requestAnimationFrame(x3SqTick); }
    }
    if(g === "barrows" || g === "wildy" || g === "derby"){
      x3CabsBuild();
      if(g === "barrows"){ XG.barrows.dom.grid.style.display = "none"; br3Sync(XG.barrows); }
      if(g === "wildy") XG.wildy.dom.cv.style.display = "none";
      if(g === "derby"){ XG.derby.dom.track.style.display = "none"; db3Draw(XG.derby); }
    }
  }
  var x3BootN = 0;
  (function x3Boot(){
    if(G && G.ok){ x3RoomBuild(); x3CabsBuild(); x3SqBuild(); crowdBuild(); return; }
    if(++x3BootN < 40) setTimeout(x3Boot, 400);
  })();
  /* --- hot games rotation: one 2x and one 3x game every 10 minutes --- */
  var HOT = {slot:-1, x2:null, x3:null};
  var HOT_POOL = ["poker","bj","dice","ceelo","stake","rou","pach","slots","bac","d55","flower","squeal","barrows","wildy","derby"];
  var HOT_NAMES = {poker:"Poker", bj:"Blackjack", dice:"Craps", ceelo:"Cee-lo", stake:"Staking", rou:"Roulette",
    pach:"Pachinko", slots:"Slots", bac:"Baccarat", d55:"Dicing", flower:"Flower Game", squeal:"Squeal",
    barrows:"Barrows", wildy:"Wildy Run", derby:"Pet Derby"};
  function hotCalc(){
    var slot = Math.floor(Date.now() / 600000);
    if(HOT.slot === slot) return;
    HOT.slot = slot;
    function rnd(k){ var x = Math.sin(slot * 8887.7 + k * 2971.3) * 43758.5453; return x - Math.floor(x); }
    var pool = HOT_POOL.slice();
    HOT.x3 = pool.splice(Math.floor(rnd(1) * pool.length), 1)[0];
    HOT.x2 = pool[Math.floor(rnd(2) * pool.length)];
    hotBadges();
    if(!MP.live) say("Hot tables, lad: " + HOT_NAMES[HOT.x3] + " pays triple, " + HOT_NAMES[HOT.x2] + " pays double.");
  }
  function hotMult(){
    if(MP.live) return 1;
    hotCalc();
    return state.game === HOT.x3 ? 3 : state.game === HOT.x2 ? 2 : 1;
  }
  function hotPay(v){
    var m = hotMult();
    return m > 1 ? Math.round(v * m) : v;
  }
  function hotBadges(){
    if(!XG) return;
    var bs = el.gtabs.querySelectorAll("button[data-g]");
    for(var i = 0; i < bs.length; i++){
      var b = bs[i], g = b.dataset.g;
      b.classList.remove("hot2", "hot3");
      var old = b.querySelector(".hotb");
      if(old) old.parentNode.removeChild(old);
      var m = g === HOT.x3 ? 3 : g === HOT.x2 ? 2 : 0;
      if(m){
        b.classList.add("hot" + m);
        b.appendChild(xNode("span", "hotb", m + "x"));
        b.style.display = "flex"; b.style.alignItems = "center"; b.style.justifyContent = "space-between";
      }
    }
    (XG.cats || []).forEach(function(cn){
      var hb = cn.querySelector(".gcatb");
      if(!hb) return;
      hb.classList.remove("hot2", "hot3");
      var ob = hb.querySelector(".hotb");
      if(ob) ob.parentNode.removeChild(ob);
      var has3 = !!cn.querySelector("[data-g='" + HOT.x3 + "']");
      var has2 = !!cn.querySelector("[data-g='" + HOT.x2 + "']");
      var m2 = has3 ? 3 : has2 ? 2 : 0;
      if(m2){
        hb.classList.add("hot" + m2);
        hb.appendChild(xNode("span", "hotb", has3 && has2 ? "3x 2x" : m2 + "x"));
      }
    });
  }
  function hotPaint(){
    hotCalc();
    if(!HOT.badged && XG){ HOT.badged = true; hotBadges(); }
    var p = el.hotPill;
    if(!p){
      p = document.createElement("div");
      p.id = "hotPill";
      p.style.cssText = "display:none;position:absolute;right:12px;top:132px;z-index:26;pointer-events:none;" +
        "background:rgba(20,12,6,.9);border:1px solid #e0b458;border-radius:6px;padding:6px 12px;" +
        "font-family:'Barlow Condensed',sans-serif;font-size:14px;letter-spacing:.05em;color:#ffd98a;text-align:right";
      var sui = xRoot.querySelector(".stage-ui");
      (sui || document.body).appendChild(p);
      el.hotPill = p;
    }
    if(MP.live){ p.style.display = "none"; return; }
    var left = Math.max(1, Math.ceil((600000 - (Date.now() % 600000)) / 60000));
    var m = state.game === HOT.x3 ? 3 : state.game === HOT.x2 ? 2 : 1;
    if(m > 1){
      p.innerHTML = "<b style='color:" + (m === 3 ? "#ff8a3a" : "#ffd98a") + ";font-size:16px'>HOT GAME · " + m + "x wins</b><br>rotates in " + left + "m";
    } else {
      p.innerHTML = "<span style='color:#d8cdb4'>Hot tables · " + left + "m left</span><br>" +
        "<b style='color:#ff8a3a'>" + HOT_NAMES[HOT.x3] + " 3x</b> · <b style='color:#ffd98a'>" + HOT_NAMES[HOT.x2] + " 2x</b>";
    }
    p.style.display = "";
  }
  setInterval(hotPaint, 20000);
  /* --- tavern life: wanderers, bartender, crowd reactions, murmur --- */
  var CROWD = {list:[], wand:[], react:null, mur:null, built:false, bar:null, nbuf:null};
  function crowdFree(x, z){
    if(Math.abs(x) > 7.2 || z < -4.6 || z > 5.3) return false;
    if(Math.hypot(x + 3.6, z + 2.4) < 1.5) return false;
    if(Math.hypot(x - 3.6, z + 2.6) < 1.5) return false;
    if(Math.hypot(x - 4.7, z + 1.7) < 0.8) return false;
    if(Math.abs(x) < 2.95 && z > -0.5 && z < 1.75) return false;
    if(x < -6.7 && z > -4.3 && z < 1.2) return false;
    if(Math.hypot(x + 7.5, z - 4.2) < 1.2) return false;
    if(Math.hypot(x - 4.05, z - 2.6) < 1.6) return false;
    if(Math.abs(x) < 1.7 && z > 1.7 && z < 4.7) return false;
    return true;
  }
  function crowdClear(x0, z0, x1, z1){
    for(var k = 1; k <= 14; k++){
      var u = k / 14;
      if(!crowdFree(x0 + (x1 - x0) * u, z0 + (z1 - z0) * u)) return false;
    }
    return true;
  }
  var CROWD_SPOTS = [
    {x:-2.2, z:-2.3, face:[-3.6, -2.4]}, {x:2.3, z:-3.1, face:[3.6, -2.6]},
    {x:3.25, z:1.0, face:[2.4, 1.1]},
    {x:-1.35, z:5.1, face:[-1.35, 6.8], act:"slots"}, {x:1.35, z:5.1, face:[1.35, 6.8], act:"pach"},
    {x:-5.4, z:-1.0, face:[-6.4, -1.0]}, {x:5.3, z:0.2, face:[6.4, 0.2]},
    {x:0, z:-3.9, face:[0, -5.3]},
    {x:-6.45, z:-1.1, face:[-7.3, -1.1], act:"bar"}, {x:-6.45, z:-2.3, face:[-7.3, -2.3], act:"bar"},
    {x:2.62, z:-2.6, face:[3.6, -2.6], act:"sit"}, {x:3.6, z:-3.6, face:[3.6, -2.6], act:"sit"}
  ];
  function crowdWander(m, opts){
    var w = {m:m, st:"idle", t:0, wait:1 + Math.random() * 4, tx:0, tz:0, speed:opts.speed || 0.5, hop:!!m.hop, spot:null, drink:!!opts.drink, stage:null};
    CROWD.wand.push(w);
    return w;
  }
  function crowdPick(w){
    var g = w.m.group.position, k;
    if(Math.random() < 0.55){
      var s = CROWD_SPOTS[Math.floor(Math.random() * CROWD_SPOTS.length)];
      if(s.act === "sit"){
        if(s.busy || !w.m.fan) s = null;
        else {
          var ax = s.x + (s.x - s.face[0]) * 0.9, az = s.z + (s.z - s.face[1]) * 0.9;
          if(crowdClear(g.x, g.z, ax, az)){ s.busy = true; w.spot = s; w.stage = "approach"; w.tx = ax; w.tz = az; return; }
          s = null;
        }
      }
      if(s){
        var sx = s.x + (Math.random() - 0.5) * 0.3, sz = s.z + (Math.random() - 0.5) * 0.3;
        if(crowdClear(g.x, g.z, sx, sz)){ w.spot = s; w.stage = null; w.tx = sx; w.tz = sz; return; }
      }
    }
    w.spot = null; w.stage = null;
    for(k = 0; k < 50; k++){
      var x = (Math.random() - 0.5) * 14, z = -4.4 + Math.random() * 9.5;
      if(crowdFree(x, z) && Math.hypot(x - g.x, z - g.z) > 1.4 && crowdClear(g.x, g.z, x, z)){ w.tx = x; w.tz = z; return; }
    }
    w.tx = g.x; w.tz = g.z;
  }
  function crowdUpdate(t, dt){
    for(var a = 0; a < CROWD.wand.length; a++){
      var wa = CROWD.wand[a], pa = wa.m.group.position;
      if(wa.st === "sit") continue;
      for(var b2 = a + 1; b2 < CROWD.wand.length; b2++){
        var wb = CROWD.wand[b2], pb = wb.m.group.position;
        var ddx = pb.x - pa.x, ddz = pb.z - pa.z, dd = Math.hypot(ddx, ddz);
        if(dd < 0.62 && dd > 0.0001){
          var push = (0.62 - dd) * 0.5, nx = ddx / dd, nz = ddz / dd;
          if(wb.st !== "sit"){ pa.x -= nx * push; pa.z -= nz * push; pb.x += nx * push; pb.z += nz * push; }
          else { pa.x -= nx * push * 2; pa.z -= nz * push * 2; }
        }
      }
      (G.crowd || []).forEach(function(o){
        var po = o.group.position, ox = pa.x - po.x, oz = pa.z - po.z, od = Math.hypot(ox, oz);
        if(od < 0.62 && od > 0.0001){ pa.x += ox / od * (0.62 - od); pa.z += oz / od * (0.62 - od); }
      });
    }
    CROWD.wand.forEach(function(w){
      var m = w.m, g = m.group;
      if(w.st === "sit"){
        w.t += dt;
        m.lLeg.rotation.x = -1.45; m.rLeg.rotation.x = -1.45;
        m.lArm.rotation.x = -1.05 + Math.sin(t * 0.8 + w.t) * 0.04; m.rArm.rotation.x = -1.05;
        m.head.rotation.x = 0.28 + Math.sin(t * 0.9) * 0.05; m.head.rotation.y = Math.sin(t * 0.5 + w.t) * 0.2;
        if(m.fan){ m.fan.rotation.z = Math.sin(t * 1.3 + w.t) * 0.06; m.fan.position.y = 0.71 + Math.sin(t * 1.7 + w.t) * 0.012; }
        g.position.y = m.baseY;
        if(w.t > w.wait){
          w.st = "idle"; w.t = 0; w.wait = 1;
          m.baseY = 0; g.position.y = 0;
          m.lLeg.rotation.x = 0; m.rLeg.rotation.x = 0; m.head.rotation.x = 0;
          if(m.fan) m.fan.visible = false;
          if(w.spot) w.spot.busy = false;
          w.spot = null;
        }
        return;
      }
      if(w.st === "idle"){
        w.t += dt;
        if(m.lLeg){ m.lLeg.rotation.x = 0; m.rLeg.rotation.x = 0; }
        g.position.y = 0;
        if(w.spot && w.spot.act === "slots"){ m.rArm.rotation.x = -1.2 + Math.max(0, Math.sin(t * 2.2)) * 0.8; m.lArm.rotation.x = 0; }
        else if(w.spot && w.spot.act === "pach"){ m.rArm.rotation.x = -1.4 + Math.sin(t * 4) * 0.1; m.lArm.rotation.x = Math.sin(t * 2) * 0.2; }
        else if(w.spot && w.spot.act === "bar"){ m.rArm.rotation.x = -0.9; m.lArm.rotation.x = -1.7 * Math.max(0, Math.sin(t * 0.6 + w.t)); }
        else {
          m.lArm.rotation.x = Math.sin(t * 1.1 + w.t) * 0.12;
          m.rArm.rotation.x = Math.sin(t * 0.9) * 0.1 - (w.drink ? 1.6 * Math.max(0, Math.sin(t * 0.55 + w.t)) : 0);
        }
        m.head.rotation.y = Math.sin(t * 0.6 + w.t) * 0.35;
        if(w.t > w.wait){ w.st = "walk"; crowdPick(w); }
      } else {
        var dx = w.tx - g.position.x, dz = w.tz - g.position.z, dist = Math.hypot(dx, dz);
        if(dist < 0.1){
          if(w.spot && w.spot.act === "sit"){
            if(w.stage === "approach"){ w.stage = "seat"; w.tx = w.spot.x; w.tz = w.spot.z; return; }
            g.position.set(w.spot.x, -0.28, w.spot.z);
            g.rotation.y = Math.atan2(w.spot.face[0] - g.position.x, w.spot.face[1] - g.position.z);
            m.baseY = -0.28;
            if(m.fan) m.fan.visible = true;
            w.st = "sit"; w.t = 0; w.wait = 18 + Math.random() * 30;
            return;
          }
          w.st = "idle"; w.t = 0; w.wait = 2 + Math.random() * 7;
          if(w.spot) g.rotation.y = Math.atan2(w.spot.face[0] - g.position.x, w.spot.face[1] - g.position.z);
          return;
        }
        g.position.x += dx / dist * w.speed * dt; g.position.z += dz / dist * w.speed * dt;
        var ty = Math.atan2(dx, dz), dy = ty - g.rotation.y;
        dy = Math.atan2(Math.sin(dy), Math.cos(dy)); g.rotation.y += dy * Math.min(1, dt * 8);
        var sw = Math.sin(t * 10 * w.speed);
        if(w.hop){
          var hs = Math.abs(Math.sin(t * w.speed * 6));
          g.position.y = hs * 0.05; m.lArm.rotation.x = 0.2 + sw * 0.7; m.rArm.rotation.x = 0.2 + sw * 0.7;
          m.lLeg.rotation.x = -sw * 0.8; m.rLeg.rotation.x = -sw * 0.8;
        } else {
          g.position.y = Math.abs(Math.sin(t * w.speed * 6)) * 0.03;
          m.lArm.rotation.x = sw * 0.5; m.rArm.rotation.x = -sw * 0.5;
          var la = m.skirt ? 0.3 : 0.6;
          m.lLeg.rotation.x = -sw * la; m.rLeg.rotation.x = sw * la;
        }
        m.head.rotation.y = 0;
      }
    });
    if(CROWD.bar){
      var b = CROWD.bar;
      if(b.serve > 0){ b.serve -= dt; b.rArm.rotation.x = -1.7; b.rArm.rotation.z = -0.5; }
      else { b.rArm.rotation.x = -1.35 + Math.sin(t * 5) * 0.22; b.rArm.rotation.z = Math.sin(t * 5) * 0.28; }
      b.lArm.rotation.x = -1.15; b.lArm.rotation.z = -0.25;
      b.head.rotation.y = Math.sin(t * 0.5) * 0.3; b.head.rotation.x = 0.25;
    }
    if(CROWD.react){
      var r = CROWD.react; r.t += dt;
      var u = r.t / r.dur;
      CROWD.list.forEach(function(m, i){
        var by = m.baseY || 0;
        if(r.kind === "lose"){
          m.lArm.rotation.x = 0.15; m.rArm.rotation.x = 0.15;
          m.head.rotation.x = 0.45 * Math.sin(Math.min(1, u * 1.5) * Math.PI);
          m.head.rotation.z = Math.sin(t * 6 + i) * 0.12 * (1 - u);
        } else {
          var lift = Math.sin(Math.min(1, u * 1.2) * Math.PI);
          m.lArm.rotation.x = -2.7 * lift + Math.sin(t * 12 + i) * 0.25 * lift;
          m.rArm.rotation.x = -2.7 * lift + Math.cos(t * 12 + i) * 0.25 * lift;
          m.lArm.rotation.z = (m.splay || 0) + 0.55 * lift; m.rArm.rotation.z = -(m.splay || 0) - 0.55 * lift;
          m.group.position.y = by + Math.abs(Math.sin(t * 9 + i)) * (r.kind === "big" ? 0.14 : 0.06) * lift;
        }
      });
      if(u >= 1){
        CROWD.react = null;
        CROWD.list.forEach(function(m){
          m.head.rotation.x = 0; m.head.rotation.z = 0; m.group.position.y = m.baseY || 0;
          if(m.armBase){ m.lArm.rotation.x = m.armBase[0]; m.rArm.rotation.x = m.armBase[1]; m.lArm.rotation.z = m.armBase[2]; m.rArm.rotation.z = m.armBase[3]; }
          else { m.lArm.rotation.z = m.splay || 0; m.rArm.rotation.z = -(m.splay || 0); }
        });
      }
    }
  }
  function crowdReact(kind){
    if(!G.ok || !CROWD.built || CROWD.react) return;
    CROWD.react = {kind:kind, t:0, dur:kind === "big" ? 2.4 : 1.5};
    crowdSound(kind);
  }
  function crowdNoise(c){
    if(CROWD.nbuf) return CROWD.nbuf;
    var len = c.sampleRate * 2, b = c.createBuffer(1, len, c.sampleRate), d = b.getChannelData(0);
    for(var i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
    CROWD.nbuf = b; return b;
  }
  function crowdSound(kind){
    if(!state.sound) return;
    var c = actx(); if(!c) return;
    try{
      var t0 = c.currentTime;
      var src = c.createBufferSource(); src.buffer = crowdNoise(c);
      var f = c.createBiquadFilter(); f.type = "bandpass";
      var g = c.createGain();
      src.connect(f); f.connect(g); g.connect(c.destination);
      if(kind === "lose"){
        f.frequency.setValueAtTime(420, t0); f.frequency.exponentialRampToValueAtTime(170, t0 + 0.9); f.Q.value = 1.2;
        g.gain.setValueAtTime(0.0001, t0); g.gain.exponentialRampToValueAtTime(0.09, t0 + 0.08); g.gain.exponentialRampToValueAtTime(0.0001, t0 + 1.0);
        src.start(t0); src.stop(t0 + 1.1);
        tone(220, 0.5, "sawtooth", 0.03); tone(165, 0.7, "sawtooth", 0.028, 0.15);
      } else {
        var big = kind === "big";
        f.frequency.setValueAtTime(700, t0); f.frequency.exponentialRampToValueAtTime(1600, t0 + 0.25);
        f.frequency.exponentialRampToValueAtTime(900, t0 + (big ? 1.8 : 1.0)); f.Q.value = 0.8;
        g.gain.setValueAtTime(0.0001, t0); g.gain.exponentialRampToValueAtTime(big ? 0.16 : 0.11, t0 + 0.12);
        g.gain.exponentialRampToValueAtTime(0.0001, t0 + (big ? 2.0 : 1.1));
        src.start(t0); src.stop(t0 + 2.2);
        [392, 494, 587].forEach(function(n, i){ tone(n, big ? 0.5 : 0.3, "triangle", 0.028, 0.05 + i * 0.03); });
        if(big) tone(784, 0.6, "triangle", 0.03, 0.3);
      }
    }catch(e){}
  }
  function crowdMurmur(){
    var c = actx(); if(!c || c.state !== "running") return;
    try{
      var on = state.sound && !document.hidden;
      if(!on) return;
      var lvl = X3.room === 1 ? 0.5 : 1;
      var phrases = 1 + (Math.random() < 0.7 ? 1 : 0) + (Math.random() < 0.4 ? 1 : 0);
      for(var p = 0; p < phrases; p++) crowdPhrase(c, c.currentTime + Math.random() * 0.8, lvl);
      if(Math.random() < 0.07) crowdLaugh(c, c.currentTime + Math.random() * 0.5, lvl);
      if(X3.room !== 1 && Math.random() < 0.08) tone(1900 + Math.random() * 700, 0.04, "sine", 0.014);
    }catch(e){}
  }
  function crowdVoiceOut(c, t0, pan){
    var g = c.createGain(); g.gain.value = 0.0001;
    var out = g;
    if(c.createStereoPanner){ var pn = c.createStereoPanner(); pn.pan.value = pan; g.connect(pn); out = pn; }
    out.connect(c.destination);
    return g;
  }
  function crowdSyllable(c, g, t, pitch, dur, vol){
    var o = c.createOscillator(); o.type = "sawtooth";
    o.frequency.setValueAtTime(pitch, t);
    o.frequency.linearRampToValueAtTime(pitch * (0.9 + Math.random() * 0.25), t + dur);
    var fm = c.createBiquadFilter(); fm.type = "bandpass"; fm.Q.value = 2.2;
    var f0 = 380 + Math.random() * 900;
    fm.frequency.setValueAtTime(f0, t);
    fm.frequency.linearRampToValueAtTime(f0 * (0.7 + Math.random() * 0.7), t + dur);
    var e = c.createGain();
    e.gain.setValueAtTime(0.0001, t);
    e.gain.exponentialRampToValueAtTime(vol, t + 0.03);
    e.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(fm); fm.connect(e); e.connect(g);
    o.start(t); o.stop(t + dur + 0.02);
  }
  function crowdPhrase(c, t0, lvl){
    var pitch = Math.random() < 0.55 ? 95 + Math.random() * 60 : 170 + Math.random() * 90;
    var g = crowdVoiceOut(c, t0, (Math.random() - 0.5) * 1.4);
    g.gain.value = 1;
    var n = 2 + Math.floor(Math.random() * 5), t = t0;
    for(var i = 0; i < n; i++){
      var dur = 0.09 + Math.random() * 0.16;
      crowdSyllable(c, g, t, pitch * (0.92 + Math.random() * 0.2), dur, 0.014 * lvl);
      t += dur + 0.02 + Math.random() * 0.06;
    }
  }
  function crowdLaugh(c, t0, lvl){
    var pitch = 150 + Math.random() * 120, g = crowdVoiceOut(c, t0, (Math.random() - 0.5) * 1.2);
    g.gain.value = 1;
    var n = 3 + Math.floor(Math.random() * 3), t = t0;
    for(var i = 0; i < n; i++){
      crowdSyllable(c, g, t, pitch * (1.15 - i * 0.05), 0.11, 0.013 * lvl);
      t += 0.16;
    }
  }
  setInterval(crowdMurmur, 1000);
  function crowdBuild(){
    if(CROWD.built || !G.ok) return;
    CROWD.built = true;
    var HATM = mat(0xd8c98a), STRAW = mat(0xc9b878), RED = mat(0xa32b1f), WHT = mat(0xf2ead2), WOOD = mat(0x4a3322), WOODD = mat(0x3a2712);
    function straw(m){ cyl(0.2, 0.2, 0.018, 12, HATM, 0, 0.09, 0, m.head); cyl(0.1, 0.11, 0.1, 10, STRAW, 0, 0.145, 0, m.head); }
    function pitchfork(m){
      var H = mat(0x8a6d3b), T = mat(0x9a9aa4);
      var pf = new THREE.Group(); pf.position.set(0.04, -0.36, 0.02); pf.rotation.x = -0.55; pf.rotation.z = -0.12; m.rArm.add(pf);
      cyl(0.012, 0.012, 0.78, 5, H, 0, 0.29, 0, pf);
      box(0.09, 0.012, 0.012, T, 0, 0.66, 0, pf);
      [-0.034, 0, 0.034].forEach(function(o){ box(0.008, 0.1, 0.008, T, o, 0.71, 0, pf); });
    }
    function beard(m, col, s){ sph(0.055 * (s || 1), mat(col), 0, -0.07, 0.085, m.head, 1, 1.25, 0.7); }
    function mug(m){ cyl(0.03, 0.028, 0.06, 6, mat(0x8a6d3b), -0.04, -0.37, 0.03, m.lArm); }
    function female(m, hairC, shirtC){
      var HR = mat(hairC), SH = mat(shirtC);
      m.group.scale.set(1.7 * 0.88, 1.7, 1.7 * 0.9);
      sph(0.055, HR, -0.088, -0.04, -0.03, m.head, 0.5, 1.9, 0.7);
      sph(0.055, HR, 0.088, -0.04, -0.03, m.head, 0.5, 1.9, 0.7);
      sph(0.09, HR, 0, -0.1, -0.095, m.head, 0.85, 2.4, 0.5);
      if(m.group.children[2]) m.group.children[2].scale.set(0.9, 1, 0.86);
      sph(0.06, SH, 0, 0.71, 0.128, m.group, 1.6, 0.6, 0.7);
    }
    var monk = makeMan({shirt:0x8a5a2a, pants:0x8a5a2a, hair:0x6b4a2a});
    if(monk.head.children[2]) monk.head.children[2].visible = false;
    var tons = new THREE.Mesh(new THREE.TorusGeometry(0.104, 0.02, 6, 18), mat(0x6b4a2a)); tons.rotation.x = Math.PI / 2; tons.position.y = 0.055; monk.head.add(tons);
    monk.hatY = 0.015;
    mug(monk);
    var guard = makeMan({shirt:0x9a9aa4, pants:0xa32b1f, hair:0x4a3322});
    var STEEL = new THREE.MeshStandardMaterial({color:0xb0b4bd, metalness:0.45, roughness:0.5, side:THREE.DoubleSide, flatShading:false});
    if(guard.head.children[2]) guard.head.children[2].visible = false;
    var hside = new THREE.Mesh(new THREE.CylinderGeometry(0.119, 0.123, 0.17, 14, 1, true, Math.PI * 0.3, Math.PI * 1.4), STEEL);
    hside.position.y = -0.05; guard.head.add(hside);
    var hcap = new THREE.Mesh(new THREE.SphereGeometry(0.122, 14, 8, 0, TAU, 0, 1.33), STEEL);
    hcap.position.y = 0.008; guard.head.add(hcap);
    cyl(0.127, 0.127, 0.026, 14, RED, 0, 0.035, 0, guard.head);
    guard.hatY = 0.02;
    sph(0.06, mat(0x2a3fb0), -0.19, 0.74, 0, guard.group); sph(0.06, mat(0x2a3fb0), 0.19, 0.74, 0, guard.group);
    sph(0.035, mat(0x6a6a2a), -0.04, -0.36, 0.02, guard.lArm); sph(0.035, mat(0x6a6a2a), 0.04, -0.36, 0.02, guard.rArm);
    beard(guard, 0x4a3322);
    var farmM = makeMan({shirt:0x4a7a3a, pants:0xb8a25a, hair:0x2a2733});
    straw(farmM); farmM.hatY = 0.085;
    var farmF = makeMan({shirt:0x6b4a2a, pants:0xb8a25a, hair:0x2a2733});
    straw(farmF); farmF.hatY = 0.085; female(farmF, 0x2a2733, 0x6b4a2a);
    var woman = makeMan({shirt:0xe8b8c8, pants:0x2a6a6a, hair:0x1a1a1a});
    var skirt = new THREE.Mesh(new THREE.CylinderGeometry(0.125, 0.245, 0.36, 12), mat(0x2a6a6a)); skirt.position.y = 0.36; woman.group.add(skirt); woman.skirt = true;
    female(woman, 0x1a1a1a, 0xe8b8c8);
    mug(woman);
    var gnome = makeGnome();
    var GRNH = mat(0x2a8a2a);
    [2, 3, 4, 5, 6].forEach(function(ci){ if(gnome.head.children[ci]) gnome.head.children[ci].material = GRNH; });
    var monkey2 = makeMonkey();
    var roster = [[monk, 0.45, true], [guard, 0.55, false], [farmM, 0.5, false], [farmF, 0.5, false], [woman, 0.45, true], [gnome, 0.6, false], [monkey2, 0.8, false]];
    var spawns = [[-1.9, -3.6], [1.6, -3.9], [-4.9, -0.6], [4.9, 0.4], [0.4, -2.6], [-2.6, -0.9], [2.8, -1.2]];
    roster.forEach(function(r, i){
      var m = r[0], sp = spawns[i];
      m.group.position.set(sp[0], 0, sp[1]);
      m.group.rotation.y = Math.random() * TAU;
      m.baseY = 0;
      if(m !== monkey2){ handCards(m); m.fan.visible = false; m.splay = 0.16; m.lArm.rotation.z = 0.16; m.rArm.rotation.z = -0.16; }
      G.scene.add(m.group);
      crowdWander(m, {speed:r[1], drink:r[2]});
      CROWD.list.push(m);
      if(G.npcHeads) G.npcHeads.push({h:m.head, s:m === monkey2 ? 0.62 : 0.5, y:m.hatY != null ? m.hatY : (m === monkey2 ? 0.02 : 0.045)});
    });
    (G.crowd || []).forEach(function(m){ m.baseY = 0; m.armBase = [m.lArm.rotation.x, m.rArm.rotation.x, m.lArm.rotation.z, m.rArm.rotation.z]; CROWD.list.push(m); });
    /* stools at the east table for the card seats */
    [[2.62, -2.6], [3.6, -3.6]].forEach(function(p){
      cyl(0.17, 0.15, 0.06, 8, WOOD, p[0], 0.40, p[1], G.scene);
      cyl(0.04, 0.05, 0.38, 6, WOODD, p[0], 0.19, p[1], G.scene);
    });
    /* bartender works the original west-wall bar */
    var bt = makeMan({shirt:0x8a8f9a, pants:0x2f3d2f, hair:0x7a3a14});
    box(0.22, 0.34, 0.03, WHT, 0, 0.33, 0.165, bt.group);
    box(0.02, 0.2, 0.02, WHT, -0.06, 0.66, 0.16, bt.group); box(0.02, 0.2, 0.02, WHT, 0.06, 0.66, 0.16, bt.group);
    cyl(0.175, 0.175, 0.025, 10, mat(0x7a1a1a), 0, 0.5, 0, bt.group);
    beard(bt, 0x7a3a14, 1.4);
    cyl(0.025, 0.02, 0.075, 6, new THREE.MeshStandardMaterial({color:0xcfe6ff, transparent:true, opacity:0.55, roughness:0.2}), -0.04, -0.37, 0.03, bt.lArm);
    box(0.055, 0.03, 0.055, WHT, 0.04, -0.37, 0.02, bt.rArm);
    bt.group.position.set(-7.78, 0, -1.6); bt.group.rotation.y = Math.PI / 2;
    bt.baseY = 0;
    G.scene.add(bt.group);
    CROWD.bar = bt;
    G.npcs.push({update:crowdUpdate});
    beerInit();
    try{ applyPrestigeScene(); }catch(e){}
  }
  /* --- beer at the bar, and the consequences --- */
  var DRUNK = {n:0, last:0, btn:null, row:null};
  function beerInit(){
    if(DRUNK.btn) return;
    var st = document.createElement("style");
    st.textContent = "@keyframes pvmWob{0%,100%{transform:rotate(0deg) scale(1.03)}25%{transform:rotate(var(--wob,0.4deg)) scale(1.04)}75%{transform:rotate(calc(var(--wob,0.4deg) * -1)) scale(1.04)}}" +
      "#pvm-poker #scene.drunk{animation:pvmWob 5s ease-in-out infinite}";
    document.head.appendChild(st);
    var b = document.createElement("button");
    b.id = "beerBtn";
    b.textContent = "Beer \u00b7 2 gp";
    b.style.cssText = "display:none;position:absolute;left:12px;top:132px;z-index:26;background:rgba(20,12,6,.9);border:1px solid #c9a24d;" +
      "border-radius:999px;padding:6px 14px;font-family:'Barlow Condensed',sans-serif;font-size:14px;letter-spacing:.05em;color:#ffd98a;cursor:pointer;pointer-events:auto";
    b.addEventListener("click", beerBuy);
    var sui = xRoot.querySelector(".stage-ui");
    (sui || document.body).appendChild(b);
    DRUNK.btn = b;
    var bk = document.createElement("button");
    bk.id = "beerBack";
    bk.textContent = "Go back";
    bk.style.cssText = "display:none;position:absolute;left:150px;top:132px;z-index:26;background:rgba(20,12,6,.9);border:1px solid #8a6d3b;" +
      "border-radius:999px;padding:6px 14px;font-family:'Barlow Condensed',sans-serif;font-size:14px;letter-spacing:.05em;color:#d8cdb4;cursor:pointer;pointer-events:auto";
    bk.addEventListener("click", beerBack);
    (sui || document.body).appendChild(bk);
    DRUNK.back = bk;
    var atmRow = el.sAtm ? el.sAtm.parentNode : null;
    if(atmRow){
      var row = xNode("div", "stat", "<span>Beers drunk</span><span>0</span>");
      atmRow.parentNode.insertBefore(row, atmRow);
      DRUNK.row = row.lastChild;
    }
    setInterval(drunkTick, 2000);
  }
  var BEER = {stage:0, yaw:0, lx:0};
  function beerServe(){
    state.coins -= 2;
    state.stats.beers = (state.stats.beers || 0) + 1;
    DRUNK.n = Math.min(12, DRUNK.n + 1); DRUNK.last = Date.now();
    tone(1800, 0.05, "sine", 0.05); tone(2400, 0.08, "sine", 0.04, 0.05);
    if(CROWD.bar){
      CROWD.bar.serve = 1.2;
      var mg = cyl(0.065, 0.058, 0.17, 8, mat(0x8a6d3b), -7.35, 1.2, -1.35, G.scene);
      cyl(0.062, 0.062, 0.05, 8, mat(0xf2ead2), 0, 0.105, 0, mg);
      box(0.022, 0.09, 0.022, mat(0x6b4a2a), 0.078, 0.005, 0, mg);
      var t0 = performance.now();
      (function slide(now){
        var u = Math.min(1, (now - t0) / 700);
        mg.position.x = -7.35 + u * 0.4; mg.position.z = -1.35 + u * 0.35;
        if(u < 1) requestAnimationFrame(slide); else setTimeout(function(){ G.scene.remove(mg); }, 2600);
      })(t0);
    }
    var n = DRUNK.n;
    say(n >= 12 ? "That's the lot. The floor is yours, lad." :
        n >= 10 ? "You're seeing two of me. Only one of us takes bets." :
        n >= 8 ? "Your bets are getting brave. Your legs are not." :
        n >= 7 ? "Last one, lad. I mean it this time." :
        n >= 5 ? "You're swaying. The dice are not." :
        n >= 3 ? "Slow down, the tables are not going anywhere." :
        state.coins < 0 ? "On the tab. The tab is getting long." : "Cheers, lad.");
    drunkApply();
    if(n >= 12) setTimeout(beerPassOut, 1400);
    paint(); save();
  }
  function beerBuy(){
    if(MP.live || !G.ok || ATM.stage || ATM.busy || X3.room === 1 || DRUNK.out) return;
    if(BEER.stage){ beerServe(); return; }
    if(gameBusy()){ say("Finish the hand first, lad."); return; }
    actx();
    setGame(state.game, true);
    BEER.stage = 1;
    BEER.yaw = G.lookYawT; BEER.lx = G.lookXT;
    G.lookYawT = Math.PI * 1.5;
    x3Steps(false);
    setTimeout(beerServe, 1100);
    drunkTick();
  }
  function beerBack(){
    if(!BEER.stage) return;
    BEER.stage = 0;
    G.lookYawT = BEER.yaw; G.lookXT = BEER.lx;
    x3Steps(false);
    drunkTick();
  }
  function beerPassOut(){
    if(DRUNK.out) return;
    DRUNK.out = true;
    var f = X3.fade;
    if(!f){
      f = document.createElement("div");
      f.style.cssText = "position:absolute;inset:0;background:#050308;opacity:0;pointer-events:none;transition:opacity .22s ease;z-index:21";
      (el.scene && el.scene.parentElement ? el.scene.parentElement : document.body).appendChild(f);
      X3.fade = f;
    }
    f.style.transition = "opacity 1.4s ease";
    f.style.opacity = "1";
    tone(120, 0.6, "sawtooth", 0.05);
    setTimeout(function(){
      BEER.stage = 0;
      G.lookYawT = Math.PI; G.lookXT = 0;
      G.lookYaw = Math.PI; G.lookX = 0;
      DRUNK.n = 5; DRUNK.last = Date.now();
      drunkApply();
      f.style.transition = "opacity .9s ease";
      f.style.opacity = "0";
      say("You slept on the floor, lad. The rat took your hat.");
      setTimeout(function(){ DRUNK.out = false; f.style.transition = "opacity .22s ease"; drunkTick(); }, 900);
    }, 2600);
  }
  function drunkApply(){
    var n = DRUNK.n, sc = el.scene;
    if(!sc) return;
    var blur = Math.min(6, Math.max(0, n - 1) * 0.7);
    var dbl = n >= 9 ? " drop-shadow(" + (4 + (n - 8) * 3) + "px 0 rgba(255,220,180,.45))" : "";
    var hue = n >= 10 ? " hue-rotate(" + ((n - 9) * 14) + "deg)" : "";
    sc.style.filter = n >= 2 ? "blur(" + blur + "px) saturate(" + (1 + n * 0.04) + ")" + hue + dbl : "";
    sc.classList.toggle("drunk", n >= 3);
    sc.style.setProperty("--wob", (0.25 + n * 0.14) + "deg");
    if(DRUNK.btn) DRUNK.btn.textContent = (BEER.stage ? "Another" : "Beer") + " \u00b7 2 gp" + (n ? " (" + n + ")" : "");
  }
  function drunkTick(){
    if(DRUNK.n > 0 && Date.now() - DRUNK.last > 40000){ DRUNK.n--; DRUNK.last = Date.now(); drunkApply(); }
    if(DRUNK.n >= 9 && !DRUNK.out && Math.random() < 0.18){ tone(520, 0.05, "square", 0.035); tone(780, 0.04, "square", 0.03, 0.07); }
    var show = G.ok && !MP.live && X3.room !== 1 && !DRUNK.out;
    if(DRUNK.btn){ DRUNK.btn.style.display = show ? "" : "none"; DRUNK.btn.textContent = (BEER.stage ? "Another" : "Beer") + " \u00b7 2 gp" + (DRUNK.n ? " (" + DRUNK.n + ")" : ""); }
    if(DRUNK.back) DRUNK.back.style.display = (show && BEER.stage) ? "" : "none";
    if(DRUNK.row) DRUNK.row.textContent = state.stats.beers || 0;
  }
  /* ---------- shared wiring ---------- */
  function xGo(){
    if(MP.live) return;
    var g = state.game;
    if(g === "bac") bacGo();
    else if(g === "d55"){ if(!G.ok) d55Go(); }
    else if(g === "flower") flGo();
    else if(g === "squeal") sqGo();
    else if(g === "barrows") brGo();
    else if(g === "wildy") wyGo();
    else if(g === "derby") dbGo();
  }
  function xZones(g){
    if(!XG) return;
    XG_KEYS.forEach(function(k){ XG[k].zone.style.display = g === k ? "flex" : "none"; });
    if(g !== "flower") fl3Clear();
    x3Room(g);
    xRoot.classList.toggle("game-x", xIs(g) && g !== "bac");
    var sl = XG.sideSpans;
    if(sl.length >= 2){
      sl[0].textContent = g === "bac" ? "Banker, Wise Old Man" : XG.sideTxt[0];
      sl[1].textContent = g === "bac" ? "Player" : XG.sideTxt[1];
    }
    el.goBtn.disabled = false;
    el.goBtn.classList.remove("urge");
  }
  function xEnter(g){
    var X = XG[g], txt = {
      bac: ["Punto banco against the Wise Old Man", "Baccarat", "Back Player, Banker or the Tie, then deal", "Deal"],
      d55: ["Percentile dice at the counter", "Dicing", "Roll 55 or higher and your bet doubles", "Roll"],
      flower: ["Mithril seeds on the counter", "Flower Game", "Hot is red, orange, yellow. Cold is blue, purple, pastel", "Plant"],
      squeal: ["Down in the cellar, a wheel he swears is not Treasure Hunter", "Squeal of Fortune", "Pick a prize, then spin the wheel", "Spin"],
      barrows: ["The crypt cabinet down in the cellar", "Barrows Chests", "Open chests, dodge the brothers, cash out any time", "Enter crypt"],
      wildy: ["The cellar machine with a death wish", "Wilderness Run", "Teleport out before a PKer finds you", "Run in"],
      derby: ["Race night down in the cellar", "Pet Derby", "Pick a runner, the odds are posted", "Race"]
    }[g];
    el.brandSub.textContent = txt[0];
    el.vHand.textContent = txt[1];
    el.vDelta.textContent = txt[2];
    el.goBtn.textContent = txt[3];
    X.busy = false;
    if(g === "barrows"){ X.on = false; X.tiles = null; brRender(X); brInfo(X); }
    if(g === "wildy"){
      X.on = false; X.phase = "idle"; X.fx = 0;
      if(!X.loop){ X.loop = true; X.last = 0; requestAnimationFrame(wyLoop); }
    }
    if(g === "derby"){ X.phase = "bet"; dbNew(); el.vHand.textContent = txt[1]; el.vDelta.textContent = txt[2]; }
    if(g === "squeal") sqDraw(X);
    x3dEnter(g);
  }
  function xPaint(){
    if(!XG) return;
    var st = state.stats;
    XROWS.forEach(function(r){ if(r.node) r.node.textContent = r.f ? r.f(st[r.k] || 0) : (st[r.k] || 0); });
    if(!xIs(state.game) || MP.live) return;
    var g = state.game, X = XG[g], busy = xBusy();
    (X.rails || []).forEach(function(r){
      for(var i = 0; i < r.children.length; i++) r.children[i].disabled = busy;
    });
    if(g === "barrows") el.goBtn.disabled = X.on && X.opened === 0;
    else if(g === "derby") el.goBtn.disabled = X.phase === "run" || (X.phase === "bet" && X.pick < 0);
    else if(g === "wildy"){ el.goBtn.disabled = false; el.goBtn.classList.toggle("urge", !!X.on); }
    else el.goBtn.disabled = busy;
  }
  function xRailSync(g){
    if(!XG) return;
    XG.cats.forEach(function(cn){
      var has = !!cn.querySelector("[data-g='" + g + "']");
      cn.classList.toggle("hasg", has);
      cn.classList.toggle("open", has);
    });
  }
  function xRailOpen(i){
    XG.cats.forEach(function(cn, k){ cn.classList.toggle("open", k === i ? !cn.classList.contains("open") : false); });
  }

  (function xBuild(){
    XG = {
      bac:{busy:false, pick:"player", hist:[]},
      d55:{busy:false, hist:[]},
      flower:{busy:false, pick:"hot", hist:[]},
      squeal:{busy:false, pick:"coins", rot:0},
      barrows:{on:false, bros:6, opened:0, tiles:null},
      wildy:{on:false, phase:"idle", auto:0, hist:[], dist:0, ditch:230, m:1, fx:0, speed:0, ph:0, endM:1, lvl:1, tt:0},
      derby:{busy:false, phase:"bet", pick:-1, field:null}
    };
    var css = [
      "#pvm-poker .xzone{display:none;flex-direction:column;align-items:center;gap:7px;padding:6px 0 6px}",
      "#pvm-poker.mp-live .xzone{display:none!important}",
      "#pvm-poker.game-x .row,#pvm-poker.game-x .side-label{display:none}",
      "#pvm-poker .xpick{display:flex;flex-wrap:wrap;gap:6px;justify-content:center}",
      "#pvm-poker .xpick button{border:1px solid #8a6d3b;background:rgba(8,6,13,.72);color:#e0b458;border-radius:999px;padding:5px 14px;font-family:'Barlow Condensed',sans-serif;font-size:15px;letter-spacing:.04em;cursor:pointer;line-height:1.1}",
      "#pvm-poker .xpick button.on{outline:2px solid #ffd98a;background:rgba(224,180,88,.18);color:#ffd98a}",
      "#pvm-poker .xpick button:disabled{opacity:.45;cursor:default}",
      "#pvm-poker .xpick button i{font-style:normal;font-family:'JetBrains Mono',monospace;font-size:11px;opacity:.75;margin-left:6px}",
      "#pvm-poker .dot{display:inline-block;width:10px;height:10px;border-radius:50%;margin-right:6px;vertical-align:-1px;border:1px solid rgba(0,0,0,.45)}",
      "#pvm-poker .xhist{display:flex;gap:4px;flex-wrap:wrap;justify-content:center;min-height:16px;max-width:560px}",
      "#pvm-poker .xhist span{font:11px 'JetBrains Mono',monospace;padding:1px 6px;border-radius:8px;background:#221d2c;color:#b9b2c4;border:1px solid #3a3150}",
      "#pvm-poker .xhist .xw{color:#6fce8b;border-color:#2c7a3f}#pvm-poker .xhist .xl{color:#e0685c;border-color:#7a2c24}#pvm-poker .xhist .xg2{color:#ffd98a;border-color:#8a6d3b}",
      "#pvm-poker .xhist .xh-player{color:#7fb0ff;border-color:#3f6fc9}#pvm-poker .xhist .xh-banker{color:#e0685c;border-color:#7a2c24}#pvm-poker .xhist .xh-tie{color:#6fce8b;border-color:#2c7a3f}",
      "#pvm-poker .xhist .fd{width:13px;height:13px;padding:0;border-radius:50%;border:1px solid rgba(0,0,0,.5)}",
      "#pvm-poker .xrain{background:linear-gradient(90deg,#e8392f,#f39a1f,#f4dc2c,#3fae4a,#3d6fdc);-webkit-background-clip:text;background-clip:text;color:transparent}",
      "#pvm-poker .d55wrap{display:flex;align-items:center;gap:18px;flex-wrap:wrap;justify-content:center}",
      "#pvm-poker .d55die{width:78px;height:84px;display:flex;align-items:center;justify-content:center;font:700 30px 'JetBrains Mono',monospace;color:#1a1426;background:radial-gradient(circle at 35% 30%,#fff3cf,#e0b458 55%,#8a6d3b);clip-path:polygon(50% 0,95% 25%,95% 75%,50% 100%,5% 75%,5% 25%)}",
      "#pvm-poker .d55die.roll{animation:xgWob .14s linear infinite}",
      "#pvm-poker .d55die.win{background:radial-gradient(circle at 35% 30%,#e4ffe8,#6fce8b 55%,#2c7a3f)}",
      "#pvm-poker .d55die.lose{background:radial-gradient(circle at 35% 30%,#ffe2dc,#e0685c 55%,#7a2c24)}",
      "@keyframes xgWob{0%{transform:rotate(-9deg) scale(.96)}50%{transform:rotate(9deg) scale(1.04)}100%{transform:rotate(-9deg) scale(.96)}}",
      "#pvm-poker .d55bar{position:relative;width:min(300px,56vw);height:14px;border-radius:7px;background:linear-gradient(90deg,#5a2020 0 54%,#2c7a3f 54% 100%);border:1px solid #4a3d2a}",
      "#pvm-poker .d55mark{position:absolute;top:-7px;width:3px;height:28px;background:#ffd98a;box-shadow:0 0 10px #ffd98a;display:none;transition:left .35s cubic-bezier(.3,1.4,.5,1)}",
      "#pvm-poker .d55t{position:absolute;top:18px;transform:translateX(-50%);font:11px 'JetBrains Mono',monospace;color:#9a92a4}",
      "#pvm-poker .flbed{width:150px;height:128px}#pvm-poker .flbed svg{width:100%;height:100%;overflow:visible}",
      "#pvm-poker .flg{transform-box:view-box;transform-origin:60px 96px;animation:xgGrow .75s cubic-bezier(.25,1.5,.5,1) both}",
      "#pvm-poker .flg.wilt{animation:xgWilt .5s ease-in forwards}",
      "#pvm-poker .flseed{animation:xgSeed .38s ease-in both}",
      "@keyframes xgGrow{0%{transform:scale(.1,0)}100%{transform:scale(1,1)}}",
      "@keyframes xgWilt{to{transform:rotate(18deg) scale(.9,.2);opacity:0}}",
      "@keyframes xgSeed{from{transform:translateY(0)}to{transform:translateY(86px)}}",
      "#pvm-poker .sqwrap{display:flex;align-items:center;gap:16px;flex-wrap:wrap;justify-content:center}",
      "#pvm-poker .sqwheel{position:relative;width:210px;height:210px;flex:0 0 auto}",
      "#pvm-poker .sqwheel canvas{width:210px!important;height:210px!important;display:block;border-radius:50%;box-shadow:0 0 0 4px #3a2a14,0 0 28px rgba(255,79,163,.35)}",
      "#pvm-poker .sqptr{position:absolute;left:50%;top:-9px;margin-left:-10px;border-left:10px solid transparent;border-right:10px solid transparent;border-top:22px solid #ffd98a;filter:drop-shadow(0 2px 2px #000);z-index:2}",
      "#pvm-poker .sqhub{position:absolute;left:50%;top:50%;width:66px;height:66px;margin:-33px 0 0 -33px;border-radius:50%;background:radial-gradient(circle at 40% 35%,#ff9fcf,#c23a7c 60%,#5a1238);display:flex;align-items:center;justify-content:center;text-align:center;font:700 12px/1.02 'Grenze Gotisch',serif;color:#fff;border:2px solid #ffd98a;pointer-events:none}",
      "#pvm-poker .sqpick{display:grid;grid-template-columns:1fr 1fr;gap:5px;max-width:320px}",
      "#pvm-poker .sqpick button{text-align:left;padding:4px 10px;font-size:14px}",
      "#pvm-poker .brgrid{display:grid;grid-template-columns:repeat(5,46px);gap:5px}",
      "#pvm-poker .brt{width:46px;height:40px;border-radius:5px;border:1px solid #2a1a0e;background:linear-gradient(180deg,#7a5530 0 36%,#c9a24d 36% 44%,#5a3d20 44%);box-shadow:inset 0 -3px 0 rgba(0,0,0,.35);cursor:pointer;position:relative;font:600 10px/1 'Barlow Condensed',sans-serif;color:#f2ead2;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:0;gap:1px;overflow:hidden}",
      "#pvm-poker .brt::after{content:'';position:absolute;left:50%;top:30%;width:6px;height:8px;margin-left:-3px;background:#e0b458;border-radius:1px;box-shadow:0 0 0 1px #3a2a14}",
      "#pvm-poker .brt:hover:not(:disabled){filter:brightness(1.18)}",
      "#pvm-poker .brt:disabled{cursor:default;filter:saturate(.7)}",
      "#pvm-poker .brt.safe{background:radial-gradient(circle at 50% 40%,#ffe7a0,#c9a24d 50%,#5a3d20);color:#1a1426;font-weight:700}",
      "#pvm-poker .brt.safe::after,#pvm-poker .brt.bro::after{display:none}",
      "#pvm-poker .brt.bro{background:linear-gradient(180deg,#5a1414,#2a0808);color:#ff9a8a;border-color:#a33}",
      "#pvm-poker .brt.bro.hit{outline:2px solid #ff5a4a;animation:xgShake .4s}",
      "#pvm-poker .brt.dim{opacity:.5}",
      "#pvm-poker .brt img{width:24px!important;height:24px!important;object-fit:contain}",
      "@keyframes xgShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-4px)}75%{transform:translateX(4px)}}",
      "#pvm-poker .wycv{width:min(600px,100%)!important;height:auto!important;aspect-ratio:640/220;border-radius:6px;border:1px solid #4a3d2a;display:block}",
      "#pvm-poker .dbtrack{width:min(580px,100%);display:flex;flex-direction:column;gap:3px;padding:6px;border:1px solid #4a3d2a;border-radius:6px;background:repeating-linear-gradient(90deg,#3b2d1c 0 24px,#44321f 24px 48px)}",
      "#pvm-poker .dblane{display:flex;align-items:center;gap:6px;height:32px;cursor:pointer;border-radius:4px;padding:0 4px;background:rgba(0,0,0,.2)}",
      "#pvm-poker .dblane:hover{background:rgba(224,180,88,.08)}",
      "#pvm-poker .dblane.pick{background:rgba(224,180,88,.2);outline:1px solid #e0b458}",
      "#pvm-poker .dbgate{width:20px;height:20px;border-radius:50%;background:#1a1426;color:#e0b458;font:700 12px 'JetBrains Mono',monospace;display:flex;align-items:center;justify-content:center;flex:0 0 auto}",
      "#pvm-poker .dbrail{position:relative;flex:1;height:100%;border-right:3px dashed rgba(242,234,210,.75)}",
      "#pvm-poker .dbname{position:absolute;left:40px;top:50%;transform:translateY(-50%);font:600 13px 'Barlow Condensed',sans-serif;color:#d8cdb4;opacity:.75;white-space:nowrap;pointer-events:none}",
      "#pvm-poker .dbname i{font-style:normal;color:#e0b458;font-size:11px;margin-left:4px}",
      "#pvm-poker .dbrun{position:absolute;top:0;left:0;width:34px;height:32px;display:flex;align-items:center;justify-content:center}",
      "#pvm-poker .dbrun img{width:30px!important;height:30px!important;object-fit:contain;filter:drop-shadow(0 2px 2px rgba(0,0,0,.6));transition:transform .15s}",
      "#pvm-poker .dbrun.stum img{transform:rotate(-30deg) translateY(4px)}",
      "#pvm-poker .dbrun.stum::after{content:'!';position:absolute;top:-3px;right:0;color:#ff6a5a;font:700 15px 'JetBrains Mono',monospace}",
      "#pvm-poker .dbodds{width:54px;text-align:right;font:700 13px 'JetBrains Mono',monospace;color:#e0b458;flex:0 0 auto}",
      "#pvm-poker .dbodds.dbwin{color:#6fce8b}",
      "#pvm-poker #gtabs .gcat{display:flex;flex-direction:column}",
      "#pvm-poker #gtabs button.gcatb{font-family:'JetBrains Mono',monospace;font-size:11px;letter-spacing:.16em;text-transform:uppercase;padding:6px 12px;color:#b9a67e;background:rgba(10,8,16,.78);border-color:#3a3150;text-align:left;display:flex;justify-content:space-between;align-items:center;gap:12px;min-width:150px}",
      "#pvm-poker #gtabs button.gcatb::after{content:'+';font-size:13px;opacity:.7}",
      "#pvm-poker #gtabs .gcat.open button.gcatb::after{content:'\\2212'}",
      "#pvm-poker #gtabs .gcat.hasg button.gcatb{color:#ffd98a;border-color:#8a6d3b}",
      "#pvm-poker #gtabs .gsub{display:none;flex-direction:column;gap:4px;margin:4px 0 2px 10px}",
      "#pvm-poker #gtabs .gcat.open .gsub{display:flex}",
      "#pvm-poker #gtabs .gsub button{font-size:15px;padding:3px 12px;text-align:left}",
      "#pvm-poker .panel[data-xg] td.m{white-space:nowrap}",
      "#pvm-poker #gtabs button.hot2{border-color:#e0b458;box-shadow:0 0 9px rgba(224,180,88,.4);color:#ffd98a}",
      "#pvm-poker #gtabs button.hot3{border-color:#ff8a3a;box-shadow:0 0 11px rgba(255,138,58,.45);color:#ffb27a}",
      "#pvm-poker #gtabs .hotb{font:700 11px 'JetBrains Mono',monospace;background:linear-gradient(180deg,#f0cf7a,#c9a24d);color:#1a1426;border-radius:8px;padding:1px 6px;margin-left:8px;flex:0 0 auto}",
      "#pvm-poker #gtabs button.hot3 .hotb{background:linear-gradient(180deg,#ffb27a,#e06a2a);color:#2a1206}"
    ].join("\n");
    var sty = document.createElement("style");
    sty.id = "pvmXgStyle"; sty.textContent = css;
    document.head.appendChild(sty);

    /* zones */
    var anchor = el.stakeZone;
    function addZone(k, node){
      node.className = "xzone"; node.id = "xz-" + k; node.style.display = "none";
      anchor.parentNode.insertBefore(node, anchor.nextSibling);
      anchor = node;
      XG[k].zone = node; XG[k].dom = XG[k].dom || {};
    }
    var z, X;

    /* baccarat: cards use the existing rows */
    X = XG.bac; z = xNode("div");
    addZone("bac", z);
    z.appendChild(xPickRail(X, "pick", [
      {v:"player", l:"Player", s:"2x"}, {v:"banker", l:"Banker", s:"1.95x"}, {v:"tie", l:"Tie", s:"9x"}]));
    X.dom.read = xNode("div", "droll", "&nbsp;"); z.appendChild(X.dom.read);
    X.dom.hist = xNode("div", "xhist"); z.appendChild(X.dom.hist);

    /* dicing */
    X = XG.d55; z = xNode("div");
    addZone("d55", z);
    var dw = xNode("div", "d55wrap");
    X.dom.die = xNode("div", "d55die", "55");
    var bar = xNode("div", "d55bar", "<span class='d55t' style='left:0'>1</span><span class='d55t' style='left:54%'>55</span><span class='d55t' style='left:100%'>100</span>");
    X.dom.mark = xNode("div", "d55mark"); bar.appendChild(X.dom.mark);
    dw.appendChild(X.dom.die); dw.appendChild(bar);
    z.appendChild(dw);
    X.dom.read = xNode("div", "droll", "&nbsp;"); X.dom.read.style.marginTop = "8px"; z.appendChild(X.dom.read);
    X.dom.hist = xNode("div", "xhist"); z.appendChild(X.dom.hist);

    /* hot or cold */
    X = XG.flower; z = xNode("div");
    addZone("flower", z);
    z.appendChild(xPickRail(X, "pick", [
      {v:"hot", l:"Hot", s:"red orange yellow", dot:"#ef8a22"}, {v:"cold", l:"Cold", s:"blue purple pastel", dot:"#3565d8"}]));
    X.dom.svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    X.dom.svg.setAttribute("viewBox", "0 0 120 110");
    X.dom.svg.innerHTML = FL_MOUND;
    var bed = xNode("div", "flbed"); bed.appendChild(X.dom.svg); z.appendChild(bed);
    X.dom.read = xNode("div", "droll", "&nbsp;"); z.appendChild(X.dom.read);
    X.dom.hist = xNode("div", "xhist"); z.appendChild(X.dom.hist);

    /* squeal of fortune */
    X = XG.squeal; z = xNode("div");
    addZone("squeal", z);
    var sw = xNode("div", "sqwrap"), wh = xNode("div", "sqwheel");
    X.dom.cv = document.createElement("canvas"); X.dom.cv.width = 768; X.dom.cv.height = 768;
    X.ctx = X.dom.cv.getContext("2d");
    wh.appendChild(X.dom.cv); wh.appendChild(xNode("div", "sqptr")); wh.appendChild(xNode("div", "sqhub", "Squeal<br>of<br>Fortune"));
    sw.appendChild(wh);
    sw.appendChild(xPickRail(X, "pick", SQ_SYM.map(function(s){ return {v:s.k, l:s.n, s:s.m + "x", dot:s.c}; }), "sqpick"));
    z.appendChild(sw);
    X.dom.read = xNode("div", "droll", "&nbsp;"); z.appendChild(X.dom.read);
    sqDraw(X);

    /* barrows */
    X = XG.barrows; z = xNode("div");
    addZone("barrows", z);
    X.onPick = function(){ brInfo(XG.barrows); br3Sync(XG.barrows); };
    z.appendChild(xPickRail(X, "bros", [{v:1, l:"1 brother"}, {v:3, l:"3 brothers"}, {v:6, l:"All six"}]));
    X.dom.grid = xNode("div", "brgrid"); z.appendChild(X.dom.grid);
    X.dom.grid.addEventListener("click", function(ev){
      var b = ev.target.closest(".brt");
      if(b && !b.disabled) brPick(+b.dataset.i);
    });
    X.dom.read = xNode("div", "droll", "&nbsp;"); z.appendChild(X.dom.read);

    /* wilderness run */
    X = XG.wildy; z = xNode("div");
    addZone("wildy", z);
    X.dom.cv = document.createElement("canvas"); X.dom.cv.width = 1280; X.dom.cv.height = 440; X.dom.cv.className = "wycv";
    X.ctx = X.dom.cv.getContext("2d");
    z.appendChild(X.dom.cv);
    z.appendChild(xPickRail(X, "auto", [{v:0, l:"Auto tele off"}, {v:1.5, l:"1.5x"}, {v:2, l:"2x"}, {v:3, l:"3x"}, {v:5, l:"5x"}, {v:10, l:"10x"}]));
    X.dom.hist = xNode("div", "xhist"); z.appendChild(X.dom.hist);

    /* pet derby */
    X = XG.derby; z = xNode("div");
    addZone("derby", z);
    X.dom.track = xNode("div", "dbtrack"); z.appendChild(X.dom.track);
    X.dom.track.addEventListener("click", function(ev){
      var ln = ev.target.closest(".dblane"), D = XG.derby;
      if(!ln || D.phase !== "bet") return;
      dbPickLane(+ln.dataset.i);
    });
    X.dom.read = xNode("div", "droll", "&nbsp;"); z.appendChild(X.dom.read);

    /* side-label text for baccarat swap */
    XG.sideSpans = xRoot.querySelectorAll(".deck-zone .side-label > span");
    XG.sideTxt = [XG.sideSpans[0] ? XG.sideSpans[0].textContent : "House hand", XG.sideSpans[1] ? XG.sideSpans[1].textContent : "Your hand"];

    /* rules panels */
    var brRows = [1, 3, 5, 8].map(function(k){ return "<tr><td>All six, " + k + (k === 1 ? " chest" : " chests") + "</td><td class='m'>" + brFmt(brMult(k, 6)) + "</td></tr>"; }).join("") +
                 [3, 10].map(function(k){ return "<tr><td>3 brothers, " + k + " chests</td><td class='m'>" + brFmt(brMult(k, 3)) + "</td></tr>"; }).join("");
    var PANELS = {
      bac: ["Baccarat", "<tr><td>Player</td><td class='m'>2x</td></tr><tr><td>Banker</td><td class='m'>1.95x</td></tr><tr><td>Tie</td><td class='m'>9x</td></tr>",
            "Eight decks, standard third card rules. Tens and faces count zero, only the last digit matters. A tie pushes Player and Banker bets. The Wise Old Man takes 5% of banker wins for beard upkeep."],
      d55: ["Dicing", "<tr><td>55 to 100</td><td class='m'>2x</td></tr><tr><td>1 to 54</td><td class='m'>lose</td></tr>",
            "One roll of the percentile dice. Fifty-five or higher doubles your stake, just like the old clan chat hosts, minus the part where he logs out with your coins."],
      flower: ["Flower Game", "<tr><td>Hot: red, orange, yellow</td><td class='m'>2x</td></tr><tr><td>Cold: blue, purple, pastel</td><td class='m'>2x</td></tr><tr><td>Rainbow</td><td class='m'>lose</td></tr><tr><td>Black or white</td><td class='m'>replant</td></tr>",
            "One mithril seed per round. Black and white flowers get pulled and replanted. A rainbow belongs to the house."],
      squeal: ["Squeal of Fortune", SQ_SYM.map(function(s){ return "<tr><td><span class='dot' style='background:" + s.c + "'></span>" + s.n + " (" + s.cnt + " of 52)</td><td class='m'>" + s.m + "x</td></tr>"; }).join(""),
            "Pick a prize and spin. The pointer decides. The thinner the slice, the fatter the payout."],
      barrows: ["Barrows Chests", brRows,
            "Twenty-five chests, some hide a brother. Every safe chest raises your cash out. Open a brother and the run is over. More brothers, faster climb."],
      wildy: ["Wilderness Run", "<tr><td>Make it past 2x</td><td class='m'>48.5%</td></tr><tr><td>Make it past 5x</td><td class='m'>19.4%</td></tr><tr><td>Make it past 10x</td><td class='m'>9.7%</td></tr><tr><td>Ambushed at the ditch</td><td class='m'>3%</td></tr>",
            "The multiplier climbs the deeper you run. A PKer can show up at any moment. Teleport to lock in your multiplier, or set auto tele and let it fire for you."],
      derby: ["Pet Derby", "<tr><td>Winner</td><td class='m'>posted odds</td></tr><tr><td>Anything else</td><td class='m'>lose</td></tr>",
            "Six boss pets per race. Odds come from each pet's form, so the favourite pays least. Pets stumble. It is part of their charm."]
    };
    var pAnchor = document.getElementById("ceePanel");
    XG_KEYS.forEach(function(k){
      var p = PANELS[k], pn = xNode("div", "panel", "<h2>" + p[0] + "</h2><table>" + p[1] + "</table><div class='note'>" + p[2] + "</div>");
      pn.dataset.xg = k; pn.style.display = "none";
      if(pAnchor){ pAnchor.parentNode.insertBefore(pn, pAnchor.nextSibling); pAnchor = pn; }
    });

    /* stat rows */
    var atmRow = el.sAtm ? el.sAtm.parentNode : null;
    XROWS.forEach(function(r){
      var row = xNode("div", "stat", "<span>" + r.n + "</span><span>0</span>");
      row.dataset.bf = r.bf;
      r.node = row.lastChild;
      if(atmRow) atmRow.parentNode.insertBefore(row, atmRow);
    });

    /* grouped rail */
    var gt = el.gtabs;
    gt.innerHTML = "";
    XG.cats = [];
    XRAIL.forEach(function(cat, ci){
      var cn = xNode("div", "gcat");
      var hb = xNode("button", "gcatb", cat[0]);
      hb.dataset.cat = ci;
      cn.appendChild(hb);
      var sub = xNode("div", "gsub");
      cat[1].forEach(function(gm){
        var b = xNode("button", gm[0] === state.game ? "on" : "", gm[1]);
        b.dataset.g = gm[0];
        if(XG_CELLAR.indexOf(gm[0]) !== -1){
          b.innerHTML += CELLAR_ICO;
          b.title = "Down in the cellar";
          b.style.display = "flex";
          b.style.alignItems = "center";
          b.style.justifyContent = "space-between";
        }
        sub.appendChild(b);
      });
      cn.appendChild(sub);
      gt.appendChild(cn);
      XG.cats.push(cn);
    });
    xRailSync(state.game);
  })();

  /* ---------- game switcher ---------- */
  var root = document.getElementById("pvm-poker");
  function gameBusy(){
    if(state.game === "bj") return BJ.phase === "play" || BJ.phase === "resolve";
    if(state.game === "dice") return DICE.rolling;
    if(state.game === "ceelo") return CEE.busy;
    if(state.game === "rou") return ROU.spinning || ROU.anim;
    if(state.game === "stake") return STAKE.on || el.stakeAsk.style.display !== "none";
    if(state.game === "slots") return SLOTS.spinning;
    if(state.game === "pach") return PACH.balls.length > 0;
    if(xIs(state.game)) return xBusy();
    return state.phase !== "idle";
  }
  function mpApplyPanels(g){
    var pcls = g === "poker" ? "g-poker" : g === "bj" ? "g-bj" : g === "dice" ? "g-dice"
             : g === "slots" ? "g-slots" : g === "pach" ? "g-pach" : null;
    var pls = root.querySelectorAll(".panel");
    for(var pi = 0; pi < pls.length; pi++){
      var pe = pls[pi];
      if(pe.classList.contains("wide")) continue;
      if(pe.dataset.xg){ pe.style.display = g === pe.dataset.xg ? "block" : "none"; continue; }
      if(pe.id === "rouPanel"){ pe.style.display = g === "rou" ? "block" : "none"; continue; }
      if(pe.id === "ceePanel"){ pe.style.display = g === "ceelo" ? "block" : "none"; continue; }
      if(pe.id === "stakePanel"){ pe.style.display = g === "stake" ? "block" : "none"; continue; }
      if(pe.id === "mpPanel"){ pe.style.display = g === "mp" ? "block" : "none"; continue; }
      pe.style.display = (pcls && pe.classList.contains(pcls)) ? "block" : "none";
    }
  }
  function setGame(g, force){
    if(!force && state.game === g) return;
    if(!force && gameBusy()){ say("Finish this round first, lad."); return; }
    state.game = g;
    root.className = root.className.replace(/(^|\s)game-[a-z0-9]+/g, " ").replace(/\s+/g, " ").trim();
    if(g !== "poker") root.classList.add("game-" + g);
    if(g === "ceelo") root.classList.add("game-dice");
    var tb = el.gtabs.querySelectorAll("button[data-g]");
    for(var i = 0; i < tb.length; i++) tb[i].classList.toggle("on", tb[i].dataset.g === g);
    xRailSync(g);
    G.lookYawT = (g === "slots" || g === "pach" || g === "barrows" || g === "wildy" || g === "derby") ? 0 : g === "rou" ? Math.PI * 0.5 : g === "squeal" ? Math.PI * 1.5 : Math.PI;
    G.lookXT = g === "slots" ? -1.35 : g === "pach" ? 1.35 : g === "rou" ? -1.95 : g === "squeal" ? 0.8 : g === "barrows" ? -3.2 : g === "derby" ? 3.2 : 0;
    G.lookXBase = G.lookXT; G.lookYawBase = G.lookYawT;
    el.diceZone.style.display = (g === "dice" || g === "ceelo") ? "flex" : "none";
    el.rouZone.style.display = g === "rou" ? "flex" : "none";
    el.stakeZone.style.display = g === "stake" ? "flex" : "none";
    el.stakeAsk.style.display = "none";
    xZones(g);
    mpApplyPanels(g);
    clearDice();
    el.dealerRow.innerHTML = ""; el.playerRow.innerHTML = "";
    el.dealerHand.textContent = ""; el.playerHand.textContent = "";
    el.verdict.className = "verdict";
    el.diceReadout.innerHTML = "&nbsp;";
    if(g === "poker"){
      state.phase = "idle";
      el.brandSub.textContent = "Five cards against the Wise Old Man";
      el.vHand.textContent = "Place your bet";
      el.vDelta.textContent = "Beat the house and your bet pays the multiplier";
      el.goBtn.textContent = "Deal";
    } else if(g === "bj"){
      BJ.phase = "bet";
      el.brandSub.textContent = "Twenty-one against the Wise Old Man";
      el.vHand.textContent = "Blackjack pays 3 to 2";
      el.vDelta.textContent = "Dealer stands on all 17s";
      el.goBtn.textContent = "Deal";
    } else if(g === "slots"){
      SLOTS.spinning = false;
      el.brandSub.textContent = "Reels in the corner of the tavern";
      el.vHand.textContent = "Loot Slots";
      el.vDelta.textContent = "Three of a kind pays big, any pair pays 2x";
      el.goBtn.textContent = "Spin";
    } else if(g === "pach"){
      PACH.balls.forEach(function(bb2){ if(G.pach) G.pach.remove(bb2.mesh); });
      PACH.balls.length = 0;
      el.brandSub.textContent = "Pachinko in the corner of the tavern";
      el.vHand.textContent = "Pachinko";
      el.vDelta.textContent = "Edge bins pay 20x, the middle eats your coin";
      el.goBtn.textContent = "Drop";
    } else if(g === "stake"){
      el.brandSub.textContent = "The sand casino by the counter";
      el.vHand.textContent = "Staking";
      el.vDelta.textContent = "Stake it all, first to fall hands over the pot";
      el.goBtn.textContent = "Stake";
    } else if(g === "rou"){
      ROU.spinning = false;
      el.brandSub.textContent = "The wheel by the east wall";
      el.vHand.textContent = "Roulette";
      el.vDelta.textContent = "Pick a bet on the rail below, then spin";
      el.goBtn.textContent = "Spin";
    } else if(g === "ceelo"){
      CEE.busy = false;
      el.brandSub.textContent = "Three dice against the Wise Old Man";
      el.vHand.textContent = "Cee-lo";
      el.vDelta.textContent = "4-5-6 or trips pays double, higher point wins";
      el.goBtn.textContent = "Hold to shake";
    } else if(xIs(g)){
      xEnter(g);
    } else {
      DICE.rolling = false;
      el.brandSub.textContent = "High rolls against the Wise Old Man";
      el.vHand.textContent = "Craps";
      el.vDelta.textContent = "Pass line: 7 or 11 wins the come-out, then make your point before a 7";
      el.goBtn.textContent = "Hold to shake";
    }
    state.bet = Math.max(minBet(), Math.min(state.bet, maxBet()));
    saveLocal(); paint();
  }
  (function(){
    var xb = document.createElement("button");
    xb.id = "exitBtn";
    xb.textContent = "\u2715 Exit game";
    xb.style.cssText = "display:none;position:absolute;left:12px;top:86px;z-index:26;pointer-events:auto;" +
      "background:#241d15;color:#d8cdb4;border:1px solid #4a3d2a;border-radius:6px;padding:7px 12px;" +
      "font-family:'Barlow Condensed',sans-serif;font-size:15px;letter-spacing:.06em;cursor:pointer";
    var sui2 = root.querySelector(".stage-ui");
    (sui2 || document.body).appendChild(xb);
    el.exitBtn = xb;
    xb.addEventListener("click", function(){
      if(MP.live || gameBusy()) return;
      setGame("poker", true);
    });
  })();
  el.gtabs.addEventListener("click", function(ev){
    var b = ev.target.closest("button");
    if(!b) return;
    if(b.dataset.cat != null){ xRailOpen(+b.dataset.cat); return; }
    if(b.dataset.g) setGame(b.dataset.g);
  });
  el.goBtn.addEventListener("pointerdown", function(){
    if(MP.live || (state.game !== "dice" && state.game !== "ceelo" && state.game !== "d55") || DICE.rolling || CEE.busy || XG.d55.busy || DICE.shaking) return;
    actx();
    DICE.shaking = true;
    DICE.shakeAt = Date.now();
    el.goBtn.textContent = "Shaking...";
    spawnHeld(state.game === "ceelo" || state.game === "d55" ? 2 + (state.game === "ceelo" ? 1 : 0) : 2);
    if(state.game === "d55") d55Skin();
    DICE.shakeIv = setInterval(function(){
      tone(160 + Math.random() * 90, 0.03, "square", 0.14);
      tone(1050 + Math.random() * 450, 0.02, "square", 0.10);
    }, 90);
  });
  function diceRelease(){
    if(!DICE.shaking) return;
    DICE.shaking = false;
    clearInterval(DICE.shakeIv);
    el.goBtn.textContent = "Hold to shake";
    var pw9 = Math.min(1.6, 1 + (Date.now() - DICE.shakeAt) / 1200);
    if(state.game === "ceelo") ceeRoll(pw9);
    else if(state.game === "d55") d55Roll3(pw9);
    else diceRoll(pw9);
  }
  el.goBtn.addEventListener("pointerup", diceRelease);
  el.goBtn.addEventListener("pointerleave", diceRelease);
  el.stakeAccept.addEventListener("click", stakeAccepted);
  el.stakeDecline.addEventListener("click", function(){
    el.stakeAsk.style.display = "none";
    el.vHand.textContent = "You turned the duel down";
    el.vDelta.textContent = STAKE.scam ? "Wise. That name looked... off." : "The old man shrugs and shuffles off";
    tone(420, 0.06, "triangle", 0.05);
  });
  el.rmode.addEventListener("click", function(ev){
    var b = ev.target.closest("button");
    if(!b || ROU.spinning) return;
    var pk = b.dataset.r;
    if(pk === "num"){
      var nv = parseInt(prompt("Straight-up number (0-36):"), 10);
      if(!isFinite(nv) || nv < 0 || nv > 36) return;
      state.rouNum = nv;
      b.textContent = "#" + nv + " (35x)";
    }
    state.rouPick = pk;
    var rb = el.rmode.children;
    for(var i = 0; i < rb.length; i++){
      rb[i].classList.toggle("on", rb[i] === b);
      rb[i].style.outline = rb[i] === b ? "2px solid #ffd98a" : "none";
    }
    el.rouReadout.innerHTML = "&nbsp;";
    saveLocal();
  });
  el.standBtn.addEventListener("click", function(){
    if(MP.live){ if(MP.mode !== "poker") mpAct("stand"); }
    else bjStand();
  });
  el.dblBtn.addEventListener("click", function(){
    if(MP.live){ if(MP.mode === "poker") mpPokerBet("fold"); else mpAct("double"); }
    else bjDouble();
  });

  /* wiring */
  el.goBtn.addEventListener("click", function(){
    if(MP.live){ mpGo(); return; }
    if(state.game === "bj"){
      if(BJ.phase === "bet" || BJ.phase === "done") bjDeal();
      else if(BJ.phase === "play") bjHit();
    } else if(state.game === "dice" || state.game === "ceelo"){
      /* dice games use hold-to-shake pointer events */
    } else if(state.game === "rou"){
      rouSpin();
    } else if(state.game === "stake"){
      stakeStart();
    } else if(state.game === "slots"){
      slotSpin();
    } else if(state.game === "pach"){
      pachDrop();
    } else if(xIs(state.game)){
      xGo();
    } else {
      if(state.phase === "idle") startHand();
      else if(state.phase === "draw") doDraw();
    }
  });
  function presetClick(ev){
    var b = ev.target.closest("button");
    if(!b || !canBet()) return;
    var v = b.dataset.b;
    if(v === "min") state.bet = minBet();
    else if(v === "max") state.bet = maxBet();
    else if(v === "x"){
      var n = parseBet(prompt("Enter bet amount. Suffixes: k m b t q qi sx sp oc no dc", state.bet));
      if(!isFinite(n) || n <= 0) return;
      state.bet = Math.max(minBet(), Math.min(n, maxBet()));
    }
    else if(v === "last"){
      if(!state.lastBet) return;
      state.bet = Math.max(minBet(), Math.min(state.lastBet, maxBet()));
    }
    else state.bet = Math.max(minBet(), Math.min(+v, maxBet()));
    tone(640, 0.05, "square", 0.07);
    paint();
  }
  el.presets.addEventListener("click", presetClick);
  el.presets2.addEventListener("click", presetClick);
  el.soundBtn.addEventListener("click", function(){
    state.sound = !state.sound;
    el.soundBtn.textContent = state.sound ? "Sound on" : "Sound off";
    if(state.sound) tone(660,0.08,"square",0.085);
    saveLocal();
  });
  el.musicBtn.addEventListener("click", function(){
    state.music = !state.music;
    el.musicBtn.textContent = state.music ? "Music on" : "Music off";
    if(state.music) tryMusic();
    else { if(bgm) bgm.pause(); if(chinBgm) chinBgm.pause(); if(X3 && X3.mf && X3.mf.el) X3.mf.el.pause(); }
    saveLocal();
  });
  el.musicVol.addEventListener("input", function(){
    state.musicVol = +el.musicVol.value;
    xVol();
    if(chinBgm) chinBgm.volume = state.musicVol / 100;
    saveLocal();
  });

  /* ranking chart, strongest first */
  ITEMS.slice().reverse().forEach(function(item, i){
    var row = document.createElement("div");
    row.className = "rank" + (i === 0 ? " top" : "");
    var n = document.createElement("span"); n.className = "n"; n.textContent = item.tier;
    var pic = document.createElement("span"); pic.className = "pic";
    pic.appendChild(itemImg(item));
    var nm = document.createElement("span"); nm.className = "nm";
    nm.textContent = item.name;
    if(i === 0){ var tagi = document.createElement("i"); tagi.textContent = "highest"; nm.appendChild(tagi); }
    if(i === ITEMS.length - 1){ var tagl = document.createElement("i"); tagl.textContent = "lowest"; nm.appendChild(tagl); }
    row.appendChild(n); row.appendChild(pic); row.appendChild(nm);
    el.ladder.appendChild(row);
  });

  load();
  el.soundBtn.textContent = state.sound ? "Sound on" : "Sound off";
  el.musicBtn.textContent = state.music ? "Music on" : "Music off";
  el.musicVol.value = state.musicVol;
  state.bet = minBet();
  renderDealer(false, false);
  el.playerRow.innerHTML = "";
  for(var q = 0; q < 5; q++) el.playerRow.appendChild(cardEl(null, false, false));
  paint();
  initGL();
  setGame(state.game || "poker", true);
  setTimeout(function(){ say("Sit down, lad. The bank's mine and so is the luck."); }, 800);
})();
